import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects.item');
import { ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";
import { reviewOpsCodexBuiltinModelSettings } from 'src/app/codex-model-catalog';
import { FitAddon } from '@xterm/addon-fit';
import { WebLinksAddon } from '@xterm/addon-web-links';
import { Terminal } from '@xterm/xterm';
import { io } from 'socket.io-client';

declare const require: any;
const showdown = require('showdown');

@Component({
    selector: 'wiz-page-projects-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.projects.item/view.scss */
:host {
  display: block;
  height: 100%;
}

:host ::ng-deep #reviewops-pdf-shell,
:host ::ng-deep #reviewops-pdf-viewer,
:host ::ng-deep #reviewops-pdf-stage,
:host ::ng-deep #reviewops-pdf-image {
  color-scheme: only light;
  forced-color-adjust: none;
}

:host ::ng-deep #reviewops-pdf-stage {
  isolation: isolate;
}

:host ::ng-deep #reviewops-pdf-image {
  filter: none !important;
  mix-blend-mode: normal !important;
  background: #ffffff;
}

:host ::ng-deep .reviewops-markdown {
  color: #334155;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

:host ::ng-deep .reviewops-markdown > *:first-child {
  margin-top: 0;
}

:host ::ng-deep .reviewops-markdown > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .reviewops-markdown p {
  margin: 0 0 0.75rem;
}

:host ::ng-deep .reviewops-markdown h1,
:host ::ng-deep .reviewops-markdown h2,
:host ::ng-deep .reviewops-markdown h3,
:host ::ng-deep .reviewops-markdown h4,
:host ::ng-deep .reviewops-markdown h5,
:host ::ng-deep .reviewops-markdown h6 {
  margin: 1.15rem 0 0.55rem;
  color: #0f172a;
  font-weight: 700;
  line-height: 1.3;
}

:host ::ng-deep .reviewops-markdown h1,
:host ::ng-deep .reviewops-markdown h2 {
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e2e8f0;
}

:host ::ng-deep .reviewops-markdown h1 {
  font-size: 1.35rem;
}

:host ::ng-deep .reviewops-markdown h2 {
  font-size: 1.15rem;
}

:host ::ng-deep .reviewops-markdown h3 {
  font-size: 1rem;
}

:host ::ng-deep .reviewops-markdown h4,
:host ::ng-deep .reviewops-markdown h5,
:host ::ng-deep .reviewops-markdown h6 {
  font-size: 0.92rem;
}

:host ::ng-deep .reviewops-markdown ul,
:host ::ng-deep .reviewops-markdown ol {
  margin: 0.5rem 0 0.85rem;
  padding-left: 1.55rem;
}

:host ::ng-deep .reviewops-markdown ul {
  list-style: disc;
}

:host ::ng-deep .reviewops-markdown ol {
  list-style: decimal;
}

:host ::ng-deep .reviewops-markdown li {
  margin: 0.22rem 0;
  padding-left: 0.1rem;
}

:host ::ng-deep .reviewops-markdown li > p {
  margin: 0.25rem 0;
}

:host ::ng-deep .reviewops-markdown li > ul,
:host ::ng-deep .reviewops-markdown li > ol {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

:host ::ng-deep .reviewops-markdown ul ul {
  list-style: circle;
}

:host ::ng-deep .reviewops-markdown ul ul ul {
  list-style: square;
}

:host ::ng-deep .reviewops-markdown .contains-task-list {
  padding-left: 1.35rem;
}

:host ::ng-deep .reviewops-markdown .task-list-item {
  list-style: none;
}

:host ::ng-deep .reviewops-markdown blockquote {
  margin: 0.85rem 0;
  padding: 0.1rem 0 0.1rem 0.85rem;
  border-left: 0.25rem solid #d0d7de;
  color: #64748b;
}

:host ::ng-deep .reviewops-markdown blockquote > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .reviewops-markdown a {
  color: #0969da;
  text-decoration: underline;
  text-underline-offset: 2px;
}

:host ::ng-deep .reviewops-markdown a:hover {
  color: #0756b8;
}

:host ::ng-deep .reviewops-markdown code {
  padding: 0.12rem 0.28rem;
  border-radius: 4px;
  background: #f1f5f9;
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.92em;
}

:host ::ng-deep .reviewops-markdown pre {
  margin: 0.85rem 0;
  padding: 0.85rem;
  overflow-x: auto;
  border-radius: 6px;
  background: #f6f8fa;
  color: #0f172a;
  font-size: 12px;
  line-height: 1.55;
}

:host ::ng-deep .reviewops-markdown pre code {
  display: block;
  padding: 0;
  border-radius: 0;
  background: transparent;
  font-size: inherit;
  white-space: pre;
}

:host ::ng-deep .reviewops-markdown table {
  display: block;
  width: max-content;
  max-width: 100%;
  margin: 0.85rem 0;
  overflow-x: auto;
  border-collapse: collapse;
  font-size: 12px;
}

:host ::ng-deep .reviewops-markdown th,
:host ::ng-deep .reviewops-markdown td {
  padding: 0.42rem 0.65rem;
  border: 1px solid #d0d7de;
}

:host ::ng-deep .reviewops-markdown th {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 700;
}

:host ::ng-deep .reviewops-markdown tr:nth-child(2n) {
  background: #f8fafc;
}

:host ::ng-deep .reviewops-markdown hr {
  height: 1px;
  margin: 1rem 0;
  border: 0;
  background: #e2e8f0;
}

:host ::ng-deep .reviewops-markdown img {
  max-width: 100%;
  border-radius: 6px;
}

:host ::ng-deep .reviewops-markdown input[type=checkbox] {
  width: 0.9rem;
  height: 0.9rem;
  margin: 0 0.4rem 0.15rem -1.25rem;
  vertical-align: middle;
}

.reviewops-page-fixed-header {
  border-color: #1d314f;
  background: #13233a;
  color: #e5edf7;
  box-shadow: 0 4px 16px rgba(15, 31, 53, 0.18);
}

.reviewops-page-fixed-header h1 {
  color: #ffffff;
}

.reviewops-page-fixed-header p {
  color: #9fb0c6;
}

.reviewops-page-fixed-header a {
  color: #c9d5e5;
}

.reviewops-page-fixed-header a:hover {
  color: #ffffff;
}

.reviewops-page-fixed-header span.rounded-full {
  background: #38bdf8;
  color: #082f49;
}

.reviewops-mobile-pane-switcher {
  border-color: #1d314f;
  background: #13233a;
}

.reviewops-mobile-pane-switcher > div {
  background: #1b2d46;
}

.reviewops-viewer-toolbar {
  border-color: #b7c8dc;
  background: #dce6f1;
  box-shadow: inset 0 -1px 0 rgba(15, 31, 53, 0.08);
}

.reviewops-viewer-toolbar input,
.reviewops-viewer-toolbar select,
.reviewops-viewer-toolbar button {
  border-color: #9fb0c6;
}

.reviewops-viewer-toolbar button:hover {
  background: #eef4fa;
}

.reviewops-workspace-pane-surface,
.reviewops-workspace-section {
  background: #e9f0f7;
}

.reviewops-workspace-pane-surface {
  border-color: #1d314f;
  box-shadow: inset 3px 0 0 #1d314f, -8px 0 24px rgba(15, 31, 53, 0.16);
}

.reviewops-workspace-resizer {
  border-left: 1px solid #adc0d4;
  border-right: 1px solid #adc0d4;
  background: #d7e2ee;
  box-shadow: inset 1px 0 0 rgba(15, 31, 53, 0.08);
}

.reviewops-workspace-resizer:hover {
  border-color: #7fa7c9;
  background: #c8d9ea;
}

.reviewops-workspace-section-header {
  border-color: #b7c8dc;
  background: #d9e5f1;
}

.reviewops-workspace-section-header h2 {
  color: #0f1f35;
}

.reviewops-codex-usage-footer {
  border-color: #1d314f;
  background: #13233a;
  color: #dbeafe;
  box-shadow: 0 -1px 0 rgba(255, 255, 255, 0.06);
}

.reviewops-codex-usage-footer-icon,
.reviewops-codex-usage-footer-label,
.reviewops-codex-usage-footer-reset,
.reviewops-codex-usage-footer-meta {
  color: #9fb0c6;
}

.reviewops-codex-usage-footer-percent,
.reviewops-codex-usage-footer-text {
  color: #ffffff;
}

.reviewops-codex-usage-footer button {
  border-color: #2d4260;
  background: #1b2d46;
  color: #dbeafe;
}

.reviewops-codex-usage-footer button:hover {
  background: #203554;
  color: #ffffff;
}

:host ::ng-deep .reviewops-project-terminal .xterm {
  height: 100%;
  padding: 10px;
}

:host ::ng-deep .reviewops-project-terminal .xterm-viewport {
  background: #020617 !important;
}

.reviewops-review-list-table th,
.reviewops-review-list-table th button {
  white-space: nowrap;
}

.reviewops-html-fallback-fullscreen {
  height: var(--reviewops-viewport-height, 100vh);
  max-height: var(--reviewops-viewport-height, 100vh);
}

.reviewops-html-fullscreen-exit {
  top: calc(env(safe-area-inset-top, 0px) + 0.75rem);
  right: calc(env(safe-area-inset-right, 0px) + 0.75rem);
}

@media (max-width: 1023px) {
  .reviewops-review-create-form {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
  .reviewops-review-create-form-writing {
    position: fixed;
    left: 0;
    right: 0;
    top: var(--reviewops-viewport-offset-top, 0px);
    z-index: 70;
    height: var(--reviewops-viewport-height, 100vh);
    max-height: var(--reviewops-viewport-height, 100vh);
    border-bottom: 0;
    background: #ffffff;
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  }
  .reviewops-review-create-form-writing textarea[name=reviewBody] {
    min-height: 0;
    height: 100%;
  }
}`],
})
export class PageProjectsItemComponent implements OnInit, OnDestroy {
    public projectId: string = '';
    public adminMode: boolean = false;
    public project: any = null;
    public projectForm: any = {};
    public sshPublicKey: any = { available: false, auth_ready: false, public_key: '', public_key_path: '' };
    public sshPublicKeySettingsOpen: boolean = false;
    public sshAdvancedSettingsOpen: boolean = false;
    public sshKeyUpload: any = { privateFile: null, publicFile: null, passphrase: '' };
    public sshKeyUploading: boolean = false;
    public sshKeyDeleting: boolean = false;
    public groupForm: any = {};
    public groupOptions: any[] = [];
    public reviews: any[] = [];
    public loading: boolean = true;
    public saving: boolean = false;
    public reviewInfoExporting: boolean = false;
    public projectStats: any = null;
    public projectStatsLoading: boolean = false;
    public projectStatsError: string = '';
    public projectStatsLoadedFor: string = '';
    public projectDashboardStatsToken: string = '';
    private chartInstances: any = {};
    private chartRenderTimer: any = null;
    public deletingProject: boolean = false;
    public restoringProject: boolean = false;
    public projectDeleteConfirmName: string = '';
    public testingSshConnection: boolean = false;
    public testingCodexSettings: boolean = false;
    public testingCodexCustomEndpointId: string = '';
    public codexCustomEndpointKeyEditingId: string = '';
    public codexCustomEndpointKeyDraft: string = '';
    public loggingInCodex: boolean = false;
    public requestingCodexLogin: boolean = false;
    public codexLoginRequestFormOpen: boolean = false;
    public codexLoginRequestReason: string = '';
    public codexLoginPanelOpen: boolean = false;
    public codexDeviceAuth: any = null;
    public copiedCodexDeviceCode: string = '';
    public codexStatusPanelOpen: boolean = false;
    public codexUpgradeBusy: boolean = false;
    public wizSetupChecking: boolean = false;
    public wizSetupRunning: boolean = false;
    public wizSetupStatus: any = null;
    public wizSetupStatusPanelOpen: boolean = false;
    public fileBrowserLoading: boolean = false;
    public fileOpenLoading: boolean = false;
    public fileBrowser: any = { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
    public fileViewer: any = null;
    public fileError: string = '';
    public fileActionBusy: boolean = false;
    public fileUploadBusy: boolean = false;
    public fileRenamePath: string = '';
    public fileRenameValue: string = '';
    public fileDragPath: string = '';
    public fileUploadDropTarget: string = '';
    public uploadDropTarget: string = '';
    public fileContextMenu: any = { open: false, x: 0, y: 0, item: null };
    public fileDialog: any = { open: false, mode: '', title: '', message: '', action: '', actionBtn: 'primary', inputValue: '', item: null, busy: false, error: '' };
    public fileUploadProgress: any = { visible: false, mode: 'file', status: '', totalFiles: 0, completedFiles: 0, currentIndex: 0, currentFileName: '', currentPercent: 0, totalBytes: 0, uploadedBytes: 0, currentLoaded: 0, currentTotal: 0, error: '', renderedAt: 0 };
    public macroLoading: boolean = false;
    public macroSaving: boolean = false;
    public macroRunningId: string = '';
    public macroError: string = '';
    public macros: any[] = [];
    public macroEditorOpen: boolean = false;
    public macroEditingId: string = '';
    public macroForm: any = this.blankMacroForm();
    public macroRunResult: any = null;
    public macroRunContext: any = null;
    public macroLogCollapsed: boolean = false;
    private projectFileEditorOptionsCache: any = {
        readOnly: true,
        language: 'plaintext',
        automaticLayout: true,
        minimap: { enabled: false },
        lineNumbers: 'on',
        scrollBeyondLastLine: false,
        wordWrap: 'on',
        fontSize: 12,
        renderWhitespace: 'selection'
    };
    private macroEditorOptionsCache: any = {
        readOnly: false,
        language: 'shell',
        automaticLayout: true,
        minimap: { enabled: false },
        lineNumbers: 'on',
        scrollBeyondLastLine: false,
        wordWrap: 'on',
        fontSize: 12,
        renderWhitespace: 'selection'
    };
    public terminalStarting: boolean = false;
    public terminalReady: boolean = false;
    public terminalError: string = '';
    public terminalStatusMessage: string = '';
    private terminal: any = null;
    private terminalHostElement: any = null;
    private terminalFitAddon: any = null;
    private terminalWebLinksAddon: any = null;
    private terminalInputDisposable: any = null;
    private terminalResizeTimer: any = null;
    private terminalConnectTimer: any = null;
    public savingProjectAdmins: boolean = false;
    public projectAdminForm: any = { user_id: '' };
    public savingReview: boolean = false;
    public reviewListLoading: boolean = false;
    public tab: string = 'review';
    public mobileProjectPane: string = 'workspace';
    public mobileMainMenuOpen: boolean = false;
    public mobileMainMenuRect: any = null;
    public settingsSubTab: string = 'info';
    public showReviewForm: boolean = false;
    public reviewCreateFocusedControl: string = '';
    public sdkManualChecking: boolean = false;
    public sdkManualProbeCompleted: boolean = false;
    public sdkProbeCheckedAt: string = '';
    public sdkProbeResultMessage: string = '';
    public sdkProbeResultDetail: string = '';

    public presets: any[] = [
        { name: 'Desktop', width: 1440, height: 900 },
        { name: 'Laptop', width: 1280, height: 800 },
        { name: 'Tablet', width: 768, height: 1024 },
        { name: 'Mobile', width: 390, height: 844 },
        { name: 'Custom', width: 1440, height: 900 }
    ];
    public viewerModeOptions: any[] = [
        { value: 'browser', label: '브라우저', description: '탐색 헤더와 지정한 해상도를 함께 표시합니다.' },
        { value: 'fullscreen', label: '전체화면', description: '헤더 아래 캔버스를 빈 공간 없이 채웁니다.' }
    ];
    public htmlScaleOptions: any[] = [
        { value: 'fit', label: 'Fit' },
        { value: '50', label: '50%' },
        { value: '75', label: '75%' },
        { value: '100', label: '100%' },
        { value: '125', label: '125%' },
        { value: '150', label: '150%' },
        { value: '200', label: '200%' }
    ];
    public selectedPreset: string = 'Desktop';
    public viewport: any = { width: 1440, height: 900 };
    public scale: number = 1;
    public scaleMode: string = 'fit';
    public webViewerMode: string = 'browser';
    private webViewerBrowserState: any = null;
    private webViewerLayoutTimer: any = null;
    private webViewerResizeObserver: any = null;
    private webViewerObservedElement: HTMLElement | null = null;
    public frameUrl: string = '';
    public currentUrl: string = '';
    public previewLinkMode: string = 'qa';
    public frameTitle: string = '';
    public navigationLog: any[] = [];
    public inputLog: any[] = [];
    public networkLog: any[] = [];
    public consoleLog: any[] = [];
    public fingerprintLog: any[] = [];
    public logBufferLimits: any = { navigation: 140, input: 120, network: 180, console: 160, fingerprint: 80 };
    public evidenceLimits: any = { navigation: 40, input: 60, network: 90, networkImportant: 54, console: 100, fingerprint: 24 };
    public screenshotDataUrl: string = '';
    public screenshotFallbackDataUrl: string = '';
    public screenshotReceivedAt: number = 0;
    public screenshotErrorAt: number = 0;
    public screenshotInlinedResources: number = 0;
    public screenshotSkippedResources: number = 0;
    public domSnapshotInlineMaxBytes: number = 8 * 1024 * 1024;
    public captureMethod: string = 'capture-pending';
    public screenshotCaptureModeOptions: any[] = [
        { value: 'auto', label: '자동', icon: 'fa-solid fa-wand-magic-sparkles' },
        { value: 'browser-partial', label: 'Chrome 부분', icon: 'fa-solid fa-crop-simple' },
        { value: 'none', label: '캡처 안함', icon: 'fa-solid fa-ban' }
    ];
    public documentScreenshotCaptureModeOptions: any[] = [
        { value: 'browser-partial', label: '캡처함', icon: 'fa-solid fa-camera' },
        { value: 'none', label: '캡처 안함', icon: 'fa-solid fa-ban' }
    ];
    public fitScaleTimer: any = null;
    public frameUrlWatchTimer: any = null;
    public frameActionBusy: boolean = false;
    public frameHistoryEntries: string[] = [];
    public frameHistoryIndex: number = -1;
    private frameHistoryPending: any = null;
    private frameHistorySeq: number = 0;
    private frameHistoryLimit: number = 80;
    private reviewCreateFocusTimer?: number;
    private reviewCreateFocusScrollTimer?: number;
    public elementSelectActive: boolean = false;
    public selectedElementInfo: any = null;
    public elementSelectStatus: string = '';
    private sameOriginElementSelectCleanup: any = null;
    private sameOriginElementOverlay: any = null;
    public previewLogPanelOpen: boolean = false;
    public previewLogTab: string = 'all';
    public previewLogTabs: any[] = [
        { key: 'all', label: '전체' },
        { key: 'navigation', label: '네비게이션' },
        { key: 'input', label: '입력' },
        { key: 'network', label: '트래픽' },
        { key: 'console', label: '콘솔' },
        { key: 'fingerprint', label: '환경' }
    ];
    public sdkInstalled: boolean = false;
    public sdkStatus: string = 'checking';
    public sdkVersion: string = '';
    public sdkOrigin: string = '';
    public sdkLastMessageAt: string = '';
    public reviewOpsGuideModalOpen: boolean = false;
    public htmlDocumentStandardReady: boolean = false;
    public htmlDocumentStandardMessage: string = '';
    public sdkProbeTimer: any = null;
    public remotePollTimer: any = null;
    public remoteReady: boolean = false;
    public remoteLoading: boolean = false;
    public remoteActionBusy: boolean = false;
    public remoteError: string = '';
    public remoteAddress: string = '';
    public remoteScreenshotDataUrl: string = '';
    public remoteDisplayDataUrl: string = '';
    public remoteSnapshotId: string = '';
    public remoteNavigationLog: any[] = [];
    public remoteNetworkLog: any[] = [];
    public remoteConsoleLog: any[] = [];
    public remoteSocket: any = null;
    public remoteSocketConnected: boolean = false;
    public remoteSocketConnecting: boolean = false;
    public codexStatusSocket: any = null;
    public codexStatusSocketConnected: boolean = false;
    private codexStatusSocketReviewKey: string = '';
    public remoteRequestSeq: number = 0;
    public remoteRequests: any = {};
    public remoteRenderTimer: any = null;
    public remoteTextBuffer: string = '';
    public remoteTextFlushTimer: any = null;
    public remoteWheelBuffer: any = { delta_x: 0, delta_y: 0 };
    public remoteWheelFlushTimer: any = null;
    public remoteMouseMoveTimer: any = null;
    public remoteMouseMovePayload: any = null;
    public remoteMouseButtonDown: boolean = false;
    public remoteLastRightMouseAt: number = 0;
    public remoteSnapshotRefreshTimer: any = null;
    public codexFooterRefreshing: boolean = false;
    public codexFooterError: string = '';
    public reviewListSyncTimer: any = null;
    public reviewListSyncPaused: boolean = false;
    public reviewListAutoRefreshEnabled: boolean = false;
    public reviewListAutoRefreshTimer: any = null;
    public reviewListAutoRefreshBusy: boolean = false;
    public reviewListAutoRefreshIntervalMs: number = 30000;
    public remoteSurfaceFocused: boolean = false;
    public remoteFrameDrawSeq: number = 0;

    public reviewPanelWidth: number = 560;
    public reviewPanelMinWidth: number = 420;
    public reviewPanelMaxWidth: number = 900;
    public resizingReviewPanel: boolean = false;
    private reviewPanelResizePointerId: number | null = null;
    private reviewPanelResizeCaptureElement: any = null;
    private reviewPanelResizeContainerRect: any = null;
    public resizingViewport: boolean = false;
    public viewportResizeAxis: string = '';
    private viewportResizePointerId: number | null = null;
    private viewportResizeCaptureElement: any = null;
    private viewportResizeStart: any = null;
    private readonly viewportResizeMinWidth: number = 240;
    private readonly viewportResizeMinHeight: number = 240;
    private readonly viewportResizeMaxWidth: number = 7680;
    private readonly viewportResizeMaxHeight: number = 7680;
    private readonly customViewportSessionStoragePrefix: string = 'reviewops_custom_viewport:';
    private readonly customViewportSessionStorageVersion: number = 1;

    public language: string = 'ko';
    public selectedReview: any = null;
    public autoOpenedReviewId: string = '';
    public reviewDetailLoading: boolean = false;
    public screenshotPreviewUrl: string = '';
    public screenshotPreviewTitle: string = '';
    public reviewModalTab: string = 'info';
    public reviewLogTab: string = 'navigation';
    public editingReview: boolean = false;
    public savingReviewEdit: boolean = false;
    public reviewEditForm: any = {};
    public activityForm: any = { message: '', status: '', attachments: [] };
    public activityEditId: string = '';
    public activityEditForm: any = { message: '', attachments: [] };
    public savingActivityEdit: boolean = false;
    public sendingActivity: boolean = false;
    public activityAttachmentBusy: boolean = false;
    public activityEditAttachmentBusy: boolean = false;
    public activityAttachmentAccept: string = 'image/*,.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public activityAttachmentLimits: any = { files: 5, fileBytes: 500 * 1024 * 1024, totalBytes: 500 * 1024 * 1024 };
    public reviewAttachmentBusy: boolean = false;
    public selectedReviewAttachmentBusy: boolean = false;
    public reviewAttachmentAccept: string = 'image/*,.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public reviewAttachmentLimits: any = { files: 10, fileBytes: 500 * 1024 * 1024, totalBytes: 500 * 1024 * 1024 };
    public reviewAttachmentPreviewMaxBytes: number = 8 * 1024 * 1024;
    public reviewBodyMaxLength: number = 1000;
    public reviewFilters: any = { title: '', status: [], category: '', priority: '', author_user_id: '' };
    public reviewAuthorPicker: any = { query: '', open: false };
    public reviewSortField: string = '';
    public reviewSortOrder: string = '';
    public reviewAdvancedFiltersOpen: boolean = false;
    public mobileReviewFiltersOpen: boolean = false;
    public reviewPage: number = 1;
    public reviewPageSize: number = 20;
    public reviewTotalCount: number = 0;
    public reviewForm: any = this.blankReviewForm();
    public movingGroup: boolean = false;
    public groupMoveForm: any = { group_id: '', query: '', open: false };
    public introForm: any = { intro_html: '', intro_attachments: [] };
    public editingIntro: boolean = false;
    public savingIntro: boolean = false;
    public ckeditorLoading: boolean = false;
    public introFileBusy: boolean = false;
    public htmlDocumentFileBusy: any = { reference: false, resource: false };
    public uploadProgress: any = {};
    public uploadSettings: any = { policies: {} };
    public documentUploadAccept: string = 'application/pdf,.pdf';
    public htmlReferenceUploadAccept: string = '.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public htmlResourceUploadAccept: string = 'image/*,.svg,.pdf,.zip,.fig,.ai,.psd,.sketch';
    public projectFileUploadAccept: string = '';
    public htmlDocumentUploadLimits: any = { fileBytes: 500 * 1024 * 1024 };
    public introEditor: any = null;
    public introEditorMode: string = 'visual';
    public introUploadAccept: string = '.pdf,.txt,.md,.csv,.json,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
    public introUploadLimits: any = { fileBytes: 500 * 1024 * 1024, totalBytes: 500 * 1024 * 1024 };
    public introFrameUrl: string = '';
    private ckeditorLoader: any = null;
    private introFrameHtml: string = '';
    public selectedDocumentVersionId: string = '';
    public pdfPage: number = 1;
    public pdfScaleMode: string = 'fit';
    public pdfScale: number = 1;
    public pdfRenderedScale: number = 1;
    public pdfScaleMin: number = 0.25;
    public pdfScaleMax: number = 2.5;
    public pdfScaleOptions: any[] = [
        { value: 'fit', label: '맞춤' },
        { value: '0.25', label: '25%' },
        { value: '0.5', label: '50%' },
        { value: '0.75', label: '75%' },
        { value: '1', label: '100%' },
        { value: '1.25', label: '125%' },
        { value: '1.5', label: '150%' },
        { value: '2', label: '200%' },
        { value: '2.5', label: '250%' }
    ];
    public pdfFullscreen: boolean = false;
    public htmlFullscreen: boolean = false;
    public htmlFullscreenFallback: boolean = false;
    public htmlSnapshotBusy: boolean = false;
    public htmlSnapshotModalOpen: boolean = false;
    public htmlSnapshotForm: any = { label: '' };
    public selectedHtmlSnapshotId: string = '';
    public htmlSnapshotDropdownOpen: boolean = false;
    public htmlSnapshotQuery: string = '';
    public htmlSnapshotDeletingId: string = '';
    public htmlSnapshotRestoringId: string = '';
    public htmlShareModalOpen: boolean = false;
    public htmlShareSaving: boolean = false;
    public htmlDocumentState: any = { page: 1, page_count: 1, strategy: 'loading' };
    public htmlPdfExporting: boolean = false;
    public htmlPdfExportProgress: string = '';
    private htmlDocumentLoadSeq: number = 0;
    private htmlDocumentRestorePageAfterLoad: number = 0;
    public documentFileLoading: boolean = false;
    public pdfJsLoading: boolean = false;
    public pdfRendering: boolean = false;
    public pdfRenderError: string = '';
    public pdfCanvasWidth: number = 0;
    public pdfCanvasHeight: number = 0;
    public pdfPageImageUrl: string = '';
    public pdfRenderSeq: number = 0;
    public documentVersionBusy: boolean = false;
    public downloadingDocumentVersionId: string = '';
    public documentVersionForm: any = { document: null };
    public documentVersionPage: number = 1;
    public documentVersionPageSize: number = 5;
    private pdfjsLib: any = null;
    private pdfDocument: any = null;
    private pdfDocumentVersionId: string = '';
    private pdfRenderTimer: any = null;
    private pdfDomRetryTimer: any = null;
    private pdfLayoutObserver: any = null;
    private pdfLayoutObservedElement: any = null;
    private pdfLastLayoutKey: string = '';
    private pdfRenderTask: any = null;
    private pdfLastRenderedKey: string = '';
    private pdfRenderedCanvas: HTMLCanvasElement | null = null;
    private markdownConverter: any = null;
    private markdownHtmlCache: any = {};
    private markdownHtmlCacheKeys: string[] = [];
    private destroyed: boolean = false;
    private workspaceDetached: boolean = false;

    public projectTypeOptions: any[] = [
        { value: 'web_service', label: '웹서비스', description: 'URL 기반 화면 리뷰' },
        { value: 'pdf', label: 'PDF', description: 'PDF 파일 리뷰' },
        { value: 'html', label: 'HTML', description: 'HTML 화면 리뷰' }
    ];
    public visibilityOptions: any[] = [
        { value: 'private', label: '비공개', description: '구성원만 접근' },
        { value: 'public', label: '공개', description: '로그인 사용자 접근' }
    ];
    public projectStatusOptions: any[] = [
        { value: 'active', label: '활성', description: '리뷰 접수 가능' },
        { value: 'archived', label: '보관', description: '기록 중심 관리' },
        { value: 'disabled', label: '비활성', description: '접근 일시 중지' }
    ];
    public htmlLayoutPresetOptions: any[] = [
        { value: 'a4_portrait', label: 'A4 세로', width: 1240, height: 1754, render_mode: 'document' },
        { value: 'a4_landscape', label: 'A4 가로', width: 1754, height: 1240, render_mode: 'document' },
        { value: 'slide_16_9', label: '16:9', width: 1920, height: 1080, render_mode: 'document' },
        { value: 'slide_4_3', label: '4:3', width: 1024, height: 768, render_mode: 'document' },
        { value: 'web', label: '웹 해상도', width: 1440, height: 900, render_mode: 'web' },
        { value: 'custom', label: '직접 입력', width: 1440, height: 900, render_mode: 'web' }
    ];
    public htmlDocumentKindOptions: any[] = [
        { value: 'proposal', label: '제안서' },
        { value: 'proposal_presentation', label: '제안발표' },
        { value: 'lecture', label: '강의자료' },
        { value: 'report', label: '문서' },
        { value: 'custom', label: '직접 설정' }
    ];
    public statusOptions: string[] = ['open', 'in_progress', 'in_review', 'resolved', 'recheck', 'closed'];
    public priorityOptions: string[] = ['low', 'normal', 'high', 'critical'];
    public webCategoryOptions: string[] = ['bug', 'ux', 'design', 'content', 'performance', 'accessibility', 'security', 'other'];
    public documentCategoryOptions: string[] = ['content', 'structure', 'design', 'data', 'message', 'typo', 'other'];
    public categoryOptions: string[] = this.webCategoryOptions.slice();
    public dictionaries: any = {
        ko: {
            status: {
                open: '열림',
                in_progress: '진행',
                in_review: '검토',
                resolved: '해결',
                recheck: '재검토',
                closed: '닫힘'
            },
            statusDescription: {
                open: '새로 등록되어 확인이 필요한 리뷰입니다.',
                in_progress: '수정 또는 조치가 진행 중인 리뷰입니다.',
                in_review: '개발 내용 검토가 진행 중인 리뷰입니다.',
                resolved: '작업자 검토가 완료되어 작성자 확인이 필요한 리뷰입니다.',
                recheck: '작성자가 재검토를 요청한 리뷰입니다.',
                closed: '추가 조치 없이 종료된 리뷰입니다.'
            },
            priority: {
                low: '낮음',
                normal: '보통',
                high: '높음',
                critical: '긴급'
            },
            category: {
                bug: '버그',
                ux: '사용성',
                content: '콘텐츠',
                performance: '성능',
                accessibility: '접근성',
                security: '보안',
                structure: '구성',
                design: '설계',
                data: '데이터',
                message: '메시지',
                typo: '오탈자',
                other: '기타'
            },
            capture: {
                'capture-pending': '캡처 대기',
                'browser-capture-required': '브라우저 캡처 필요',
                'capture-unavailable-cross-origin': '교차 출처 제한으로 캡처 불가',
                'same-origin-dom-snapshot': '동일 출처 DOM 스냅샷',
                'postmessage-screenshot': '협조형 스크린샷 수신',
                'reviewops-sdk-dom-snapshot': 'ReviewOps SDK 스냅샷',
                'reviewops-sdk-screenshot-unavailable': 'ReviewOps SDK 캡처 불가',
                'remote-cdp-screencast': '원격 브라우저 스트림',
                'remote-cdp-screencast-unchanged': '원격 브라우저 스트림 대기',
                'browser-display-capture': '브라우저 화면 캡처',
                'browser-display-capture-crop': '브라우저 화면 캡처(iframe 영역)',
                'browser-display-capture-element': 'iframe 영역 캡처',
                'browser-capture-denied': '브라우저 화면 캡처 취소',
                'browser-capture-blank': '브라우저 화면 캡처 비어 있음',
                'browser-capture-unavailable': '브라우저 화면 캡처 미지원',
                'review-create-screenshot-skipped': '캡처 안함',
                'pdf-viewer': 'PDF 뷰어',
                not_available: '사용할 수 없음'
            }
        },
        en: {
            status: {
                open: 'Open',
                in_progress: 'In progress',
                in_review: 'In review',
                resolved: 'Resolved',
                recheck: 'Recheck',
                closed: 'Closed'
            },
            statusDescription: {
                open: 'New review waiting for inspection.',
                in_progress: 'Review is being handled.',
                in_review: 'Development review is in progress.',
                resolved: 'Worker review is complete and waiting for author confirmation.',
                recheck: 'Author requested another review pass.',
                closed: 'Review is closed without more action.'
            },
            priority: {
                low: 'Low',
                normal: 'Normal',
                high: 'High',
                critical: 'Critical'
            },
            category: {
                bug: 'Bug',
                ux: 'UX',
                content: 'Content',
                performance: 'Performance',
                accessibility: 'Accessibility',
                security: 'Security',
                structure: 'Structure',
                design: 'Design',
                data: 'Data',
                message: 'Message',
                typo: 'Typo',
                other: 'Other'
            },
            capture: {
                'capture-pending': 'Capture pending',
                'browser-capture-required': 'Browser capture required',
                'capture-unavailable-cross-origin': 'Unavailable by cross-origin policy',
                'same-origin-dom-snapshot': 'Same-origin DOM snapshot',
                'postmessage-screenshot': 'Cooperative screenshot',
                'reviewops-sdk-dom-snapshot': 'ReviewOps SDK snapshot',
                'reviewops-sdk-screenshot-unavailable': 'ReviewOps SDK capture unavailable',
                'remote-cdp-screencast': 'Remote browser stream',
                'remote-cdp-screencast-unchanged': 'Remote browser stream pending',
                'browser-display-capture': 'Browser display capture',
                'browser-display-capture-crop': 'Browser display capture (iframe area)',
                'browser-display-capture-element': 'Iframe area capture',
                'browser-capture-denied': 'Browser display capture canceled',
                'browser-capture-blank': 'Browser display capture blank',
                'browser-capture-unavailable': 'Browser display capture unavailable',
                'review-create-screenshot-skipped': 'Capture skipped',
                'pdf-viewer': 'PDF viewer',
                not_available: 'Not available'
            }
        }
    };

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router,@Inject( ElementRef)  private elementRef: ElementRef) {
        this.markdownConverter = new showdown.Converter({
            tables: true,
            tasklists: true,
            strikethrough: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            ghCodeBlocks: true,
            openLinksInNewWindow: true,
            backslashEscapesHTMLTags: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: false
        });
    }

    public async ngOnInit() {
        this.destroyed = false;
        await this.service.init();
        await this.service.auth.allow('/login');
        this.language = this.storedLanguage();
        this.adminMode = this.routeAdminMode();

        const route = (window as any).WizRoute || {};
        const segment = route.segment || {};
        this.projectId = segment.id || '';
        this.tab = this.normalizeProjectTab(segment.tab || '');
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.setHtmlFullscreenLock(false);
        this.finishViewportResize();
        this.finishReviewPanelResize();
        if (this.fitScaleTimer) window.clearTimeout(this.fitScaleTimer);
        this.clearWebViewerLayoutTimer();
        this.disconnectWebViewerResizeObserver();
        if (this.chartRenderTimer) window.clearTimeout(this.chartRenderTimer);
        if (this.frameUrlWatchTimer) window.clearInterval(this.frameUrlWatchTimer);
        this.deactivateElementSelect(false);
        if (this.sdkProbeTimer) window.clearTimeout(this.sdkProbeTimer);
        if (this.remotePollTimer) window.clearInterval(this.remotePollTimer);
        if (this.remoteRenderTimer) cancelAnimationFrame(this.remoteRenderTimer);
        if (this.remoteTextFlushTimer) window.clearTimeout(this.remoteTextFlushTimer);
        if (this.remoteWheelFlushTimer) window.clearTimeout(this.remoteWheelFlushTimer);
        if (this.remoteMouseMoveTimer) window.clearTimeout(this.remoteMouseMoveTimer);
        if (this.remoteSnapshotRefreshTimer) window.clearTimeout(this.remoteSnapshotRefreshTimer);
        if (this.reviewListSyncTimer) window.clearTimeout(this.reviewListSyncTimer);
        if (this.reviewListAutoRefreshTimer) window.clearTimeout(this.reviewListAutoRefreshTimer);
        if (this.reviewCreateFocusTimer) window.clearTimeout(this.reviewCreateFocusTimer);
        if (this.reviewCreateFocusScrollTimer) window.clearTimeout(this.reviewCreateFocusScrollTimer);
        if (this.terminalResizeTimer) window.clearTimeout(this.terminalResizeTimer);
        this.clearTerminalConnectTimer();
        if (this.pdfRenderTimer) window.clearTimeout(this.pdfRenderTimer);
        if (this.pdfDomRetryTimer) window.clearTimeout(this.pdfDomRetryTimer);
        this.cancelPdfRenderTask();
        this.disconnectPdfLayoutObserver();
        this.destroyIntroEditor();
        this.revokeIntroFrameUrl();
        this.disposePdfDocument();
        this.updateRemoteFrameDom('');
        this.stopProjectTerminal(false);
        this.disposeProjectTerminal();
        this.disconnectRemoteSocket();
        this.disconnectCodexStatusSocket();
        this.destroyCharts();
        document.title = 'SEASON::ReviewOps';
    }

    public reviewopsWorkspaceDetached() {
        if (this.isHtmlProject()) this.preserveHtmlDocumentFramePage('workspace-detach');
        this.workspaceDetached = true;
        this.clearReviewListSyncTimer();
        this.clearReviewListAutoRefreshTimer();
        this.disconnectCodexStatusSocket();
        if (this.sdkProbeTimer) {
            window.clearTimeout(this.sdkProbeTimer);
            this.sdkProbeTimer = null;
        }
        if (this.remoteSnapshotRefreshTimer) {
            window.clearTimeout(this.remoteSnapshotRefreshTimer);
            this.remoteSnapshotRefreshTimer = null;
        }
    }

    public reviewopsWorkspaceAttached() {
        const wasDetached = this.workspaceDetached;
        this.workspaceDetached = false;
        if (!wasDetached || this.destroyed) return;
        this.restoreWorkspaceViewerLayout();
        if (this.tab === 'review') this.syncCodexReviewStatusSocket(true);
        this.syncReviewListAutoRefresh();
        if (this.remoteReady) this.scheduleRemoteSnapshotRefresh(0, true);
        if (this.isWebServiceProject()) this.probeSdk(false);
        if (this.isHtmlProject()) {
            window.setTimeout(async () => {
                if (this.destroyed || this.workspaceDetached) return;
                if (this.ensureHtmlProjectFrameUrl('workspace-attach-url-guard')) {
                    await this.renderView();
                    return;
                }
                this.startFrameUrlWatcher();
                const restorePage = Math.max(Number(this.htmlDocumentRestorePageAfterLoad) || 0, 0);
                let readable = this.requestHtmlDocumentState(false);
                if (!readable) {
                    await this.service.sleep(320);
                    if (this.destroyed || this.workspaceDetached) return;
                    readable = this.requestHtmlDocumentState(false);
                }
                if (restorePage > 0 && readable && this.htmlDocumentPage() !== restorePage) {
                    await this.goToHtmlDocumentPage(restorePage, 'html-document-workspace-restore');
                    return;
                }
                await this.renderView();
            }, 80);
        }
    }

    public reviewopsWorkspaceVisibilityRestored() {
        this.workspaceDetached = false;
        if (this.destroyed) return;
        this.restoreWorkspaceViewerLayout();
    }

    private restoreWorkspaceViewerLayout() {
        this.scheduleFitScale();
        if (this.isDocumentProject()) this.queuePdfRender();
        if (this.tab === 'terminal') this.scheduleTerminalFit();
    }

    public async renderView() {
        if (this.destroyed) return;
        try {
            await this.service.render();
        } catch (e) { }
    }

    @HostListener('window:message', ['$event'])
    public receiveMessage(event: MessageEvent) {
        const data: any = event.data || {};
        if (!data || data.type !== 'wiz-review-event') return;

        const iframe = this.reviewFrame();
        if (iframe && iframe.contentWindow && event.source && event.source !== iframe.contentWindow) return;
        const htmlSdkMessage = this.isHtmlProject() && !!data.sdk;

        if (!this.isHtmlProject() && (data.sdk || data.event === 'ready' || data.event === 'sdk-ready')) {
            this.markSdkInstalled(data, event.origin);
        }
        if (!htmlSdkMessage && data.title !== undefined) {
            this.setFrameTitle(data.title, data.event || data.source || 'postMessage');
        }
        if (!htmlSdkMessage && data.event === 'navigation') {
            this.commitFrameHistoryNavigation(data.url || this.currentUrl, data.source || 'sdk-navigation');
        } else if (!htmlSdkMessage && data.url) {
            this.setCurrentUrl(data.url, data.event || 'postMessage', false);
        }
        if (data.event === 'input') {
            this.recordInput({
                field: data.field || 'unknown',
                value_length: data.value_length || 0,
                masked: true,
                at: new Date().toISOString(),
                source: data.source || 'postMessage'
            });
        }
        if (data.event === 'network') {
            this.recordNetwork(data.entry || data);
        }
        if (data.event === 'network-batch') {
            for (const entry of data.entries || []) this.recordNetwork(entry);
        }
        if (data.event === 'console') {
            this.recordConsole(data.entry || data);
        }
        if (data.event === 'console-batch') {
            for (const entry of data.entries || []) this.recordConsole(entry);
        }
        if (data.event === 'fingerprint') {
            this.recordFingerprint(Object.assign({}, data.entry || data, {
                source: data.source || 'postMessage',
                at: data.at || new Date().toISOString()
            }));
        }
        if (data.event === 'element-selected') {
            this.selectedElementInfo = data.element || data.entry || {};
            this.elementSelectStatus = this.selectedElementInfo.selector || this.selectedElementInfo.tag || 'element-selected';
            this.elementSelectActive = false;
            this.uninstallSameOriginElementSelector(true);
        }
        if (!htmlSdkMessage && data.event === 'screenshot' && (data.data_url || data.screenshot_data_url)) {
            this.screenshotDataUrl = data.data_url || data.screenshot_data_url;
            this.screenshotFallbackDataUrl = data.fallback_data_url || '';
            this.screenshotReceivedAt = Date.now();
            this.screenshotInlinedResources = Number(data.inlined_resources) || 0;
            this.screenshotSkippedResources = Number(data.skipped_resources) || 0;
            this.captureMethod = data.capture_method || 'postmessage-screenshot';
        }
        if (!htmlSdkMessage && data.event === 'screenshot-error') {
            this.screenshotErrorAt = Date.now();
            this.captureMethod = data.capture_method || 'reviewops-sdk-screenshot-unavailable';
        }
        this.service.render();
    }

    @HostListener('window:reviewops-language-change', ['$event'])
    public onReviewOpsLanguageChange(event: any) {
        const language = event && event.detail ? event.detail.language : this.storedLanguage();
        this.language = this.normalizeLanguage(language);
        this.service.render();
    }

    @HostListener('window:storage', ['$event'])
    public onStorage(event: StorageEvent) {
        if (event.key !== 'reviewops_language') return;
        this.language = this.storedLanguage();
        this.service.render();
    }

    @HostListener('window:resize')
    public onWindowResize() {
        this.scheduleFitScale();
        if (this.isDocumentProject()) this.queuePdfRender();
        if (this.tab === 'terminal') this.scheduleTerminalFit();
        if (this.groupMoveForm.open) this.service.render();
        if (this.htmlSnapshotDropdownOpen) this.service.render();
        if (this.mobileMainMenuOpen) {
            this.mobileMainMenuOpen = false;
            this.mobileMainMenuRect = null;
            this.service.render();
        }
        this.scheduleReviewCreateFocusedControlScroll();
    }

    @HostListener('document:fullscreenchange')
    @HostListener('document:webkitfullscreenchange')
    public async onDocumentFullscreenChange() {
        await this.syncPdfFullscreenState();
        await this.syncHtmlFullscreenState();
    }

    @HostListener('window:scroll')
    public onWindowScroll() {
        if (this.groupMoveForm.open) this.service.render();
        if (this.htmlSnapshotDropdownOpen) this.service.render();
        if (this.mobileMainMenuOpen) {
            this.mobileMainMenuOpen = false;
            this.mobileMainMenuRect = null;
            this.service.render();
        }
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent) {
        const target: any = event.target;
        if (this.mobileMainMenuOpen && !(target && target.closest && (target.closest('.reviewops-mobile-main-menu') || target.closest('.reviewops-mobile-main-menu-popover')))) {
            this.mobileMainMenuOpen = false;
            this.mobileMainMenuRect = null;
            this.service.render();
        }
        if (!this.fileContextMenu || !this.fileContextMenu.open) return;
        if (target && target.closest && target.closest('.project-file-context-menu')) return;
        this.closeProjectFileContextMenu();
    }

    @HostListener('document:mousemove', ['$event'])
    public onDocumentMouseMove(event: MouseEvent) {
        if (!this.resizingReviewPanel) return;
        if (event.buttons === 0) {
            this.finishReviewPanelResize(event);
            return;
        }
        event.preventDefault();
        this.resizeReviewPanel(event.clientX);
    }

    @HostListener('document:mouseup', ['$event'])
    public onDocumentMouseUp(event: MouseEvent) {
        if (this.resizingReviewPanel) {
            this.finishReviewPanelResize(event);
            return;
        }
        if (this.remoteMouseButtonDown && this.remoteReady && this.remoteDisplayDataUrl && this.remoteSurfaceFocused) {
            this.remoteMouseButtonDown = false;
            this.remoteCommand('remote_mouse', this.remoteMousePayload(event, 'up'), false, false);
        }
    }

    @HostListener('window:mouseup', ['$event'])
    public onWindowMouseUp(event: MouseEvent) {
        if (!this.resizingReviewPanel) return;
        this.finishReviewPanelResize(event);
    }

    @HostListener('document:pointermove', ['$event'])
    public onDocumentPointerMove(event: PointerEvent) {
        if (this.resizingViewport) {
            if (!this.isViewportResizePointer(event)) return;
            if (event.pointerType === 'mouse' && event.buttons === 0) {
                this.finishViewportResize(event);
                return;
            }
            event.preventDefault();
            this.resizeViewport(event.clientX, event.clientY);
            return;
        }
        if (!this.resizingReviewPanel || !this.isReviewPanelResizePointer(event)) return;
        if (event.pointerType === 'mouse' && event.buttons === 0) {
            this.finishReviewPanelResize(event);
            return;
        }
        event.preventDefault();
        this.resizeReviewPanel(event.clientX);
    }

    @HostListener('document:pointerup', ['$event'])
    @HostListener('document:pointercancel', ['$event'])
    @HostListener('window:pointerup', ['$event'])
    public onDocumentPointerRelease(event: PointerEvent) {
        if (this.resizingViewport) {
            if (!this.isViewportResizePointer(event)) return;
            this.finishViewportResize(event);
            return;
        }
        if (!this.resizingReviewPanel || !this.isReviewPanelResizePointer(event)) return;
        this.finishReviewPanelResize(event);
    }

    @HostListener('window:blur')
    public onWindowBlur() {
        this.finishViewportResize();
        this.finishReviewPanelResize();
    }

    @HostListener('document:visibilitychange')
    public onDocumentVisibilityChange() {
        if (document.hidden) {
            this.finishViewportResize();
            this.finishReviewPanelResize();
        }
    }

    @HostListener('document:keydown', ['$event'])
    public onDocumentKeyDown(event: KeyboardEvent) {
        if (this.fileContextMenu && this.fileContextMenu.open && event.key === 'Escape') {
            event.preventDefault();
            this.closeProjectFileContextMenu();
            return;
        }
        if (this.htmlSnapshotDropdownOpen && event.key === 'Escape') {
            event.preventDefault();
            this.closeHtmlSnapshotDropdown();
            return;
        }
        if (this.mobileMainMenuOpen && event.key === 'Escape') {
            event.preventDefault();
            this.mobileMainMenuOpen = false;
            this.mobileMainMenuRect = null;
            this.service.render();
            return;
        }
        if (this.htmlFallbackFullscreenActive() && event.key === 'Escape') {
            event.preventDefault();
            this.exitHtmlFullscreen().then(() => this.syncHtmlFullscreenState());
            return;
        }
        if (this.handlePdfKeyboardNavigation(event)) return;
        if (this.handleHtmlDocumentKeyboardNavigation(event)) return;
        if (!this.shouldCaptureRemoteKeyboard(event)) return;
        this.onRemoteKey(event);
    }

    @HostListener('document:touchmove', ['$event'])
    public onDocumentTouchMove(event: TouchEvent) {
        if (!this.resizingReviewPanel || !event.touches || event.touches.length === 0) return;
        event.preventDefault();
        this.resizeReviewPanel(event.touches[0].clientX);
    }

    @HostListener('document:touchend')
    @HostListener('document:touchcancel')
    public onDocumentTouchEnd() {
        this.finishReviewPanelResize();
    }

    public blankReviewForm() {
        return { title: '', body: '', priority: 'normal', category: 'ux', capture_mode: 'browser-partial', attachments: [] };
    }

    public reviewFormIncludesScreenshot(form: any = this.reviewForm) {
        return this.normalizeScreenshotCaptureMode(form && form.capture_mode) !== 'none';
    }

    public emptyReviewScreenshotCapture(captureMethod: string = 'review-create-screenshot-skipped') {
        return {
            screenshot_asset_id: '',
            screenshot_data_url: '',
            capture_method: captureMethod
        };
    }

    public reviewCreateCaptureLabel() {
        if (!this.reviewFormIncludesScreenshot()) return this.captureLabel('review-create-screenshot-skipped');
        return this.captureLabel(this.captureMethod);
    }

    public normalizeScreenshotCaptureMode(mode: any) {
        const value = String(mode || '').trim();
        return value === 'auto' || value === 'none' ? value : 'browser-partial';
    }

    public reviewScreenshotCaptureModeOptions() {
        return this.isDocumentProject() ? this.documentScreenshotCaptureModeOptions : this.screenshotCaptureModeOptions;
    }

    public screenshotCaptureModeLabel(mode: any) {
        const value = this.normalizeScreenshotCaptureMode(mode);
        const option = this.reviewScreenshotCaptureModeOptions().find((item) => item.value === value);
        return option ? option.label : value;
    }

    public screenshotCaptureModeButtonClass(selected: any, value: string) {
        const base = 'inline-flex h-8 items-center justify-center gap-1.5 rounded-md border px-2 text-[11px] font-semibold transition-colors ';
        if (this.normalizeScreenshotCaptureMode(selected) === value) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public textLength(value: any) {
        return String(value || '').length;
    }

    public reviewBodyLength(form: any = this.reviewForm) {
        return this.textLength(form && form.body);
    }

    public reviewBodyCounterClass(form: any = this.reviewForm) {
        const length = this.reviewBodyLength(form);
        const base = 'text-[11px] font-medium ';
        if (length > this.reviewBodyMaxLength) return base + 'text-rose-600';
        if (length > this.reviewBodyMaxLength * 0.9) return base + 'text-amber-600';
        return base + 'text-slate-400';
    }

    public reviewBodyLimitMessage(form: any = this.reviewForm) {
        return `${this.reviewBodyLength(form)}/${this.reviewBodyMaxLength}`;
    }

    public canSubmitReview() {
        return !!(
            !this.savingReview &&
            !this.reviewAttachmentBusy &&
            String(this.reviewForm.title || '').trim() &&
            this.reviewBodyLength(this.reviewForm) <= this.reviewBodyMaxLength
        );
    }

    public preventReviewCreateSubmit(event?: any) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        return false;
    }

    public reviewCreateWritingMode() {
        return !!(this.showReviewForm && !this.isDesktopLayout() && this.reviewCreateFocusedControl === 'body');
    }

    public reviewCreateFormClass() {
        const base = 'reviewops-review-create-form min-h-0 flex-1 overflow-x-hidden border-b border-slate-200 p-3 lg:p-4 ';
        if (this.reviewCreateWritingMode()) return base + 'reviewops-review-create-form-writing flex flex-col overflow-hidden';
        return base + 'overflow-y-auto';
    }

    public reviewCreateBodyLabelClass() {
        return this.reviewCreateWritingMode()
            ? 'mt-3 flex min-h-0 flex-1 flex-col'
            : 'mt-3 block';
    }

    public reviewCreateBodyTextareaClass() {
        const base = 'mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-[13px] leading-5 outline-none focus:border-slate-500 ';
        if (this.reviewCreateWritingMode()) return base + 'min-h-0 flex-1 resize-none';
        return base;
    }

    public reviewCreateBodyRows() {
        return this.reviewCreateWritingMode() ? 12 : 4;
    }

    private reviewCreateFocusField(target: any) {
        if (!target || !target.closest || !target.closest('.reviewops-review-create-form')) return '';
        const tag = String(target.tagName || '').toLowerCase();
        if (!['input', 'textarea', 'select'].includes(tag)) return '';
        const name = String(target.getAttribute('name') || '');
        if (name === 'reviewBody') return 'body';
        if (name === 'reviewTitle') return 'title';
        return 'option';
    }

    public async onReviewCreateFormFocusIn(event: any) {
        if (!this.showReviewForm || this.isDesktopLayout()) return;
        const field = this.reviewCreateFocusField(event && event.target);
        if (!field) return;
        if (this.reviewCreateFocusTimer) window.clearTimeout(this.reviewCreateFocusTimer);
        this.reviewCreateFocusedControl = field;
        await this.service.render();
        this.scheduleReviewCreateFocusedControlScroll(event && event.target);
    }

    public onReviewCreateFormFocusOut(_event: any) {
        if (!this.reviewCreateFocusedControl) return;
        if (this.reviewCreateFocusTimer) window.clearTimeout(this.reviewCreateFocusTimer);
        this.reviewCreateFocusTimer = window.setTimeout(() => {
            const field = this.reviewCreateFocusField(document.activeElement);
            this.reviewCreateFocusedControl = field || '';
            this.service.render();
        }, 160);
    }

    private scheduleReviewCreateFocusedControlScroll(target?: any) {
        if (!this.reviewCreateWritingMode()) return;
        const control = target || document.querySelector('.reviewops-review-create-form textarea[name="reviewBody"]');
        if (!control || !control.scrollIntoView) return;
        if (this.reviewCreateFocusScrollTimer) window.clearTimeout(this.reviewCreateFocusScrollTimer);
        this.reviewCreateFocusScrollTimer = window.setTimeout(() => {
            if (!this.reviewCreateWritingMode()) return;
            try {
                control.scrollIntoView({ block: 'center', inline: 'nearest' });
            } catch (e) {
                control.scrollIntoView(false);
            }
        }, 90);
    }

    private clearReviewCreateFocusMode() {
        if (this.reviewCreateFocusTimer) window.clearTimeout(this.reviewCreateFocusTimer);
        if (this.reviewCreateFocusScrollTimer) window.clearTimeout(this.reviewCreateFocusScrollTimer);
        this.reviewCreateFocusedControl = '';
    }

    public async exitReviewCreateWritingMode() {
        const active: any = document.activeElement;
        if (active && active.blur) active.blur();
        this.clearReviewCreateFocusMode();
        await this.service.render();
    }

    public blankMacroForm() {
        return {
            id: '',
            name: '',
            description: '',
            working_dir: '',
            script: '#!/usr/bin/env bash\nset -e\n\n',
            timeout_seconds: 600,
            sort_order: 0,
            status: 'active'
        };
    }

    public normalizeLanguage(language: string) {
        return ['ko', 'en'].includes(language) ? language : 'ko';
    }

    public storedLanguage() {
        try {
            return this.normalizeLanguage(localStorage.getItem('reviewops_language') || 'ko');
        } catch (e) {
            return 'ko';
        }
    }

    public routeAdminMode() {
        try {
            return new URLSearchParams(window.location.search).get('admin') === '1';
        } catch (e) {
            return false;
        }
    }

    public routeReviewId() {
        try {
            return new URLSearchParams(window.location.search).get('review_id') || '';
        } catch (e) {
            return '';
        }
    }

    public requestParams(params: any = {}) {
        const query: any = Object.assign({}, params || {});
        if (this.adminMode) query.admin = '1';
        return query;
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('load', this.requestParams({
            id: this.projectId,
            title: this.reviewFilters.title,
            statuses: this.reviewStatusFilterParam(),
            category: this.reviewFilters.category,
            priority: this.reviewFilters.priority,
            author_user_id: this.reviewFilters.author_user_id,
            sort: this.reviewSortField,
            sort_order: this.reviewSortOrder,
            page: this.reviewPage,
            page_size: this.reviewPageSize
        }));
        if (code === 200) {
            this.project = data.project;
            this.projectDashboardStatsToken = data.dashboard_stats_token || '';
            this.codexFooterError = '';
            this.sshPublicKey = data.ssh_public_key || { available: false, auth_ready: false, public_key: '', public_key_path: '' };
            this.groupOptions = data.group_options || [];
            this.syncReviewAuthorFilterOptions();
            this.applyReviewPageData(data);
            this.updateDocumentTitle();
            this.projectForm = this.projectFormPayload(this.project);
            this.projectAdminForm = { user_id: '' };
            this.groupForm = this.groupFormPayload(this.project && this.project.group ? this.project.group : {});
            this.syncGroupMoveForm();
            this.introForm = {
                intro_html: this.project.intro_html || '',
                intro_attachments: this.cloneIntroAttachments(this.project.intro_attachments)
            };
            this.syncCategoryOptions();
            this.ensureDocumentVersionSelection(true);
            this.ensureHtmlSnapshotSelection();
            this.ensureSettingsSubTab();
            const tabs = this.availableProjectTabs();
            if (this.tab && !tabs.includes(this.tab)) this.tab = '';
            if (!this.tab) this.tab = this.canEditSettings() ? 'settings' : 'review';
            await this.syncTabUrl(false);
            if (this.tab === 'review') this.syncCodexReviewStatusSocket(true);
            else this.leaveCodexReviewStatusSocket();
            this.setupViewport();
        }

        this.loading = false;
        await this.service.render();
        if (this.isDashboardTab()) await this.loadProjectDashboardStats();
        if (this.tab === 'file' && this.canUseProjectFiles()) await this.loadProjectFiles(this.fileBrowser.path || '');
        if (this.tab === 'macro' && this.canUseProjectMacros()) await this.loadProjectMacros();
        if (this.tab === 'terminal' && this.canUseProjectTerminal()) this.scheduleTerminalFit();
        this.scheduleFitScale();
        await this.openRouteReviewDetail();
        this.syncReviewListAutoRefresh();
        if (this.isDocumentProject()) await this.preparePdfViewer(true);
        if (this.isWebServiceProject()) this.probeSdk(false);
    }

    public async loadReviews(options: any = {}) {
        const silent = !!(options && options.silent);
        const pauseForReviewModal = !!(options && options.pauseForReviewModal);
        if (pauseForReviewModal && this.isReviewDetailOpen()) return;
        if (!silent) {
            this.reviewListLoading = true;
            this.reviews = [];
        }
        this.ensureReviewPage();
        if (!silent) await this.service.render();

        const { code, data } = await wiz.call('load_reviews', this.requestParams({
            id: this.projectId,
            title: this.reviewFilters.title,
            statuses: this.reviewStatusFilterParam(),
            category: this.reviewFilters.category,
            priority: this.reviewFilters.priority,
            author_user_id: this.reviewFilters.author_user_id,
            sort: this.reviewSortField,
            sort_order: this.reviewSortOrder,
            page: this.reviewPage,
            page_size: this.reviewPageSize
        }));
        if (code === 200) {
            if (pauseForReviewModal && this.isReviewDetailOpen()) {
                if (!silent) this.reviewListLoading = false;
                return;
            }
            this.applyReviewPageData(data);
            if (!options || options.syncStatus !== false) this.syncCodexReviewStatusSocket();
        }
        if (!silent) this.reviewListLoading = false;
        await this.service.render();
        if (!silent) this.syncReviewListAutoRefresh();
    }

    public async refreshReviewList() {
        if (this.reviewListLoading) return;
        await this.loadReviews();
    }

    public async loadProjectDashboardStats(force: boolean = false) {
        if (!this.projectId || this.projectStatsLoading) return;
        if (!force && this.projectStats && this.projectStatsLoadedFor === this.projectId) {
            this.scheduleChartRender();
            return;
        }
        this.projectStatsLoading = true;
        this.projectStatsError = '';
        await this.service.render();

        try {
            let { code, data } = await this.requestProjectDashboardStats();
            if (code !== 200 && (Number(code) === 0 || Number(code) === 401)) {
                await new Promise((resolve) => window.setTimeout(resolve, 250));
                const retry = await this.requestProjectDashboardStats();
                code = retry.code;
                data = retry.data;
            }

            if (code === 200 && data && data.stats) {
                this.projectStats = data.stats || null;
                this.projectStatsLoadedFor = this.projectId;
                this.projectStatsError = '';
            } else {
                this.projectStats = null;
                this.projectStatsLoadedFor = '';
                this.projectStatsError = this.projectDashboardStatsErrorMessage(code, data);
            }
        } catch (e) {
            this.projectStats = null;
            this.projectStatsLoadedFor = '';
            this.projectStatsError = '프로젝트 통계를 불러오지 못했습니다.';
        }
        this.projectStatsLoading = false;
        await this.service.render();
        this.scheduleChartRender();
    }

    private async requestProjectDashboardStats() {
        if (this.projectDashboardStatsToken) {
            try {
                const params = new URLSearchParams({ token: this.projectDashboardStatsToken });
                if (this.adminMode) params.set('admin', '1');
                const response = await fetch(`/api/projects/${encodeURIComponent(this.projectId)}/dashboard-stats?${params.toString()}`, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { Accept: 'application/json' }
                });
                const payload = await response.json();
                if (payload && Number(payload.code) !== 401) return payload;
            } catch (e) { }
        }
        return await wiz.call('load_project_dashboard_stats', this.requestParams({ id: this.projectId }));
    }

    private projectDashboardStatsErrorMessage(code: any, data: any) {
        const message = String((data && data.message) || '').trim();
        if (message) return message;
        if (Number(code) === 401) return '로그인 세션을 확인한 뒤 다시 시도해주세요.';
        return '프로젝트 통계를 불러오지 못했습니다.';
    }

    public async refreshProjectDashboardStats() {
        await this.loadProjectDashboardStats(true);
    }

    public invalidateProjectDashboardStats() {
        this.projectStatsLoadedFor = '';
    }

    private scheduleChartRender() {
        if (this.chartRenderTimer) window.clearTimeout(this.chartRenderTimer);
        this.chartRenderTimer = window.setTimeout(() => {
            this.chartRenderTimer = null;
            this.renderCharts();
        }, 0);
    }

    private destroyCharts(scope: string = '') {
        Object.keys(this.chartInstances).forEach((key: string) => {
            if (scope && !key.startsWith(scope)) return;
            try {
                this.chartInstances[key].destroy();
            } catch (e) { }
            delete this.chartInstances[key];
        });
    }

    private chartCanvas(id: string) {
        if (typeof document === 'undefined') return null;
        return document.getElementById(id) as HTMLCanvasElement | null;
    }

    private renderCharts() {
        if (!this.isDashboardTab() || this.projectStatsLoading || !this.projectStats || (!this.isDesktopLayout() && this.mobileProjectPane === 'workspace')) {
            this.destroyCharts('dashboard');
            return;
        }
        this.renderDashboardStatusChart();
        this.renderDashboardDailyChart();
        this.renderDashboardCodexChart();
    }

    private chartColor(hex: string, alpha: number) {
        const value = String(hex || '').replace('#', '');
        if (value.length !== 6) return `rgba(15, 23, 42, ${alpha})`;
        const r = parseInt(value.slice(0, 2), 16);
        const g = parseInt(value.slice(2, 4), 16);
        const b = parseInt(value.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    private chartCount(value: any) {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? Math.max(0, numberValue) : 0;
    }

    private renderDashboardStatusChart() {
        const canvas = this.chartCanvas('projectDashboardStatusChart');
        const rows = this.dashboardStatusRows().filter((row: any) => this.chartCount(row.count) > 0);
        if (!canvas || !rows.length) {
            this.destroyCharts('dashboardStatus');
            return;
        }
        const colors = ['#0f766e', '#2563eb', '#7c3aed', '#f59e0b', '#dc2626', '#64748b', '#0f172a'];
        this.destroyCharts('dashboardStatus');
        this.chartInstances.dashboardStatus = new Chart(canvas, {
            type: 'doughnut',
            data: {
                labels: rows.map((row: any) => this.statusLabel(row.key)),
                datasets: [{
                    data: rows.map((row: any) => this.chartCount(row.count)),
                    backgroundColor: rows.map((_row: any, index: number) => this.chartColor(colors[index % colors.length], 0.82)),
                    borderColor: '#ffffff',
                    borderWidth: 2,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '62%',
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: { boxWidth: 10, boxHeight: 10, color: '#334155', font: { size: 11, weight: '600' } },
                    },
                    tooltip: {
                        callbacks: {
                            label: (item: any) => `${item.label}: ${this.dashboardCount(item.raw)}건`,
                        },
                    },
                },
            },
        });
    }

    private renderDashboardDailyChart() {
        const canvas = this.chartCanvas('projectDashboardDailyChart');
        const rows = this.dashboardTrendRows();
        if (!canvas || !rows.length) {
            this.destroyCharts('dashboardDaily');
            return;
        }
        const pointRadius = rows.length > 30 ? 0 : 2.5;
        this.destroyCharts('dashboardDaily');
        this.chartInstances.dashboardDaily = new Chart(canvas, {
            type: 'line',
            data: {
                labels: rows.map((item: any) => item.label || this.dashboardDateLabel(item.date)),
                datasets: [
                    {
                        label: '리뷰 등록',
                        data: rows.map((item: any) => this.chartCount(item.reviews)),
                        borderColor: '#2563eb',
                        backgroundColor: this.chartColor('#2563eb', 0.1),
                        borderWidth: 2,
                        pointRadius: pointRadius,
                        tension: 0.32,
                        fill: true,
                    },
                    {
                        label: '작업이력',
                        data: rows.map((item: any) => this.chartCount(item.activities)),
                        borderColor: '#0f766e',
                        backgroundColor: this.chartColor('#0f766e', 0.08),
                        borderWidth: 2,
                        pointRadius: pointRadius,
                        tension: 0.32,
                        fill: true,
                    },
                    {
                        label: '에이전트',
                        data: rows.map((item: any) => this.chartCount(item.codex)),
                        borderColor: '#7c3aed',
                        backgroundColor: this.chartColor('#7c3aed', 0.08),
                        borderWidth: 2,
                        pointRadius: pointRadius,
                        tension: 0.32,
                        fill: true,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: {
                        position: 'top',
                        labels: { boxWidth: 10, boxHeight: 10, color: '#334155', font: { size: 11, weight: '600' } },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                const row = rows[index] || {};
                                return row.period_label || row.label || row.date || '';
                            },
                        },
                    },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: '#64748b', font: { size: 11, weight: '600' }, maxRotation: 0 } },
                    y: { beginAtZero: true, ticks: { precision: 0, color: '#64748b', font: { size: 11, weight: '600' } }, grid: { color: 'rgba(148, 163, 184, 0.18)' } },
                },
            },
        });
    }

    private renderDashboardCodexChart() {
        const canvas = this.chartCanvas('projectDashboardCodexChart');
        const rows = this.dashboardCodexReviewRows().slice(0, 8);
        if (!canvas || !rows.length) {
            this.destroyCharts('dashboardCodex');
            return;
        }
        this.destroyCharts('dashboardCodex');
        this.chartInstances.dashboardCodex = new Chart(canvas, {
            type: 'bar',
            data: {
                labels: rows.map((item: any) => this.dashboardShortTitle(item.title || item.review_id)),
                datasets: [{
                    label: '리뷰 당 에이전트 사용',
                    data: rows.map((item: any) => this.chartCount(item.count)),
                    backgroundColor: this.chartColor('#7c3aed', 0.72),
                    borderColor: '#6d28d9',
                    borderWidth: 1,
                    borderRadius: 6,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                return rows[index] ? rows[index].title || rows[index].review_id : '';
                            },
                            label: (item: any) => `${this.dashboardCount(item.raw)}회`,
                        },
                    },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: '#64748b', font: { size: 10, weight: '600' }, maxRotation: 0 } },
                    y: { beginAtZero: true, ticks: { precision: 0, color: '#64748b', font: { size: 11, weight: '600' } }, grid: { color: 'rgba(148, 163, 184, 0.18)' } },
                },
            },
        });
    }

    public dashboardStatsReady() {
        return !!(this.projectStats && !this.projectStatsLoading && !this.projectStatsError);
    }

    public dashboardCount(value: any) {
        const numberValue = Number(value) || 0;
        return Math.round(numberValue).toLocaleString('ko-KR');
    }

    public dashboardPercent(value: any) {
        const numberValue = Number(value);
        if (!Number.isFinite(numberValue)) return '0%';
        return `${Math.round(numberValue * 10) / 10}%`;
    }

    public dashboardPercentValue(value: any) {
        const numberValue = Number(value);
        if (!Number.isFinite(numberValue)) return 0;
        return Math.max(0, Math.min(100, numberValue));
    }

    public dashboardDuration(seconds: any) {
        const value = Math.max(Number(seconds) || 0, 0);
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const remainSeconds = Math.floor(value % 60);
        if (hours > 0) return `${hours}시간 ${minutes}분`;
        if (minutes > 0) return `${minutes}분 ${remainSeconds}초`;
        return `${remainSeconds}초`;
    }

    public dashboardDateLabel(date: any) {
        const text = String(date || '');
        return text.length >= 10 ? text.slice(5, 10).replace('-', '.') : text || '-';
    }

    private dashboardFullDateLabel(date: any) {
        const text = String(date || '');
        return text.length >= 10 ? text.slice(0, 10).replace(/-/g, '.') : text || '-';
    }

    private dashboardDateFromKey(date: any) {
        const match = String(date || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) return null;
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    }

    private dashboardDateKeyFromDate(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private dashboardMonthKeyFromDate(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    }

    private dashboardTrendScaleKey(rows: any[] = this.dashboardDailyRows()) {
        const dates = (rows || [])
            .map((row: any) => this.dashboardDateFromKey(row && row.date))
            .filter((date: any) => !!date)
            .sort((a: Date, b: Date) => a.getTime() - b.getTime());
        if (dates.length < 2) return 'day';
        const spanDays = Math.floor((dates[dates.length - 1].getTime() - dates[0].getTime()) / 86400000) + 1;
        if (spanDays >= 365) return 'month';
        if (spanDays >= 60) return 'week';
        return 'day';
    }

    public dashboardTrendScaleLabel() {
        const scale = this.dashboardTrendScaleKey();
        if (scale === 'month') return '월간';
        if (scale === 'week') return '주간';
        return '일간';
    }

    private dashboardTrendBucketInfo(dateValue: any, scale: string) {
        const date = this.dashboardDateFromKey(dateValue);
        if (!date) return null;
        if (scale === 'month') {
            const key = this.dashboardMonthKeyFromDate(date);
            const start = `${key}-01`;
            return {
                key: key,
                date: start,
                label: key.replace('-', '.'),
                period_label: `${key.replace('-', '.')}월`,
                period_start: start,
                period_end: '',
            };
        }
        if (scale === 'week') {
            const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const day = start.getDay();
            start.setDate(start.getDate() + (day === 0 ? -6 : 1 - day));
            const end = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            end.setDate(start.getDate() + 6);
            const startKey = this.dashboardDateKeyFromDate(start);
            const endKey = this.dashboardDateKeyFromDate(end);
            return {
                key: startKey,
                date: startKey,
                label: `${this.dashboardFullDateLabel(startKey)}주`,
                period_label: `${this.dashboardFullDateLabel(startKey)} ~ ${this.dashboardFullDateLabel(endKey)}`,
                period_start: startKey,
                period_end: endKey,
            };
        }
        const key = String(dateValue || '').slice(0, 10);
        return {
            key: key,
            date: key,
            label: this.dashboardDateLabel(key),
            period_label: this.dashboardFullDateLabel(key),
            period_start: key,
            period_end: key,
        };
    }

    public dashboardGeneratedAtText() {
        return this.projectStats && this.projectStats.generated_at ? this.kstDateTime(this.projectStats.generated_at) : '-';
    }

    public dashboardStatusRows() {
        return this.projectStats && Array.isArray(this.projectStats.status_counts) ? this.projectStats.status_counts : [];
    }

    public dashboardPriorityRows() {
        return this.projectStats && Array.isArray(this.projectStats.priority_counts) ? this.projectStats.priority_counts : [];
    }

    public dashboardCategoryRows() {
        return this.projectStats && Array.isArray(this.projectStats.category_counts) ? this.projectStats.category_counts : [];
    }

    public dashboardActivityStatusRows() {
        const activity = this.projectStats && this.projectStats.activity ? this.projectStats.activity : {};
        return Array.isArray(activity.status_counts) ? activity.status_counts : [];
    }

    public dashboardDailyRows() {
        return this.projectStats && Array.isArray(this.projectStats.daily) ? this.projectStats.daily : [];
    }

    public dashboardTrendRows() {
        const rows = this.dashboardDailyRows();
        const scale = this.dashboardTrendScaleKey(rows);
        const buckets: any = {};
        rows.forEach((row: any) => {
            const info = this.dashboardTrendBucketInfo(row && row.date, scale);
            if (!info) return;
            if (!buckets[info.key]) {
                buckets[info.key] = {
                    key: info.key,
                    date: info.date,
                    label: info.label,
                    period_label: info.period_label,
                    period_start: info.period_start,
                    period_end: info.period_end,
                    reviews: 0,
                    activities: 0,
                    codex: 0,
                    codex_duration_seconds: 0,
                };
            }
            buckets[info.key].reviews += this.chartCount(row && row.reviews);
            buckets[info.key].activities += this.chartCount(row && row.activities);
            buckets[info.key].codex += this.chartCount(row && row.codex);
            buckets[info.key].codex_duration_seconds += this.chartCount(row && row.codex_duration_seconds);
        });
        return Object.keys(buckets).sort().map((key: string) => buckets[key]);
    }

    public dashboardRecentDailyRows() {
        return this.dashboardDailyRows().slice(-10).reverse();
    }

    public dashboardCodexReviewRows() {
        const codex = this.projectStats && this.projectStats.codex ? this.projectStats.codex : {};
        return Array.isArray(codex.review_rows) ? codex.review_rows : [];
    }

    public dashboardResponseRows() {
        const response = this.projectStats && this.projectStats.response ? this.projectStats.response : {};
        return Array.isArray(response.rows) ? response.rows : [];
    }

    public dashboardTopResponseRows() {
        return this.dashboardResponseRows().slice(0, 5);
    }

    public dashboardCodexRequesterRows() {
        const codex = this.projectStats && this.projectStats.codex ? this.projectStats.codex : {};
        return Array.isArray(codex.requester_counts) ? codex.requester_counts : [];
    }

    public dashboardMetricCards() {
        const stats = this.projectStats || {};
        const codex = stats.codex || {};
        const activity = stats.activity || {};
        const response = stats.response || {};
        return [
            {
                label: '전체 리뷰',
                value: this.dashboardCount(stats.review_total),
                sub: `진행 ${this.dashboardCount(stats.active_review_count)} · 완료 ${this.dashboardCount(stats.done_review_count)}`,
                icon: 'fa-regular fa-comments',
            },
            {
                label: '작업이력',
                value: this.dashboardCount(activity.total_count),
                sub: `리뷰당 ${activity.avg_per_review || 0}건`,
                icon: 'fa-solid fa-list-check',
            },
            {
                label: '에이전트 사용',
                value: `${this.dashboardCount(codex.total_count)}회`,
                sub: `총 ${this.dashboardDuration(codex.total_duration_seconds)} · 리뷰당 ${codex.avg_per_review || 0}회`,
                icon: 'fa-solid fa-code',
            },
            {
                label: '초기 대응',
                value: this.dashboardDuration(response.median_seconds),
                sub: `중앙값 · 응답 ${this.dashboardCount(response.answered_count)} · 미응답 ${this.dashboardCount(response.pending_count)}`,
                icon: 'fa-regular fa-clock',
            },
        ];
    }

    public dashboardResponseMetricRows() {
        const response = this.projectStats && this.projectStats.response ? this.projectStats.response : {};
        return [
            { label: '중앙값', value: this.dashboardDuration(response.median_seconds) },
            { label: '평균', value: this.dashboardDuration(response.avg_seconds) },
            { label: '최단', value: this.dashboardDuration(response.min_seconds) },
            { label: '최장', value: this.dashboardDuration(response.max_seconds) },
        ];
    }

    public dashboardCodexMetricRows() {
        const codex = this.projectStats && this.projectStats.codex ? this.projectStats.codex : {};
        return [
            { label: '에이전트 응답', value: `${this.dashboardCount(codex.total_count)}회` },
            { label: '사용 리뷰', value: `${this.dashboardCount(codex.review_count)}건` },
            { label: '총 사용시간', value: this.dashboardDuration(codex.total_duration_seconds) },
            { label: '평균 사용시간', value: this.dashboardDuration(codex.avg_duration_seconds) },
            { label: '오류 응답', value: `${this.dashboardCount(codex.error_count)}회` },
        ];
    }

    public dashboardQuality() {
        return this.projectStats && this.projectStats.quality ? this.projectStats.quality : {};
    }

    public dashboardQualityIndicators() {
        const quality = this.dashboardQuality();
        return Array.isArray(quality.indicators) ? quality.indicators : [];
    }

    public dashboardQualityIndicatorMeta(item: any) {
        if (item && item.key === 'codex_effort') return `요청당 중앙값 ${this.dashboardDuration(item.value_seconds)}`;
        return `평균 ${item && item.value ? item.value : '0 words'} · 낮음 ${this.dashboardCount(item && item.low_count)}`;
    }

    public dashboardQualityScore(value: any) {
        const score = Number(value);
        if (!Number.isFinite(score)) return 0;
        return Math.max(0, Math.min(100, Math.round(score)));
    }

    public dashboardQualityBarClass(score: any) {
        const value = this.dashboardQualityScore(score);
        if (value >= 75) return 'h-full rounded-full bg-emerald-600';
        if (value >= 55) return 'h-full rounded-full bg-amber-500';
        return 'h-full rounded-full bg-rose-500';
    }

    public dashboardQualityTextClass(score: any) {
        const value = this.dashboardQualityScore(score);
        if (value >= 75) return 'text-emerald-700';
        if (value >= 55) return 'text-amber-700';
        return 'text-rose-700';
    }

    public dashboardQualitySummary(key: string) {
        const quality = this.dashboardQuality();
        return quality && quality[key] ? quality[key] : {};
    }

    public dashboardShortTitle(value: any) {
        const text = String(value || '-').trim();
        return text.length > 16 ? `${text.slice(0, 15)}…` : text;
    }

    public dashboardCsvEscape(value: any) {
        const text = String(value === null || value === undefined ? '' : value);
        return `"${text.replace(/"/g, '""')}"`;
    }

    public dashboardAddCsvSection(lines: string[], title: string, columns: string[], rows: any[][]) {
        lines.push('');
        lines.push(this.dashboardCsvEscape(title));
        lines.push(columns.map((value) => this.dashboardCsvEscape(value)).join(','));
        (rows || []).forEach((row) => lines.push(row.map((value) => this.dashboardCsvEscape(value)).join(',')));
    }

    public projectDashboardExportFileName() {
        const projectName = this.project && this.project.name ? this.project.name : 'project';
        const suffix = this.kstDateTime(new Date().toISOString()).replace(/[^\d]+/g, '-');
        return this.safeAttachmentName(`${projectName}-dashboard-stats-${suffix}.csv`);
    }

    public downloadProjectDashboardStats() {
        if (!this.projectStats) return;
        const stats = this.projectStats || {};
        const codex = stats.codex || {};
        const activity = stats.activity || {};
        const response = stats.response || {};
        const quality = stats.quality || {};
        const lines: string[] = ['\ufeffReviewOps 프로젝트 통계'];
        this.dashboardAddCsvSection(lines, '요약', ['항목', '값'], [
            ['생성일시', stats.generated_at || ''],
            ['전체 리뷰', stats.review_total || 0],
            ['진행 리뷰', stats.active_review_count || 0],
            ['완료 리뷰', stats.done_review_count || 0],
            ['작업이력', activity.total_count || 0],
            ['에이전트 사용 횟수', codex.total_count || 0],
            ['에이전트 사용 시간(초)', codex.total_duration_seconds || 0],
            ['초기 대응 중앙값(초)', response.median_seconds || 0],
            ['초기 대응 평균(초)', response.avg_seconds || 0],
            ['종합 품질 점수', quality.overall_score || 0],
        ]);
        this.dashboardAddCsvSection(lines, '품질 지표', ['항목', '점수', '대표 수치', '평균 단어', '낮음 건수'], this.dashboardQualityIndicators().map((row: any) => {
            const summary = this.dashboardQualitySummary(row.key);
            return [row.label, row.score, this.dashboardQualityIndicatorMeta(row), summary.avg_words || 0, row.low_count || 0];
        }));
        this.dashboardAddCsvSection(lines, '리뷰 상태별 통계', ['상태', '건수', '비율'], this.dashboardStatusRows().map((row: any) => [this.statusLabel(row.key), row.count, row.percent]));
        this.dashboardAddCsvSection(lines, '날짜별 통계', ['날짜', '리뷰 등록', '작업이력', '에이전트', '에이전트 사용 시간(초)'], this.dashboardDailyRows().map((row: any) => [row.date, row.reviews, row.activities, row.codex, row.codex_duration_seconds]));
        this.dashboardAddCsvSection(lines, '리뷰 당 에이전트 사용', ['리뷰 ID', '제목', '상태', '횟수', '사용 시간(초)', '마지막 사용'], this.dashboardCodexReviewRows().map((row: any) => [row.review_id, row.title, this.statusLabel(row.status), row.count, row.duration_seconds, row.last_at]));
        this.dashboardAddCsvSection(lines, '초기 대응 시간', ['리뷰 ID', '제목', '상태', '초기 대응(초)', '생성일시', '첫 대응일시'], this.dashboardResponseRows().map((row: any) => [row.review_id, row.title, this.statusLabel(row.status), row.first_response_seconds, row.created, row.first_response_at]));

        const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
        const objectUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = this.projectDashboardExportFileName();
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    }

    public clearReviewListSyncTimer() {
        if (this.reviewListSyncTimer) {
            window.clearTimeout(this.reviewListSyncTimer);
            this.reviewListSyncTimer = null;
        }
    }

    public scheduleReviewListSync(delay: number = 0) {
        const hadTimer = !!this.reviewListSyncTimer;
        this.clearReviewListSyncTimer();
        if (this.workspaceDetached) return;
        if (this.isReviewDetailOpen()) {
            this.reviewListSyncPaused = this.reviewListSyncPaused || hadTimer || this.tab === 'review';
            return;
        }
        const interval = Math.max(Number(delay) || 0, 0);
        this.reviewListSyncTimer = window.setTimeout(async () => {
            this.reviewListSyncTimer = null;
            if (this.workspaceDetached || this.tab !== 'review') return;
            if (this.isReviewDetailOpen()) {
                this.reviewListSyncPaused = true;
                return;
            }
            await this.loadReviews({ silent: true, pauseForReviewModal: true });
        }, interval);
    }

    public clearReviewListAutoRefreshTimer() {
        if (this.reviewListAutoRefreshTimer) {
            window.clearTimeout(this.reviewListAutoRefreshTimer);
            this.reviewListAutoRefreshTimer = null;
        }
    }

    public syncReviewListAutoRefresh(delay: number = -1) {
        if (!this.reviewListAutoRefreshEnabled || this.workspaceDetached || this.destroyed || this.tab !== 'review' || this.isReviewDetailOpen()) {
            this.clearReviewListAutoRefreshTimer();
            return;
        }
        this.scheduleReviewListAutoRefresh(delay);
    }

    public scheduleReviewListAutoRefresh(delay: number = -1) {
        this.clearReviewListAutoRefreshTimer();
        if (!this.reviewListAutoRefreshEnabled || this.workspaceDetached || this.destroyed || this.tab !== 'review' || this.isReviewDetailOpen()) return;
        const interval = delay >= 0
            ? Math.max(Number(delay) || 0, 0)
            : this.reviewListAutoRefreshIntervalMs;
        this.reviewListAutoRefreshTimer = window.setTimeout(async () => {
            this.reviewListAutoRefreshTimer = null;
            await this.runReviewListAutoRefresh();
        }, interval);
    }

    public async runReviewListAutoRefresh() {
        if (!this.reviewListAutoRefreshEnabled || this.workspaceDetached || this.destroyed || this.tab !== 'review') return;
        if (!this.isReviewDetailOpen() && !this.reviewListLoading && !this.reviewListAutoRefreshBusy) {
            this.reviewListAutoRefreshBusy = true;
            try {
                await this.loadReviews({ silent: true, pauseForReviewModal: true });
            } catch (e) {
            } finally {
                this.reviewListAutoRefreshBusy = false;
            }
        }
        this.syncReviewListAutoRefresh();
    }

    public reviewListAutoRefreshTitle() {
        return this.reviewListAutoRefreshEnabled ? '자동 새로고침 끄기' : '자동 새로고침 켜기';
    }

    public reviewListAutoRefreshToggleClass() {
        const base = 'flex h-9 min-w-9 items-center justify-center gap-2 rounded-md border px-3 text-[13px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (this.reviewListAutoRefreshEnabled) return base + 'border-cyan-600 bg-cyan-50 text-cyan-700 hover:bg-cyan-100';
        return base + 'border-slate-300 text-slate-600 hover:bg-slate-50';
    }

    public async toggleReviewListAutoRefresh() {
        this.reviewListAutoRefreshEnabled = !this.reviewListAutoRefreshEnabled;
        if (!this.reviewListAutoRefreshEnabled) {
            this.clearReviewListAutoRefreshTimer();
            await this.service.render();
            return;
        }
        await this.service.render();
        await this.runReviewListAutoRefresh();
    }

    public setupViewport() {
        this.clearWebViewerLayoutTimer();
        this.disconnectWebViewerResizeObserver();
        this.webViewerMode = 'browser';
        this.webViewerBrowserState = null;
        this.navigationLog = [];
        this.inputLog = [];
        this.networkLog = [];
        this.consoleLog = [];
        this.fingerprintLog = [];
        this.remoteNavigationLog = [];
        this.remoteNetworkLog = [];
        this.remoteConsoleLog = [];
        this.remoteScreenshotDataUrl = '';
        this.setRemoteFrameDataUrl('', false);
        this.remoteSnapshotId = '';
        this.remoteError = '';
        this.remoteReady = false;
        this.frameActionBusy = false;
        const htmlPageCount = Math.max(this.configuredHtmlDocumentPageCount(), 1);
        this.htmlDocumentState = { page: 1, page_count: htmlPageCount, manual_page_count: this.configuredHtmlDocumentPageCount(), strategy: this.isHtmlProject() ? 'loading' : 'document' };
        this.htmlPdfExporting = false;
        this.htmlPdfExportProgress = '';
        this.sdkInstalled = false;
        this.sdkStatus = 'checking';
        this.sdkVersion = '';
        this.sdkOrigin = '';
        this.sdkLastMessageAt = '';
        this.htmlDocumentStandardReady = false;
        this.htmlDocumentStandardMessage = '';
        if (this.sdkProbeTimer) {
            window.clearTimeout(this.sdkProbeTimer);
            this.sdkProbeTimer = null;
        }
        this.viewport = {
            width: this.project.default_viewport_width || 1440,
            height: this.project.default_viewport_height || 900
        };
        if (!this.restoreCustomViewportSession()) {
            this.selectedPreset = this.viewportPresetName();
        }
        this.scale = 1;
        this.scaleMode = 'fit';
        if (this.isWebServiceProject() && this.normalizeWebViewerMode(this.project && this.project.default_viewer_mode) === 'fullscreen') {
            this.webViewerBrowserState = this.webViewerBrowserStateSnapshot();
            this.webViewerMode = 'fullscreen';
        }
        this.previewLinkMode = this.normalizePreviewLinkMode(this.previewLinkMode);
        if (this.isDocumentProject()) {
            this.ensureDocumentVersionSelection(false);
            this.frameUrl = '';
            this.currentUrl = this.documentReviewCurrentUrl();
            this.remoteAddress = '';
            this.frameTitle = '';
            this.resetFrameHistory('');
            this.screenshotDataUrl = '';
            this.screenshotFallbackDataUrl = '';
            this.screenshotReceivedAt = 0;
            this.screenshotErrorAt = 0;
            this.screenshotInlinedResources = 0;
            this.screenshotSkippedResources = 0;
            this.captureMethod = 'pdf-viewer';
            this.disconnectRemoteSocket();
            this.scheduleFitScale();
            return;
        }
        this.ensureHtmlSnapshotSelection();
        const initialUrl = this.projectPreviewServerUrl(this.previewLinkMode);
        this.frameUrl = initialUrl;
        this.currentUrl = initialUrl;
        this.remoteAddress = initialUrl;
        this.frameTitle = '';
        this.resetFrameHistory(initialUrl);
        this.screenshotDataUrl = '';
        this.screenshotFallbackDataUrl = '';
        this.screenshotReceivedAt = 0;
        this.screenshotErrorAt = 0;
        this.screenshotInlinedResources = 0;
        this.screenshotSkippedResources = 0;
        this.captureMethod = 'capture-pending';
        this.recordNavigation(this.currentUrl, `initial:${this.previewLinkMode}`);
        this.collectFingerprintLog('initial');
        this.scheduleFitScale();
    }

    public normalizeProjectTab(tab: string) {
        const value = String(tab || '').trim();
        if (value === 'intro') return 'dashboard';
        return value;
    }

    public isDashboardTab() {
        return this.tab === 'dashboard';
    }

    public availableProjectTabs() {
        const tabs: string[] = [];
        if (this.canEditSettings()) tabs.push('settings');
        if (this.canUseProjectFiles()) tabs.push('file');
        if (this.canUseProjectMacros()) tabs.push('macro');
        if (this.canUseProjectTerminal()) tabs.push('terminal');
        tabs.push('dashboard', 'review');
        return tabs;
    }

    public async selectTab(tab: string) {
        tab = this.normalizeProjectTab(tab);
        if (!this.availableProjectTabs().includes(tab)) return;
        if (this.isHtmlProject() && this.tab !== 'dashboard' && tab === 'dashboard') {
            this.preserveHtmlDocumentFramePage('project-tab-dashboard');
        }
        if (this.isDashboardTab() && tab !== 'dashboard') await this.parkIntroEditor();
        this.tab = tab;
        this.mobileProjectPane = 'workspace';
        this.mobileMainMenuOpen = false;
        this.mobileReviewFiltersOpen = false;
        this.groupMoveForm.open = false;
        await this.syncTabUrl(true);
        this.scheduleFitScale();
        await this.service.render();
        if (tab === 'file' && this.canUseProjectFiles()) await this.loadProjectFiles(this.fileBrowser.path || '');
        if (tab === 'macro') await this.loadProjectMacros();
        if (tab === 'terminal') this.scheduleTerminalFit();
        if (tab === 'review') this.syncCodexReviewStatusSocket(true);
        else {
            this.leaveCodexReviewStatusSocket();
        }
        this.syncReviewListAutoRefresh();
        if (tab === 'dashboard') await this.loadProjectDashboardStats();
        else this.destroyCharts('dashboard');
        if (this.isWebServiceProject()) this.probeSdk(false);
        if (this.isDocumentProject()) await this.preparePdfViewer(false);
        if (tab === 'dashboard' && this.editingIntro && this.introEditorMode === 'visual') {
            await this.initIntroEditor();
        }
        await this.service.render();
    }

    public mainTabLabel(tab: string) {
        if (tab === 'settings') return '설정';
        if (tab === 'file') return '파일';
        if (tab === 'macro') return '매크로';
        if (tab === 'terminal') return '터미널';
        if (tab === 'dashboard') return '대시보드';
        if (tab === 'review') return '리뷰';
        return tab;
    }

    public mobilePrimaryProjectTabs() {
        const available = this.availableProjectTabs();
        const ordered: string[] = [];
        const add = (tab: string) => {
            if (available.includes(tab) && !ordered.includes(tab)) ordered.push(tab);
        };
        add('dashboard');
        add('review');
        add(this.tab);
        available.forEach((tab) => add(tab));
        return ordered.length > 4 ? ordered.slice(0, 3) : ordered.slice(0, 4);
    }

    public mobileOverflowProjectTabs() {
        const primary = this.mobilePrimaryProjectTabs();
        return this.availableProjectTabs().filter((tab) => !primary.includes(tab));
    }

    public mobileMainGridClass() {
        const primary = this.mobilePrimaryProjectTabs();
        const count = primary.length + (this.mobileOverflowProjectTabs().length ? 1 : 0);
        const columns = count <= 2 ? 'grid-cols-2' : count === 3 ? 'grid-cols-3' : 'grid-cols-4';
        return `reviewops-mobile-main-menu grid w-full ${columns} gap-1 lg:hidden`;
    }

    public mobileMainTabClass(tab: string) {
        const base = 'flex h-9 min-w-0 items-center justify-center rounded-md px-2 text-center text-[12px] font-semibold transition-colors ';
        if (this.tab === tab) return base + 'bg-white text-slate-950 shadow-sm';
        return base + 'text-slate-300 hover:bg-slate-800 hover:text-white';
    }

    public mobileMainMoreButtonClass() {
        const base = 'flex h-9 w-full min-w-0 items-center justify-center gap-1 rounded-md px-2 text-[12px] font-semibold transition-colors ';
        if (this.mobileMainMenuOpen) return base + 'bg-white text-slate-950 shadow-sm';
        return base + 'text-slate-300 hover:bg-slate-800 hover:text-white';
    }

    public mobileMainMenuStyle() {
        const width = 160;
        const margin = 8;
        const viewportWidth = Math.max((typeof window !== 'undefined' ? window.innerWidth : 0) || document.documentElement.clientWidth || width + (margin * 2), width + (margin * 2));
        const viewportHeight = Math.max((typeof window !== 'undefined' ? window.innerHeight : 0) || document.documentElement.clientHeight || 320, 320);
        const rect = this.mobileMainMenuRect || {};
        const rectRight = Number(rect.right || 0);
        const rectTop = Number(rect.top || 0);
        const rectBottom = Number(rect.bottom || 0);
        const overflowCount = Math.max(this.mobileOverflowProjectTabs().length, 1);
        const estimatedHeight = Math.min(320, 8 + (overflowCount * 36));
        const maxLeft = Math.max(margin, viewportWidth - width - margin);
        const left = Math.min(Math.max(margin, rectRight ? rectRight - width : maxLeft), maxLeft);
        let top = Math.max(margin, Math.round((rectBottom || 0) + margin));
        if (top + estimatedHeight > viewportHeight - margin && rectTop) {
            top = Math.max(margin, Math.round(rectTop - estimatedHeight - margin));
        }
        const maxHeight = Math.max(120, viewportHeight - top - margin);
        return { left: `${Math.round(left)}px`, top: `${Math.round(top)}px`, width: `${width}px`, maxHeight: `${maxHeight}px` };
    }

    public mobileOverflowTabClass(tab: string) {
        const base = 'block w-full px-3 py-2 text-left text-[13px] font-semibold transition-colors ';
        if (this.tab === tab) return base + 'bg-slate-950 text-white';
        return base + 'text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public async toggleMobileMainMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.mobileMainMenuOpen) {
            await this.closeMobileMainMenu();
            return;
        }
        this.mobileMainMenuRect = this.mobileMainMenuTriggerRect(event);
        this.mobileMainMenuOpen = true;
        await this.service.render();
    }

    public async closeMobileMainMenu(render: boolean = true) {
        if (!this.mobileMainMenuOpen && !this.mobileMainMenuRect) return;
        this.mobileMainMenuOpen = false;
        this.mobileMainMenuRect = null;
        if (render) await this.service.render();
    }

    public async selectMobileOverflowTab(tab: string, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.mobileMainMenuOpen = false;
        this.mobileMainMenuRect = null;
        await this.selectTab(tab);
    }

    private mobileMainMenuTriggerRect(event?: Event) {
        const target: any = event ? ((event as any).currentTarget || event.target) : null;
        if (!target || !target.getBoundingClientRect) return null;
        const rect = target.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height
        };
    }

    public projectTabPath(tab: string = this.tab) {
        if (!this.projectId) return '';
        const normalizedTab = this.normalizeProjectTab(tab);
        const suffixes: any = {
            review: '/review',
            dashboard: '/dashboard',
            file: '/file',
            macro: '/macro',
            terminal: '/terminal'
        };
        return `/projects/${this.projectId}${suffixes[normalizedTab] || ''}`;
    }

    public projectTabUrl(tab: string = this.tab) {
        const path = this.projectTabPath(tab);
        if (!path) return '';
        return `${path}${this.adminMode ? '?admin=1' : ''}`;
    }

    public async syncTabUrl(replace: boolean = true) {
        const nextUrl = this.projectTabUrl(this.tab);
        if (!nextUrl) return;
        if (!replace) return;

        try {
            if (this.router && this.router.url !== nextUrl) {
                const navigated = await this.router.navigateByUrl(nextUrl, { replaceUrl: true });
                if (navigated) return;
            }
        } catch (error) { }

        if (typeof window !== 'undefined' && window.history) {
            const currentUrl = `${window.location.pathname}${window.location.search}`;
            if (currentUrl !== nextUrl) window.history.replaceState({}, '', nextUrl);
        }
        this.notifyWorkspaceUrlChange(nextUrl);
    }

    private notifyWorkspaceUrlChange(url: string) {
        if (!url || typeof window === 'undefined' || typeof CustomEvent === 'undefined') return;
        window.dispatchEvent(new CustomEvent('reviewops-workspace-url-change', {
            detail: { url }
        }));
    }

    public mainTabClass(tab: string) {
        const base = 'min-w-[70px] rounded-lg px-3 py-2 text-center text-[13px] transition-colors lg:min-w-[86px] lg:rounded-xl lg:px-5 lg:py-2.5 lg:text-[15px] ';
        if (this.tab === tab) return base + 'bg-white text-slate-950 shadow-sm';
        return base + 'text-slate-300 hover:bg-slate-800 hover:text-white';
    }

    public projectWorkspaceLabel() {
        if (this.tab === 'settings') return '설정';
        if (this.tab === 'file') return '파일';
        if (this.tab === 'macro') return '매크로';
        if (this.tab === 'terminal') return '터미널';
        if (this.isDashboardTab()) return '소개';
        return '리뷰';
    }

    public projectPreviewLabel() {
        if (this.isDashboardTab()) return '통계';
        if (this.isDocumentProject()) return 'PDF';
        if (this.isHtmlProject()) return 'HTML';
        return '화면';
    }

    public mobilePaneTabClass(pane: string) {
        const base = 'h-9 flex-1 rounded-md px-3 text-[12px] font-semibold transition-colors ';
        if (this.mobileProjectPane === pane) return base + 'bg-white text-slate-950 shadow-sm';
        return base + 'text-slate-300 hover:bg-slate-800 hover:text-white';
    }

    public async selectMobileProjectPane(pane: string) {
        if (!['preview', 'workspace'].includes(pane)) return;
        this.mobileProjectPane = pane;
        if (pane === 'preview') {
            this.scheduleFitScale();
            if (this.isDocumentProject()) await this.preparePdfViewer(false);
            if (this.isDashboardTab()) this.scheduleChartRender();
        }
        await this.service.render();
    }

    public projectPaneContainerClass() {
        const direction = this.isDashboardTab() ? 'lg:flex-row-reverse' : 'lg:flex-row';
        return `flex min-h-0 flex-1 flex-col overflow-hidden ${direction}`;
    }

    public previewPaneClass() {
        const mobile = this.mobileProjectPane === 'preview' ? 'flex' : 'hidden';
        return `${mobile} min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-b border-slate-200 bg-slate-100 lg:flex lg:border-b-0 lg:border-r`;
    }

    public workspacePaneClass() {
        const mobile = this.mobileProjectPane === 'workspace' ? 'block' : 'hidden';
        return `${mobile} reviewops-workspace-pane-surface w-full min-h-0 min-w-0 overflow-hidden border-t border-[#1d314f] bg-[#e9f0f7] lg:block lg:min-w-[420px] lg:shrink-0 lg:border-l lg:border-t-0`;
    }

    public async selectSettingsSubTab(tab: string) {
        if (!this.availableSettingsSubTabs().includes(tab)) return;
        if (this.settingsSubTab === tab) return;
        this.settingsSubTab = tab;
        this.groupMoveForm.open = false;
        await this.service.render();
    }

    public async openReviewOpsIntegrationGuide() {
        if (!this.isWebServiceProject()) return;
        this.reviewOpsGuideModalOpen = true;
        await this.service.render();
    }

    public async closeReviewOpsIntegrationGuide() {
        this.reviewOpsGuideModalOpen = false;
        await this.service.render();
    }

    public availableSettingsSubTabs() {
        const tabs = ['info'];
        if (this.isWebServiceProject()) tabs.push('server');
        if (this.isWebServiceProject() || this.isHtmlProject()) tabs.push('ai');
        if (this.isHtmlProject()) tabs.push('document');
        tabs.push('etc');
        return tabs;
    }

    public ensureSettingsSubTab() {
        if (!this.availableSettingsSubTabs().includes(this.settingsSubTab)) {
            this.settingsSubTab = 'info';
        }
    }

    public settingsSubTabGridClass() {
        if (this.isWebServiceProject() || this.isHtmlProject()) return 'grid grid-cols-4 gap-1';
        return 'grid grid-cols-2 gap-1';
    }

    public settingsSubTabClass(tab: string) {
        const base = 'h-9 flex-1 rounded-md px-3 text-[12px] font-semibold transition-colors ';
        if (this.settingsSubTab === tab) return base + 'bg-slate-900 text-white shadow-sm';
        return base + 'text-slate-500 hover:bg-white hover:text-slate-900';
    }

    public optionToggleClass(current: string, value: string) {
        const base = 'min-h-[58px] rounded-md border px-3 py-2 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60 ';
        if (current === value) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
    }

    public projectTypeTabClass(current: string, value: string, readonly: boolean = false) {
        const base = 'min-h-[58px] rounded-md border px-3 py-2 text-left transition-colors ';
        const state = readonly ? 'cursor-default ' : '';
        if (current === value) return base + state + 'border-slate-900 bg-slate-900 text-white shadow-sm';
        return base + state + 'border-transparent bg-transparent text-slate-500';
    }

    public reviewToggleClass(current: string, value: string, kind: string = '') {
        const base = 'h-9 rounded-md border px-3 text-[12px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (current !== value) return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
        if (kind === 'priority' && value === 'critical') return base + 'border-rose-700 bg-rose-700 text-white';
        if (kind === 'priority' && value === 'high') return base + 'border-amber-700 bg-amber-600 text-white';
        if (kind === 'category' && value === 'bug') return base + 'border-sky-700 bg-sky-700 text-white';
        return base + 'border-slate-900 bg-slate-900 text-white';
    }

    public setProjectOption(key: string, value: string) {
        if (!this.canEditSettings()) return;
        this.projectForm[key] = value;
        this.service.render();
    }

    public defaultHtmlDocumentSettings(width: any = 1440, height: any = 900) {
        return {
            layout: {
                preset: 'web',
                render_mode: 'web',
                width: Number(width) || 1440,
                height: Number(height) || 900
            },
            instruction: {
                document_kind: 'proposal',
                audience: '',
                goal: '',
                tone: '',
                brand_rules: '',
                content_rules: '',
                harness_prompt: ''
            },
            presentation: {
                page_count: 0
            },
            sharing: {
                enabled: false
            }
        };
    }

    public normalizeHtmlDocumentSettings(settings: any, width: any = 1440, height: any = 900) {
        const source = settings && typeof settings === 'object' ? settings : {};
        const defaults = this.defaultHtmlDocumentSettings(width, height);
        const layout = Object.assign({}, defaults.layout, source.layout || {});
        const instruction = Object.assign({}, defaults.instruction, source.instruction || {});
        const presentation = Object.assign({}, defaults.presentation, source.presentation || {});
        const sharing = Object.assign({}, defaults.sharing, source.sharing || {});
        layout.width = Math.min(Math.max(Number(layout.width) || Number(width) || 1440, 320), 7680);
        layout.height = Math.min(Math.max(Number(layout.height) || Number(height) || 900, 240), 7680);
        if (!['a4_portrait', 'a4_landscape', 'slide_16_9', 'slide_4_3', 'web', 'custom'].includes(layout.preset)) layout.preset = 'web';
        if (!['document', 'web'].includes(layout.render_mode)) layout.render_mode = 'web';
        if (!['proposal', 'proposal_presentation', 'lecture', 'report', 'custom'].includes(instruction.document_kind)) instruction.document_kind = 'custom';
        presentation.page_count = Math.min(Math.max(Math.floor(Number(presentation.page_count) || 0), 0), 1000);
        sharing.enabled = !!sharing.enabled;
        return { layout, instruction, presentation, sharing };
    }

    public ensureHtmlDocumentSettings() {
        if (!this.projectForm) this.projectForm = {};
        const settings = this.projectForm.html_document_settings;
        if (!settings || typeof settings !== 'object' || !settings.layout || !settings.instruction) {
            this.projectForm.html_document_settings = this.normalizeHtmlDocumentSettings(
                settings,
                this.projectForm.default_viewport_width,
                this.projectForm.default_viewport_height
            );
        }
        return this.projectForm.html_document_settings;
    }

    public htmlDocumentLayout() {
        return this.ensureHtmlDocumentSettings().layout;
    }

    public htmlDocumentInstruction() {
        return this.ensureHtmlDocumentSettings().instruction;
    }

    public htmlDocumentPresentationSettings() {
        const settings = this.ensureHtmlDocumentSettings();
        if (!settings.presentation || typeof settings.presentation !== 'object') {
            settings.presentation = { page_count: 0 };
        }
        settings.presentation.page_count = Math.min(Math.max(Math.floor(Number(settings.presentation.page_count) || 0), 0), 1000);
        return settings.presentation;
    }

    public htmlDocumentSharingSettings() {
        const settings = this.ensureHtmlDocumentSettings();
        if (!settings.sharing || typeof settings.sharing !== 'object') {
            settings.sharing = { enabled: false };
        }
        settings.sharing.enabled = !!settings.sharing.enabled;
        return settings.sharing;
    }

    public async setHtmlLayoutPreset(option: any) {
        if (!this.canEditSettings() || !option) return;
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = option.value;
        settings.layout.render_mode = option.render_mode || 'web';
        if (option.value !== 'custom') {
            settings.layout.width = option.width;
            settings.layout.height = option.height;
        }
        this.projectForm.default_viewport_width = settings.layout.width;
        this.projectForm.default_viewport_height = settings.layout.height;
        await this.service.render();
    }

    public updateHtmlLayoutWidth(value: any) {
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = 'custom';
        settings.layout.width = Math.min(Math.max(Number(value) || 1440, 320), 7680);
        this.projectForm.default_viewport_width = settings.layout.width;
    }

    public updateHtmlLayoutHeight(value: any) {
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = 'custom';
        settings.layout.height = Math.min(Math.max(Number(value) || 900, 240), 7680);
        this.projectForm.default_viewport_height = settings.layout.height;
    }

    public async setHtmlDocumentKind(kind: string) {
        if (!this.canEditSettings()) return;
        this.htmlDocumentInstruction().document_kind = kind || 'custom';
        await this.service.render();
    }

    public htmlDocumentLayoutPresetClass(value: string) {
        return this.optionToggleClass(this.htmlDocumentLayout().preset, value);
    }

    public htmlDocumentKindClass(value: string) {
        return this.reviewToggleClass(this.htmlDocumentInstruction().document_kind, value);
    }

    public htmlDocumentFiles(kind: string) {
        if (kind === 'resource') return (this.project && this.project.html_resource_files) || [];
        return (this.project && this.project.html_reference_files) || [];
    }

    public htmlDocumentFileBusyState(kind: string) {
        return !!(this.htmlDocumentFileBusy && this.htmlDocumentFileBusy[kind === 'resource' ? 'resource' : 'reference']);
    }

    public htmlDocumentFileUploadButtonClass(kind: string) {
        const disabled = this.htmlDocumentFileBusyState(kind) || !this.canUseHtmlProjectFiles();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public htmlDocumentFileIcon(file: any) {
        const mime = String(file && file.mime ? file.mime : '').toLowerCase();
        if (mime.startsWith('image/')) return 'fa-regular fa-file-image text-[15px] text-cyan-600';
        if (mime === 'application/pdf') return 'fa-regular fa-file-pdf text-[15px] text-rose-600';
        if (mime.includes('presentation') || /\.pptx?$/i.test(String(file && file.name || ''))) return 'fa-regular fa-file-powerpoint text-[15px] text-orange-600';
        if (mime.includes('word') || /\.docx?$/i.test(String(file && file.name || ''))) return 'fa-regular fa-file-word text-[15px] text-blue-600';
        return 'fa-regular fa-file text-[15px] text-slate-500';
    }

    public htmlDocumentFileUploadUrl(kind: string) {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId, kind }) as any).toString();
        return `/wiz/api/page.projects.item/upload_html_document_setting_file${query ? `?${query}` : ''}`;
    }

    public async selectHtmlDocumentFile(event: any, kind: string) {
        const fileKind = kind === 'resource' ? 'resource' : 'reference';
        const files = this.uploadEventFiles(event);
        if (!this.canUseHtmlProjectFiles() || this.htmlDocumentFileBusyState(fileKind)) return;
        if (!files.length) return;

        const policyKey = fileKind === 'resource' ? 'html_resource_file' : 'html_reference_file';
        const validationMessage = this.uploadPolicyValidationMessage(policyKey, files);
        if (validationMessage) {
            await this.service.modal.error(validationMessage);
            return;
        }

        this.htmlDocumentFileBusy[fileKind] = true;
        const progressKey = this.uploadProgressKey(fileKind);
        this.startUploadProgress(progressKey, fileKind === 'resource' ? '리소스 파일' : '참고자료 파일', files, 'uploading');
        await this.renderView();
        try {
            let uploadedBefore = 0;
            for (const file of files) {
                await this.updateUploadProgress(progressKey, {
                    phase: 'uploading',
                    currentIndex: files.indexOf(file) + 1,
                    currentFileName: file.name || 'file',
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    processedBytes: uploadedBefore
                }, true);
                const fd = new FormData();
                fd.append('id', this.projectId);
                fd.append('kind', fileKind);
                if (this.adminMode) fd.append('admin', '1');
                fd.append('file', file);
                const { code, data } = this.normalizeUploadResponse(await this.service.file.upload(this.htmlDocumentFileUploadUrl(fileKind), fd, async (percent: number, total: number, position: number) => {
                    const loaded = Number(position || 0);
                    const currentTotal = Number(total || file.size || 0);
                    await this.updateUploadProgress(progressKey, {
                        currentPercent: Number(percent || 0),
                        currentLoaded: loaded,
                        currentTotal,
                        processedBytes: uploadedBefore + loaded
                    });
                }));
                if (code === 200) {
                    this.applyProject(data.project);
                    uploadedBefore += Number(file.size || 0);
                    await this.updateUploadProgress(progressKey, {
                        completedFiles: files.indexOf(file) + 1,
                        currentPercent: 100,
                        currentLoaded: file.size || 0,
                        currentTotal: file.size || 0,
                        processedBytes: uploadedBefore
                    }, true);
                } else {
                    this.finishUploadProgress(progressKey, false, data.message || '파일을 업로드하지 못했습니다.');
                    await this.service.modal.error(data.message || '파일을 업로드하지 못했습니다.');
                    break;
                }
            }
            if (this.uploadProgressState(progressKey).status !== 'error') {
                this.finishUploadProgress(progressKey, true, '업로드가 완료되었습니다.');
            }
        } catch (e) {
            this.finishUploadProgress(progressKey, false, '파일을 업로드하지 못했습니다.');
            await this.service.modal.error('파일을 업로드하지 못했습니다.');
        }
        this.htmlDocumentFileBusy[fileKind] = false;
        await this.service.render();
    }

    public async deleteHtmlDocumentFile(kind: string, file: any) {
        const fileKind = kind === 'resource' ? 'resource' : 'reference';
        if (!this.canUseHtmlProjectFiles() || this.htmlDocumentFileBusyState(fileKind) || !file) return;
        const confirmed = await this.service.modal.show({
            title: '파일 삭제',
            message: `'${file.name}' 파일을 삭제할까요?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        this.htmlDocumentFileBusy[fileKind] = true;
        await this.renderView();
        const { code, data } = await wiz.call('delete_html_document_setting_file', this.requestParams({
            id: this.projectId,
            data: JSON.stringify({ kind: fileKind, path: file.path || file.name })
        }));
        this.htmlDocumentFileBusy[fileKind] = false;
        if (code === 200) {
            this.applyProject(data.project);
        } else {
            await this.service.modal.error(data.message || '파일을 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public downloadHtmlDocumentFile(file: any) {
        if (!file || !file.url) return;
        const link = document.createElement('a');
        link.href = file.url;
        link.download = file.name || 'download';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public async setProjectFileEnabled(value: boolean) {
        if (!this.canEditSettings()) return;
        this.projectForm.file_enabled = !!value;
        await this.service.render();
    }

    public async setProjectCodexEnabled(value: boolean) {
        if (!this.canEditSettings()) return;
        this.projectForm.codex_enabled = !!value;
        if (!String(this.projectForm.codex_root_path || '').trim()) this.projectForm.codex_root_path = '/opt/app';
        await this.service.render();
    }

    public async setProjectMacroEnabled(value: boolean) {
        if (!this.canEditSettings()) return;
        this.projectForm.macro_enabled = !!value;
        await this.service.render();
    }

    public async setProjectTerminalEnabled(value: boolean) {
        if (!this.canEditSettings()) return;
        this.projectForm.terminal_enabled = !!value;
        await this.service.render();
    }

    public projectToggleClass(enabled: boolean) {
        const base = 'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border p-0.5 transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        return enabled ? base + 'border-slate-900 bg-slate-900' : base + 'border-slate-300 bg-slate-200';
    }

    public projectToggleKnobClass(enabled: boolean) {
        const base = 'block h-5 w-5 rounded-full bg-white shadow-sm transition-transform ';
        return enabled ? base + 'translate-x-5' : base + 'translate-x-0';
    }

    public projectFileToggleClass() {
        return this.projectToggleClass(!!(this.projectForm && this.projectForm.file_enabled));
    }

    public projectFileToggleKnobClass() {
        return this.projectToggleKnobClass(!!(this.projectForm && this.projectForm.file_enabled));
    }

    public projectCodexToggleClass() {
        return this.projectToggleClass(!!(this.projectForm && this.projectForm.codex_enabled));
    }

    public projectCodexToggleKnobClass() {
        return this.projectToggleKnobClass(!!(this.projectForm && this.projectForm.codex_enabled));
    }

    public projectMacroToggleClass() {
        return this.projectToggleClass(!!(this.projectForm && this.projectForm.macro_enabled));
    }

    public projectMacroToggleKnobClass() {
        return this.projectToggleKnobClass(!!(this.projectForm && this.projectForm.macro_enabled));
    }

    public projectTerminalToggleClass() {
        return this.projectToggleClass(!!(this.projectForm && this.projectForm.terminal_enabled));
    }

    public projectTerminalToggleKnobClass() {
        return this.projectToggleKnobClass(!!(this.projectForm && this.projectForm.terminal_enabled));
    }

    private codexBuiltinModelSettings() {
        return reviewOpsCodexBuiltinModelSettings();
    }

    private newCodexCustomEndpointId() {
        try {
            const cryptoApi: any = typeof window !== 'undefined' ? (window as any).crypto : null;
            if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
                return String(cryptoApi.randomUUID()).replace(/[^a-zA-Z0-9]/g, '').toLowerCase().slice(0, 24);
            }
        } catch (e) { }
        return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`.toLowerCase();
    }

    public normalizeCodexModelSettings(value: any) {
        let source: any = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
        const openaiSource = Array.isArray(source.openai) ? source.openai : [];
        const openaiByValue: any = {};
        openaiSource.forEach((item: any) => {
            const key = String((item && (item.value || item.model)) || '').trim().toLowerCase();
            if (key) openaiByValue[key] = item || {};
        });
        const cleanTokens = (input: any) => {
            const value = Number(input);
            return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
        };
        const openai = this.codexBuiltinModelSettings().map((item: any) => {
            const override = openaiByValue[item.value] || {};
            return Object.assign({}, item, {
                context_window: cleanTokens(override.context_window),
                auto_compact_token_limit: cleanTokens(override.auto_compact_token_limit)
            });
        });
        const seen: any = {};
        const customSource = Array.isArray(source.custom_endpoints)
            ? source.custom_endpoints
            : (Array.isArray(source.ollama) ? source.ollama : []);
        const custom_endpoints = customSource.slice(0, 20).map((item: any) => {
            let id = String((item && item.id) || '').trim().toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
            if (!id || seen[id]) id = this.newCodexCustomEndpointId();
            seen[id] = true;
            return {
                id,
                provider: 'custom',
                label: String((item && item.label) || '').trim(),
                model: String((item && item.model) || '').trim(),
                api_url: String((item && (item.api_url || item.base_url)) || '').trim(),
                context_window: cleanTokens(item && item.context_window),
                auto_compact_token_limit: cleanTokens(item && item.auto_compact_token_limit),
                api_key_configured: !!(item && item.api_key_configured),
                api_key_changed: !!(item && item.api_key_changed),
                api_key: item && item.api_key_changed ? String(item.api_key || '') : ''
            };
        });
        return { version: 2, openai, custom_endpoints };
    }

    public codexOpenAiModels() {
        const settings = this.projectForm && this.projectForm.codex_model_settings;
        return settings && Array.isArray(settings.openai) ? settings.openai : [];
    }

    public codexCustomEndpoints() {
        const settings = this.projectForm && this.projectForm.codex_model_settings;
        return settings && Array.isArray(settings.custom_endpoints) ? settings.custom_endpoints : [];
    }

    public async addCodexCustomEndpoint() {
        if (!this.canEditSettings()) return;
        if (!this.projectForm) this.projectForm = {};
        this.projectForm.codex_model_settings = this.normalizeCodexModelSettings(this.projectForm.codex_model_settings);
        if (this.projectForm.codex_model_settings.custom_endpoints.length >= 20) {
            await this.service.modal.warning('Custom Endpoint는 최대 20개까지 추가할 수 있습니다.');
            return;
        }
        const endpoint = {
            id: this.newCodexCustomEndpointId(),
            provider: 'custom',
            label: '',
            model: '',
            api_url: '',
            context_window: 0,
            auto_compact_token_limit: 0,
            api_key_configured: false,
            api_key_changed: false,
            api_key: ''
        };
        this.projectForm.codex_model_settings.custom_endpoints.push(endpoint);
        await this.service.render();
    }

    public async removeCodexCustomEndpoint(index: number) {
        if (!this.canEditSettings()) return;
        const endpoints = this.codexCustomEndpoints();
        if (index < 0 || index >= endpoints.length) return;
        const removedId = String(endpoints[index].id || '');
        endpoints.splice(index, 1);
        if (this.codexCustomEndpointKeyEditingId === removedId) this.cancelCodexCustomEndpointApiKey();
        await this.service.render();
    }

    public openCodexCustomEndpointApiKey(endpoint: any) {
        if (!this.canEditSettings() || !endpoint) return;
        this.codexCustomEndpointKeyEditingId = String(endpoint.id || '');
        this.codexCustomEndpointKeyDraft = '';
        this.service.render();
    }

    public cancelCodexCustomEndpointApiKey() {
        this.codexCustomEndpointKeyEditingId = '';
        this.codexCustomEndpointKeyDraft = '';
        this.service.render();
    }

    public async applyCodexCustomEndpointApiKey(endpoint: any) {
        if (!this.canEditSettings() || !endpoint) return;
        const apiKey = String(this.codexCustomEndpointKeyDraft || '');
        if (!apiKey) {
            await this.service.modal.warning('API Key를 입력해주세요. 인증이 필요 없으면 삭제를 선택하세요.');
            return;
        }
        endpoint.api_key = apiKey;
        endpoint.api_key_changed = true;
        endpoint.api_key_configured = true;
        this.codexCustomEndpointKeyEditingId = '';
        this.codexCustomEndpointKeyDraft = '';
        await this.service.render();
    }

    public async clearCodexCustomEndpointApiKey(endpoint: any) {
        if (!this.canEditSettings() || !endpoint) return;
        endpoint.api_key = '';
        endpoint.api_key_changed = true;
        endpoint.api_key_configured = false;
        this.codexCustomEndpointKeyEditingId = '';
        this.codexCustomEndpointKeyDraft = '';
        await this.service.render();
    }

    public async testCodexCustomEndpoint(endpoint: any) {
        if (!this.canEditSettings() || !endpoint || this.testingCodexCustomEndpointId) return;
        this.testingCodexCustomEndpointId = String(endpoint.id || '');
        await this.service.render();
        const { code, data } = await wiz.call('test_codex_custom_endpoint', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(endpoint)
        }));
        this.testingCodexCustomEndpointId = '';
        if (code === 200 && data && data.result && data.result.ok) {
            const latency = Number(data.result.latency_ms || 0);
            await this.service.modal.success(`${data.result.message || 'Custom Endpoint 테스트에 성공했습니다.'}${latency ? ` (${latency}ms)` : ''}`);
        } else {
            await this.service.modal.error((data && data.message) || 'Custom Endpoint 테스트에 실패했습니다.');
        }
        await this.service.render();
    }

    public projectFormPayload(project: any) {
        const form = JSON.parse(JSON.stringify(project || {}));
        form.default_viewer_mode = this.normalizeWebViewerMode(form.default_viewer_mode);
        form.labels = this.normalizeLabels(form.labels);
        form.labelInput = '';
        form.admin_memo = form.admin_memo || '';
        form.ssh_host = form.ssh_host || '';
        form.ssh_port = this.cleanSshPortValue(form.ssh_port, 22);
        form.ssh_user = form.ssh_user || '';
        form.ssh_password = '';
        form.ssh_password_changed = false;
        form.ssh_password_configured = !!(project && project.ssh_password_configured);
        form.ssh_auth_mode = this.normalizeSshAuthMode(project && project.ssh_auth_mode);
        form.ssh_private_key = '';
        form.ssh_private_key_configured = !!(project && project.ssh_private_key_configured);
        form.ssh_private_key_name = (project && project.ssh_private_key_name) || '';
        form.ssh_private_key_passphrase = '';
        form.ssh_private_key_passphrase_configured = !!(project && project.ssh_private_key_passphrase_configured);
        form.ssh_public_key = (project && project.ssh_public_key) || '';
        form.ssh_public_key_configured = !!(project && project.ssh_public_key_configured);
        form.ssh_public_key_name = (project && project.ssh_public_key_name) || '';
        form.ssh_key_algorithm = (project && project.ssh_key_algorithm) || '';
        form.ssh_key_fingerprint = (project && project.ssh_key_fingerprint) || '';
        form.ssh_proxy_enabled = !!(project && project.ssh_proxy_enabled);
        form.ssh_proxy_host = form.ssh_proxy_host || '';
        form.ssh_proxy_user = form.ssh_proxy_user || '';
        form.ssh_proxy_password = '';
        form.ssh_proxy_password_changed = false;
        form.ssh_proxy_password_configured = !!(project && project.ssh_proxy_password_configured);
        form.ssh_proxy2_enabled = !!(project && project.ssh_proxy2_enabled);
        form.ssh_proxy2_host = form.ssh_proxy2_host || '';
        form.ssh_proxy2_user = form.ssh_proxy2_user || '';
        form.ssh_proxy2_password = '';
        form.ssh_proxy2_password_changed = false;
        form.ssh_proxy2_password_configured = !!(project && project.ssh_proxy2_password_configured);
        form.file_enabled = !!(project && project.file_enabled);
        form.file_root_path = form.file_root_path || '';
        form.macro_enabled = !!(project && project.macro_enabled);
        form.terminal_enabled = !!(project && project.terminal_enabled);
        form.codex_enabled = !!(project && project.codex_enabled);
        form.codex_root_path = form.codex_root_path || '/opt/app';
        form.codex_command_path = form.codex_command_path || '';
        form.codex_model_settings = this.normalizeCodexModelSettings(form.codex_model_settings);
        form.codex_status = project && project.codex_status ? project.codex_status : null;
        form.dev_server_url = form.dev_server_url || '';
        form.html_document_settings = this.normalizeHtmlDocumentSettings(form.html_document_settings, form.default_viewport_width, form.default_viewport_height);
        return form;
    }

    public markSshPasswordChanged() {
        if (!this.projectForm) return;
        this.projectForm.ssh_password_changed = true;
        if (String(this.projectForm.ssh_password || '')) this.projectForm.ssh_auth_mode = 'password';
        this.service.render();
    }

    public markSshProxyPasswordChanged() {
        if (!this.projectForm) return;
        this.projectForm.ssh_proxy_password_changed = true;
        this.service.render();
    }

    public markSshProxy2PasswordChanged() {
        if (!this.projectForm) return;
        this.projectForm.ssh_proxy2_password_changed = true;
        this.service.render();
    }

    public toggleSshAdvancedSettings() {
        this.sshAdvancedSettingsOpen = !this.sshAdvancedSettingsOpen;
        this.service.render();
    }

    public toggleSshPublicKeySettings() {
        this.sshPublicKeySettingsOpen = !this.sshPublicKeySettingsOpen;
        this.service.render();
    }

    public onSshProxyEnabledChange(value: any) {
        if (!this.projectForm) return;
        this.projectForm.ssh_proxy_enabled = !!value;
        if (!this.projectForm.ssh_proxy_enabled) this.projectForm.ssh_proxy2_enabled = false;
        this.service.render();
    }

    public onSshProxy2EnabledChange(value: any) {
        if (!this.projectForm) return;
        this.projectForm.ssh_proxy2_enabled = !!value;
        if (this.projectForm.ssh_proxy2_enabled) this.projectForm.ssh_proxy_enabled = true;
        this.service.render();
    }

    public normalizeSshAuthMode(value: any) {
        const mode = String(value || '').trim().toLowerCase();
        const aliases: any = {
            key: 'private_key',
            project_key: 'private_key',
            uploaded_key: 'private_key',
            public_key: 'system_key',
            reviewops_key: 'system_key'
        };
        const normalized = aliases[mode] || mode;
        if (['password', 'private_key', 'system_key'].includes(normalized)) return normalized;
        if (this.project && this.project.ssh_password_configured) return 'password';
        if (this.project && this.project.ssh_private_key_configured) return 'private_key';
        return 'system_key';
    }

    public onSshAuthModeChange(value: any) {
        if (!this.projectForm) return;
        this.projectForm.ssh_auth_mode = this.normalizeSshAuthMode(value);
        if (this.projectForm.ssh_auth_mode !== 'password') this.sshPublicKeySettingsOpen = true;
        this.service.render();
    }

    public sshAdvancedSummary(form: any = this.projectForm || {}) {
        if (form.ssh_proxy_enabled && form.ssh_proxy2_enabled) return '이중 Proxy 사용 중';
        if (form.ssh_proxy_enabled) return 'Proxy 사용 중';
        return '직접 접속';
    }

    public sshPublicKeySummary() {
        const mode = this.normalizeSshAuthMode(this.projectForm && this.projectForm.ssh_auth_mode);
        if (mode === 'password') return '비밀번호 인증 선택';
        if (mode === 'private_key') {
            const selected = this.sshKeyUpload && this.sshKeyUpload.privateFile;
            if (selected) return selected.name || '새 비밀키 선택됨';
            if (this.projectForm && this.projectForm.ssh_private_key_configured) {
                return this.projectForm.ssh_private_key_name || '업로드 키 등록됨';
            }
            return '비밀키 업로드 필요';
        }
        if (!this.sshPublicKey || !this.sshPublicKey.public_key) return '시스템 공개키 없음';
        if (!this.sshPublicKey.auth_ready) return '시스템 비밀키 확인 필요';
        return 'ReviewOps 시스템 키';
    }

    public cleanSshPortValue(value: any, fallback: number = 22) {
        const port = parseInt(String(value || '').trim(), 10);
        if (!Number.isFinite(port) || port < 1 || port > 65535) return fallback;
        return port;
    }

    public sshPublicKeyText() {
        return String((this.sshPublicKey && this.sshPublicKey.public_key) || '');
    }

    public sshAuthModeLabel(form: any = this.projectForm || {}) {
        const mode = this.normalizeSshAuthMode(form && form.ssh_auth_mode);
        if (mode === 'password') return '비밀번호 인증';
        if (mode === 'private_key') return '업로드 키 파일 인증';
        return 'ReviewOps 시스템 키 인증';
    }

    public async copySshPublicKey() {
        const publicKey = this.sshPublicKeyText();
        if (!publicKey) {
            await this.service.modal.error('복사할 SSH 공개키를 찾지 못했습니다.');
            return;
        }
        try {
            await this.copyTextToClipboard(publicKey);
            await this.service.modal.success('SSH 공개키가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('SSH 공개키 복사에 실패했습니다.');
        }
    }

    public sshPublicKeyGuideMessage() {
        const publicKey = this.sshPublicKeyText() || '(ReviewOps 서버 공개키를 먼저 생성해주세요.)';
        return [
            '대상 서버에서 ReviewOps가 접속할 계정으로 아래 명령을 실행합니다.',
            '',
            'mkdir -p ~/.ssh && chmod 700 ~/.ssh',
            `printf '%s\\n' '${publicKey.replace(/'/g, "'\\''")}' >> ~/.ssh/authorized_keys`,
            'chmod 600 ~/.ssh/authorized_keys',
            '',
            'ReviewOps 서버 설정에는 Host, Port, SSH ID를 입력합니다.',
            '인증 방식을 ReviewOps 시스템 키로 선택하면 위 공개키와 연결된 비밀키로 접속합니다.',
            `현재 인증 방식: ${this.sshAuthModeLabel()}`
        ].join('\n');
    }

    public async showSshPublicKeyGuide() {
        await this.service.modal.show({
            title: 'SSH 공개키 설정 방법',
            message: this.sshPublicKeyGuideMessage(),
            cancel: false,
            action: '확인',
            actionBtn: 'success',
            status: 'success'
        });
    }

    public sshKeyUploadUrl() {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId }) as any).toString();
        return `/wiz/api/page.projects.item/upload_ssh_key${query ? `?${query}` : ''}`;
    }

    public sshKeyFileName(kind: string) {
        const key = kind === 'public' ? 'publicFile' : 'privateFile';
        const selected = this.sshKeyUpload && this.sshKeyUpload[key];
        if (selected && selected.name) return selected.name;
        if (kind === 'public' && this.sshKeyUpload && this.sshKeyUpload.privateFile) return '새 비밀키에서 자동 생성';
        if (!this.projectForm) return '';
        return kind === 'public'
            ? String(this.projectForm.ssh_public_key_name || '')
            : String(this.projectForm.ssh_private_key_name || '');
    }

    public async selectSshKeyFile(event: any, kind: string) {
        const files = this.uploadEventFiles(event);
        if (!this.canEditSettings() || this.sshKeyOperationBlocked()) return;
        if (!files.length) return;
        if (files.length !== 1) {
            await this.service.modal.error('SSH 키 파일은 한 번에 하나만 선택해주세요.');
            return;
        }
        const file = files[0];
        const isPublic = kind === 'public';
        const maxBytes = isPublic ? 16 * 1024 : 32 * 1024;
        if (Number(file.size || 0) > maxBytes) {
            await this.service.modal.error(isPublic ? '공개키 파일은 16KB 이하만 업로드할 수 있습니다.' : '비밀키 파일은 32KB 이하만 업로드할 수 있습니다.');
            return;
        }
        if (isPublic) this.sshKeyUpload.publicFile = file;
        else {
            this.sshKeyUpload.privateFile = file;
            if (this.projectForm) this.projectForm.ssh_auth_mode = 'private_key';
        }
        this.sshPublicKeySettingsOpen = true;
        await this.service.render();
    }

    public clearSshKeyFile(kind: string) {
        if (kind === 'public') this.sshKeyUpload.publicFile = null;
        else this.sshKeyUpload.privateFile = null;
        this.service.render();
    }

    public canUploadSshKey() {
        return this.canEditSettings()
            && !this.sshKeyOperationBlocked()
            && !!(this.sshKeyUpload && this.sshKeyUpload.privateFile);
    }

    public sshKeyOperationBlocked() {
        return !!(
            this.sshKeyUploading
            || this.sshKeyDeleting
            || this.saving
            || this.testingSshConnection
            || this.testingCodexSettings
            || this.loggingInCodex
            || this.requestingCodexLogin
            || this.codexSetupActionBusy()
        );
    }

    public applySshKeyProjectState(project: any) {
        if (!project) return;
        const fields = [
            'ssh_auth_mode',
            'ssh_private_key_configured',
            'ssh_private_key_name',
            'ssh_private_key_passphrase_configured',
            'ssh_public_key',
            'ssh_public_key_configured',
            'ssh_public_key_name',
            'ssh_key_algorithm',
            'ssh_key_fingerprint'
        ];
        for (const field of fields) {
            if (!(field in project)) continue;
            if (this.project) this.project[field] = project[field];
            if (this.projectForm) this.projectForm[field] = project[field];
        }
        if (this.projectForm) {
            this.projectForm.ssh_private_key = '';
            this.projectForm.ssh_private_key_passphrase = '';
        }
    }

    public async uploadSshKey() {
        if (!this.canUploadSshKey()) return;
        const fd = new FormData();
        fd.append('id', this.projectId);
        if (this.adminMode) fd.append('admin', '1');
        fd.append('private_key', this.sshKeyUpload.privateFile);
        if (this.sshKeyUpload.publicFile) fd.append('public_key', this.sshKeyUpload.publicFile);
        if (this.sshKeyUpload.passphrase) fd.append('passphrase', String(this.sshKeyUpload.passphrase));

        this.sshKeyUploading = true;
        await this.service.render();
        try {
            const { code, data } = this.normalizeUploadResponse(await this.service.file.upload(this.sshKeyUploadUrl(), fd));
            if (code !== 200) {
                await this.service.modal.error(data.message || 'SSH 키 파일을 등록하지 못했습니다.');
                return;
            }
            this.sshKeyUpload = { privateFile: null, publicFile: null, passphrase: '' };
            this.applySshKeyProjectState(data.project);
            if (this.projectForm) this.projectForm.ssh_auth_mode = 'private_key';
            this.sshPublicKeySettingsOpen = true;
            await this.service.modal.success('SSH 키 파일을 등록했습니다. 접속 테스트 후 설정을 저장해주세요.');
        } catch (e) {
            await this.service.modal.error('SSH 키 파일을 등록하지 못했습니다.');
        } finally {
            this.sshKeyUploading = false;
            await this.service.render();
        }
    }

    public async deleteSshKey() {
        if (!this.canEditSettings() || this.sshKeyOperationBlocked() || !this.projectForm || !this.projectForm.ssh_private_key_configured) return;
        const confirmed = await this.service.modal.show({
            title: 'SSH 키 삭제',
            message: '등록된 SSH 비밀키와 공개키를 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        this.sshKeyDeleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_ssh_key', this.requestParams({ id: this.projectId }));
            if (code !== 200) {
                await this.service.modal.error(data.message || 'SSH 키 파일을 삭제하지 못했습니다.');
                return;
            }
            this.sshKeyUpload = { privateFile: null, publicFile: null, passphrase: '' };
            this.applySshKeyProjectState(data.project);
            await this.service.modal.success('SSH 키 파일이 삭제되었습니다.');
        } catch (e) {
            await this.service.modal.error('SSH 키 파일을 삭제하지 못했습니다.');
        } finally {
            this.sshKeyDeleting = false;
            await this.service.render();
        }
    }

    public groupFormPayload(group: any) {
        const form = JSON.parse(JSON.stringify(group || {}));
        return {
            id: form.id || '',
            name: form.name || '',
            description: form.description || '',
            visibility: form.visibility || 'public',
            status: form.status || 'active'
        };
    }

    public projectGroupPath() {
        const groupId = this.project && this.project.group_id ? this.project.group_id : '';
        if (!groupId) return '/projects';
        const storedPath = this.storedProjectReturnPath(groupId);
        if (storedPath) return String(storedPath).split('?')[0];
        if (this.adminMode) return `/projects/group/${groupId}`;
        const role = this.project && this.project.group ? this.project.group.group_role : '';
        if (role === 'owner') return `/projects/mine/group/${groupId}`;
        if (role === 'developer' || role === 'reviewer') return `/projects/participating/group/${groupId}`;
        return `/projects/group/${groupId}`;
    }

    public projectGroupQueryParams() {
        const groupId = this.project && this.project.group_id ? this.project.group_id : '';
        const storedPath = this.storedProjectReturnPath(groupId);
        if (this.adminMode || String(storedPath || '').indexOf('admin=1') >= 0) return { admin: '1' };
        return {};
    }

    public storedProjectReturnPath(groupId: string) {
        if (!this.projectId || !groupId) return '';
        try {
            const raw = sessionStorage.getItem(`reviewops_project_return:${this.projectId}`);
            if (!raw) return '';
            const data = JSON.parse(raw);
            const path = String(data && data.path || '');
            const storedGroupId = String(data && data.group_id || '');
            if (storedGroupId !== String(groupId)) return '';
            if (this.validProjectReturnPath(path, groupId)) return path;
        } catch (e) { }
        return '';
    }

    public validProjectReturnPath(path: string, groupId: string) {
        const cleanPath = String(path || '').split('?')[0];
        if ([
            '/reviews/managed',
            '/reviews/participating',
            '/reviews/authored',
            '/reviews/authored-review',
            '/reviews/authored-closed',
            '/reviews/task-new',
            '/reviews/task-active',
            '/reviews/task-review',
            '/reviews/task-closed',
            '/reviews/todo'
        ].includes(cleanPath)) return true;
        return [
            `/projects/group/${groupId}`,
            `/projects/mine/group/${groupId}`,
            `/projects/participating/group/${groupId}`
        ].includes(cleanPath);
    }

    public labelCandidates(value: any): string[] {
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) {
            let result: string[] = [];
            for (const item of value) result = result.concat(this.labelCandidates(item));
            return result;
        }
        if (typeof value === 'object') {
            for (const key of ['value', 'label', 'text', 'title', 'name']) {
                if (value[key] !== null && value[key] !== undefined) return this.labelCandidates(value[key]);
            }
            return [];
        }
        const text = String(value).trim();
        if (text.startsWith('[') || text.startsWith('{')) {
            try {
                return this.labelCandidates(JSON.parse(text));
            } catch (e) { }
        }
        return [text];
    }

    public normalizeLabel(value: any) {
        const candidates = this.labelCandidates(value);
        let label = String(candidates.length ? candidates[0] : '').trim().replace(/^#+/, '').trim();
        while (label.indexOf('  ') >= 0) label = label.replace(/  /g, ' ');
        const key = label.toLowerCase();
        if (key === 'object' || key === '[object object]') return '';
        return label.slice(0, 40);
    }

    public normalizeLabels(labels: any) {
        let source = labels;
        if (typeof labels === 'string') {
            const text = labels.trim();
            source = text.startsWith('[') || text.startsWith('{') ? labels : text.replace(/\n/g, ',').split(',');
        }
        const result: string[] = [];
        const seen: any = {};
        for (const value of this.labelCandidates(source)) {
            const label = this.normalizeLabel(value);
            const key = label.toLowerCase();
            if (!label || key === 'object' || key === '[object object]' || seen[key]) continue;
            seen[key] = true;
            result.push(label);
            if (result.length >= 12) break;
        }
        return result;
    }

    public labelEventComposing(event: any) {
        const source = event && (event.originalEvent || event.nativeEvent || event);
        return !!(source && (source.isComposing || source.keyCode === 229 || source.which === 229));
    }

    public labelEventValue(event: any, fallback: any) {
        const target = event && event.target;
        if (target && typeof target.value === 'string') return target.value;
        return fallback;
    }

    public clearLabelEventValue(event: any) {
        const target = event && event.target;
        if (target && typeof target.value === 'string') target.value = '';
    }

    public addProjectFormLabel(value?: any) {
        if (!this.canEditSettings()) return;
        const label = this.normalizeLabel(value !== undefined ? value : this.projectForm.labelInput);
        if (!label) return false;
        this.projectForm.labels = this.normalizeLabels([...(this.projectForm.labels || []), label]);
        this.projectForm.labelInput = '';
        this.service.render();
        return true;
    }

    public removeProjectFormLabel(label: string) {
        if (!this.canEditSettings()) return;
        const key = String(label || '').toLowerCase();
        this.projectForm.labels = this.normalizeLabels(this.projectForm.labels).filter((item) => item.toLowerCase() !== key);
        this.service.render();
    }

    public handleProjectFormLabelKeydown(event: any) {
        if (!event || !['Enter', ','].includes(event.key)) return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (event.key === ',' && this.addProjectFormLabel(this.labelEventValue(event, this.projectForm.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public handleProjectFormLabelKeyup(event: any) {
        if (!event || event.key !== 'Enter') return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (this.addProjectFormLabel(this.labelEventValue(event, this.projectForm.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public async setReviewFormOption(key: string, value: string) {
        this.reviewForm[key] = value;
        await this.service.render();
    }

    public async toggleReviewForm() {
        this.showReviewForm = !this.showReviewForm;
        if (!this.showReviewForm) this.clearReviewCreateFocusMode();
        await this.service.render();
    }

    public async closeReviewForm() {
        this.showReviewForm = false;
        this.clearReviewCreateFocusMode();
        await this.service.render();
    }

    public async setReviewEditOption(key: string, value: string) {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        this.reviewEditForm[key] = value;
        await this.service.render();
    }

    public async setReviewFilter(key: string, value: string) {
        this.reviewFilters[key] = value;
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public reviewStatusFilterValues() {
        const current = this.reviewFilters && this.reviewFilters.status;
        const values = Array.isArray(current) ? current : (current ? [current] : []);
        return this.statusOptions.filter((status) => values.includes(status));
    }

    public reviewStatusFilterParam() {
        return JSON.stringify(this.reviewStatusFilterValues());
    }

    public reviewStatusFilterSelected(status: string = '') {
        const selected = this.reviewStatusFilterValues();
        return status ? selected.includes(status) : selected.length === 0;
    }

    public async toggleReviewStatusFilter(status: string = '') {
        const selected = this.reviewStatusFilterValues();
        if (!status) {
            this.reviewFilters.status = [];
        } else if (this.statusOptions.includes(status)) {
            const next = selected.includes(status)
                ? selected.filter((item) => item !== status)
                : selected.concat(status);
            this.reviewFilters.status = this.statusOptions.filter((item) => next.includes(item));
        } else {
            return;
        }
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public async searchReviewTitle() {
        this.reviewFilters.title = String(this.reviewFilters.title || '').trim();
        this.applyReviewAuthorQueryExactMatch();
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public async clearReviewTitleFilter() {
        if (!this.reviewFilters.title) return;
        this.reviewFilters.title = '';
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public syncReviewAuthorFilterOptions() {
        if (!this.reviewFilters.author_user_id) return;
        if (!this.selectedReviewAuthor()) this.reviewFilters.author_user_id = '';
    }

    public reviewAuthorFilterOptions() {
        const members = this.project && Array.isArray(this.project.members) ? this.project.members : [];
        const seen: any = {};
        const result = [];
        for (const member of members) {
            if (!member || !member.id || seen[member.id]) continue;
            seen[member.id] = true;
            result.push(member);
        }
        return result.sort((a: any, b: any) => this.reviewAuthorOptionLabel(a).localeCompare(this.reviewAuthorOptionLabel(b)));
    }

    public reviewAuthorOptionLabel(user: any) {
        if (!user) return '';
        return user.name || user.display_name || '이름 없음';
    }

    public selectedReviewAuthor() {
        const selectedId = String(this.reviewFilters.author_user_id || '');
        if (!selectedId) return null;
        return this.reviewAuthorFilterOptions().find((user: any) => user && user.id === selectedId) || null;
    }

    public reviewAuthorPickerInputValue() {
        if (this.reviewAuthorPicker.open) return this.reviewAuthorPicker.query || '';
        const selected = this.selectedReviewAuthor();
        return selected ? this.reviewAuthorOptionLabel(selected) : '';
    }

    public reviewAuthorFilterPlaceholder() {
        return '작성자';
    }

    public filteredReviewAuthorOptions() {
        const query = String(this.reviewAuthorPicker.query || '').trim().toLowerCase();
        const options = this.reviewAuthorFilterOptions();
        if (!query) return options;
        return options.filter((user: any) => {
            const text = [
                this.reviewAuthorOptionLabel(user),
                user && user.name,
                user && user.display_name,
                user && user.email
            ].join(' ').toLowerCase();
            return text.indexOf(query) >= 0;
        });
    }

    public reviewAuthorPickerMenuOpen() {
        return this.reviewAuthorPicker.open && this.reviewAuthorFilterOptions().length > 0;
    }

    public openReviewAuthorPicker() {
        this.reviewAuthorPicker.open = true;
        this.reviewAuthorPicker.query = '';
    }

    public onReviewAuthorPickerInput(value: string) {
        this.reviewAuthorPicker.query = String(value || '');
        this.reviewAuthorPicker.open = true;
        const selected = this.selectedReviewAuthor();
        const selectedLabel = selected ? this.reviewAuthorOptionLabel(selected).trim().toLowerCase() : '';
        if (this.reviewFilters.author_user_id && this.reviewAuthorPicker.query.trim().toLowerCase() !== selectedLabel) {
            this.reviewFilters.author_user_id = '';
        }
    }

    public blurReviewAuthorPicker() {
        window.setTimeout(async () => {
            this.reviewAuthorPicker.open = false;
            this.reviewAuthorPicker.query = '';
            await this.service.render();
        }, 120);
    }

    public applyReviewAuthorQueryExactMatch() {
        const query = String(this.reviewAuthorPicker.query || '').trim().toLowerCase();
        if (!query) return;
        const exact = this.reviewAuthorFilterOptions().find((user: any) => {
            const values = [
                this.reviewAuthorOptionLabel(user),
                user && user.name,
                user && user.display_name,
                user && user.email
            ];
            return values.some((value: any) => String(value || '').trim().toLowerCase() === query);
        });
        if (exact && exact.id) this.reviewFilters.author_user_id = exact.id;
    }

    public async selectReviewAuthorFilter(user: any) {
        const nextId = user && user.id ? user.id : '';
        this.reviewFilters.author_user_id = nextId;
        this.reviewAuthorPicker.open = false;
        this.reviewAuthorPicker.query = '';
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public async clearReviewAuthorFilter() {
        if (!this.reviewFilters.author_user_id && !this.reviewAuthorPicker.query) return;
        this.reviewFilters.author_user_id = '';
        this.reviewAuthorPicker.query = '';
        this.reviewAuthorPicker.open = false;
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public async toggleReviewAdvancedFilters() {
        this.reviewAdvancedFiltersOpen = !this.reviewAdvancedFiltersOpen;
        await this.service.render();
    }

    public async toggleMobileReviewFilters() {
        this.mobileReviewFiltersOpen = !this.mobileReviewFiltersOpen;
        await this.service.render();
    }

    public advancedReviewFilterCount() {
        let count = 0;
        if (this.reviewFilters.category) count += 1;
        if (this.reviewFilters.priority) count += 1;
        return count;
    }

    public reviewFilterCount() {
        let count = 0;
        if (String(this.reviewFilters.title || '').trim()) count += 1;
        if (this.reviewFilters.author_user_id) count += 1;
        if (this.reviewStatusFilterValues().length) count += 1;
        count += this.advancedReviewFilterCount();
        return count;
    }

    public mobileReviewFilterButtonClass() {
        const base = 'relative flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-[13px] font-semibold transition-colors lg:hidden ';
        if (this.mobileReviewFiltersOpen || this.reviewFilterCount()) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50';
    }

    public reviewFilterPanelClass() {
        const display = this.mobileReviewFiltersOpen ? 'block' : 'hidden lg:block';
        return `${display} mt-2 space-y-2`;
    }

    public normalizeReviewList(reviews: any[] = []) {
        return (reviews || []).filter((review) => this.reviewMatchesCurrentFilters(review));
    }

    public isReviewSortableField(field: string) {
        return ['status', 'title', 'priority'].includes(field);
    }

    public async toggleReviewSort(field: string) {
        if (!this.isReviewSortableField(field)) return;
        if (this.reviewSortField !== field) {
            this.reviewSortField = field;
            this.reviewSortOrder = 'asc';
        } else if (this.reviewSortOrder === 'asc') {
            this.reviewSortOrder = 'desc';
        } else {
            this.reviewSortField = '';
            this.reviewSortOrder = '';
        }
        this.reviewPage = 1;
        await this.loadReviews();
    }

    public reviewSortHeaderClass(field: string) {
        const base = 'inline-flex min-w-0 items-center gap-1 whitespace-nowrap rounded px-1 py-0.5 text-[11px] font-semibold uppercase transition-colors ';
        if (this.reviewSortField === field) return base + 'text-slate-950';
        return base + 'text-slate-500 hover:text-slate-900';
    }

    public reviewSortIconClass(field: string) {
        if (this.reviewSortField !== field) return 'fa-solid fa-sort text-[10px] text-slate-300';
        if (this.reviewSortOrder === 'desc') return 'fa-solid fa-chevron-down text-[10px] text-slate-700';
        return 'fa-solid fa-chevron-up text-[10px] text-slate-700';
    }

    public reviewSortHeaderTitle(field: string) {
        const labels: any = { status: '상태', title: '제목', priority: '우선순위' };
        const label = labels[field] || '필드';
        if (this.reviewSortField !== field) return `${label} 정렬`;
        if (this.reviewSortOrder === 'asc') return `${label} 역순 정렬`;
        return '업데이트순으로 보기';
    }

    public reviewStatusSortRank(status: string) {
        const order = ['resolved', 'recheck', 'in_review', 'in_progress', 'open'];
        const index = order.indexOf(String(status || ''));
        return index >= 0 ? index : order.length;
    }

    public reviewPrioritySortRank(priority: string) {
        const order = ['critical', 'high', 'normal', 'low'];
        const index = order.indexOf(String(priority || ''));
        return index >= 0 ? index : order.length;
    }

    public compareReviewFallback(a: any, b: any) {
        const updated = String(b && b.updated || '').localeCompare(String(a && a.updated || ''));
        if (updated) return updated;
        const created = String(b && b.created || '').localeCompare(String(a && a.created || ''));
        if (created) return created;
        return String(a && a.id || '').localeCompare(String(b && b.id || ''));
    }

    public compareReviewRows(a: any, b: any) {
        let result = 0;
        if (this.reviewSortField === 'status') {
            result = this.reviewStatusSortRank(a && a.status) - this.reviewStatusSortRank(b && b.status);
        } else if (this.reviewSortField === 'priority') {
            result = this.reviewPrioritySortRank(a && a.priority) - this.reviewPrioritySortRank(b && b.priority);
        } else if (this.reviewSortField === 'title') {
            const titleA = String(a && a.title || '').toLocaleLowerCase();
            const titleB = String(b && b.title || '').toLocaleLowerCase();
            result = titleA.localeCompare(titleB);
        }
        if (result && this.reviewSortOrder === 'desc') result = result * -1;
        return result || this.compareReviewFallback(a, b);
    }

    public sortReviewRows(reviews: any[] = []) {
        return (reviews || []).slice().sort((a: any, b: any) => this.compareReviewRows(a, b));
    }

    public applyReviewPageData(data: any = {}) {
        this.reviewPageSize = Math.max(Number(data.review_page_size || this.reviewPageSize) || 20, 1);
        this.reviewTotalCount = Math.max(Number(data.review_total_count || 0) || 0, 0);
        this.reviewPage = Math.max(Number(data.review_page || this.reviewPage) || 1, 1);
        this.reviews = this.sortReviewRows(this.normalizeReviewList(data.reviews || []));
        if (!this.reviewTotalCount && this.reviews.length) this.reviewTotalCount = this.reviews.length;
        this.ensureReviewPage();
        this.syncSelectedReviewListFields();
    }

    public syncSelectedReviewListFields() {
        if (!this.selectedReview || !this.selectedReview.id) return;
        const review = this.reviews.find((item: any) => item && item.id === this.selectedReview.id);
        if (!review) return;
        this.selectedReview = Object.assign({}, this.selectedReview, {
            title: review.title,
            status: review.status,
            priority: review.priority,
            category: review.category,
            current_url: review.current_url,
            codex_job_status: review.codex_job_status || '',
            codex_job_id: review.codex_job_id || '',
            codex_job_message: review.codex_job_message || '',
            codex_job_started: review.codex_job_started || '',
            codex_work_count: this.codexWorkCountValue(review.codex_work_count)
        });
    }

    public reviewMatchesCurrentFilters(review: any) {
        if (!review) return false;
        const title = String(this.reviewFilters.title || '').trim().toLowerCase();
        if (title && String(review.title || '').toLowerCase().indexOf(title) < 0) return false;
        const statuses = this.reviewStatusFilterValues();
        if (statuses.length && !statuses.includes(review.status)) return false;
        if (!statuses.length && review.status === 'closed') return false;
        const priority = this.reviewFilters.priority || '';
        if (priority && review.priority !== priority) return false;
        const category = this.reviewFilters.category || '';
        if (category && review.category !== category) return false;
        const authorUserId = this.reviewFilters.author_user_id || '';
        if (authorUserId && review.author_user_id !== authorUserId && (!review.author || review.author.id !== authorUserId)) return false;
        return true;
    }

    public visibleReviews() {
        return this.reviews.slice(0, this.reviewPageSize);
    }

    public activeCodexReviewIds() {
        return (this.reviews || [])
            .filter((review: any) => review && ['queued', 'running'].includes(review.codex_job_status))
            .map((review: any) => review.id)
            .filter((id: string) => !!id);
    }

    public codexReviewIds() {
        return (this.reviews || [])
            .map((review: any) => review && review.id)
            .filter((id: string) => !!id);
    }

    public syncCodexReviewStatusSocket(force: boolean = false) {
        this.joinCodexReviewStatusSocket(force);
    }

    public codexStatusSocketNamespace() {
        const projectName = typeof wiz.project === 'function' ? wiz.project() : 'main';
        return `/wiz/app/${projectName}/page.projects.item`;
    }

    public connectCodexStatusSocket() {
        if (this.codexStatusSocket) return;
        this.codexStatusSocket = io.connect(this.codexStatusSocketNamespace(), {
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 500
        });
        this.codexStatusSocket.on('connect', () => {
            this.codexStatusSocketConnected = true;
            this.codexStatusSocketReviewKey = '';
            this.joinCodexReviewStatusSocket(true);
        });
        this.codexStatusSocket.on('disconnect', () => {
            this.codexStatusSocketConnected = false;
            this.codexStatusSocketReviewKey = '';
        });
        this.codexStatusSocket.on('codex_review_status_snapshot', (data: any) => {
            this.applyCodexReviewStatusData(data || {});
        });
        this.codexStatusSocket.on('codex_review_status_delta', (data: any) => {
            this.applyCodexReviewStatusDelta(data || {});
        });
        this.codexStatusSocket.on('codex_review_status_error', () => {
            this.codexStatusSocketReviewKey = '';
        });
    }

    public disconnectCodexStatusSocket() {
        if (!this.codexStatusSocket) return;
        try {
            this.codexStatusSocket.emit('leave_codex_review_statuses', {});
            this.codexStatusSocket.disconnect();
        } catch (e) { }
        this.codexStatusSocket = null;
        this.codexStatusSocketConnected = false;
        this.codexStatusSocketReviewKey = '';
    }

    public leaveCodexReviewStatusSocket() {
        this.codexStatusSocketReviewKey = '';
        if (!this.codexStatusSocket || !this.codexStatusSocketConnected) return;
        try {
            this.codexStatusSocket.emit('leave_codex_review_statuses', {});
        } catch (e) { }
    }

    public joinCodexReviewStatusSocket(force: boolean = false) {
        if (this.workspaceDetached || this.destroyed || this.tab !== 'review' || !this.projectId) {
            this.leaveCodexReviewStatusSocket();
            return;
        }
        const reviewIds = this.codexReviewIds();
        this.connectCodexStatusSocket();
        if (!this.codexStatusSocket || !this.codexStatusSocketConnected) return;
        const key = `${this.projectId}:${this.adminMode ? '1' : '0'}`;
        if (!force && this.codexStatusSocketReviewKey === key) return;
        this.codexStatusSocketReviewKey = key;
        this.codexStatusSocket.emit('join_codex_review_statuses', {
            project_id: this.projectId,
            admin: this.adminMode ? '1' : '',
            review_ids: JSON.stringify(reviewIds)
        });
    }

    public applyCodexReviewStatusData(data: any = {}) {
        const metas = data.metas || {};
        const statuses = data.statuses || {};
        const workCounts = data.work_counts || {};
        let changed = false;
        this.reviews = (this.reviews || []).map((review: any) => {
            if (!review || !review.id) return review;
            const meta = metas[review.id] || {};
            const hasMeta = Object.prototype.hasOwnProperty.call(metas, review.id);
            const nextStatus = hasMeta
                ? String(meta.status || '')
                : (Object.prototype.hasOwnProperty.call(statuses, review.id) ? String(statuses[review.id] || '') : '');
            const nextWorkCount = Object.prototype.hasOwnProperty.call(workCounts, review.id)
                ? this.codexWorkCountValue(workCounts[review.id])
                : this.codexWorkCountValue(review.codex_work_count);
            const nextJobId = nextStatus ? String(meta.job_id || review.codex_job_id || '') : '';
            const nextMessage = nextStatus && Object.prototype.hasOwnProperty.call(meta, 'message')
                ? String(meta.message || '')
                : (nextStatus ? String(review.codex_job_message || '') : '');
            const nextStarted = nextStatus ? String(meta.started || review.codex_job_started || '') : '';
            if (
                String(review.codex_job_status || '') === nextStatus &&
                String(review.codex_job_id || '') === nextJobId &&
                String(review.codex_job_message || '') === nextMessage &&
                String(review.codex_job_started || '') === nextStarted &&
                this.codexWorkCountValue(review.codex_work_count) === nextWorkCount
            ) {
                return review;
            }
            changed = true;
            return Object.assign({}, review, {
                codex_job_status: nextStatus,
                codex_job_id: nextJobId,
                codex_job_message: nextMessage,
                codex_job_started: nextStarted,
                codex_work_count: nextWorkCount
            });
        });
        if (changed) {
            this.syncSelectedReviewListFields();
            this.service.render();
        }
    }

    public applyCodexReviewStatusDelta(event: any = {}) {
        const reviewId = String(event.review_id || '');
        if (!reviewId) return;
        const rawStatus = String(event.status || '');
        const active = rawStatus === 'queued' || rawStatus === 'running';
        const statuses: any = {};
        const metas: any = {};
        const workCounts: any = {};
        statuses[reviewId] = active ? rawStatus : '';
        metas[reviewId] = {
            status: active ? rawStatus : '',
            job_id: active ? String(event.job_id || '') : '',
            message: active ? String(event.message || '') : '',
            started: active ? String(event.started || '') : ''
        };
        if (Object.prototype.hasOwnProperty.call(event, 'work_count')) {
            workCounts[reviewId] = event.work_count;
        }
        this.applyCodexReviewStatusData({ statuses, metas, work_counts: workCounts });
    }

    public reviewTotalPages() {
        const total = Math.ceil(this.reviewTotalItems() / this.reviewPageSize);
        return Math.max(total || 1, 1);
    }

    public reviewTotalItems() {
        return Math.max(Number(this.reviewTotalCount) || 0, this.reviews.length);
    }

    public reviewPageStart() {
        if (!this.reviewTotalItems()) return 0;
        return (this.reviewPage - 1) * this.reviewPageSize + 1;
    }

    public reviewPageEnd() {
        return Math.min(this.reviewPage * this.reviewPageSize, this.reviewTotalItems());
    }

    public reviewPageNumbers() {
        const total = this.reviewTotalPages();
        const current = Math.min(Math.max(this.reviewPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async setReviewPage(page: number) {
        const total = this.reviewTotalPages();
        const nextPage = Math.min(Math.max(Number(page) || 1, 1), total);
        if (nextPage === this.reviewPage) return;
        this.reviewPage = nextPage;
        await this.loadReviews();
    }

    public ensureReviewPage() {
        const total = this.reviewTotalPages();
        this.reviewPage = Math.min(Math.max(Number(this.reviewPage) || 1, 1), total);
    }

    public reviewFilterToggleClass(current: string, value: string, kind: string = '') {
        const base = 'h-7 rounded-md border px-2 text-[11px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (current !== value) return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
        if (kind === 'status' && value === 'open') return base + 'border-sky-300 bg-sky-50 text-sky-700';
        if (kind === 'status' && value === 'in_progress') return base + 'border-amber-300 bg-amber-50 text-amber-800';
        if (kind === 'status' && value === 'in_review') return base + 'border-indigo-300 bg-indigo-50 text-indigo-700';
        if (kind === 'status' && value === 'resolved') return base + 'border-emerald-300 bg-emerald-50 text-emerald-700';
        if (kind === 'status' && value === 'recheck') return base + 'border-rose-300 bg-rose-50 text-rose-700';
        if (kind === 'status' && value === 'closed') return base + 'border-slate-300 bg-slate-100 text-slate-700';
        if (kind === 'priority' && value === 'low') return base + 'border-teal-300 bg-teal-50 text-teal-700';
        if (kind === 'priority' && value === 'normal') return base + 'border-sky-300 bg-sky-50 text-sky-700';
        if (kind === 'priority' && value === 'high') return base + 'border-orange-300 bg-orange-50 text-orange-700';
        if (kind === 'priority' && value === 'critical') return base + 'border-rose-300 bg-rose-50 text-rose-700';
        return base + 'border-slate-300 bg-slate-100 text-slate-700';
    }

    public reviewStatusFilterToggleClass(value: string = '') {
        const current = this.reviewStatusFilterSelected(value) ? value : '__unselected__';
        return this.reviewFilterToggleClass(current, value, 'status');
    }

    public visibilityLabel(value: string) {
        const option = this.visibilityOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public projectStatusLabel(value: string) {
        if (value === 'deleted') return '삭제';
        const option = this.projectStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public roleLabel(role: string) {
        const labels: any = {
            owner: '소유자',
            developer: '관리자',
            admin: '관리자',
            reviewer: '리뷰어',
            guest: '게스트'
        };
        return labels[role || 'reviewer'] || role;
    }

    public userDisplay(user: any) {
        if (!user) return '';
        const name = user.display_name || user.name || user.email || '';
        return user.email && user.email !== name ? `${name} <${user.email}>` : name;
    }

    public groupMoveInputClass() {
        const base = 'h-10 w-full rounded-md border px-3 pr-9 text-[13px] focus:border-slate-900 focus:outline-none ';
        if (this.groupMoveForm && this.groupMoveForm.group_id) return base + 'border-slate-900 bg-white text-slate-900';
        return base + 'border-slate-300 bg-white text-slate-700';
    }

    public groupMovePickerMenuStyle() {
        const input = document.querySelector('input[name="projectGroupMoveSearch"]') as HTMLElement;
        if (!input) return {};

        const rect = input.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || rect.width;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 640;
        const margin = 8;
        const gap = 4;
        const maxAllowedHeight = Math.max(72, viewportHeight - margin * 2);
        const desiredWidth = Math.min(Math.max(rect.width, 240), Math.max(160, viewportWidth - margin * 2));
        const availableBelow = Math.max(0, viewportHeight - rect.bottom - margin);
        const availableAbove = Math.max(0, rect.top - margin);
        const openUp = availableBelow < 220 && availableAbove > availableBelow;
        const availableHeight = openUp ? availableAbove : availableBelow;
        const menuHeight = Math.min(Math.max(72, availableHeight - gap), 288, maxAllowedHeight);

        let left = rect.left;
        if (left + desiredWidth > viewportWidth - margin) left = viewportWidth - margin - desiredWidth;
        if (left < margin) left = margin;

        let top = openUp ? rect.top - gap - menuHeight : rect.bottom + gap;
        const maxTop = viewportHeight - margin - menuHeight;
        if (top > maxTop) top = maxTop;
        if (top < margin) top = margin;

        return {
            left: `${Math.round(left)}px`,
            top: `${Math.round(top)}px`,
            width: `${Math.round(desiredWidth)}px`,
            maxHeight: `${Math.round(menuHeight)}px`
        };
    }

    public userRoleBadgeClass(role: string) {
        if (role === 'owner') return 'inline-flex rounded-full bg-slate-900 px-2 py-0.5 text-[11px] font-semibold text-white';
        if (role === 'developer') return 'inline-flex rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-700';
        if (role === 'reviewer') return 'inline-flex rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700';
        if (role === 'admin') return 'inline-flex rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-semibold text-violet-700';
        return 'inline-flex rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600';
    }

    public projectAdmins() {
        return this.project && Array.isArray(this.project.project_admins) ? this.project.project_admins : [];
    }

    public projectAdminCandidates() {
        return this.project && Array.isArray(this.project.project_admin_candidates) ? this.project.project_admin_candidates : [];
    }

    public projectAdminIds() {
        const ids: any = {};
        for (const user of this.projectAdmins()) {
            if (user && user.id) ids[user.id] = true;
        }
        return ids;
    }

    public availableProjectAdminCandidates() {
        const ids = this.projectAdminIds();
        return this.projectAdminCandidates().filter((user: any) => user && user.id && !ids[user.id]);
    }

    public projectAdminName(user: any) {
        if (!user) return '-';
        const name = user.name || user.display_name || user.email || '-';
        return user.email && user.email !== name ? `${name} · ${user.email}` : name;
    }

    public canRemoveProjectAdmin(_user: any) {
        return this.canManageProjectAdmins() && !this.savingProjectAdmins && this.projectAdmins().length > 1;
    }

    public kstDateTime(value: any) {
        return this.service.formatter.kstDateTime(value, value || '');
    }

    public reviewListRelativeDate(value: any) {
        const date = this.service.formatter.parseUtcDate(value);
        if (!date) return '-';

        const diffMs = Math.max(0, Date.now() - date.getTime());
        const minuteMs = 60 * 1000;
        const hourMs = 60 * 60 * 1000;
        const dayMs = 24 * 60 * 60 * 1000;
        const targetDate = this.service.formatter.kstDate(date, '');

        if (diffMs <= hourMs) {
            return `${Math.max(1, Math.floor(diffMs / minuteMs))}분전`;
        }

        if (diffMs <= dayMs) {
            return `${Math.max(1, Math.floor(diffMs / hourMs))}시간전`;
        }

        const days = Math.floor(diffMs / dayMs);
        if (days < 7) return `${days}일전`;
        if (days === 7) return '1주일전';
        return targetDate || '-';
    }

    public reviewListCreatedTime(review: any) {
        return review && review.created ? this.reviewListRelativeDate(review.created) : '-';
    }

    public reviewListUpdatedTime(review: any) {
        return review && review.updated ? this.reviewListRelativeDate(review.updated) : '-';
    }

    public documentVersionDisplayLabel(version: any) {
        if (!version) return '-';
        const value = version.version_label || version.created || '';
        return value ? this.kstDateTime(value) : '-';
    }

    public canEditSettings() {
        return !!(this.project && this.project.can_edit_settings);
    }

    public canExportReviewInfo() {
        return this.canEditSettings() && !!this.projectId;
    }

    public canUseRemoteProjectFiles() {
        if (!this.project || !this.project.file_enabled || this.isHtmlProject()) return false;
        if (this.project.can_manage_project_files !== undefined) return !!this.project.can_manage_project_files;
        return this.canEditSettings();
    }

    public canUseHtmlProjectFiles() {
        return !!(this.project && this.isHtmlProject() && this.project.can_manage_html_project_files);
    }

    public canUseProjectFiles() {
        return this.canUseRemoteProjectFiles() || this.canUseHtmlProjectFiles();
    }

    public canManageProjectFiles() {
        if (!this.project) return false;
        if (this.project.can_manage_project_files !== undefined) return !!this.project.can_manage_project_files;
        if (this.isHtmlProject()) return !!this.project.can_manage_html_project_files;
        return !!(this.project.file_enabled && this.canEditSettings());
    }

    public canUploadProjectFiles() {
        return this.canManageProjectFiles();
    }

    public canManageProjectFileItems() {
        return this.canManageProjectFiles();
    }

    public canUseProjectMacros() {
        return !!(this.project && this.project.can_use_macro);
    }

    public canUseProjectTerminal() {
        return !!(this.project && this.project.can_use_terminal);
    }

    public canEditIntro() {
        return !!(this.project && this.project.can_edit_intro);
    }

    public canMoveProject() {
        return !!(this.project && this.project.can_move_project);
    }

    public canManageProjectAdmins() {
        return !!(this.project && this.project.can_manage_project_admins);
    }

    public canDeleteProject() {
        return !!(this.project && this.project.can_delete_project);
    }

    public canRestoreProject() {
        return !!(this.project && this.project.can_restore_project);
    }

    public canTestSshConnection() {
        const form = this.projectForm || {};
        return this.projectSshSettingsReady(form)
            && !this.testingSshConnection
            && !this.testingCodexSettings
            && !this.loggingInCodex
            && !this.codexSetupActionBusy();
    }

    public projectSshSettingsReady(form: any = this.projectForm || {}) {
        if (this.sshKeyUploading || this.sshKeyDeleting) return false;
        const authMode = this.normalizeSshAuthMode(form.ssh_auth_mode);
        const passwordReady = form.ssh_password_changed
            ? !!String(form.ssh_password || '')
            : !!form.ssh_password_configured;
        const credentialReady = authMode === 'password'
            ? passwordReady
            : (authMode === 'private_key'
                ? !!form.ssh_private_key_configured
                : !!(this.sshPublicKey && this.sshPublicKey.auth_ready));
        const proxyReady = !form.ssh_proxy_enabled
            || (
                !!String(form.ssh_proxy_host || '').trim()
                && !!String(form.ssh_proxy_user || '').trim()
            );
        const proxy2Ready = !form.ssh_proxy2_enabled
            || (
                !!form.ssh_proxy_enabled
                && !!String(form.ssh_proxy2_host || '').trim()
                && !!String(form.ssh_proxy2_user || '').trim()
            );
        return this.canEditSettings()
            && !!String(form.ssh_host || '').trim()
            && this.cleanSshPortValue(form.ssh_port, 0) > 0
            && !!String(form.ssh_user || '').trim()
            && credentialReady
            && proxyReady
            && proxy2Ready;
    }

    public canTestCodexSettings() {
        const form = this.projectForm || {};
        return this.projectSshSettingsReady(form)
            && !this.testingSshConnection
            && !this.testingCodexSettings
            && !this.loggingInCodex
            && !this.requestingCodexLogin
            && !this.codexSetupActionBusy()
            && !!String(form.codex_root_path || '').trim();
    }

    public canLoginCodexSettings() {
        const form = this.projectForm || {};
        return this.projectSshSettingsReady(form)
            && !this.testingSshConnection
            && !this.testingCodexSettings
            && !this.loggingInCodex
            && !this.requestingCodexLogin
            && !this.codexSetupActionBusy()
            && !!String(form.codex_root_path || '').trim();
    }

    public canRequestCodexLogin() {
        const form = this.projectForm || {};
        const latest = this.latestCodexLoginRequest();
        const latestStatus = String(latest && latest.status || '');
        return this.projectSshSettingsReady(form)
            && !this.testingSshConnection
            && !this.testingCodexSettings
            && !this.loggingInCodex
            && !this.requestingCodexLogin
            && !this.codexSetupActionBusy()
            && !['requested', 'in_progress'].includes(latestStatus)
            && !!String(form.codex_root_path || '').trim();
    }

    public codexSetupActionBusy() {
        return this.codexUpgradeBusy || this.wizSetupChecking || this.wizSetupRunning;
    }

    public canRunCodexToolAction() {
        const form = this.projectForm || {};
        return this.projectSshSettingsReady(form)
            && !this.testingSshConnection
            && !this.testingCodexSettings
            && !this.loggingInCodex
            && !this.requestingCodexLogin
            && !this.codexSetupActionBusy()
            && !!String(form.codex_root_path || '').trim();
    }

    public codexSettingsPayload() {
        const form = this.projectForm || {};
        const payload: any = {
            ssh_host: form.ssh_host || '',
            ssh_port: this.cleanSshPortValue(form.ssh_port, 22),
            ssh_user: form.ssh_user || '',
            ssh_auth_mode: this.normalizeSshAuthMode(form.ssh_auth_mode),
            ssh_proxy_enabled: !!form.ssh_proxy_enabled,
            ssh_proxy_host: form.ssh_proxy_host || '',
            ssh_proxy_user: form.ssh_proxy_user || '',
            ssh_proxy2_enabled: !!form.ssh_proxy2_enabled,
            ssh_proxy2_host: form.ssh_proxy2_host || '',
            ssh_proxy2_user: form.ssh_proxy2_user || '',
            codex_enabled: !!form.codex_enabled,
            codex_root_path: form.codex_root_path || '/opt/app',
            codex_command_path: form.codex_command_path || ''
        };
        if (form.ssh_password_changed) payload.ssh_password = form.ssh_password || '';
        if (form.ssh_proxy_password_changed) payload.ssh_proxy_password = form.ssh_proxy_password || '';
        if (form.ssh_proxy2_password_changed) payload.ssh_proxy2_password = form.ssh_proxy2_password || '';
        return payload;
    }

    public latestCodexLoginRequest() {
        return (this.projectForm && this.projectForm.codex_login_request) || (this.project && this.project.codex_login_request) || null;
    }

    public codexLoginRequestStatusLabel(request: any = this.latestCodexLoginRequest()) {
        const status = String(request && request.status || '');
        const labels: any = {
            requested: '요청됨',
            in_progress: '처리중',
            completed: '완료',
            failed: '실패',
            cancelled: '취소'
        };
        return request && (request.status_label || labels[status]) || '';
    }

    public codexLoginRequestSummaryText() {
        const request = this.latestCodexLoginRequest();
        if (!request) return '';
        const created = request.created ? this.kstDateTime(request.created) : '';
        const status = this.codexLoginRequestStatusLabel(request);
        const message = request.message ? ` · ${request.message}` : '';
        return `최근 에이전트 인증 요청: ${status}${created ? ` · ${created}` : ''}${message}`;
    }

    public codexLoginRequestReasonText() {
        const request = this.latestCodexLoginRequest();
        return String(request && request.reason || '').trim();
    }

    public codexLoginRequestAdminNoteText() {
        const request = this.latestCodexLoginRequest();
        return String(request && request.admin_note || '').trim();
    }

    public codexLoginRequestType() {
        const problem = this.codexStatusProblemText();
        if (problem) return 'auth_error';
        const status = this.codexStatusSnapshot();
        const usage = status && status.usage ? status.usage : {};
        const summary = this.codexStatusText(usage.summary).toLowerCase();
        if (summary.includes('limit') || summary.includes('0%')) return 'usage_limit';
        return this.codexAccountLoggedIn() ? 'relogin' : 'login';
    }

    public codexLoginRequestButtonText() {
        if (this.requestingCodexLogin) return '요청 중';
        const latest = this.latestCodexLoginRequest();
        const status = String(latest && latest.status || '');
        if (status === 'requested') return '요청 대기 중';
        if (status === 'in_progress') return '처리 중';
        if (latest && ['failed', 'cancelled', 'completed'].includes(status)) return '에이전트 인증 재요청';
        return '에이전트 인증 요청';
    }

    public codexLoginRequestDefaultReason() {
        const latest = this.latestCodexLoginRequest();
        const status = String(latest && latest.status || '');
        const adminNote = String(latest && latest.admin_note || '').trim();
        const message = String(latest && latest.message || '').trim();
        if (status === 'cancelled' && adminNote) return `이전 요청 취소 후 재신청합니다.\n취소 사유: ${adminNote}`;
        if (status === 'failed' && message) return `이전 요청 처리 실패 후 재신청합니다.\n실패 사유: ${message}`;
        const problem = this.codexStatusProblemText();
        if (problem) return problem;
        const usage = this.codexUsageFooterText();
        if (usage) return usage;
        return '';
    }

    public openCodexLoginRequestForm() {
        if (!this.canRequestCodexLogin()) return;
        this.codexLoginRequestReason = this.codexLoginRequestDefaultReason();
        this.codexLoginRequestFormOpen = true;
        this.service.render();
    }

    public closeCodexLoginRequestForm() {
        if (this.requestingCodexLogin) return;
        this.codexLoginRequestFormOpen = false;
        this.codexLoginRequestReason = '';
        this.service.render();
    }

    public async submitCodexLoginRequest() {
        await this.requestCodexLogin(this.codexLoginRequestReason);
    }

    public codexAccountLoggedIn() {
        const status = this.codexStatusSnapshot();
        const account = status && status.account ? status.account : {};
        const accountStatus = String(account.status || '').toLowerCase();
        if (
            accountStatus.includes('not_logged_in')
            || accountStatus.includes('not logged in')
            || accountStatus.includes('login required')
            || accountStatus.includes('login_expired')
            || accountStatus.includes('expired')
            || accountStatus.includes('auth_error')
            || accountStatus.includes('authentication required')
        ) return false;
        return !!(
            account.email
            || account.name
            || account.id
            || account.plan
            || account.auth_method
            || accountStatus === 'logged_in'
        );
    }

    public codexLoginPanelVisible() {
        return this.codexLoginPanelOpen || !this.codexAccountLoggedIn();
    }

    public codexLoginSummaryText() {
        const status = this.codexStatusSnapshot();
        const account = status && status.account ? status.account : {};
        const authCheck = status && status.auth_check ? status.auth_check : {};
        if (authCheck.status === 'login_expired') return '에이전트 로그인 만료';
        return account.email || account.name || account.id || account.auth_method || '로그인됨';
    }

    public async openCodexLoginPanel() {
        this.codexLoginPanelOpen = true;
        await this.service.render();
    }

    public async closeCodexLoginPanel() {
        if (this.loggingInCodex) return;
        this.codexLoginPanelOpen = false;
        this.codexDeviceAuth = null;
        this.copiedCodexDeviceCode = '';
        await this.service.render();
    }

    public codexDeviceCodeCopied(deviceCode: any) {
        const code = String(deviceCode || '').trim();
        return !!code && this.copiedCodexDeviceCode === code;
    }

    public async copyCodexDeviceCode(deviceCode: any) {
        const code = String(deviceCode || '').trim();
        if (!code) return;
        try {
            await this.copyTextToClipboard(code);
            this.copiedCodexDeviceCode = code;
        } catch (e) {
            this.copiedCodexDeviceCode = '';
        }
        await this.service.render();
    }

    public codexStatusSnapshot() {
        return (this.projectForm && this.projectForm.codex_status) || (this.project && this.project.codex_status) || null;
    }

    public codexStatusCheckedAt() {
        const status = this.codexStatusSnapshot();
        return status && status.checked_at ? this.kstDateTime(status.checked_at) : '';
    }

    public codexStatusRouteLabel() {
        const status = this.codexStatusSnapshot();
        const route = status && status.route ? String(status.route) : '';
        if (route === 'local') return '로컬';
        if (route === 'proxy') return 'Proxy 경유';
        if (route === 'double_proxy') return '이중 Proxy 경유';
        if (route === 'direct') return '직접';
        return route;
    }

    public codexStatusText(value: any) {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'number') return Number.isFinite(value) ? String(value) : '';
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return '';
            }
        }
        return String(value);
    }

    public codexStatusPercent(value: any) {
        const text = this.codexStatusText(value);
        return text ? `${text.replace(/%$/, '')}%` : '';
    }

    public codexUsagePercentText(value: any) {
        if (value === null || value === undefined || value === '') return '';
        const percent = Number(value);
        if (Number.isFinite(percent)) return `${Math.round(percent * 10) / 10}`.replace(/\.0$/, '') + '%';
        const text = this.codexStatusText(value).replace(/\s*left$/i, '').replace(/%$/, '');
        return text ? `${text}%` : '';
    }

    public codexUsageGroups(status: any = this.codexStatusSnapshot()) {
        const usage = status && status.usage ? status.usage : {};
        const rawGroups = Array.isArray(usage.groups) ? usage.groups : [];
        const groups: any[] = rawGroups.map((group: any) => {
            const source = `${group && group.key || ''} ${group && group.label || ''}`.toLowerCase();
            const key = source.includes('spark') ? 'spark' : 'default';
            return {
                key,
                label: key,
                limits: (Array.isArray(group && group.limits) ? group.limits : []).filter(
                    (item: any) => this.codexStatusText(item && item.window).toLowerCase().includes('weekly')
                )
            };
        }).filter((group) => group.key !== 'spark');
        const normalizedGroups = this.codexUsageSortedGroups(groups);
        if (normalizedGroups.length) return normalizedGroups;

        const limits = Array.isArray(usage.limits) ? usage.limits : [];
        const fallback: any = {};
        limits.forEach((line: any) => {
            const text = this.codexStatusText(line);
            const lower = text.toLowerCase();
            const key = lower.includes('spark') ? 'spark' : 'default';
            if (key === 'spark') return;
            const window = lower.includes('weekly') ? 'weekly' : '';
            const percentMatch = text.match(/(\d+(?:\.\d+)?)\s*%/);
            const resetMatch = text.match(/\(\s*resets?\s+([^)]+)\)/i);
            if (!window || !percentMatch) return;
            if (!fallback[key]) fallback[key] = { key, label: key, limits: [] };
            fallback[key].limits.push({
                window,
                remaining_percent: Number(percentMatch[1]),
                reset_at: resetMatch ? resetMatch[1] : ''
            });
        });
        const fallbackGroups = this.codexUsageSortedGroups(Object.values(fallback));
        if (fallbackGroups.length) return fallbackGroups;
        const remainingWeekly = usage.remaining_weekly ?? usage.usage_weekly_percent;
        const resetWeekly = usage.reset_weekly || usage.usage_weekly_reset_at || '';
        if (remainingWeekly !== null && remainingWeekly !== undefined && remainingWeekly !== '') {
            return [{
                key: 'default',
                label: 'default',
                limits: [{ window: 'weekly', remaining_percent: remainingWeekly, reset_at: resetWeekly }]
            }];
        }
        return [];
    }

    public codexUsageSortedGroups(groups: any[]) {
        return (groups || [])
            .filter((group) => group && group.key !== 'spark' && Array.isArray(group.limits) && group.limits.length)
            .sort((a, b) => {
                const order: any = { default: 0, spark: 1 };
                return (order[a.key] ?? 9) - (order[b.key] ?? 9);
            });
    }

    public codexUsageGroupLabel(group: any) {
        return String(group && group.key || '').toLowerCase().includes('spark') ? 'spark' : '사용현황';
    }

    public codexUsageGroupMainText(group: any) {
        const limits = Array.isArray(group && group.limits) ? group.limits : [];
        return limits.map((item: any) => {
            const window = this.codexStatusText(item.window);
            const percent = this.codexUsagePercentText(item.remaining_percent);
            return window && percent ? `${window} ${percent}` : (percent || window);
        }).filter((value: any) => !!value).join(' · ');
    }

    public codexUsageGroupResetText(group: any) {
        const limits = Array.isArray(group && group.limits) ? group.limits : [];
        const resets = limits.map((item: any) => {
            const window = this.codexStatusText(item.window);
            const reset = this.codexStatusText(item.reset_at || item.reset);
            return window && reset ? `${window} ${reset}` : reset;
        }).filter((value: any) => !!value);
        return resets.length ? `reset ${resets.join(' · ')}` : '';
    }

    public codexUsageSummaryDisplayText(value: any) {
        const summary = this.codexStatusText(value).replace(/\s*left\b/gi, '');
        if (!summary) return '';
        const parts = summary
            .replace(/;\s*/g, ' / ')
            .split(/\s*\/\s*/)
            .map((part) => part.trim())
            .filter((part) => {
                const lower = part.toLowerCase();
                return !!part && lower.includes('weekly') && !lower.includes('spark');
            })
            .map((part) => part.replace(/\bdefault\b\s*:?/i, '사용현황 '));
        return parts.join(' / ').replace(/\s+/g, ' ').trim();
    }

    public codexStatusFirstValue(source: any, keys: string[]) {
        const data = source || {};
        for (const key of keys) {
            const value = this.codexStatusText(data[key]);
            if (value) return value;
        }
        return '';
    }

    public codexStatusDateText(value: any) {
        const text = this.codexStatusText(value);
        return text ? this.kstDateTime(text) : '';
    }

    public codexStatusAuthCheckLabel(value: any) {
        const text = String(value || '').toLowerCase();
        if (text === 'available') return '정상';
        if (text === 'login_expired') return '로그인 만료';
        if (text === 'failed') return '확인 실패';
        return this.codexStatusText(value);
    }

    public codexStatusRows(source: any, rows: any[]) {
        const data = source || {};
        return rows
            .map((row) => ({ label: row.label, value: row.format ? row.format(data[row.key]) : this.codexStatusText(data[row.key]) }))
            .filter((row) => !!row.value);
    }

    public codexStatusAccountRows() {
        const status = this.codexStatusSnapshot();
        const account = status && status.account ? status.account : {};
        return this.codexStatusRows(account, [
            { label: '이메일', key: 'email' },
            { label: '구독', key: 'plan' },
            { label: '구독 시작', key: 'subscription_start', format: (value: any) => this.codexStatusDateText(value) },
            { label: '구독 만료', key: 'subscription_until', format: (value: any) => this.codexStatusDateText(value) },
            { label: '구독 확인', key: 'subscription_last_checked', format: (value: any) => this.codexStatusDateText(value) },
            { label: '이름', key: 'name' },
            { label: '인증 상태', key: 'status' },
            { label: '인증', key: 'auth_method' },
            { label: '조직', key: 'organization' },
            { label: '계정 ID', key: 'id' }
        ]);
    }

    public codexStatusUsageRows() {
        const status = this.codexStatusSnapshot();
        const groups = this.codexUsageGroups(status);
        if (groups.length) {
            return groups.map((group) => ({
                label: `${this.codexUsageGroupLabel(group)} 사용량`,
                value: [
                    this.codexUsageGroupMainText(group),
                    this.codexUsageGroupResetText(group)
                ].filter((value) => !!value).join(' · ')
            }));
        }
        return [];
    }

    public codexStatusEnvironmentRows() {
        const status = this.codexStatusSnapshot();
        const env = status && status.environment ? status.environment : {};
        const baseRows = this.codexStatusRows(env, [
            { label: '에이전트', key: 'codex' },
            { label: '버전', key: 'version' },
            { label: '모델', key: 'model' },
            { label: 'Provider', key: 'provider' }
        ]);
        const metaRows = [
            { label: '명령', value: this.codexStatusText(status && status.status_command) },
            { label: '경로', value: this.codexStatusText(status && status.root_path) },
            { label: '접속', value: this.codexStatusRouteLabel() }
        ].filter((row) => !!row.value);
        return [...baseRows, ...metaRows];
    }

    public codexStatusDisplayRows() {
        const status = this.codexStatusSnapshot() || {};
        const account = status.account || {};
        const environment = status.environment || {};
        const authCheck = status.auth_check || {};
        const rows: any[] = [];
        const add = (label: string, value: any, formatter?: any) => {
            const text = formatter ? formatter(value) : this.codexStatusText(value);
            if (text) rows.push({ label, value: text });
        };

        add('실행 인증', authCheck.label || authCheck.status, (value: any) => authCheck.label || this.codexStatusAuthCheckLabel(value));
        add('실행 인증 메시지', authCheck.message);
        add('이메일', this.codexStatusFirstValue(account, ['email', 'account_email', 'user_email']));
        add('구독', this.codexStatusFirstValue(account, ['subscription', 'plan', 'tier', 'chatgpt_plan_type']));
        add('구독 시작', this.codexStatusFirstValue(account, ['subscription_start', 'subscription_active_start', 'chatgpt_subscription_active_start']), (value: any) => this.codexStatusDateText(value));
        add('구독 만료', this.codexStatusFirstValue(account, ['subscription_until', 'subscription_active_until', 'chatgpt_subscription_active_until']), (value: any) => this.codexStatusDateText(value));
        add('구독 확인', this.codexStatusFirstValue(account, ['subscription_last_checked', 'chatgpt_subscription_last_checked']), (value: any) => this.codexStatusDateText(value));
        add('이름', this.codexStatusFirstValue(account, ['name', 'account_name', 'user_name']));
        add('조직', this.codexStatusFirstValue(account, ['organization', 'org', 'workspace', 'team']));
        add('인증 상태', this.codexStatusFirstValue(account, ['status']));
        add('인증 방식', this.codexStatusFirstValue(account, ['auth_method']));
        add('계정 ID', this.codexStatusFirstValue(account, ['id', 'account_id', 'user_id']));
        const usageGroups = this.codexUsageGroups(status);
        if (usageGroups.length) {
            usageGroups.forEach((group) => {
                add(`${this.codexUsageGroupLabel(group)} 사용량`, this.codexUsageGroupMainText(group));
                add(`${this.codexUsageGroupLabel(group)} 리셋`, this.codexUsageGroupResetText(group).replace(/^reset\s*/, ''));
            });
        }
        add('에이전트', environment.codex);
        add('버전', environment.version);
        add('모델', environment.model);
        add('Provider', environment.provider);
        add('명령', status.status_command);
        add('경로', status.root_path);
        add('접속', this.codexStatusRouteLabel());
        return rows;
    }

    public async toggleCodexStatusPanel() {
        this.codexStatusPanelOpen = !this.codexStatusPanelOpen;
        await this.service.render();
    }

    public codexVersionText() {
        const status = this.codexStatusSnapshot();
        const environment = status && status.environment ? status.environment : {};
        return this.codexStatusText(environment.version || environment.codex) || '확인 전';
    }

    public wizSetupStatusText() {
        const status = this.wizSetupStatus;
        if (!status) return '확인 전';
        if (status.configured) return '설정됨';
        if (status.ok === false) return '확인 실패';
        return '미설정';
    }

    public wizSetupStatusClass() {
        const base = 'inline-flex h-7 shrink-0 items-center rounded-md px-2 text-[11px] font-semibold ';
        const status = this.wizSetupStatus;
        if (!status) return base + 'bg-slate-100 text-slate-500';
        if (status.configured) return base + 'bg-emerald-50 text-emerald-700';
        if (status.ok === false) return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-amber-50 text-amber-700';
    }

    public wizSetupStatusItems() {
        return this.wizSetupStatus && Array.isArray(this.wizSetupStatus.items) ? this.wizSetupStatus.items : [];
    }

    public async toggleWizSetupStatusPanel() {
        this.wizSetupStatusPanelOpen = !this.wizSetupStatusPanelOpen;
        await this.service.render();
    }

    public showCodexUsageFooter() {
        return !!(this.project && this.project.codex_enabled && this.project.can_use_codex);
    }

    public codexStatusProblemText(status: any = this.codexStatusSnapshot()) {
        if (!status) return '';
        const authCheck = status.auth_check || {};
        if (authCheck && authCheck.ok === false) {
            return authCheck.message || authCheck.label || this.codexStatusAuthCheckLabel(authCheck.status) || '에이전트 실행 인증 확인에 실패했습니다.';
        }
        const account = status.account || {};
        const accountStatus = String(account.status || '').toLowerCase();
        if (
            accountStatus.includes('not_logged_in')
            || accountStatus.includes('not logged in')
            || accountStatus.includes('login required')
            || accountStatus.includes('login_expired')
            || accountStatus.includes('expired')
            || accountStatus.includes('auth_error')
            || accountStatus.includes('authentication required')
        ) {
            return account.status || '에이전트 로그인이 필요합니다.';
        }
        const exitCode = Number(status.status_exit_code || 0);
        if (exitCode) return `에이전트 상태 확인 명령이 실패했습니다. (exit ${exitCode})`;
        return '';
    }

    public codexUsageFooterBadgeClass() {
        const base = 'inline-flex h-6 shrink-0 items-center rounded-md px-2 text-[11px] font-semibold ';
        if (this.codexFooterRefreshing) return base + 'bg-slate-100 text-slate-600';
        if (this.codexFooterError || this.codexStatusProblemText()) return base + 'bg-rose-50 text-rose-700';
        if (!this.codexStatusSnapshot()) return base + 'bg-amber-50 text-amber-700';
        return base + 'bg-emerald-50 text-emerald-700';
    }

    public codexUsageFooterBadgeText() {
        if (this.codexFooterRefreshing) return '확인 중';
        if (this.codexFooterError || this.codexStatusProblemText()) return '연동 문제';
        if (!this.codexStatusSnapshot()) return '정보 없음';
        return '정상';
    }

    public codexUsageSummaryText(status: any = this.codexStatusSnapshot()) {
        const usage = status && status.usage ? status.usage : {};
        const groups = this.codexUsageGroups(status);
        if (groups.length) {
            return groups.map((group) => `${this.codexUsageGroupLabel(group)} ${this.codexUsageGroupMainText(group)}`).join(' / ');
        }
        const summary = this.codexUsageSummaryDisplayText(usage.summary);
        if (summary) return `사용량 ${summary}`;
        return '';
    }

    public codexUsageFooterGroups() {
        const status = this.codexStatusSnapshot();
        if (!status || this.codexFooterError || this.codexStatusProblemText(status)) return [];
        return this.codexUsageGroups(status);
    }

    public codexUsageFooterText() {
        if (this.codexFooterRefreshing) return 'OpenAI 사용량 정보를 확인하는 중입니다.';
        if (this.codexFooterError) return `연동 문제: ${this.codexFooterError}`;
        const status = this.codexStatusSnapshot();
        if (!status) return 'OpenAI 사용량 정보 없음';
        const problem = this.codexStatusProblemText(status);
        if (problem) return `연동 문제: ${problem}`;
        return this.codexUsageSummaryText(status) || 'OpenAI 사용량 정보가 없습니다.';
    }

    public codexUsageFooterMetaText() {
        const status = this.codexStatusSnapshot();
        if (!status) return '';
        const account = status.account || {};
        const accountLabel = account.email || account.name || account.id || account.plan || '';
        const checkedAt = this.codexStatusCheckedAt();
        const resetAt = this.codexUsageFooterGroups()
            .map((group: any) => this.codexUsageGroupResetText(group).replace(/^reset\s*/, ''))
            .filter((value: any) => !!value)
            .join(' · ');
        return [
            accountLabel,
            checkedAt ? `확인 ${checkedAt}` : '',
            resetAt ? `초기화 ${resetAt}` : '',
            this.codexStatusRouteLabel()
        ].filter((value) => !!value).join(' · ');
    }

    public async refreshCodexUsageFooter() {
        if (!this.showCodexUsageFooter() || this.codexFooterRefreshing) return;
        this.codexFooterRefreshing = true;
        this.codexFooterError = '';
        await this.service.render();
        const { code, data } = await wiz.call('refresh_codex_status', this.requestParams({
            id: this.projectId
        }));
        const result = data && data.result ? data.result : null;
        if (result && result.status) {
            if (this.project) this.project.codex_status = result.status;
            if (this.projectForm) this.projectForm.codex_status = result.status;
        }
        if (code === 200 && result) {
            if (!result.ok) this.codexFooterError = result.message || this.codexStatusProblemText(result.status) || 'OpenAI 사용량 확인에 실패했습니다.';
        } else {
            this.codexFooterError = (data && data.message) || 'OpenAI 사용량 확인에 실패했습니다.';
        }
        this.codexFooterRefreshing = false;
        await this.service.render();
    }

    public projectFileItems() {
        return (this.fileBrowser && this.fileBrowser.items) || [];
    }

    public projectFileBreadcrumbs() {
        const breadcrumbs = (this.fileBrowser && this.fileBrowser.breadcrumbs && this.fileBrowser.breadcrumbs.length)
            ? this.fileBrowser.breadcrumbs
            : [{ label: 'root', path: '' }];
        return breadcrumbs.map((item: any, index: number) => {
            return index === 0 ? Object.assign({}, item, { label: '' }) : item;
        });
    }

    public fileParentPath() {
        const current = String(this.fileBrowser && this.fileBrowser.path || '').split('/').filter((part) => !!part);
        current.pop();
        return current.join('/');
    }

    public canOpenFileParent() {
        return !!String(this.fileBrowser && this.fileBrowser.path || '');
    }

    public fileApiName(remoteApi: string, htmlApi: string) {
        return this.canUseHtmlProjectFiles() ? htmlApi : remoteApi;
    }

    public htmlProjectFileUploadUrl(path: any = null) {
        const uploadPath = path === null ? String(this.fileBrowser && this.fileBrowser.path || '') : String(path || '');
        const query = new URLSearchParams(this.requestParams({
            id: this.projectId,
            path: uploadPath
        }) as any).toString();
        return `/wiz/api/page.projects.item/upload_html_project_file${query ? `?${query}` : ''}`;
    }

    public projectFileUploadUrl(path: any = null) {
        const uploadPath = path === null ? String(this.fileBrowser && this.fileBrowser.path || '') : String(path || '');
        if (this.canUseHtmlProjectFiles()) return this.htmlProjectFileUploadUrl(uploadPath);
        const query = new URLSearchParams(this.requestParams({
            id: this.projectId,
            path: uploadPath
        }) as any).toString();
        return `/wiz/api/page.projects.item/upload_project_file${query ? `?${query}` : ''}`;
    }

    public projectFileDownloadUrl(path: any = '') {
        const query = new URLSearchParams(this.requestParams({
            id: this.projectId,
            path: String(path || '')
        }) as any).toString();
        return `/wiz/api/page.projects.item/download_project_file${query ? `?${query}` : ''}`;
    }

    public htmlProjectArchiveDownloadUrl(path: any = '', scope: string = 'item') {
        const query = new URLSearchParams(this.requestParams({
            id: this.projectId,
            data: JSON.stringify({
                path: String(path || ''),
                scope: scope || 'item'
            })
        }) as any).toString();
        return `/wiz/api/page.projects.item/download_html_project_archive${query ? `?${query}` : ''}`;
    }

    public projectFileBrowserWindowUrl(path: any = null) {
        const targetPath = path === null
            ? String((this.fileViewer && this.fileViewer.path) || (this.fileBrowser && this.fileBrowser.path) || '')
            : String(path || '');
        const query: any = {};
        if (this.adminMode) query.admin = '1';
        if (targetPath) query.path = targetPath;
        const queryString = new URLSearchParams(query).toString();
        return `/project-file-browser/${encodeURIComponent(this.projectId)}${queryString ? `?${queryString}` : ''}`;
    }

    public openProjectFileBrowserWindow(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canUseProjectFiles()) return;
        const opened = window.open(this.projectFileBrowserWindowUrl(), '_blank');
        if (opened) {
            try {
                opened.opener = null;
            } catch (e) { }
        }
    }

    public async loadProjectFiles(path: any = '') {
        if (!this.canUseProjectFiles()) return;
        this.fileBrowserLoading = true;
        this.fileError = '';
        this.fileViewer = null;
        this.fileOpenLoading = false;
        this.fileRenamePath = '';
        this.fileRenameValue = '';
        this.fileBrowser = Object.assign({}, this.fileBrowser || {}, {
            path: String(path || ''),
            items: []
        });
        await this.service.render();
        const { code, data } = await wiz.call(this.fileApiName('load_project_files', 'load_html_project_files'), this.requestParams({
            id: this.projectId,
            path: String(path || '')
        }));
        this.fileBrowserLoading = false;
        if (code === 200) {
            this.fileBrowser = data.browser || { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
            this.fileViewer = null;
        } else {
            this.fileError = data.message || '파일 목록을 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async openProjectFileItem(item: any) {
        if (!item) return;
        if (item.is_directory || item.type === 'directory') {
            await this.loadProjectFiles(item.path || '');
            return;
        }
        await this.loadProjectFile(item.path || '');
    }

    public async loadProjectFile(path: any) {
        const filePath = String(path || '');
        if (!filePath || !this.canUseProjectFiles()) return;
        this.fileOpenLoading = true;
        this.fileError = '';
        this.fileViewer = null;
        await this.service.render();
        const { code, data } = await wiz.call(this.fileApiName('load_project_file', 'load_html_project_file'), this.requestParams({
            id: this.projectId,
            path: filePath
        }));
        this.fileOpenLoading = false;
        if (code === 200) {
            const file = data.file || null;
            if (file && file.viewer === 'download' && file.data_url) {
                this.downloadDataUrl(file.data_url, file.name || 'download', file.mime || 'application/octet-stream');
                this.fileViewer = Object.assign({}, file, { viewer: 'downloaded' });
            } else {
                this.fileViewer = file;
            }
        } else {
            this.fileError = data.message || '파일을 열지 못했습니다.';
        }
        await this.service.render();
    }

    public closeProjectFileViewer() {
        this.fileViewer = null;
        this.service.render();
    }

    public downloadProjectFile(file: any = this.fileViewer) {
        if (!file) return;
        if (file.data_url) {
            this.downloadDataUrl(file.data_url, file.name || 'download', file.mime || 'application/octet-stream');
            return;
        }
        const mime = file.mime || 'text/plain';
        const content = encodeURIComponent(String(file.content || ''));
        this.downloadDataUrl(`data:${mime};charset=utf-8,${content}`, file.name || 'download', mime);
    }

    public downloadCurrentProjectFile() {
        if (this.canUseHtmlProjectFiles() && this.fileViewer && this.fileViewer.url) {
            this.downloadHtmlProjectFileItem(this.fileViewer);
            return;
        }
        this.downloadProjectFile();
    }

    public downloadHtmlProjectFileItem(item: any) {
        if (!item || item.is_directory || item.type === 'directory') return;
        const url = item.url || this.projectHtmlFileUrl(item.path || '');
        if (!url) return;
        const link = document.createElement('a');
        link.href = url;
        link.download = item.name || 'download';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public async downloadRemoteProjectFile(path: any, fallbackName: string = 'download') {
        const filePath = String(path || '');
        if (this.fileActionBusy) return;
        this.fileActionBusy = true;
        this.fileError = '';
        await this.service.render();
        try {
            const response = await fetch(this.projectFileDownloadUrl(filePath), { credentials: 'same-origin' });
            if (!response.ok) {
                let message = '파일을 다운로드하지 못했습니다.';
                try {
                    const data = await response.json();
                    message = data && data.message ? data.message : message;
                } catch (e) { }
                this.fileError = message;
                return;
            }
            const blob = await response.blob();
            const fileName = this.responseDownloadFileName(response, fallbackName);
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = this.safeAttachmentName(fileName);
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            this.fileError = '파일을 다운로드하지 못했습니다.';
        } finally {
            this.fileActionBusy = false;
            await this.service.render();
        }
    }

    public async downloadProjectFileItem(item: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!item) return;
        if (item.is_directory || item.type === 'directory') {
            await this.downloadProjectFileArchive(item.path || '', 'item');
            return;
        }
        if (this.canUseHtmlProjectFiles()) {
            this.downloadHtmlProjectFileItem(item);
            return;
        }
        await this.downloadRemoteProjectFile(item.path || '', item.name || 'download');
    }

    public codexReviewActiveProjectFile() {
        if (this.isHtmlProject() || !this.fileViewer || this.fileViewer.is_directory || this.fileViewer.type === 'directory') return null;
        const rawPath = String(this.fileViewer.path || '').replace(/\\/g, '/').trim();
        if (!rawPath) return null;
        const relativePath = rawPath.replace(/^\/+/, '');
        const rootPath = String(this.project && (this.project.file_root_path || this.project.codex_root_path) || '').replace(/\\/g, '/').replace(/\/+$/, '').trim();
        const resolvedPath = rawPath.charAt(0) === '/' ? rawPath : rootPath ? `${rootPath}/${relativePath}` : relativePath;
        return Object.assign({}, this.fileViewer, {
            source: 'project_file',
            path: resolvedPath,
            project_path: resolvedPath,
            absolute_path: resolvedPath.charAt(0) === '/' ? resolvedPath : '',
            relative_path: relativePath,
            root_path: rootPath,
            is_directory: false
        });
    }

    public projectHtmlFileUrl(path: any) {
        const projectUrl = String(this.project && this.project.html_project_url || '').replace(/\/+$/, '');
        const relative = String(path || '').replace(/^\/+/, '');
        if (!projectUrl || !relative) return projectUrl;
        return `${projectUrl}/${relative.split('/').map((part) => encodeURIComponent(part)).join('/')}`;
    }

    public hasUploadFiles(event: any) {
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        if (!transfer) return false;
        if (transfer.files && transfer.files.length) return true;
        const types = transfer.types ? Array.prototype.slice.call(transfer.types) : [];
        if (types.indexOf('Files') >= 0) return true;
        const items = transfer.items ? Array.prototype.slice.call(transfer.items) : [];
        return items.some((item: any) => item && item.kind === 'file');
    }

    public uploadEventFiles(event: any): File[] {
        if (event && event.dataTransfer) {
            event.preventDefault();
            event.stopPropagation();
        }
        const input = event && event.target ? event.target : null;
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        const source = transfer && transfer.files && transfer.files.length ? transfer.files : input && input.files ? input.files : [];
        const files = Array.prototype.slice.call(source || []).filter((file: File) => !!file && !String((file as any).type || '').startsWith('inode/'));
        if (input && input.value !== undefined) input.value = '';
        this.clearUploadDropTarget();
        return files;
    }

    public uploadDropClass(key: string, base: string, disabled: boolean = false) {
        if (disabled) return `${base} cursor-not-allowed opacity-60`;
        if (this.uploadDropTarget !== key) return base;
        return `${base} border-slate-900 bg-white ring-2 ring-inset ring-slate-900`;
    }

    public async onUploadDragOver(event: any, key: string, disabled: boolean = false) {
        if (!this.hasUploadFiles(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (disabled) {
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
            if (this.uploadDropTarget === key) {
                this.uploadDropTarget = '';
                await this.service.render();
            }
            return;
        }
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        if (this.uploadDropTarget !== key) {
            this.uploadDropTarget = key;
            await this.service.render();
        }
    }

    public async onUploadDragLeave(event: any, key: string) {
        const current = event && event.currentTarget ? event.currentTarget : null;
        const related = event && event.relatedTarget ? event.relatedTarget : null;
        if (current && related && current.contains && current.contains(related)) return;
        if (this.uploadDropTarget === key) {
            this.uploadDropTarget = '';
            await this.service.render();
        }
    }

    public clearUploadDropTarget(key: string = '') {
        if (!key || this.uploadDropTarget === key) this.uploadDropTarget = '';
    }

    public uploadFileDisplayName(file: File, includeRelativePath: boolean = false) {
        if (!file) return 'file';
        if (includeRelativePath) {
            const relative = String((file as any).webkitRelativePath || (file as any).filepath || '');
            if (relative) return relative;
        }
        return file.name || 'file';
    }

    public resetFileUploadProgress() {
        this.fileUploadProgress = {
            visible: false,
            mode: 'file',
            status: '',
            totalFiles: 0,
            completedFiles: 0,
            currentIndex: 0,
            currentFileName: '',
            currentPercent: 0,
            totalBytes: 0,
            uploadedBytes: 0,
            currentLoaded: 0,
            currentTotal: 0,
            error: '',
            renderedAt: 0
        };
    }

    public startFileUploadProgress(files: File[], includeRelativePath: boolean = false) {
        const totalBytes = (files || []).reduce((sum, file) => sum + Number(file && file.size || 0), 0);
        this.fileUploadProgress = {
            visible: true,
            mode: includeRelativePath ? 'folder' : 'file',
            status: 'uploading',
            totalFiles: (files || []).length,
            completedFiles: 0,
            currentIndex: 0,
            currentFileName: '',
            currentPercent: 0,
            totalBytes,
            uploadedBytes: 0,
            currentLoaded: 0,
            currentTotal: 0,
            error: '',
            renderedAt: 0
        };
    }

    public async updateFileUploadProgress(partial: any = {}, forceRender: boolean = false) {
        this.fileUploadProgress = Object.assign({}, this.fileUploadProgress || {}, partial || {}, { visible: true });
        const now = Date.now();
        if (forceRender || now - Number(this.fileUploadProgress.renderedAt || 0) > 120) {
            this.fileUploadProgress.renderedAt = now;
            await this.service.render();
        }
    }

    public finishFileUploadProgress(hasError: boolean = false) {
        this.fileUploadProgress = Object.assign({}, this.fileUploadProgress || {}, {
            visible: true,
            status: hasError ? 'error' : 'done',
            currentPercent: hasError ? Number(this.fileUploadProgress.currentPercent || 0) : 100,
            uploadedBytes: hasError ? Number(this.fileUploadProgress.uploadedBytes || 0) : Number(this.fileUploadProgress.totalBytes || 0)
        });
        if (!hasError) {
            window.setTimeout(async () => {
                if (this.fileUploadProgress && this.fileUploadProgress.status === 'done') {
                    this.resetFileUploadProgress();
                    await this.service.render();
                }
            }, 1400);
        }
    }

    public clearFileUploadProgress(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.fileUploadBusy) return;
        this.resetFileUploadProgress();
        this.service.render();
    }

    public fileUploadProgressTitle() {
        if (!this.fileUploadProgress || !this.fileUploadProgress.visible) return '';
        if (this.fileUploadProgress.status === 'done') return '업로드 완료';
        if (this.fileUploadProgress.status === 'error') return '업로드 실패';
        return this.fileUploadProgress.mode === 'folder' ? '폴더 업로드 중' : '파일 업로드 중';
    }

    public fileUploadOverallPercent() {
        const progress = this.fileUploadProgress || {};
        const totalBytes = Number(progress.totalBytes || 0);
        if (totalBytes > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(progress.uploadedBytes || 0) / totalBytes * 100)));
        }
        const totalFiles = Number(progress.totalFiles || 0);
        if (totalFiles > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(progress.completedFiles || 0) / totalFiles * 100)));
        }
        return 0;
    }

    public fileUploadProgressMeta() {
        const progress = this.fileUploadProgress || {};
        const count = `${Number(progress.completedFiles || 0)}/${Number(progress.totalFiles || 0)}`;
        const size = Number(progress.totalBytes || 0) > 0
            ? `${this.networkSizeLabel(progress.uploadedBytes || 0)} / ${this.networkSizeLabel(progress.totalBytes || 0)}`
            : '';
        return size ? `${count} · ${size}` : count;
    }

    public uploadProgressKey(kind: string) {
        return kind === 'resource' ? 'html-resource' : 'html-reference';
    }

    public uploadProgressState(key: string) {
        return (this.uploadProgress && this.uploadProgress[key]) || {};
    }

    public uploadProgressVisible(key: string) {
        return !!this.uploadProgressState(key).visible;
    }

    public startUploadProgress(key: string, title: string, files: File[], phase: string = 'reading') {
        const list = files || [];
        const totalBytes = list.reduce((sum, file) => sum + Number(file && file.size || 0), 0);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: {
                visible: true,
                title,
                phase,
                status: 'running',
                totalFiles: list.length,
                completedFiles: 0,
                currentIndex: 0,
                currentFileName: '',
                currentPercent: 0,
                totalBytes,
                processedBytes: 0,
                currentLoaded: 0,
                currentTotal: 0,
                message: '',
                renderedAt: 0
            }
        });
    }

    public async updateUploadProgress(key: string, partial: any = {}, forceRender: boolean = false) {
        const current = this.uploadProgressState(key);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: Object.assign({}, current, partial || {}, { visible: true })
        });
        const state = this.uploadProgressState(key);
        const now = Date.now();
        if (forceRender || now - Number(state.renderedAt || 0) > 120) {
            state.renderedAt = now;
            this.uploadProgress = Object.assign({}, this.uploadProgress || {}, { [key]: state });
            await this.service.render();
        }
    }

    public finishUploadProgress(key: string, success: boolean = true, message: string = '') {
        const current = this.uploadProgressState(key);
        const totalFiles = Number(current.totalFiles || 0);
        const totalBytes = Number(current.totalBytes || 0);
        this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
            [key]: Object.assign({}, current, {
                visible: true,
                status: success ? 'done' : 'error',
                phase: success ? 'done' : 'error',
                completedFiles: success ? totalFiles : Number(current.completedFiles || 0),
                currentPercent: success ? 100 : Number(current.currentPercent || 0),
                processedBytes: success ? totalBytes : Number(current.processedBytes || 0),
                message: message || (success ? '완료되었습니다.' : '처리하지 못했습니다.')
            })
        });
        if (success) {
            window.setTimeout(async () => {
                const latest = this.uploadProgressState(key);
                if (latest.status === 'done') {
                    this.uploadProgress = Object.assign({}, this.uploadProgress || {}, {
                        [key]: Object.assign({}, latest, { visible: false })
                    });
                    await this.service.render();
                }
            }, 1400);
        }
    }

    public uploadProgressTitle(key: string) {
        const state = this.uploadProgressState(key);
        if (state.status === 'done') return '완료';
        if (state.status === 'error') return '오류';
        if (state.phase === 'saving') return `${state.title || '파일'} 저장 중`;
        if (state.phase === 'uploading') return `${state.title || '파일'} 업로드 중`;
        return `${state.title || '파일'} 읽는 중`;
    }

    public uploadProgressPercent(key: string) {
        const state = this.uploadProgressState(key);
        const totalBytes = Number(state.totalBytes || 0);
        if (totalBytes > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(state.processedBytes || 0) / totalBytes * 100)));
        }
        const totalFiles = Number(state.totalFiles || 0);
        if (totalFiles > 0) {
            return Math.max(0, Math.min(100, Math.round(Number(state.completedFiles || 0) / totalFiles * 100)));
        }
        return Math.max(0, Math.min(100, Math.round(Number(state.currentPercent || 0))));
    }

    public uploadProgressMeta(key: string) {
        const state = this.uploadProgressState(key);
        const count = `${Number(state.completedFiles || 0)}/${Number(state.totalFiles || 0)}`;
        const size = Number(state.totalBytes || 0) > 0
            ? `${this.networkSizeLabel(state.processedBytes || 0)} / ${this.networkSizeLabel(state.totalBytes || 0)}`
            : '';
        return size ? `${count} · ${size}` : count;
    }

    public uploadProgressCurrentFile(key: string) {
        const state = this.uploadProgressState(key);
        return state.currentFileName || state.message || '-';
    }

    public async selectHtmlProjectUpload(event: any) {
        await this.selectProjectUpload(event);
    }

    public async selectHtmlProjectFolderUpload(event: any) {
        await this.selectProjectFolderUpload(event);
    }

    public async selectProjectUpload(event: any) {
        await this.uploadProjectFilesFromInput(event, false);
    }

    public async selectProjectFolderUpload(event: any) {
        await this.uploadProjectFilesFromInput(event, true);
    }

    public async uploadHtmlProjectFilesFromInput(event: any, includeRelativePath: boolean = false) {
        await this.uploadProjectFilesFromInput(event, includeRelativePath);
    }

    public async uploadProjectFilesFromInput(event: any, includeRelativePath: boolean = false) {
        const files = this.uploadEventFiles(event);
        await this.uploadProjectFiles(files, includeRelativePath);
    }

    public async uploadProjectFiles(files: File[], includeRelativePath: boolean = false, path: any = null) {
        if (this.projectFileUploadDropBlocked()) return;
        if (!files.length) return;
        const uploadPolicyKey = this.isHtmlProject() ? 'html_project_file' : 'project_file';
        const validationMessage = this.uploadPolicyValidationMessage(uploadPolicyKey, files);
        if (validationMessage) {
            await this.service.modal.error(validationMessage);
            return;
        }
        this.fileUploadBusy = true;
        this.fileError = '';
        this.startFileUploadProgress(files, includeRelativePath);
        await this.service.render();
        let hasError = false;
        try {
            const uploadUrl = this.projectFileUploadUrl(path);
            let uploadedBefore = 0;
            for (let index = 0; index < files.length; index++) {
                const file = files[index];
                const displayName = this.uploadFileDisplayName(file, includeRelativePath);
                await this.updateFileUploadProgress({
                    currentIndex: index + 1,
                    currentFileName: displayName,
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    uploadedBytes: uploadedBefore
                }, true);
                const fd = new FormData();
                fd.append('file', file);
                if (includeRelativePath) {
                    const relativePath = String((file as any).webkitRelativePath || (file as any).filepath || file.name || '');
                    if (relativePath) fd.append('relative_path', relativePath);
                }
                const { code, data } = this.normalizeUploadResponse(await this.service.file.upload(uploadUrl, fd, async (percent: number, total: number, position: number) => {
                    const loaded = Number(position || 0);
                    const currentTotal = Number(total || file.size || 0);
                    await this.updateFileUploadProgress({
                        currentPercent: Number(percent || 0),
                        currentLoaded: loaded,
                        currentTotal,
                        uploadedBytes: uploadedBefore + loaded
                    });
                }));
                if (code === 200) {
                    this.applyProject(data.project);
                    uploadedBefore += Number(file.size || 0);
                    await this.updateFileUploadProgress({
                        completedFiles: index + 1,
                        currentPercent: 100,
                        currentLoaded: file.size || 0,
                        currentTotal: file.size || 0,
                        uploadedBytes: uploadedBefore
                    }, true);
                } else {
                    this.fileError = data.message || '파일을 업로드하지 못했습니다.';
                    await this.updateFileUploadProgress({
                        status: 'error',
                        error: this.fileError
                    }, true);
                    hasError = true;
                    break;
                }
            }
        } catch (e) {
            this.fileError = '파일을 업로드하지 못했습니다.';
            await this.updateFileUploadProgress({
                status: 'error',
                error: this.fileError
            }, true);
            hasError = true;
        }
        this.fileUploadBusy = false;
        this.finishFileUploadProgress(hasError);
        await this.loadProjectFiles(this.fileBrowser.path || '');
    }

    public async downloadHtmlProjectArchive(path: any = '', scope: string = 'item', event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canUseHtmlProjectFiles() || this.fileActionBusy) return;
        this.fileActionBusy = true;
        this.fileError = '';
        await this.service.render();
        try {
            const response = await fetch(this.htmlProjectArchiveDownloadUrl(path, scope), { credentials: 'same-origin' });
            if (!response.ok) {
                let message = '압축파일을 다운로드하지 못했습니다.';
                try {
                    const data = await response.json();
                    message = data && data.message ? data.message : message;
                } catch (e) { }
                this.fileError = message;
                return;
            }
            const blob = await response.blob();
            const fallback = scope === 'current' ? 'current-folder.zip' : 'project-file.zip';
            const fileName = this.responseDownloadFileName(response, fallback);
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = this.safeAttachmentName(fileName);
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            this.fileError = '압축파일을 다운로드하지 못했습니다.';
        } finally {
            this.fileActionBusy = false;
            await this.service.render();
        }
    }

    public async downloadProjectFileArchive(path: any = '', scope: string = 'item', event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.canUseHtmlProjectFiles()) {
            await this.downloadHtmlProjectArchive(path, scope, event);
            return;
        }
        const fallback = scope === 'current' ? 'current-folder.zip' : 'project-file.zip';
        await this.downloadRemoteProjectFile(path, fallback);
    }

    public async downloadCurrentProjectDirectoryArchive(event?: any) {
        await this.downloadProjectFileArchive(this.fileBrowser && this.fileBrowser.path || '', 'current', event);
    }

    public async downloadCurrentHtmlProjectDirectoryArchive(event?: any) {
        await this.downloadCurrentProjectDirectoryArchive(event);
    }

    public async createProjectFolder() {
        if (!this.canManageProjectFileItems() || this.fileActionBusy) return;
        this.openFileDialog({
            mode: 'create_folder',
            title: '새 폴더',
            message: '현재 위치에 만들 폴더 이름을 입력하세요.',
            action: '만들기',
            actionBtn: 'primary',
            inputValue: ''
        });
    }

    public async createHtmlProjectFolder() {
        await this.createProjectFolder();
    }

    public openFileDialog(options: any = {}) {
        this.closeProjectFileContextMenu();
        this.fileDialog = Object.assign({
            open: true,
            mode: '',
            title: '',
            message: '',
            action: '확인',
            actionBtn: 'primary',
            inputValue: '',
            item: null,
            busy: false,
            error: ''
        }, options || {}, { open: true, busy: false, error: '' });
        this.service.render();
    }

    public closeFileDialog(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.fileDialog && this.fileDialog.busy) return;
        this.fileDialog = { open: false, mode: '', title: '', message: '', action: '', actionBtn: 'primary', inputValue: '', item: null, busy: false, error: '' };
        this.service.render();
    }

    public fileDialogActionClass() {
        const danger = this.fileDialog && this.fileDialog.actionBtn === 'error';
        return danger
            ? 'h-9 rounded-md bg-rose-600 px-4 text-[12px] font-semibold text-white hover:bg-rose-500 disabled:opacity-40'
            : 'h-9 rounded-md bg-slate-900 px-4 text-[12px] font-semibold text-white hover:bg-slate-700 disabled:opacity-40';
    }

    public async submitFileDialog(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.fileDialog || !this.fileDialog.open || this.fileDialog.busy) return;
        const mode = this.fileDialog.mode;
        this.fileDialog.error = '';
        if (mode === 'create_folder') {
            const name = String(this.fileDialog.inputValue || '').trim();
            if (!name) {
                this.fileDialog.error = '폴더 이름을 입력해주세요.';
                await this.service.render();
                return;
            }
            this.fileDialog.busy = true;
            await this.service.render();
            const api = this.canUseHtmlProjectFiles() ? 'create_html_project_folder' : 'create_project_folder';
            const ok = await this.runProjectFileAction(api, {
                path: this.fileBrowser.path || '',
                name
            }, '폴더를 만들지 못했습니다.');
            this.fileDialog.busy = false;
            if (ok) {
                this.closeFileDialog();
            } else {
                this.fileDialog.error = this.fileError || '폴더를 만들지 못했습니다.';
                await this.service.render();
            }
            return;
        }
        if (mode === 'delete_file') {
            const item = this.fileDialog.item;
            if (!item) return;
            this.fileDialog.busy = true;
            await this.service.render();
            const api = this.canUseHtmlProjectFiles() ? 'delete_html_project_file' : 'delete_project_file';
            const ok = await this.runProjectFileAction(api, {
                path: item.path || ''
            }, '삭제하지 못했습니다.');
            this.fileDialog.busy = false;
            if (ok) {
                this.closeFileDialog();
            } else {
                this.fileDialog.error = this.fileError || '삭제하지 못했습니다.';
                await this.service.render();
            }
        }
    }

    public openProjectFileContextMenu(event: any, item: any) {
        if (!this.canUseProjectFiles() || !item || this.isRenamingProjectFile(item)) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.fileContextMenu = {
            open: true,
            x: event && typeof event.clientX === 'number' ? event.clientX : 0,
            y: event && typeof event.clientY === 'number' ? event.clientY : 0,
            item
        };
        this.service.render();
    }

    public closeProjectFileContextMenu() {
        if (!this.fileContextMenu || !this.fileContextMenu.open) return;
        this.fileContextMenu = { open: false, x: 0, y: 0, item: null };
        this.service.render();
    }

    public projectFileContextMenuStyle() {
        const width = 192;
        const height = this.canManageProjectFileItems() ? 236 : 132;
        const viewportWidth = Math.max(window.innerWidth || 0, width + 16);
        const viewportHeight = Math.max(window.innerHeight || 0, height + 16);
        const x = Math.min(Math.max(Number(this.fileContextMenu && this.fileContextMenu.x || 8), 8), viewportWidth - width - 8);
        const y = Math.min(Math.max(Number(this.fileContextMenu && this.fileContextMenu.y || 8), 8), viewportHeight - height - 8);
        return { left: `${x}px`, top: `${y}px` };
    }

    public projectFileContextItem() {
        return this.fileContextMenu && this.fileContextMenu.item ? this.fileContextMenu.item : null;
    }

    public async openProjectFileFromContext(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.projectFileContextItem();
        this.closeProjectFileContextMenu();
        if (!item) return;
        await this.openProjectFileItem(item);
    }

    public async downloadHtmlProjectFileFromContext(event?: any) {
        await this.downloadProjectFileFromContext(event);
    }

    public async downloadProjectFileFromContext(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.projectFileContextItem();
        this.closeProjectFileContextMenu();
        if (!item || item.is_directory) return;
        await this.downloadProjectFileItem(item);
    }

    public async downloadHtmlProjectArchiveFromContext(event?: any) {
        await this.downloadProjectFileArchiveFromContext(event);
    }

    public async downloadProjectFileArchiveFromContext(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.projectFileContextItem();
        this.closeProjectFileContextMenu();
        if (!item) return;
        await this.downloadProjectFileArchive(item.path || '', 'item');
    }

    public startProjectFileRenameFromContext(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.projectFileContextItem();
        this.closeProjectFileContextMenu();
        if (!item) return;
        this.startProjectFileRename(item);
    }

    public async deleteProjectFileFromContext(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const item = this.projectFileContextItem();
        this.closeProjectFileContextMenu();
        if (!item) return;
        await this.deleteProjectFileItem(item);
    }

    public async deleteHtmlProjectFileFromContext(event?: any) {
        await this.deleteProjectFileFromContext(event);
    }

    public isRenamingProjectFile(item: any) {
        return !!(item && this.fileRenamePath && this.fileRenamePath === item.path);
    }

    public startProjectFileRename(item: any, event?: any) {
        if (event) event.stopPropagation();
        if (!this.canManageProjectFileItems() || !item) return;
        this.fileRenamePath = item.path || '';
        this.fileRenameValue = item.name || '';
        this.service.render();
    }

    public cancelProjectFileRename(event?: any) {
        if (event) event.stopPropagation();
        this.fileRenamePath = '';
        this.fileRenameValue = '';
        this.service.render();
    }

    public async submitProjectFileRename(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canManageProjectFileItems() || !this.fileRenamePath || this.fileActionBusy) return;
        const name = String(this.fileRenameValue || '').trim();
        if (!name) {
            this.fileError = '새 이름을 입력해주세요.';
            await this.service.render();
            return;
        }
        const api = this.canUseHtmlProjectFiles() ? 'rename_html_project_file' : 'rename_project_file';
        await this.runProjectFileAction(api, {
            path: this.fileRenamePath,
            name
        }, '이름을 변경하지 못했습니다.');
        this.fileRenamePath = '';
        this.fileRenameValue = '';
    }

    public async deleteProjectFileItem(item: any, event?: any) {
        if (event) event.stopPropagation();
        if (!this.canManageProjectFileItems() || !item || this.fileActionBusy) return;
        this.openFileDialog({
            mode: 'delete_file',
            title: item.is_directory ? '폴더 삭제' : '파일 삭제',
            message: `'${item.name}' ${item.is_directory ? '폴더' : '파일'}을 삭제할까요? 삭제한 항목은 복구할 수 없습니다.`,
            action: '삭제',
            actionBtn: 'error',
            item
        });
    }

    public async deleteHtmlProjectFileItem(item: any, event?: any) {
        await this.deleteProjectFileItem(item, event);
    }

    public async readAllDataTransferEntries(reader: any): Promise<any[]> {
        const entries: any[] = [];
        while (reader) {
            const chunk: any[] = await new Promise((resolve) => {
                reader.readEntries((items: any[]) => resolve(items || []), () => resolve([]));
            });
            if (!chunk.length) break;
            entries.push(...chunk);
        }
        return entries;
    }

    public async dataTransferEntryFiles(entry: any, parentPath: string = ''): Promise<File[]> {
        if (!entry) return [];
        if (entry.isFile) {
            const file: File = await new Promise((resolve, reject) => entry.file(resolve, reject));
            const relativePath = `${parentPath}${file.name || entry.name || 'file'}`;
            try {
                Object.defineProperty(file, 'webkitRelativePath', { value: relativePath, configurable: true });
            } catch (e) {
                (file as any).filepath = relativePath;
            }
            return [file];
        }
        if (!entry.isDirectory) return [];
        const reader = entry.createReader();
        const children = await this.readAllDataTransferEntries(reader);
        const nested: File[] = [];
        const nextParent = `${parentPath}${entry.name || 'folder'}/`;
        for (const child of children) {
            nested.push(...await this.dataTransferEntryFiles(child, nextParent));
        }
        return nested;
    }

    public async projectFilesFromDropEvent(event: any): Promise<any> {
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        const items = transfer && transfer.items ? Array.prototype.slice.call(transfer.items) : [];
        const entries = items
            .map((item: any) => item && typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null)
            .filter((entry: any) => !!entry);
        if (entries.length) {
            const files: File[] = [];
            for (const entry of entries) {
                files.push(...await this.dataTransferEntryFiles(entry, ''));
            }
            const includeRelativePath = files.some((file: File) => String((file as any).webkitRelativePath || (file as any).filepath || '').indexOf('/') >= 0);
            return { files, includeRelativePath };
        }
        const files = transfer && transfer.files ? Array.prototype.slice.call(transfer.files) : [];
        return { files, includeRelativePath: false };
    }

    public projectFileDropListClass() {
        const base = 'min-h-0 flex-1 overflow-x-hidden overflow-y-auto';
        if (this.projectFileUploadDropBlocked()) return base;
        if (this.fileUploadDropTarget === 'current') return `${base} ring-2 ring-inset ring-slate-900 bg-slate-50`;
        return base;
    }

    public projectFileDropHintClass() {
        const base = 'm-3 flex min-w-0 shrink-0 items-center gap-3 rounded-md border border-dashed border-slate-300 bg-slate-50 px-3 py-3 transition';
        if (this.projectFileUploadDropBlocked()) return `${base} cursor-not-allowed opacity-60`;
        if (this.fileUploadDropTarget !== 'current') return base;
        return `${base} border-slate-900 bg-white ring-2 ring-inset ring-slate-900`;
    }

    public projectFileUploadDropBlocked() {
        return !!(!this.canUploadProjectFiles() || this.fileUploadBusy || this.fileActionBusy || this.fileBrowserLoading);
    }

    public projectFileDropHintTitle() {
        if (this.fileUploadBusy) return '파일을 업로드하는 중입니다.';
        if (this.fileActionBusy) return '진행 중인 파일 작업이 있습니다.';
        return '파일 또는 폴더를 여기에 끌어다 놓으세요';
    }

    public projectFileDropHintDescription() {
        if (this.projectFileUploadDropBlocked()) return '작업이 완료되면 다시 드롭할 수 있습니다.';
        return `현재 폴더 ${this.fileBrowser.path || '/'}에 업로드됩니다.`;
    }

    public projectFileRowClass(item: any) {
        const base = 'flex w-full min-w-0 max-w-full items-center gap-2 overflow-hidden border-b border-slate-50 px-4 py-2.5 hover:bg-slate-50';
        if (this.projectFileUploadDropBlocked()) return base;
        const targetPath = item && item.is_directory ? String(item.path || '') : '';
        if (!targetPath || this.fileUploadDropTarget !== targetPath) return base;
        return `${base} bg-slate-100 ring-2 ring-inset ring-slate-900`;
    }

    public async onProjectFileDropLeave(event: any) {
        const current = event && event.currentTarget ? event.currentTarget : null;
        const related = event && event.relatedTarget ? event.relatedTarget : null;
        if (current && related && current.contains && current.contains(related)) return;
        if (this.fileUploadDropTarget) {
            this.fileUploadDropTarget = '';
            await this.service.render();
        }
    }

    public canDragProjectFile(item: any) {
        return !!(this.canManageProjectFileItems() && item && item.path && !this.fileActionBusy);
    }

    public startProjectFileDrag(event: any, item: any) {
        if (!this.canDragProjectFile(item)) return;
        this.fileDragPath = item.path || '';
        if (event && event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', this.fileDragPath);
        }
    }

    public clearProjectFileDrag() {
        this.fileDragPath = '';
    }

    public onProjectFileDragOver(event: any, item: any) {
        if (this.hasUploadFiles(event)) {
            if (this.projectFileUploadDropBlocked()) {
                event.preventDefault();
                event.stopPropagation();
                if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
                return;
            }
            if (!item || !item.is_directory) return;
            event.preventDefault();
            event.stopPropagation();
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
            const targetPath = String(item.path || '');
            if (this.fileUploadDropTarget !== targetPath) {
                this.fileUploadDropTarget = targetPath;
                this.service.render();
            }
            return;
        }
        if (!this.canManageProjectFileItems() || !this.fileDragPath || !item) return;
        if (!item.is_directory) {
            event.preventDefault();
            event.stopPropagation();
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
            return;
        }
        if (item.path === this.fileDragPath || String(item.path || '').startsWith(`${this.fileDragPath}/`)) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    }

    public onProjectFileListDragOver(event: any) {
        if (this.hasUploadFiles(event)) {
            event.preventDefault();
            event.stopPropagation();
            if (this.projectFileUploadDropBlocked()) {
                if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
                if (this.fileUploadDropTarget) {
                    this.fileUploadDropTarget = '';
                    this.service.render();
                }
                return;
            }
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
            if (this.fileUploadDropTarget !== 'current') {
                this.fileUploadDropTarget = 'current';
                this.service.render();
            }
            return;
        }
        if (!this.canManageProjectFileItems() || !this.fileDragPath) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    }

    public async dropProjectFile(event: any, item: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.hasUploadFiles(event)) {
            this.fileUploadDropTarget = '';
            if (this.projectFileUploadDropBlocked()) return;
            const dropped = await this.projectFilesFromDropEvent(event);
            const targetPath = item && item.is_directory ? String(item.path || '') : String(this.fileBrowser.path || '');
            await this.uploadProjectFiles(dropped.files, dropped.includeRelativePath, targetPath);
            return;
        }
        if (!item || !item.is_directory) return;
        await this.moveProjectFileTo(item.path || '');
    }

    public async dropProjectFileToCurrent(event: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.hasUploadFiles(event)) {
            this.fileUploadDropTarget = '';
            if (this.projectFileUploadDropBlocked()) return;
            const dropped = await this.projectFilesFromDropEvent(event);
            await this.uploadProjectFiles(dropped.files, dropped.includeRelativePath, this.fileBrowser.path || '');
            return;
        }
        await this.moveProjectFileTo(this.fileBrowser.path || '');
    }

    public async moveProjectFileTo(targetPath: string) {
        if (!this.canManageProjectFileItems() || !this.fileDragPath || this.fileActionBusy) return;
        const source = this.fileDragPath;
        this.fileDragPath = '';
        const api = this.canUseHtmlProjectFiles() ? 'move_html_project_file' : 'move_project_file';
        await this.runProjectFileAction(api, {
            path: source,
            target_path: targetPath || ''
        }, '파일을 이동하지 못했습니다.');
    }

    public async moveHtmlProjectFileTo(targetPath: string) {
        await this.moveProjectFileTo(targetPath);
    }

    public async runProjectFileAction(api: string, payload: any, fallbackMessage: string) {
        this.fileActionBusy = true;
        this.fileError = '';
        await this.service.render();
        const { code, data } = await wiz.call(api, this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload || {})
        }));
        this.fileActionBusy = false;
        if (code === 200) {
            this.applyProject(data.project);
            await this.loadProjectFiles(this.fileBrowser.path || '');
            return true;
        } else {
            this.fileError = data.message || fallbackMessage;
            await this.service.render();
            return false;
        }
    }

    public async runHtmlProjectFileAction(api: string, payload: any, fallbackMessage: string) {
        return await this.runProjectFileAction(api, payload, fallbackMessage);
    }

    public projectFileIconClass(item: any) {
        if (!item) return 'fa-regular fa-file text-[15px]';
        if (item.is_directory || item.type === 'directory') return 'fa-solid fa-folder text-[15px] text-amber-500';
        if (item.viewer === 'markdown') return 'fa-regular fa-file-lines text-[15px] text-slate-600';
        if (item.viewer === 'html') return 'fa-regular fa-file-code text-[15px] text-orange-500';
        if (item.viewer === 'image') return 'fa-regular fa-file-image text-[15px] text-cyan-600';
        if (item.viewer === 'code') return 'fa-regular fa-file-code text-[15px] text-indigo-600';
        return 'fa-regular fa-file text-[15px] text-slate-500';
    }

    public projectFileViewerTitle() {
        if (!this.fileViewer) return '파일 미리보기';
        return this.fileViewer.name || this.fileViewer.path || '파일 미리보기';
    }

    public projectFileHtmlPreviewUrl() {
        if (!this.fileViewer) return '';
        if (this.fileViewer.url) return this.fileViewer.url;
        return `data:text/html;charset=utf-8,${encodeURIComponent(String(this.fileViewer.content || ''))}`;
    }

    public projectFileEditorOptions() {
        this.projectFileEditorOptionsCache.language = (this.fileViewer && this.fileViewer.language) || 'plaintext';
        return this.projectFileEditorOptionsCache;
    }

    public macroEditorOptions() {
        this.macroEditorOptionsCache.readOnly = this.macroSaving || !!this.macroRunningId;
        return this.macroEditorOptionsCache;
    }

    public macroRows() {
        return (this.macros || []).filter((macro: any) => macro && macro.status !== 'deleted');
    }

    public macroLastRunLabel(macro: any) {
        if (!macro || !macro.last_run_at) return '실행 기록 없음';
        const status = macro.last_run_status === 'success' ? '성공' : '실패';
        return `${status} · ${this.kstDateTime(macro.last_run_at)} · exit ${macro.last_run_exit_code || 0}`;
    }

    public macroStatusBadgeClass(macro: any) {
        const base = 'rounded-full px-2 py-0.5 text-[11px] font-semibold ';
        if (macro && macro.last_run_status === 'success') return base + 'bg-emerald-50 text-emerald-700';
        if (macro && macro.last_run_status === 'error') return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-slate-100 text-slate-500';
    }

    public macroRunContextPayload(macro: any) {
        if (!macro) return null;
        return {
            id: macro.id || '',
            name: macro.name || '이름 없는 매크로',
            description: macro.description || '',
            working_dir: macro.working_dir || '',
            timeout_seconds: macro.timeout_seconds || 0
        };
    }

    public activeMacroRunContext() {
        if (this.macroRunResult && this.macroRunResult.macro) return this.macroRunContextPayload(this.macroRunResult.macro);
        if (this.macroRunContext) return this.macroRunContext;
        return null;
    }

    public macroLogPanelClass() {
        const base = 'flex shrink-0 flex-col border-t border-slate-800 bg-slate-950 text-slate-100';
        return this.macroLogCollapsed ? `${base} h-12` : `${base} h-52 sm:h-60`;
    }

    public macroLogTitle() {
        const macro = this.activeMacroRunContext();
        if (macro && macro.name) return macro.name;
        if (this.macroRunningId) return '매크로 실행 중';
        return '매크로 실행 로그';
    }

    public macroLogSubtitle() {
        const macro = this.activeMacroRunContext();
        if (!macro) return this.macroRunningId ? '실행 결과를 기다리는 중입니다.' : '최근 실행된 매크로가 없습니다.';
        const parts = [];
        if (macro.working_dir || (this.projectForm && this.projectForm.codex_root_path)) {
            parts.push(macro.working_dir || this.projectForm.codex_root_path || '/opt/app');
        }
        if (macro.timeout_seconds) parts.push(`${macro.timeout_seconds}s`);
        if (macro.description) parts.push(macro.description);
        return parts.join(' · ');
    }

    public macroLogStatusLabel() {
        if (this.macroRunningId) return 'running';
        if (!this.macroRunResult) return 'idle';
        return `exit ${this.macroRunResult.exit_code || 0}`;
    }

    public macroLogStatusBadgeClass() {
        const base = 'shrink-0 rounded px-2 py-0.5 text-[11px] font-semibold ';
        if (this.macroRunningId) return base + 'bg-sky-500/15 text-sky-200';
        if (!this.macroRunResult) return base + 'bg-slate-800 text-slate-300';
        if (this.macroRunResult.ok) return base + 'bg-emerald-500/15 text-emerald-200';
        return base + 'bg-rose-500/15 text-rose-200';
    }

    public macroLogOutputText() {
        if (this.macroRunningId) return '실행 결과를 기다리는 중입니다.';
        if (this.macroRunResult) return this.macroRunResult.output || '출력 없음';
        return '아직 실행된 매크로가 없습니다.';
    }

    public toggleMacroLogCollapsed() {
        this.macroLogCollapsed = !this.macroLogCollapsed;
        this.service.render();
    }

    public canRunMacro(macro: any) {
        return !!(macro && macro.id && macro.status === 'active' && !this.macroRunningId && !this.macroSaving && this.canUseProjectMacros());
    }

    public openMacroCreate() {
        this.macroForm = this.blankMacroForm();
        this.macroForm.sort_order = this.macroRows().length + 1;
        this.macroEditingId = '';
        this.macroEditorOpen = true;
        this.macroRunResult = null;
        this.macroRunContext = null;
        this.service.render();
    }

    public editMacro(macro: any) {
        if (!macro) return;
        this.macroForm = Object.assign(this.blankMacroForm(), JSON.parse(JSON.stringify(macro)));
        this.macroEditingId = macro.id || '';
        this.macroEditorOpen = true;
        this.macroRunResult = null;
        this.macroRunContext = null;
        this.service.render();
    }

    public cancelMacroEdit() {
        this.macroEditorOpen = false;
        this.macroEditingId = '';
        this.macroForm = this.blankMacroForm();
        this.service.render();
    }

    public async loadProjectMacros() {
        if (!this.canUseProjectMacros()) return;
        this.macroLoading = true;
        this.macroError = '';
        await this.service.render();
        const { code, data } = await wiz.call('load_project_macros', this.requestParams({ id: this.projectId }));
        this.macroLoading = false;
        if (code === 200) {
            this.macros = data.macros || [];
        } else {
            this.macroError = data.message || '매크로 목록을 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async saveProjectMacro() {
        if (!this.canUseProjectMacros() || this.macroSaving) return;
        this.macroSaving = true;
        await this.service.render();
        const payload = Object.assign({}, this.macroForm || {}, { id: this.macroEditingId || this.macroForm.id || '' });
        const { code, data } = await wiz.call('save_project_macro', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload)
        }));
        this.macroSaving = false;
        if (code === 200 && data.result) {
            this.macros = data.result.macros || [];
            this.macroForm = Object.assign(this.blankMacroForm(), data.result.macro || {});
            this.macroEditingId = this.macroForm.id || '';
            this.macroEditorOpen = false;
            await this.service.modal.success('매크로가 저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '매크로를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteProjectMacro(macro: any) {
        if (!macro || !macro.id || this.macroSaving || this.macroRunningId) return;
        const confirmed = await this.service.modal.show({
            title: '매크로 삭제',
            message: `${macro.name || '매크로'}를 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        this.macroSaving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_project_macro', this.requestParams({
            id: this.projectId,
            macro_id: macro.id
        }));
        this.macroSaving = false;
        if (code === 200 && data.result) {
            this.macros = data.result.macros || [];
            if (this.macroEditingId === macro.id) this.cancelMacroEdit();
            if (this.macroRunContext && this.macroRunContext.id === macro.id) {
                this.macroRunContext = null;
                this.macroRunResult = null;
            }
        } else {
            await this.service.modal.error(data.message || '매크로를 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public async runProjectMacro(macro: any) {
        if (!this.canRunMacro(macro)) return;
        this.macroRunningId = macro.id;
        this.macroRunResult = null;
        this.macroRunContext = this.macroRunContextPayload(macro);
        this.macroLogCollapsed = false;
        await this.service.render();
        const { code, data } = await wiz.call('run_project_macro', this.requestParams({
            id: this.projectId,
            macro_id: macro.id
        }));
        this.macroRunningId = '';
        if (code === 200 && data.result) {
            this.macroRunResult = data.result;
            if (data.result.macro) {
                this.macroRunContext = this.macroRunContextPayload(data.result.macro);
                const index = this.macros.findIndex((item: any) => item && item.id === data.result.macro.id);
                if (index >= 0) this.macros[index] = data.result.macro;
            }
        } else {
            this.macroRunResult = { ok: false, message: data.message || '매크로 실행에 실패했습니다.', output: '' };
            await this.service.modal.error(this.macroRunResult.message);
        }
        await this.service.render();
    }

    public terminalElement() {
        return document.getElementById('reviewops-project-terminal');
    }

    public ensureProjectTerminal() {
        const element = this.terminalElement();
        if (!element) return false;
        if (this.terminal) {
            if (this.terminalHostElement === element && element.querySelector('.xterm')) {
                this.scheduleTerminalFit();
                return true;
            }
            this.disposeProjectTerminal();
        }
        this.terminal = new Terminal({
            cursorBlink: true,
            convertEol: true,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
            fontSize: 12,
            lineHeight: 1.45,
            scrollback: 5000,
            theme: {
                background: '#020617',
                foreground: '#e2e8f0',
                cursor: '#f8fafc',
                selectionBackground: '#334155'
            }
        });
        this.terminalFitAddon = new FitAddon();
        this.terminalWebLinksAddon = new WebLinksAddon();
        this.terminal.loadAddon(this.terminalFitAddon);
        this.terminal.loadAddon(this.terminalWebLinksAddon);
        this.terminal.open(element);
        this.terminalHostElement = element;
        this.terminalInputDisposable = this.terminal.onData((data: string) => {
            this.emitTerminalSocket('terminal_input', { data });
        });
        this.scheduleTerminalFit();
        return true;
    }

    public scheduleTerminalFit() {
        if (this.terminalResizeTimer) window.clearTimeout(this.terminalResizeTimer);
        this.terminalResizeTimer = window.setTimeout(() => {
            this.terminalResizeTimer = null;
            this.fitProjectTerminal(true);
        }, 80);
    }

    public fitProjectTerminal(emitResize: boolean = false) {
        if (!this.terminal || !this.terminalFitAddon) return;
        try {
            this.terminalFitAddon.fit();
            if (emitResize && this.terminalReady) {
                this.emitTerminalSocket('terminal_resize', {
                    cols: this.terminal.cols || 100,
                    rows: this.terminal.rows || 32
                });
            }
        } catch (e) { }
    }

    public terminalSocketEnvelope(payload: any = {}) {
        return {
            project_id: this.projectId,
            admin: this.adminMode ? '1' : '',
            payload: Object.assign({
                project_id: this.projectId,
                admin: this.adminMode ? '1' : ''
            }, payload || {})
        };
    }

    public emitTerminalSocket(event: string, payload: any = {}) {
        if (!this.remoteSocket || !this.remoteSocket.connected) return;
        this.remoteSocket.emit(event, this.terminalSocketEnvelope(payload));
    }

    public clearTerminalConnectTimer() {
        if (!this.terminalConnectTimer) return;
        window.clearTimeout(this.terminalConnectTimer);
        this.terminalConnectTimer = null;
    }

    public scheduleTerminalConnectTimeout() {
        this.clearTerminalConnectTimer();
        this.terminalConnectTimer = window.setTimeout(() => {
            this.terminalConnectTimer = null;
            if (!this.terminalStarting || this.terminalReady) return;
            this.terminalStarting = false;
            this.terminalReady = false;
            this.terminalError = '터미널 소켓 응답이 없습니다. 잠시 후 다시 연결해주세요.';
            this.terminalStatusMessage = '터미널 연결 실패';
            if (this.terminal) this.terminal.writeln(`\r\n[ReviewOps] ${this.terminalError}`);
            if (this.remoteSocket && this.remoteSocket.connected) {
                try {
                    this.remoteSocket.emit('leave_terminal', this.terminalSocketEnvelope({}));
                } catch (e) { }
            }
            this.service.render();
        }, 30000);
    }

    public async startProjectTerminal() {
        if (!this.canUseProjectTerminal() || this.terminalStarting) return;
        if (this.terminalReady) {
            this.scheduleTerminalFit();
            return;
        }
        this.terminalStarting = true;
        this.terminalError = '';
        this.terminalStatusMessage = '터미널 연결 중';
        await this.service.render();
        await this.service.sleep(0);
        if (!this.ensureProjectTerminal()) {
            this.terminalStarting = false;
            this.terminalError = '터미널 영역을 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        this.terminal.clear();
        this.terminal.writeln('ReviewOps terminal connecting...');
        const connected = await this.connectRemoteSocket();
        if (!connected || !this.remoteSocket) {
            this.terminalStarting = false;
            this.terminalReady = false;
            this.terminalError = '터미널 소켓에 연결하지 못했습니다.';
            this.terminal.writeln(this.terminalError);
            await this.service.render();
            return;
        }
        this.fitProjectTerminal(false);
        this.remoteSocket.emit('join_terminal', this.terminalSocketEnvelope({
            cols: this.terminal.cols || 100,
            rows: this.terminal.rows || 32
        }));
        this.scheduleTerminalConnectTimeout();
        await this.service.render();
    }

    public stopProjectTerminal(writeMessage: boolean = true) {
        this.clearTerminalConnectTimer();
        if (this.remoteSocket && this.remoteSocket.connected) {
            try {
                this.remoteSocket.emit('leave_terminal', this.terminalSocketEnvelope({}));
            } catch (e) { }
        }
        this.terminalStarting = false;
        this.terminalReady = false;
        this.terminalStatusMessage = '';
        if (writeMessage && this.terminal) this.terminal.writeln('\r\n[ReviewOps] terminal closed');
    }

    public disposeProjectTerminal() {
        try {
            if (this.terminalInputDisposable) this.terminalInputDisposable.dispose();
        } catch (e) { }
        try {
            if (this.terminal) this.terminal.dispose();
        } catch (e) { }
        this.terminalInputDisposable = null;
        this.terminalFitAddon = null;
        this.terminalWebLinksAddon = null;
        this.terminal = null;
        this.terminalHostElement = null;
    }

    public handleTerminalReady(data: any) {
        this.clearTerminalConnectTimer();
        this.terminalStarting = false;
        this.terminalReady = true;
        this.terminalError = '';
        this.terminalStatusMessage = data && data.message ? data.message : '터미널에 연결되었습니다.';
        if (this.terminal) this.terminal.writeln('[ReviewOps] connected');
        this.scheduleTerminalFit();
        this.service.render();
    }

    public handleTerminalData(data: any) {
        if (!this.ensureProjectTerminal()) return;
        this.terminal.write(data && data.data ? data.data : '');
    }

    public handleTerminalError(data: any) {
        this.clearTerminalConnectTimer();
        this.terminalStarting = false;
        this.terminalReady = false;
        this.terminalError = data && data.message ? data.message : '터미널 오류가 발생했습니다.';
        if (this.terminal) this.terminal.writeln(`\r\n[ReviewOps] ${this.terminalError}`);
        this.service.render();
    }

    public handleTerminalClosed(data: any) {
        this.clearTerminalConnectTimer();
        this.terminalStarting = false;
        this.terminalReady = false;
        this.terminalStatusMessage = data && data.message ? data.message : '터미널 연결이 종료되었습니다.';
        if (this.terminal) this.terminal.writeln(`\r\n[ReviewOps] ${this.terminalStatusMessage}`);
        this.service.render();
    }

    public hasEtcSettings() {
        return this.canExportReviewInfo()
            || this.canManageProjectAdmins()
            || (this.canMoveProject() && this.movableGroupOptions().length > 0)
            || this.canDeleteProject()
            || this.canRestoreProject();
    }

    public canSubmitProjectDelete() {
        return this.canDeleteProject() && String(this.projectDeleteConfirmName || '') === String(this.project && this.project.name || '');
    }

    public canCreateReview() {
        return !!(this.project && this.project.can_create_review);
    }

    public projectType(project: any = this.project) {
        return project && project.project_type ? String(project.project_type) : 'web_service';
    }

    public projectTypeLabel(project: any = this.project) {
        if (project && project.project_type_label) return project.project_type_label;
        const labels: any = {
            web_service: '웹서비스',
            pdf: 'PDF',
            html: 'HTML',
            pdf_document: 'PDF',
            pdf_presentation: 'PDF',
            html_document: 'HTML',
            html_presentation: 'HTML',
            proposal: 'PDF',
            presentation: 'PDF'
        };
        return labels[this.projectType(project)] || '웹서비스';
    }

    public isDocumentType(value: string) {
        return ['pdf', 'pdf_document', 'pdf_presentation', 'proposal', 'presentation'].includes(String(value || ''));
    }

    public isDocumentProject(project: any = this.project) {
        return this.isDocumentType(this.projectType(project));
    }

    public isHtmlType(value: string) {
        return ['html', 'html_document', 'html_presentation'].includes(String(value || ''));
    }

    public isHtmlProject(project: any = this.project) {
        return this.isHtmlType(this.projectType(project));
    }

    public usesDocumentCategoryOptions(project: any = this.project) {
        return this.isDocumentProject(project) || this.isHtmlProject(project);
    }

    public isWebProject(project: any = this.project) {
        return !this.isDocumentProject(project);
    }

    public isWebServiceProject(project: any = this.project) {
        return this.projectType(project) === 'web_service';
    }

    public projectQaServerUrl(project: any = this.project) {
        return String(project && project.link_url ? project.link_url : '').trim();
    }

    public projectDevServerUrl(project: any = this.project) {
        return String(project && project.dev_server_url ? project.dev_server_url : '').trim();
    }

    public reviewOpsOrigin() {
        try {
            return (window && window.location && window.location.origin) ? window.location.origin : 'https://review.season.co.kr';
        } catch (e) {
            return 'https://review.season.co.kr';
        }
    }

    public reviewOpsNormalizedOrigin() {
        return String(this.reviewOpsOrigin() || 'https://review.season.co.kr').replace(/\/+$/, '');
    }

    public reviewOpsSdkInstallSnippet() {
        const origin = this.reviewOpsNormalizedOrigin();
        return [
            '<script>',
            '  window.ReviewOpsSDK = {',
            `    parentOrigin: '${origin}'`,
            '  };',
            '</script>',
            `<script async src="${origin}/assets/reviewops-sdk.js"></script>`
        ].join('\n');
    }

    public reviewOpsSdkStatusLabel() {
        if (this.sdkStatus === 'connected') return this.sdkVersion ? `연결됨 · ${this.sdkVersion}` : '연결됨';
        if (this.sdkStatus === 'missing') return '응답 없음';
        return '확인 중';
    }

    public reviewOpsSdkStatusBadgeClass() {
        const base = 'inline-flex h-7 items-center rounded-full px-2.5 text-[11px] font-semibold ';
        if (this.sdkStatus === 'connected') return base + 'bg-emerald-100 text-emerald-700';
        if (this.sdkStatus === 'missing') return base + 'bg-amber-100 text-amber-700';
        return base + 'bg-slate-200 text-slate-600';
    }

    public reviewOpsIntegrationStatusText() {
        if (this.sdkStatus === 'connected') {
            return `현재 iframe에서 SDK 응답을 받았습니다${this.sdkOrigin ? ` (${this.sdkOrigin})` : ''}.`;
        }
        if (this.sdkStatus === 'missing') {
            return '현재 iframe에서 SDK 응답이 없습니다. 아래 설치 스크립트와 parentOrigin 설정을 확인하세요.';
        }
        return 'SDK 응답을 확인 중입니다. 설치 여부와 관계없이 아래 연동 설정을 유지하세요.';
    }

    public async copyReviewOpsSdkInstallSnippet() {
        try {
            await this.copyTextToClipboard(this.reviewOpsSdkInstallSnippet());
            await this.service.modal.success('SDK 설치 스크립트가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('SDK 설치 스크립트 복사에 실패했습니다.');
        }
    }

    public reviewOpsHeaderConfigSnippet() {
        const origin = this.reviewOpsNormalizedOrigin();
        return [
            `ReviewOps origin: ${origin}`,
            '',
            '필수 확인 항목',
            '1. iframe 허용: X-Frame-Options: DENY 또는 SAMEORIGIN 헤더를 제거합니다.',
            `2. CSP frame-ancestors: 기존 정책에 ${origin}을 허용합니다.`,
            `   예: frame-ancestors 'self' ${origin};`,
            `3. CSP script-src: SDK 파일 로드를 위해 ${origin}을 허용합니다.`,
            `   예: script-src 'self' ${origin};`,
            '4. inline window.ReviewOpsSDK 설정을 CSP 환경에서 사용할 때는 nonce/hash를 쓰거나 앱 번들에서 설정합니다.',
            `5. SDK/API 통신을 별도 제한하는 CSP가 있으면 connect-src에도 ${origin}을 병합합니다.`,
            '6. iframe 로그인 세션이 필요한 서비스는 세션 쿠키에 Secure; SameSite=None; HttpOnly; Path=/ 적용을 검토합니다.',
            '',
            '주의',
            '- Content-Security-Policy 헤더를 여러 개 중복으로 추가하면 브라우저가 모든 정책을 동시에 적용합니다.',
            '- 이미 CSP가 있다면 새 헤더를 덮어쓰지 말고 필요한 directive만 기존 정책에 병합하세요.'
        ].join('\n');
    }

    public reviewOpsNginxHeaderSnippet() {
        const origin = this.reviewOpsNormalizedOrigin();
        return [
            '# nginx server 또는 location 블록 예시',
            '# 기존 add_header X-Frame-Options DENY/SAMEORIGIN 설정은 제거합니다.',
            '# upstream 애플리케이션이 X-Frame-Options를 내려보내면 아래 설정으로 숨깁니다.',
            'proxy_hide_header X-Frame-Options;',
            '',
            '# CSP가 이미 있으면 이 헤더를 중복 추가하지 말고 기존 CSP에 directive를 병합하세요.',
            `add_header Content-Security-Policy "frame-ancestors 'self' ${origin}; script-src 'self' ${origin}; connect-src 'self' ${origin};" always;`,
            '',
            '# inline window.ReviewOpsSDK 설정을 유지해야 하는 엄격한 CSP 환경에서는',
            "# script-src에 nonce/hash를 추가하거나 설정 스크립트를 앱 번들/외부 파일로 이동하세요.",
            '',
            '# iframe 로그인 쿠키가 필요한 경우 애플리케이션의 Set-Cookie 예시',
            '# Set-Cookie: session=...; Secure; HttpOnly; SameSite=None; Path=/'
        ].join('\n');
    }

    public reviewOpsApacheHeaderSnippet() {
        const origin = this.reviewOpsNormalizedOrigin();
        return [
            '# Apache VirtualHost 또는 Directory 예시',
            '# 필요 모듈: a2enmod headers',
            '<IfModule mod_headers.c>',
            '    # 기존 X-Frame-Options DENY/SAMEORIGIN 헤더를 제거합니다.',
            '    Header always unset X-Frame-Options',
            '',
            '    # CSP가 이미 있으면 이 헤더를 중복 추가하지 말고 기존 CSP에 directive를 병합하세요.',
            `    Header always set Content-Security-Policy "frame-ancestors 'self' ${origin}; script-src 'self' ${origin}; connect-src 'self' ${origin};"`,
            '</IfModule>',
            '',
            '# inline window.ReviewOpsSDK 설정을 유지해야 하는 엄격한 CSP 환경에서는',
            '# script-src에 nonce/hash를 추가하거나 설정 스크립트를 앱 번들/외부 파일로 이동하세요.',
            '',
            '# iframe 로그인 쿠키가 필요한 경우 애플리케이션의 Set-Cookie 예시',
            '# Set-Cookie: session=...; Secure; HttpOnly; SameSite=None; Path=/'
        ].join('\n');
    }

    public reviewOpsCookieHeaderSnippet() {
        return [
            'Set-Cookie: session=...; Secure; HttpOnly; SameSite=None; Path=/',
            '',
            '- SameSite=None은 Secure와 함께 HTTPS에서 사용해야 합니다.',
            '- 쿠키 이름과 값은 대상 서비스의 기존 세션 쿠키를 유지합니다.',
            '- cross-site iframe 로그인이 필요하지 않으면 기존 쿠키 정책을 유지해도 됩니다.'
        ].join('\n');
    }

    public reviewOpsGuideMarkdown() {
        const origin = this.reviewOpsNormalizedOrigin();
        return [
            '# ReviewOps 웹서비스 연동 가이드',
            '',
            `- ReviewOps origin: ${origin}`,
            `- 프로젝트: ${this.project && this.project.name ? this.project.name : '-'}`,
            `- QA URL: ${this.projectQaServerUrl() || '-'}`,
            `- 개발 URL: ${this.projectDevServerUrl() || '-'}`,
            '',
            '## 1. SDK 설치',
            '',
            '리뷰 대상 페이지의 공통 레이아웃에 아래 스크립트를 추가합니다. CSP가 엄격한 서비스는 inline 설정 대신 앱 번들에서 `window.ReviewOpsSDK`를 설정하거나 nonce/hash를 적용합니다.',
            '',
            '```html',
            this.reviewOpsSdkInstallSnippet(),
            '```',
            '',
            '## 2. 서버 헤더 필수 항목',
            '',
            '```text',
            this.reviewOpsHeaderConfigSnippet(),
            '```',
            '',
            '## 3. nginx 예시',
            '',
            '```nginx',
            this.reviewOpsNginxHeaderSnippet(),
            '```',
            '',
            '## 4. Apache 예시',
            '',
            '```apache',
            this.reviewOpsApacheHeaderSnippet(),
            '```',
            '',
            '## 5. iframe 로그인 쿠키',
            '',
            '```http',
            this.reviewOpsCookieHeaderSnippet(),
            '```',
            '',
            '## 6. 배포 확인',
            '',
            '- 대상 URL이 ReviewOps iframe에서 열리는지 확인합니다.',
            '- 브라우저 개발자 도구 콘솔에서 CSP 또는 X-Frame-Options 차단 오류가 없는지 확인합니다.',
            '- ReviewOps 화면의 연동 가이드 모달에서 SDK 연결 확인을 실행합니다.',
            '- 연결되면 네비게이션, 입력 요약, 네트워크, 콘솔, DOM 스냅샷 수집이 활성화됩니다.'
        ].join('\n');
    }

    public reviewOpsGuideFileName() {
        const projectName = this.project && this.project.name ? this.project.name : 'project';
        return this.safeAttachmentName(`${projectName}-reviewops-integration-guide.md`);
    }

    public async copyReviewOpsHeaderGuide() {
        try {
            await this.copyTextToClipboard(this.reviewOpsHeaderConfigSnippet());
            await this.service.modal.success('헤더 설정 항목이 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('헤더 설정 복사에 실패했습니다.');
        }
    }

    public async copyReviewOpsGuideMarkdown() {
        try {
            await this.copyTextToClipboard(this.reviewOpsGuideMarkdown());
            await this.service.modal.success('연동 가이드가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('연동 가이드 복사에 실패했습니다.');
        }
    }

    public downloadTextFile(fileName: string, content: string, mime: string = 'text/plain;charset=utf-8') {
        const blob = new Blob([content], { type: mime });
        const objectUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = this.safeAttachmentName(fileName);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    }

    public downloadReviewOpsGuideMarkdown() {
        this.downloadTextFile(this.reviewOpsGuideFileName(), this.reviewOpsGuideMarkdown(), 'text/markdown;charset=utf-8');
    }

    public hasPreviewLinkToggle() {
        return this.isWebServiceProject() && !!this.projectDevServerUrl();
    }

    public normalizePreviewLinkMode(mode: any) {
        return String(mode || '') === 'dev' && this.projectDevServerUrl() ? 'dev' : 'qa';
    }

    public projectPreviewServerUrl(mode: string = this.previewLinkMode) {
        if (this.isHtmlProject()) return this.htmlPreviewUrl(this.selectedHtmlSnapshotId);
        const normalized = this.normalizePreviewLinkMode(mode);
        if (normalized === 'dev') return this.projectDevServerUrl();
        return this.projectQaServerUrl();
    }

    public htmlSnapshots(project: any = this.project) {
        return project && Array.isArray(project.html_snapshots) ? project.html_snapshots : [];
    }

    public htmlSnapshotById(id: any) {
        const snapshotId = String(id || '');
        if (!snapshotId) return null;
        return this.htmlSnapshots().find((item: any) => String(item.id) === snapshotId) || null;
    }

    public currentHtmlSnapshot() {
        return this.htmlSnapshotById(this.selectedHtmlSnapshotId);
    }

    public ensureHtmlSnapshotSelection() {
        if (!this.selectedHtmlSnapshotId) return;
        if (!this.htmlSnapshotById(this.selectedHtmlSnapshotId)) this.selectedHtmlSnapshotId = '';
    }

    public htmlPreviewUrl(snapshotId: any = '') {
        const snapshot = this.htmlSnapshotById(snapshotId);
        if (snapshot && snapshot.url) return String(snapshot.url);
        return String(this.project && this.project.html_project_url ? this.project.html_project_url : this.projectQaServerUrl()).trim();
    }

    public htmlShareEnabled(project: any = null) {
        const source = project || (
            this.projectForm && this.projectForm.html_document_settings ? this.projectForm : (this.project || {})
        );
        let settings = source && source.html_document_settings ? source.html_document_settings : {};
        if (typeof settings === 'string') {
            try {
                settings = JSON.parse(settings || '{}');
            } catch (e) {
                settings = {};
            }
        }
        const sharing = settings && settings.sharing ? settings.sharing : {};
        return !!(sharing && sharing.enabled);
    }

    public canUseHtmlShareLink() {
        return this.isHtmlProject() && (this.canEditSettings() || this.htmlShareEnabled());
    }

    public htmlShareButtonTitle() {
        return this.htmlShareEnabled() ? '링크 공유 활성화' : '링크 공유 비활성화';
    }

    public htmlShareButtonClass() {
        const base = 'flex h-9 w-9 shrink-0 items-center justify-center rounded-md border text-[12px] disabled:opacity-40 ';
        return this.htmlShareEnabled()
            ? base + 'border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
            : base + 'border-slate-300 bg-white text-slate-600 hover:bg-slate-50';
    }

    public htmlShareStatusLabel() {
        return this.htmlShareEnabled() ? '활성' : '비활성';
    }

    public htmlShareStatusClass() {
        return this.htmlShareEnabled()
            ? 'rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-semibold text-emerald-700'
            : 'rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-500';
    }

    public absolutePreviewUrl(value: string) {
        const target = String(value || '').trim();
        if (!target) return '';
        try {
            return new URL(target, window.location.origin).toString();
        } catch (e) {
            return target;
        }
    }

    public htmlShareFrameUrl(value: string) {
        const absolute = this.absolutePreviewUrl(value);
        if (!absolute) return '';
        try {
            const url = new URL(absolute, window.location.origin);
            if (url.pathname === '/project-html') {
                url.pathname = '/project-html-frame';
            } else if (url.pathname.startsWith('/project-html/')) {
                url.pathname = `/project-html-frame/${url.pathname.slice('/project-html/'.length)}`;
            } else if (!url.pathname.startsWith('/project-html-frame/')) {
                return absolute;
            }
            return url.toString();
        } catch (e) {
            return absolute.replace('/project-html/', '/project-html-frame/');
        }
    }

    public htmlShareUrl() {
        const current = String(this.currentUrl || this.frameUrl || '').trim();
        const preview = String(this.projectPreviewServerUrl('qa') || '').trim();
        const target = current.indexOf('/project-html/') >= 0 ? current : preview;
        return this.htmlShareFrameUrl(target);
    }

    public async openHtmlShareModal() {
        if (!this.canUseHtmlShareLink()) return;
        this.ensureHtmlDocumentSettings();
        this.htmlShareModalOpen = true;
        await this.service.render();
    }

    public async closeHtmlShareModal() {
        if (this.htmlShareSaving) return;
        this.htmlShareModalOpen = false;
        await this.service.render();
    }

    public async setHtmlShareEnabled(enabled: boolean) {
        if (!this.canEditSettings() || this.htmlShareSaving) return;
        this.htmlDocumentSharingSettings().enabled = !!enabled;
        this.htmlShareSaving = true;
        await this.service.render();
        try {
            const payload = this.projectSettingsSavePayload(false);
            const { code, data } = await wiz.call('save_project', this.requestParams({
                id: this.projectId,
                data: JSON.stringify(payload)
            }));
            if (code === 200) {
                this.applyProject(data.project);
            } else {
                this.htmlDocumentSharingSettings().enabled = !enabled;
                await this.service.modal.error((data && data.message) || '링크 공유 설정을 저장하지 못했습니다.');
            }
        } catch (e) {
            this.htmlDocumentSharingSettings().enabled = !enabled;
            await this.service.modal.error('링크 공유 설정을 저장하지 못했습니다.');
        } finally {
            this.htmlShareSaving = false;
            await this.service.render();
        }
    }

    public async toggleHtmlShareEnabled() {
        if (!this.canEditSettings()) return;
        await this.setHtmlShareEnabled(!this.htmlShareEnabled());
    }

    public async copyHtmlShareLink() {
        if (!this.htmlShareEnabled()) {
            await this.service.modal.error('링크 공유를 먼저 활성화해주세요.');
            return;
        }
        const link = this.htmlShareUrl();
        if (!link) {
            await this.service.modal.error('복사할 링크를 찾지 못했습니다.');
            return;
        }
        try {
            await this.copyTextToClipboard(link);
            await this.service.modal.success('링크가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('링크 복사에 실패했습니다.');
        }
    }

    public htmlSnapshotDisplayLabel(snapshot: any) {
        if (!snapshot) return '현재 파일';
        const label = String(snapshot.label || '').trim();
        const created = snapshot.created ? this.kstDateTime(snapshot.created) : '';
        if (label && created && label !== snapshot.created) return `${label} · ${created}`;
        return label || created || '-';
    }

    public htmlSnapshotOptionLabel(snapshot: any) {
        const size = snapshot && (snapshot.size_label || this.networkSizeLabel(snapshot.total_size));
        const count = Number(snapshot && snapshot.file_count) || 0;
        const meta = [count ? `${count}개` : '', size || ''].filter((item) => !!item).join(' · ');
        const label = this.htmlSnapshotDisplayLabel(snapshot);
        return meta ? `${label} (${meta})` : label;
    }

    public htmlSnapshotSelectTitle() {
        const snapshot = this.currentHtmlSnapshot();
        return snapshot ? this.htmlSnapshotOptionLabel(snapshot) : '현재 파일';
    }

    public htmlSnapshotButtonLabel() {
        return this.htmlSnapshotSelectTitle();
    }

    public htmlSnapshotDropdownStyle() {
        const button = document.querySelector('[data-html-snapshot-picker="button"]') as HTMLElement;
        if (!button) return {};

        const rect = button.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || rect.width;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 640;
        const margin = 8;
        const gap = 4;
        const desiredWidth = Math.min(Math.max(rect.width, 420), Math.max(280, viewportWidth - margin * 2));
        const availableBelow = Math.max(0, viewportHeight - rect.bottom - margin);
        const availableAbove = Math.max(0, rect.top - margin);
        const openUp = availableBelow < 260 && availableAbove > availableBelow;
        const availableHeight = openUp ? availableAbove : availableBelow;
        const menuHeight = Math.min(Math.max(180, availableHeight - gap), 432, Math.max(180, viewportHeight - margin * 2));

        let left = rect.right - desiredWidth;
        if (left + desiredWidth > viewportWidth - margin) left = viewportWidth - margin - desiredWidth;
        if (left < margin) left = margin;

        let top = openUp ? rect.top - gap - menuHeight : rect.bottom + gap;
        const maxTop = viewportHeight - margin - menuHeight;
        if (top > maxTop) top = maxTop;
        if (top < margin) top = margin;

        return {
            left: `${Math.round(left)}px`,
            top: `${Math.round(top)}px`,
            width: `${Math.round(desiredWidth)}px`,
            maxHeight: `${Math.round(menuHeight)}px`
        };
    }

    public async openHtmlSnapshotDropdown(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.isHtmlProject()) return;
        this.htmlSnapshotDropdownOpen = true;
        await this.service.render();
        window.setTimeout(() => {
            const input = document.querySelector('input[name="htmlSnapshotSearch"]') as HTMLInputElement;
            if (input) input.focus();
        }, 0);
    }

    public async closeHtmlSnapshotDropdown() {
        if (!this.htmlSnapshotDropdownOpen) return;
        this.htmlSnapshotDropdownOpen = false;
        await this.service.render();
    }

    public async toggleHtmlSnapshotDropdown(event?: any) {
        if (this.htmlSnapshotDropdownOpen) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            await this.closeHtmlSnapshotDropdown();
            return;
        }
        await this.openHtmlSnapshotDropdown(event);
    }

    public filteredHtmlSnapshots() {
        const query = String(this.htmlSnapshotQuery || '').trim().toLowerCase();
        if (!query) return this.htmlSnapshots();
        return this.htmlSnapshots().filter((snapshot: any) => {
            const text = [
                snapshot && snapshot.label,
                snapshot && snapshot.created,
                snapshot && snapshot.created_by_label,
                snapshot && snapshot.size_label,
                snapshot && snapshot.file_count,
                snapshot && snapshot.id
            ].join(' ').toLowerCase();
            return text.includes(query);
        });
    }

    public htmlSnapshotCurrentOptionClass() {
        const base = 'flex w-full min-w-0 items-center gap-2 rounded-md px-3 py-2 text-left text-[12px] hover:bg-slate-50 ';
        return this.selectedHtmlSnapshotId
            ? base + 'text-slate-700'
            : base + 'bg-slate-100 text-slate-950 shadow-sm';
    }

    public htmlSnapshotRowClass(snapshot: any) {
        const selected = snapshot && String(snapshot.id || '') === String(this.selectedHtmlSnapshotId || '');
        const base = 'flex min-w-0 items-stretch gap-2 rounded-md border p-1 transition-colors ';
        return selected
            ? base + 'border-slate-300 bg-slate-50'
            : base + 'border-transparent bg-white hover:border-slate-200 hover:bg-slate-50';
    }

    public htmlSnapshotOptionButtonClass(snapshot: any) {
        const selected = snapshot && String(snapshot.id || '') === String(this.selectedHtmlSnapshotId || '');
        const base = 'flex min-w-0 flex-1 flex-col justify-center rounded-md px-2.5 py-2 text-left ';
        return selected ? base + 'bg-white shadow-sm' : base + 'bg-transparent';
    }

    public htmlSnapshotActionBusy() {
        return !!this.htmlSnapshotDeletingId || !!this.htmlSnapshotRestoringId;
    }

    public htmlSnapshotActionButtonClass(kind: string, snapshot: any = null) {
        const busy = kind === 'delete' && this.htmlSnapshotDeleting(snapshot);
        const base = 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md border text-[12px] disabled:opacity-40 ';
        if (busy) return base + 'border-rose-200 bg-rose-50 text-rose-400';
        if (kind === 'delete') return base + 'border-rose-200 text-rose-500 hover:bg-rose-50';
        if (kind === 'restore') {
            if (this.htmlSnapshotRestoring(snapshot)) return base + 'border-emerald-200 bg-emerald-50 text-emerald-500';
            return base + 'border-emerald-200 text-emerald-600 hover:bg-emerald-50';
        }
        return base + 'border-slate-200 text-slate-500 hover:bg-slate-50 hover:text-slate-900';
    }

    public htmlSnapshotDeleting(snapshot: any) {
        return !!snapshot && !!this.htmlSnapshotDeletingId && String(this.htmlSnapshotDeletingId) === String(snapshot.id || '');
    }

    public htmlSnapshotRestoring(snapshot: any) {
        return !!snapshot && !!this.htmlSnapshotRestoringId && String(this.htmlSnapshotRestoringId) === String(snapshot.id || '');
    }

    public async handleHtmlSnapshotSearchKeydown(event: KeyboardEvent) {
        if (!event) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            await this.closeHtmlSnapshotDropdown();
            return;
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const first = this.filteredHtmlSnapshots()[0];
            await this.selectHtmlSnapshotFromDropdown(first || null);
        }
    }

    public async selectHtmlSnapshotFromDropdown(snapshot: any) {
        const id = snapshot && snapshot.id ? snapshot.id : '';
        this.htmlSnapshotDropdownOpen = false;
        await this.selectHtmlSnapshot(id);
    }

    public htmlSnapshotArchiveFileName(snapshot: any) {
        if (snapshot && snapshot.archive_name) return this.safeAttachmentName(snapshot.archive_name);
        const label = String(snapshot && (snapshot.label || snapshot.id) || 'backup').replace(/[^\w가-힣.-]+/g, '-');
        return this.safeAttachmentName(`html-backup-${label || 'backup'}.zip`);
    }

    public downloadHtmlSnapshotArchive(snapshot: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const url = String(snapshot && (snapshot.archive_url || snapshot.download_url) || '');
        if (!url) return;
        const link = document.createElement('a');
        link.href = url;
        link.download = this.htmlSnapshotArchiveFileName(snapshot);
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public async restoreHtmlSnapshot(snapshot: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const snapshotId = String(snapshot && snapshot.id || '');
        if (!snapshotId || !this.canUseHtmlProjectFiles() || this.htmlSnapshotActionBusy()) return;
        const confirmed = await this.service.modal.show({
            title: 'HTML 백업 복원',
            message: `${this.htmlSnapshotDisplayLabel(snapshot)} 백업으로 현재 HTML 파일을 복원할까요? 현재 상태가 백업되어 있지 않으면 자동 백업 후 복원합니다.`,
            action: '복원',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.htmlSnapshotDropdownOpen = false;
        this.htmlSnapshotRestoringId = snapshotId;
        await this.service.render();
        let code = 0;
        let data: any = {};
        try {
            const response = await wiz.call('restore_html_project_snapshot', this.requestParams({
                id: this.projectId,
                data: JSON.stringify({ snapshot_id: snapshotId })
            }));
            code = response.code;
            data = response.data || {};
        } catch (e) {
            code = 0;
            data = {};
        }
        this.htmlSnapshotRestoringId = '';
        if (code === 200) {
            this.applyProject(data.project);
            this.selectedHtmlSnapshotId = '';
            this.ensureHtmlSnapshotSelection();
            await this.navigateHtmlPreviewSnapshot('html-backup:restore');
            const autoBackup = data && data.auto_snapshot;
            const message = autoBackup
                ? '복원했습니다. 복원 전 현재 상태는 자동 백업으로 저장했습니다.'
                : '복원했습니다.';
            await this.service.modal.success(message);
        } else {
            await this.service.modal.error(data.message || '백업을 복원하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteHtmlSnapshot(snapshot: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const snapshotId = String(snapshot && snapshot.id || '');
        if (!snapshotId || !this.canUseHtmlProjectFiles() || this.htmlSnapshotActionBusy()) return;
        const confirmed = await this.service.modal.show({
            title: 'HTML 백업 삭제',
            message: `${this.htmlSnapshotDisplayLabel(snapshot)} 백업을 삭제할까요?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        const wasSelected = String(this.selectedHtmlSnapshotId || '') === snapshotId;
        this.htmlSnapshotDeletingId = snapshotId;
        await this.service.render();
        let code = 0;
        let data: any = {};
        try {
            const response = await wiz.call('delete_html_project_snapshot', this.requestParams({
                id: this.projectId,
                data: JSON.stringify({ snapshot_id: snapshotId })
            }));
            code = response.code;
            data = response.data || {};
        } catch (e) {
            code = 0;
            data = {};
        }
        this.htmlSnapshotDeletingId = '';
        if (code === 200) {
            this.applyProject(data.project);
            if (wasSelected) {
                this.selectedHtmlSnapshotId = '';
                await this.navigateHtmlPreviewSnapshot('html-backup:delete');
            }
        } else {
            await this.service.modal.error(data.message || '백업을 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public canCreateHtmlSnapshot() {
        return this.canUseHtmlProjectFiles() && !this.htmlSnapshotBusy && !this.htmlSnapshotActionBusy();
    }

    public defaultHtmlSnapshotLabel() {
        const now = new Date();
        const pad = (value: number) => String(value).padStart(2, '0');
        return `백업 ${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
    }

    public async createHtmlSnapshot() {
        if (!this.canCreateHtmlSnapshot()) return;
        this.htmlSnapshotForm = { label: this.defaultHtmlSnapshotLabel() };
        this.htmlSnapshotModalOpen = true;
        await this.service.render();
    }

    public async closeHtmlSnapshotModal() {
        if (this.htmlSnapshotBusy) return;
        this.htmlSnapshotModalOpen = false;
        await this.service.render();
    }

    public async submitHtmlSnapshotModal(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.canCreateHtmlSnapshot()) return;
        const label = String(this.htmlSnapshotForm && this.htmlSnapshotForm.label || '').trim() || this.defaultHtmlSnapshotLabel();
        this.htmlSnapshotBusy = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('create_html_project_snapshot', this.requestParams({
                id: this.projectId,
                data: JSON.stringify({ label })
            }));
            this.htmlSnapshotBusy = false;
            if (code === 200) {
                this.htmlSnapshotModalOpen = false;
                this.applyProject(data.project);
                this.selectedHtmlSnapshotId = data && data.snapshot && data.snapshot.id ? data.snapshot.id : this.selectedHtmlSnapshotId;
                this.ensureHtmlSnapshotSelection();
                await this.navigateHtmlPreviewSnapshot('html-backup:create');
            } else {
                await this.service.modal.error((data && data.message) || '백업을 생성하지 못했습니다.');
            }
        } catch (e) {
            this.htmlSnapshotBusy = false;
            await this.service.modal.error('백업을 생성하지 못했습니다.');
        }
        await this.service.render();
    }

    public async selectHtmlSnapshot(id: any) {
        if (!this.isHtmlProject()) return;
        this.selectedHtmlSnapshotId = String(id || '');
        this.ensureHtmlSnapshotSelection();
        await this.navigateHtmlPreviewSnapshot(this.selectedHtmlSnapshotId ? 'html-backup:select' : 'html-backup:current');
    }

    public async navigateHtmlPreviewSnapshot(source: string = 'html-backup') {
        if (!this.isHtmlProject()) return;
        const target = this.projectPreviewServerUrl('qa');
        if (!target) return;
        const shouldForceFrameLoad = this.normalizeFrameHistoryUrl(this.frameUrl) === target;
        this.frameTitle = '';
        if (!this.beginFrameNavigation(target, 'new')) return;
        this.currentUrl = target;
        this.remoteAddress = target;
        await this.service.render();
        if (shouldForceFrameLoad) this.applyFrameUrlToIframe(target);
        this.finishPendingFrameNavigationLater(this.frameHistorySeq);
        this.recordNavigation(target, source);
    }

    public updateHtmlDocumentState(state: any) {
        if (!this.isHtmlProject()) return;
        const standard = !!(state && state.standard);
        this.htmlDocumentStandardReady = standard;
        this.htmlDocumentStandardMessage = standard
            ? ''
            : String((state && (state.standard_missing_reason || state.reason || state.strategy)) || 'iframe-page-state-unavailable');
        const detectedPageCount = Math.max(Number(state && (state.page_count || state.total_pages || state.total)) || 1, 1);
        const manualPageCount = this.configuredHtmlDocumentPageCount();
        const pageCount = Math.max(detectedPageCount, manualPageCount, 1);
        const page = Math.min(Math.max(Number(state && (state.page || state.current_page)) || 1, 1), pageCount);
        this.htmlDocumentState = Object.assign({}, state || {}, {
            page,
            page_count: pageCount,
            detected_page_count: detectedPageCount,
            manual_page_count: manualPageCount,
            strategy: state && state.strategy ? state.strategy : (standard ? 'iframe-dom' : 'iframe-dom-unavailable'),
            standard
        });
        if (standard && this.htmlDocumentRestorePageAfterLoad > 0) {
            const restorePage = Math.min(Math.max(this.htmlDocumentRestorePageAfterLoad, 1), pageCount);
            this.htmlDocumentRestorePageAfterLoad = 0;
            if (restorePage !== page) window.setTimeout(() => this.goToHtmlDocumentPage(restorePage, 'html-document-reload-restore'), 0);
        }
    }

    public configuredHtmlDocumentPageCount(project: any = null) {
        return 0;
    }

    public htmlFrameDocument() {
        const iframe = this.reviewFrame();
        try {
            const doc = iframe && iframe.contentDocument;
            const win: any = iframe && iframe.contentWindow;
            if (!doc || !doc.documentElement || !win) return null;
            const href = win.location && win.location.href;
            if (href) this.currentUrl = href;
            return doc;
        } catch (e) {
            return null;
        }
    }

    public parseHtmlPageNumber(value: any, fallback: number = 0) {
        const raw = String(value || '').trim();
        if (!raw) return fallback;
        const direct = Number(raw);
        if (Number.isFinite(direct) && direct > 0) return Math.floor(direct);
        const match = raw.match(/(\d+)/);
        if (!match) return fallback;
        const parsed = Number(match[1]);
        return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
    }

    public htmlDocumentPageElements(doc: Document | null = null) {
        const source = doc || this.htmlFrameDocument();
        if (!source) return [] as HTMLElement[];
        const root = source.documentElement as HTMLElement;
        const body = source.body as HTMLElement;
        const selector = [
            '[data-reviewops-page]',
            '[data-page]',
            '[data-page-index]',
            '[data-slide]',
            '[data-slide-index]',
            '[role="doc-page"]',
            '[aria-roledescription="page"]',
            '[aria-roledescription="slide"]',
            '[id^="page"]',
            '[id^="slide"]',
            '.document-page',
            '.reviewops-page',
            '.page',
            '.slide'
        ].join(', ');
        const nodes = Array.from(source.querySelectorAll(selector)) as HTMLElement[];
        const candidates: HTMLElement[] = [];
        nodes.forEach((node) => {
            if (!node || node === root || node === body) return;
            if (!this.htmlElementPageCandidate(node) && !this.htmlElementExplicitPageNumber(node)) return;
            if (candidates.indexOf(node) < 0) candidates.push(node);
        });
        const explicitCandidates = candidates.filter((node) => this.htmlElementExplicitPageNumber(node) > 0);
        const sourceCandidates = explicitCandidates.length ? explicitCandidates : candidates;
        const candidateSet = new Set(sourceCandidates);
        const result: HTMLElement[] = [];
        sourceCandidates.forEach((node) => {
            let parent = node.parentElement;
            while (parent && parent !== root && parent !== body) {
                if (candidateSet.has(parent as HTMLElement)) return;
                parent = parent.parentElement;
            }
            if (result.indexOf(node) < 0) result.push(node);
        });
        return result;
    }

    public htmlDocumentPageElement(doc: Document | null, page: number, visibleOnly: boolean = false) {
        const source = doc || this.htmlFrameDocument();
        if (!source) return null;
        const win: any = source.defaultView;
        const target = Math.max(Number(page) || 1, 1);
        const pages = this.htmlDocumentPageElements(source);
        for (let index = 0; index < pages.length; index++) {
            const element = pages[index];
            const itemPage = this.htmlElementPageNumber(element, index + 1);
            if (itemPage !== target) continue;
            if (visibleOnly && !this.htmlElementVisible(element, win)) continue;
            return element;
        }
        return null;
    }

    public htmlElementExplicitPageNumber(element: HTMLElement) {
        if (!element) return 0;
        return this.parseHtmlPageNumber(
            element.getAttribute('data-reviewops-page')
            || element.getAttribute('data-page')
            || element.getAttribute('data-page-index')
            || element.getAttribute('data-slide')
            || element.getAttribute('data-slide-index')
            || element.getAttribute('aria-label')
            || element.id,
            0
        );
    }

    public htmlElementPageNumber(element: HTMLElement, fallback: number) {
        return this.htmlElementExplicitPageNumber(element) || fallback;
    }

    public htmlElementPageCandidate(element: HTMLElement) {
        if (!element) return false;
        const role = String(element.getAttribute('role') || '').toLowerCase();
        const roleDescription = String(element.getAttribute('aria-roledescription') || '').toLowerCase();
        const className = String((element as any).className || '').toLowerCase();
        const id = String(element.id || '').toLowerCase();
        return !!(
            element.hasAttribute('data-reviewops-page')
            || element.hasAttribute('data-page')
            || element.hasAttribute('data-page-index')
            || element.hasAttribute('data-slide')
            || element.hasAttribute('data-slide-index')
            || /^(page|slide)[-_]?\d+/.test(id)
            || role === 'doc-page'
            || roleDescription === 'page'
            || roleDescription === 'slide'
            || /(^|\s)(document-page|reviewops-page|page|slide)(\s|$)/.test(className)
        );
    }

    public htmlElementExplicitCurrent(element: HTMLElement) {
        if (!element) return false;
        const ariaCurrent = String(element.getAttribute('aria-current') || '').toLowerCase();
        const dataCurrent = String(element.getAttribute('data-current') || '').toLowerCase();
        const className = String((element as any).className || '').toLowerCase();
        return dataCurrent === 'true'
            || ariaCurrent === 'true'
            || ariaCurrent === 'page'
            || /\b(active|current|is-active|selected)\b/.test(className);
    }

    public htmlElementRenderable(element: HTMLElement, win: any) {
        if (!element || element.hidden) return false;
        if (String(element.getAttribute('aria-hidden') || '').toLowerCase() === 'true') return false;
        try {
            const style = win && win.getComputedStyle ? win.getComputedStyle(element) : null;
            if (style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0)) return false;
        } catch (e) { }
        try {
            const rect = element.getBoundingClientRect();
            return !!(rect.width && rect.height);
        } catch (e) {
            return false;
        }
    }

    public htmlElementViewportScore(element: HTMLElement, win: any) {
        if (!this.htmlElementRenderable(element, win)) return 0;
        if (this.htmlElementExplicitCurrent(element)) return Number.MAX_SAFE_INTEGER;
        try {
            const rect = element.getBoundingClientRect();
            const viewportWidth = Math.max(Number(win && win.innerWidth) || Number(win && win.document && win.document.documentElement && win.document.documentElement.clientWidth) || 0, 1);
            const viewportHeight = Math.max(Number(win && win.innerHeight) || Number(win && win.document && win.document.documentElement && win.document.documentElement.clientHeight) || 0, 1);
            const left = Math.max(rect.left, 0);
            const right = Math.min(rect.right, viewportWidth);
            const top = Math.max(rect.top, 0);
            const bottom = Math.min(rect.bottom, viewportHeight);
            const width = Math.max(right - left, 0);
            const height = Math.max(bottom - top, 0);
            return width * height;
        } catch (e) {
            return 0;
        }
    }

    public htmlElementVisible(element: HTMLElement, win: any) {
        return this.htmlElementViewportScore(element, win) > 0;
    }

    public setHtmlDocumentPageDataset(doc: Document, page: number, pageCount: number) {
        const pageValue = String(Math.max(Number(page) || 1, 1));
        const countValue = String(Math.max(Number(pageCount) || 1, 1));
        const html = doc.documentElement as HTMLElement;
        const body = doc.body as HTMLElement;
        if (html) {
            html.hidden = false;
            html.removeAttribute('hidden');
            html.removeAttribute('aria-hidden');
            html.setAttribute('data-page', pageValue);
            html.setAttribute('data-current-page', pageValue);
            html.removeAttribute('data-reviewops-page');
            html.setAttribute('data-page-count', countValue);
            html.setAttribute('data-reviewops-page-count', countValue);
        }
        if (body) {
            body.hidden = false;
            body.removeAttribute('hidden');
            body.removeAttribute('aria-hidden');
            body.removeAttribute('data-page');
            body.setAttribute('data-current-page', pageValue);
            body.removeAttribute('data-reviewops-page');
            body.setAttribute('data-page-count', countValue);
            body.setAttribute('data-reviewops-page-count', countValue);
        }
    }

    public htmlDocumentPageApi(doc: Document | null = null) {
        const source = doc || this.htmlFrameDocument();
        try {
            const win: any = source && source.defaultView;
            return win && win.ReviewOpsPage ? win.ReviewOpsPage : null;
        } catch (e) {
            return null;
        }
    }

    public readHtmlDocumentApiState(doc: Document | null) {
        const api = this.htmlDocumentPageApi(doc);
        if (!api || typeof api.page_state !== 'function') return null;
        try {
            const raw = api.page_state() || {};
            const pageCount = Math.max(this.parseHtmlPageNumber(raw.page_count || raw.pageCount || raw.total_pages || raw.total || raw.count, 0), 0);
            const page = this.parseHtmlPageNumber(raw.page || raw.current_page || raw.current || raw.currentPage, 0);
            const loading = raw.loading === true || raw.is_loading === true || raw.pending === true || String(raw.status || '').toLowerCase() === 'loading';
            const ready = raw.ready === false || loading ? false : true;
            return Object.assign({}, raw, {
                page: page || raw.page || raw.current_page || raw.current || raw.currentPage,
                current_page: page || raw.current_page || raw.page || raw.current || raw.currentPage,
                page_count: pageCount || raw.page_count || raw.pageCount || raw.total_pages || raw.total || raw.count,
                ready,
                loading
            });
        } catch (e) {
            return null;
        }
    }

    public navigateHtmlDocumentPageApi(doc: Document | null, page: number, direction: number = 0) {
        const api = this.htmlDocumentPageApi(doc);
        if (!api) return false;
        const target = Math.max(Number(page) || 1, 1);
        try {
            if (typeof api.go_to_page === 'function') {
                api.go_to_page(target);
                return true;
            }
            if (typeof api.goToPage === 'function') {
                api.goToPage(target);
                return true;
            }
            if (typeof api.set_page === 'function') {
                api.set_page(target);
                return true;
            }
            if (typeof api.setPage === 'function') {
                api.setPage(target);
                return true;
            }
            if (direction > 0 && typeof api.next === 'function') {
                api.next();
                return true;
            }
            if (direction < 0 && typeof api.prev === 'function') {
                api.prev();
                return true;
            }
        } catch (e) { }
        return false;
    }

    public htmlDocumentNestedFrameDocument(doc: Document | null) {
        const source = doc || this.htmlFrameDocument();
        const frame = this.htmlDocumentNestedFrameElement(source);
        if (!frame) return null;
        try {
            const nested = frame && (frame.contentDocument || (frame.contentWindow && frame.contentWindow.document));
            if (!nested || nested === source || !nested.documentElement || !nested.body) return null;
            return nested;
        } catch (e) {
            return null;
        }
    }

    public htmlDocumentNestedFrameElement(doc: Document | null = null) {
        const source = doc || this.htmlFrameDocument();
        if (!source) return null;
        try {
            return source.querySelector('iframe#reviewops-frame, iframe.reviewops-frame') as HTMLIFrameElement;
        } catch (e) {
            return null;
        }
    }

    public htmlDocumentUrlPath(url: string) {
        try {
            return new URL(String(url || ''), window.location.origin).pathname;
        } catch (e) {
            return '';
        }
    }

    public normalizedFrameComparableUrl(url: string) {
        const target = String(url || '').trim();
        if (!target) return '';
        try {
            const parsed = new URL(target, window.location.origin);
            parsed.hash = '';
            return parsed.toString().replace(/\/+$/, '');
        } catch (e) {
            return target.split('#')[0].replace(/\/+$/, '');
        }
    }

    public htmlProjectFrameUrlMatches(url: string) {
        const target = String(url || '').trim();
        if (!this.isHtmlProject() || !target) return false;
        const expected = this.normalizedFrameComparableUrl(this.projectPreviewServerUrl('qa'));
        const current = this.normalizedFrameComparableUrl(target);
        if (expected && current && (current === expected || current.startsWith(`${expected}/`))) return true;

        const projectId = encodeURIComponent(String(this.projectId || '').trim());
        const path = this.htmlDocumentUrlPath(target).replace(/\/+$/, '');
        if (!projectId || !path) return false;
        const directBase = `/project-html/${projectId}`;
        const frameBase = `/project-html-frame/${projectId}`;
        return path === directBase
            || path.startsWith(`${directBase}/`)
            || path === frameBase
            || path.startsWith(`${frameBase}/`);
    }

    public readHtmlDocumentStateFromDocument(doc: Document | null) {
        if (!doc) return null;
        const html = doc.documentElement as HTMLElement;
        const body = doc.body as HTMLElement;
        const win: any = doc.defaultView;
        let url = '';
        let title = '';
        let readyState = '';
        try {
            url = win && win.location && win.location.href ? win.location.href : '';
            title = doc.title || '';
            readyState = doc.readyState || '';
        } catch (e) { }
        if (url && url !== 'about:blank' && !this.htmlProjectFrameUrlMatches(url)) return null;
        const nestedDoc = this.htmlDocumentNestedFrameDocument(doc);
        if (nestedDoc) {
            const nestedState = this.readHtmlDocumentStateFromDocument(nestedDoc);
            if (nestedState) return nestedState;
        }
        const pages = this.htmlDocumentPageElements(doc);
        const manualPageCount = this.configuredHtmlDocumentPageCount();
        const apiState = this.readHtmlDocumentApiState(doc);
        const apiPageCount = this.parseHtmlPageNumber(apiState && (apiState.page_count || apiState.pageCount || apiState.total_pages || apiState.total || apiState.count), 0);
        const apiPage = this.parseHtmlPageNumber(apiState && (apiState.page || apiState.current_page || apiState.current || apiState.currentPage), 0);
        const attrPageCount = Math.max(
            this.parseHtmlPageNumber(html && (html.getAttribute('data-page-count') || html.getAttribute('data-reviewops-page-count')), 0),
            this.parseHtmlPageNumber(body && (body.getAttribute('data-page-count') || body.getAttribute('data-reviewops-page-count')), 0)
        );
        let visiblePage = 0;
        let explicitPage = 0;
        let bestVisibleScore = 0;
        if (pages.length) {
            for (let index = 0; index < pages.length; index++) {
                const element = pages[index];
                const itemPage = this.htmlElementPageNumber(element, index + 1);
                if (!explicitPage && this.htmlElementExplicitCurrent(element) && this.htmlElementRenderable(element, win)) {
                    explicitPage = itemPage;
                }
                const score = this.htmlElementViewportScore(element, win);
                if (score > bestVisibleScore) {
                    bestVisibleScore = score;
                    visiblePage = itemPage;
                }
            }
        }
        const rootPage = Math.max(
            this.parseHtmlPageNumber(html && (html.getAttribute('data-page') || html.getAttribute('data-current-page') || html.getAttribute('data-reviewops-page')), 0),
            this.parseHtmlPageNumber(body && (body.getAttribute('data-page') || body.getAttribute('data-current-page') || body.getAttribute('data-reviewops-page')), 0)
        );
        let hashPage = 0;
        try {
            hashPage = this.parseHtmlPageNumber(win && win.location ? win.location.hash : '', 0);
        } catch (e) { }
        const hasPageStructure = pages.length > 0 || attrPageCount > 0 || apiPageCount > 0 || manualPageCount > 0;
        if (!hasPageStructure) {
            const bodyChildCount = body && body.children ? body.children.length : 0;
            const path = this.htmlDocumentUrlPath(url);
            const pending = !url || url === 'about:blank' || readyState === 'loading' || path.startsWith('/project-html-frame/');
            if (pending || bodyChildCount === 0) return null;
        }
        const detectedPageCount = Math.max(pages.length, attrPageCount, apiPageCount, 1);
        const pageCount = Math.max(detectedPageCount, manualPageCount, 1);
        let page = apiPage || explicitPage || hashPage || visiblePage || rootPage;
        if (!page) page = Math.max(Number(this.htmlDocumentState && this.htmlDocumentState.page) || 1, 1);
        page = Math.min(Math.max(page, 1), pageCount);
        this.setHtmlDocumentPageDataset(doc, page, pageCount);
        return {
            page,
            current_page: page,
            page_count: pageCount,
            detected_page_count: detectedPageCount,
            manual_page_count: manualPageCount,
            api_page_state: apiState,
            ready: apiState ? apiState.ready !== false : true,
            loading: apiState ? apiState.loading === true || apiState.ready === false : false,
            standard: true,
            strategy: apiState ? 'iframe-api' : 'iframe-dom',
            page_selector: pages.length ? 'html-page-elements' : (apiState ? 'ReviewOpsPage.page_state' : ''),
            url,
            title
        };
    }

    public readHtmlDocumentStateFromFrame() {
        if (!this.isHtmlProject()) return null;
        return this.readHtmlDocumentStateFromDocument(this.htmlFrameDocument());
    }

    public applyHtmlDocumentPageFallbackToDocument(doc: Document | null, page: number) {
        if (!doc) return false;
        const pages = this.htmlDocumentPageElements(doc);
        if (!pages.length) return false;
        const pageCount = Math.max(pages.length, this.configuredHtmlDocumentPageCount(), 1);
        const target = Math.min(Math.max(Number(page) || 1, 1), pageCount);
        pages.forEach((element, index) => {
            const itemPage = this.htmlElementPageNumber(element, index + 1);
            const active = itemPage === target;
            element.hidden = !active;
            element.setAttribute('data-current', active ? 'true' : 'false');
            element.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.setHtmlDocumentPageDataset(doc, target, pageCount);
        this.navigateHtmlDocumentHashToDocument(doc, target);
        return true;
    }

    public applyHtmlDocumentPageFallback(page: number) {
        return this.applyHtmlDocumentPageFallbackToDocument(this.htmlFrameDocument(), page);
    }

    public htmlDocumentHashForPage(win: any, page: number) {
        const target = Math.max(Number(page) || 1, 1);
        const currentHash = String((win && win.location && win.location.hash) || '');
        if (currentHash) {
            const nextHash = currentHash.replace(/\d+/, String(target));
            if (nextHash && nextHash !== currentHash) return nextHash;
        }
        return `#${target}`;
    }

    public navigateHtmlDocumentHashToDocument(doc: Document | null, page: number) {
        if (!doc) return false;
        try {
            const win: any = doc.defaultView;
            if (!win || !win.location) return false;
            const oldUrl = String(win.location.href || '');
            const nextHash = this.htmlDocumentHashForPage(win, page);
            if (!nextHash) return false;
            if (win.location.hash !== nextHash) {
                win.location.hash = nextHash;
            } else {
                try {
                    if (typeof win.HashChangeEvent === 'function') {
                        win.dispatchEvent(new win.HashChangeEvent('hashchange', { oldURL: oldUrl, newURL: oldUrl }));
                    } else {
                        win.dispatchEvent(new win.Event('hashchange'));
                    }
                } catch (e) { }
            }
            return true;
        } catch (e) {
            return false;
        }
    }

    public focusHtmlDocumentFrame() {
        const iframe = this.reviewFrame();
        const doc = this.htmlFrameDocument();
        const win: any = doc && doc.defaultView;
        try {
            if (iframe && iframe.focus) iframe.focus();
        } catch (e) { }
        try {
            if (win && win.focus) win.focus();
        } catch (e) { }
    }

    public sendHtmlDocumentKey(key: string) {
        const doc = this.htmlFrameDocument();
        if (!doc) return false;
        const win: any = doc.defaultView;
        if (!win || !win.KeyboardEvent) return false;
        const codeMap: any = {
            ArrowLeft: 'ArrowLeft',
            ArrowRight: 'ArrowRight',
            PageUp: 'PageUp',
            PageDown: 'PageDown',
            Home: 'Home',
            End: 'End',
            ' ': 'Space'
        };
        const options = {
            key,
            code: codeMap[key] || key,
            bubbles: true,
            cancelable: true
        };
        this.focusHtmlDocumentFrame();
        try {
            const targets: any[] = [win, doc, doc.activeElement, doc.body, doc.documentElement].filter(Boolean);
            const dispatched: any[] = [];
            targets.forEach((target) => {
                if (dispatched.indexOf(target) >= 0 || !target.dispatchEvent) return;
                dispatched.push(target);
                target.dispatchEvent(new win.KeyboardEvent('keydown', options));
                target.dispatchEvent(new win.KeyboardEvent('keyup', options));
            });
            return true;
        } catch (e) {
            return false;
        }
    }

    public htmlDocumentPage() {
        return Math.max(Number(this.htmlDocumentState && this.htmlDocumentState.page) || 1, 1);
    }

    public htmlDocumentPageCount() {
        return Math.max(Number(this.htmlDocumentState && this.htmlDocumentState.page_count) || 1, 1);
    }

    public htmlDocumentPageLabel() {
        const state = this.htmlDocumentState || {};
        if (!this.htmlDocumentPageControlsReady()) return '페이지 확인 중';
        if (state.strategy === 'loading') return '페이지 확인 중';
        return `${this.htmlDocumentPage()} / ${this.htmlDocumentPageCount()}`;
    }

    public async setHtmlDocumentPageFromInput(event: any, source: string = 'html-document-input') {
        if (event && event.preventDefault && event.type === 'keydown') event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        const input = event && event.target ? event.target as HTMLInputElement : null;
        const rawValue = input ? input.value : event;
        const current = this.htmlDocumentPage();
        const max = this.htmlDocumentPageCount();
        const text = String(rawValue === undefined || rawValue === null ? '' : rawValue).trim();
        let target = current;
        if (text) {
            const direct = Number(text);
            const parsed = Number.isFinite(direct) ? Math.floor(direct) : this.parseHtmlPageNumber(text, 0);
            target = Math.min(Math.max(Number(parsed) || 1, 1), max);
        }
        if (input) input.value = String(target);
        if (!this.htmlDocumentPageControlsReady() || this.htmlPdfExporting) {
            await this.renderView();
            return;
        }
        if (target === current) {
            await this.renderView();
            return;
        }
        await this.goToHtmlDocumentPage(target, source);
    }

    public htmlDocumentPageControlsReady() {
        return this.isHtmlProject() && !!(this.htmlDocumentState && this.htmlDocumentState.standard);
    }

    public canPrevHtmlDocumentPage() {
        return this.htmlDocumentPageControlsReady() && !this.htmlPdfExporting && this.htmlDocumentPage() > 1;
    }

    public canNextHtmlDocumentPage() {
        return this.htmlDocumentPageControlsReady() && !this.htmlPdfExporting && this.htmlDocumentPage() < this.htmlDocumentPageCount();
    }

    public canExportHtmlDocumentPdf() {
        return this.isHtmlProject() && !this.htmlPdfExporting && !!this.projectId;
    }

    public sdkVersionAtLeast(version: string) {
        const parse = (value: string) => String(value || '').split('.').map((part) => Number(part.replace(/[^\d].*$/, '')) || 0);
        const current = parse(this.sdkVersion);
        const required = parse(version);
        for (let i = 0; i < Math.max(current.length, required.length); i++) {
            const left = current[i] || 0;
            const right = required[i] || 0;
            if (left > right) return true;
            if (left < right) return false;
        }
        return true;
    }

    public htmlPdfExportOverlayText() {
        return this.htmlPdfExportProgress ? `PDF 다운로드 중 · ${this.htmlPdfExportProgress}` : 'PDF 다운로드 중';
    }

    public focusHtmlPdfExportGuard() {
        try {
            const active: any = document.activeElement;
            if (active && active.blur) active.blur();
        } catch (e) { }
        const target: any = document.getElementById('reviewops-html-pdf-export-guard') || this.htmlShellElement();
        if (!target || !target.focus) return;
        try {
            target.focus({ preventScroll: true } as any);
        } catch (e) {
            try {
                target.focus();
            } catch (_e) { }
        }
    }

    public setHtmlPdfExportLock(locked: boolean) {
    }

    public setHtmlPdfExportProgress(progress: string) {
        this.htmlPdfExportProgress = progress;
    }

    public requestHtmlDocumentState(render: boolean = false) {
        if (!this.isHtmlProject()) return false;
        const state = this.readHtmlDocumentStateFromFrame();
        if (state) {
            this.updateHtmlDocumentState(state);
            if (render) this.renderView();
            return true;
        }
        this.updateHtmlDocumentState({
            page: Math.max(Number(this.htmlDocumentState && this.htmlDocumentState.page) || 1, 1),
            page_count: Math.max(this.configuredHtmlDocumentPageCount(), 1),
            strategy: 'iframe-dom-unavailable',
            standard: false,
            standard_missing_reason: 'iframe-not-readable'
        });
        if (render) this.renderView();
        return false;
    }

    public syncHtmlDocumentFrameState(source: string = 'html-iframe-watch') {
        if (!this.isHtmlProject()) return false;
        const previousPage = this.htmlDocumentPage();
        const previousPageCount = this.htmlDocumentPageCount();
        const previousUrl = this.currentUrl || '';
        const previousTitle = this.frameTitle || '';
        const state = this.readHtmlDocumentStateFromFrame();
        if (!state) return false;
        this.updateHtmlDocumentState(state);
        const nextUrl = String(state.url || this.currentUrl || this.frameUrl || '');
        const nextTitle = String(state.title || '');
        if (nextTitle) this.setFrameTitle(nextTitle, source);
        if (nextUrl && nextUrl !== previousUrl) this.commitFrameHistoryNavigation(nextUrl, source);
        const pageChanged = previousPage !== this.htmlDocumentPage() || previousPageCount !== this.htmlDocumentPageCount();
        const titleChanged = nextTitle && nextTitle !== previousTitle;
        const urlChanged = nextUrl !== previousUrl;
        if (pageChanged || urlChanged) this.clearFrameScreenshotCache('capture-pending');
        return pageChanged || urlChanged || !!titleChanged;
    }

    public htmlDocumentUrlWithPage(url: string, page: number) {
        const target = String(url || '').trim();
        const pageValue = Math.max(Number(page) || 1, 1);
        if (!target) return '';
        try {
            const parsed = new URL(target, window.location.origin);
            parsed.hash = `#${pageValue}`;
            return parsed.toString();
        } catch (e) {
            const base = target.split('#')[0] || target;
            return `${base}#${pageValue}`;
        }
    }

    public ensureHtmlProjectFrameUrl(source: string = 'html-frame-url-guard') {
        if (!this.isHtmlProject()) return false;
        const iframe = this.reviewFrame();
        const current = String((iframe && iframe.src) || this.frameUrl || this.currentUrl || '').trim();
        if (this.htmlProjectFrameUrlMatches(current)) return false;
        const target = String(this.projectPreviewServerUrl('qa') || '').trim();
        if (!target) return false;
        this.frameUrl = target;
        this.currentUrl = target;
        this.remoteAddress = target;
        this.frameTitle = '';
        this.resetFrameHistory(target);
        this.htmlDocumentRestorePageAfterLoad = 0;
        this.htmlDocumentStandardReady = false;
        this.htmlDocumentStandardMessage = 'iframe-loading';
        this.htmlDocumentState = {
            page: 1,
            page_count: Math.max(this.configuredHtmlDocumentPageCount(), 1),
            manual_page_count: this.configuredHtmlDocumentPageCount(),
            strategy: 'loading',
            standard: false
        };
        if (iframe) this.applyFrameUrlToIframe(target);
        this.recordNavigation(target, source);
        return true;
    }

    public preserveHtmlDocumentFramePage(source: string = 'html-document-preserve') {
        if (!this.isHtmlProject()) return false;
        const state = this.readHtmlDocumentStateFromFrame();
        if (state) this.updateHtmlDocumentState(state);
        const page = this.htmlDocumentPage();
        this.htmlDocumentRestorePageAfterLoad = page;
        const current = String((state && state.url) || this.currentUrl || this.frameUrl || this.projectPreviewServerUrl('qa') || '').trim();
        const restoredUrl = this.htmlDocumentUrlWithPage(current, page);
        if (!restoredUrl) return false;
        this.frameUrl = restoredUrl;
        this.remoteAddress = restoredUrl;
        this.currentUrl = restoredUrl;
        this.replaceFrameHistoryCurrent(restoredUrl);
        this.recordNavigation(restoredUrl, source);
        return true;
    }

    public async goToHtmlDocumentPage(page: number, source: string = 'html-document-page') {
        if (!this.isHtmlProject()) return;
        this.requestHtmlDocumentState(false);
        const target = Math.min(Math.max(Number(page) || 1, 1), this.htmlDocumentPageCount());
        let current = this.htmlDocumentPage();
        const direction = target >= current ? 1 : -1;
        if (current !== target) {
            const doc = this.htmlFrameDocument();
            const directSent = this.navigateHtmlDocumentPageApi(doc, target, direction);
            if (directSent) {
                await this.service.sleep(220);
                const state = this.readHtmlDocumentStateFromFrame();
                if (state) this.updateHtmlDocumentState(state);
                current = this.htmlDocumentPage();
                if (current !== target) {
                    await this.service.sleep(220);
                    const delayedState = this.readHtmlDocumentStateFromFrame();
                    if (delayedState) this.updateHtmlDocumentState(delayedState);
                    current = this.htmlDocumentPage();
                }
            }
        }
        if (current !== target && this.navigateHtmlDocumentHashToDocument(this.htmlFrameDocument(), target)) {
            await this.service.sleep(140);
            const hashState = this.readHtmlDocumentStateFromFrame();
            if (hashState) this.updateHtmlDocumentState(hashState);
            current = this.htmlDocumentPage();
        }
        if (current !== target && this.applyHtmlDocumentPageFallback(target)) {
            const fallbackState = this.readHtmlDocumentStateFromFrame();
            if (fallbackState) this.updateHtmlDocumentState(fallbackState);
            current = this.htmlDocumentPage();
        }
        let guard = 0;
        while (current !== target && guard < Math.abs(target - current) + 4) {
            guard++;
            const nextPage = current + direction;
            const doc = this.htmlFrameDocument();
            const apiSent = this.navigateHtmlDocumentPageApi(doc, nextPage, direction);
            const sent = apiSent || this.sendHtmlDocumentKey(direction > 0 ? 'ArrowRight' : 'ArrowLeft');
            await this.service.sleep(apiSent ? 220 : 90);
            const state = this.readHtmlDocumentStateFromFrame();
            if (state) this.updateHtmlDocumentState(state);
            let updated = this.htmlDocumentPage();
            if (apiSent && updated === current) {
                await this.service.sleep(220);
                const delayedState = this.readHtmlDocumentStateFromFrame();
                if (delayedState) this.updateHtmlDocumentState(delayedState);
                updated = this.htmlDocumentPage();
            }
            if (!sent || updated === current) {
                if (!this.applyHtmlDocumentPageFallback(nextPage)) break;
                const fallbackState = this.readHtmlDocumentStateFromFrame();
                if (fallbackState) this.updateHtmlDocumentState(fallbackState);
                updated = this.htmlDocumentPage();
            }
            current = updated;
            if ((direction > 0 && current > target) || (direction < 0 && current < target)) {
                this.applyHtmlDocumentPageFallback(target);
                const fallbackState = this.readHtmlDocumentStateFromFrame();
                if (fallbackState) this.updateHtmlDocumentState(fallbackState);
                current = this.htmlDocumentPage();
                break;
            }
        }
        if (current !== target && this.applyHtmlDocumentPageFallback(target)) {
            const fallbackState = this.readHtmlDocumentStateFromFrame();
            if (fallbackState) this.updateHtmlDocumentState(fallbackState);
        }
        this.recordNavigation(this.currentUrl || this.frameUrl, `${source}:${target}`);
        await this.renderView();
    }

    public prevHtmlDocumentPage() {
        if (!this.canPrevHtmlDocumentPage()) return;
        this.goToHtmlDocumentPage(this.htmlDocumentPage() - 1, 'html-document-prev');
    }

    public nextHtmlDocumentPage() {
        if (!this.canNextHtmlDocumentPage()) return;
        this.goToHtmlDocumentPage(this.htmlDocumentPage() + 1, 'html-document-next');
    }

    public isHtmlKeyboardEditableTarget(target: any) {
        if (!target) return false;
        const tag = String(target.tagName || '').toLowerCase();
        if (['input', 'textarea', 'select', 'button'].includes(tag)) return true;
        if (target.isContentEditable) return true;
        return !!(target.closest && target.closest('[contenteditable="true"], [contenteditable=""]'));
    }

    public shouldHandleHtmlDocumentKeyboardNavigation(event: KeyboardEvent) {
        const keys = ['ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Home', 'End'];
        if (this.htmlPdfExporting && keys.concat(['ArrowUp', 'ArrowDown']).includes(event.key)) return true;
        if (!this.isHtmlProject() || !this.htmlDocumentPageControlsReady()) return false;
        if (!keys.includes(event.key)) return false;
        if (this.isHtmlKeyboardEditableTarget(event.target)) return false;
        const shell = this.htmlShellElement();
        const active = document.activeElement as HTMLElement;
        if (!this.htmlFullscreenActive() && shell && active && active !== document.body && !shell.contains(active)) return false;
        return true;
    }

    public handleHtmlDocumentKeyboardNavigation(event: KeyboardEvent) {
        if (!this.shouldHandleHtmlDocumentKeyboardNavigation(event)) return false;
        event.preventDefault();
        event.stopPropagation();
        if (this.htmlPdfExporting) return true;
        if (event.key === 'ArrowLeft' || event.key === 'PageUp') this.prevHtmlDocumentPage();
        if (event.key === 'ArrowRight' || event.key === 'PageDown') this.nextHtmlDocumentPage();
        if (event.key === 'Home') this.goToHtmlDocumentPage(1, 'html-document-home');
        if (event.key === 'End') this.goToHtmlDocumentPage(this.htmlDocumentPageCount(), 'html-document-end');
        return true;
    }

    public async waitForHtmlDocumentAssets(doc: Document | null, timeout: number = 3000) {
        if (!doc) return;
        const started = Date.now();
        const limit = Math.max(Number(timeout) || 0, 250);
        const withTimeout = async (promise: Promise<any>) => {
            const remaining = Math.max(limit - (Date.now() - started), 0);
            if (remaining <= 0) return;
            await Promise.race([
                promise.catch(() => null),
                new Promise((resolve) => window.setTimeout(resolve, remaining))
            ]);
        };
        const fonts: any = (doc as any).fonts;
        if (fonts && fonts.ready) await withTimeout(fonts.ready);
        const images = Array.from(doc.images || []).filter((image: HTMLImageElement) => !image.complete || !image.naturalWidth);
        if (images.length) {
            await withTimeout(Promise.all(images.slice(0, 120).map((image: any) => {
                if (image.decode) return image.decode().catch(() => null);
                return new Promise((resolve) => {
                    image.onload = () => resolve(null);
                    image.onerror = () => resolve(null);
                });
            })));
        }
        const win: any = doc.defaultView || window;
        await new Promise((resolve) => {
            if (win && win.requestAnimationFrame) {
                win.requestAnimationFrame(() => win.requestAnimationFrame(resolve));
            } else {
                window.setTimeout(resolve, 32);
            }
        });
    }

    public htmlDocumentPdfFileName() {
        const projectName = this.project && this.project.name ? this.project.name : 'html-document';
        const safeName = this.safeAttachmentName(projectName);
        return /\.pdf$/i.test(safeName) ? safeName : `${safeName}.pdf`;
    }

    public htmlDocumentPdfFrameWindow() {
        const outerFrame = this.reviewFrame();
        const outerDoc = this.htmlFrameDocument();
        const nestedFrame = this.htmlDocumentNestedFrameElement(outerDoc);
        try {
            if (nestedFrame && nestedFrame.contentWindow && nestedFrame.contentDocument) return nestedFrame.contentWindow as any;
        } catch (e) { }
        try {
            if (outerFrame && outerFrame.contentWindow && outerFrame.contentDocument) return outerFrame.contentWindow as any;
        } catch (e) { }
        return null;
    }

    public loadHtmlPdfFrameScript(doc: Document, src: string, marker: string) {
        return new Promise((resolve, reject) => {
            if (!doc || !doc.documentElement) {
                reject(new Error('html-pdf-document-unavailable'));
                return;
            }
            const existing = marker ? doc.querySelector(`script[${marker}]`) as HTMLScriptElement : null;
            if (existing) {
                const existingSrc = String(existing.getAttribute('src') || '');
                if (existingSrc === src || existing.src === src) {
                    if ((existing as any).__reviewopsLoaded) {
                        resolve(null);
                        return;
                    }
                    existing.addEventListener('load', () => resolve(null), { once: true });
                    existing.addEventListener('error', () => reject(new Error(`html-pdf-script-load-failed:${src}`)), { once: true });
                    return;
                }
                existing.remove();
            }
            const script = doc.createElement('script');
            if (marker) script.setAttribute(marker, 'true');
            (script as any).__reviewopsLoaded = false;
            script.src = src;
            script.onload = () => {
                (script as any).__reviewopsLoaded = true;
                resolve(null);
            };
            script.onerror = () => reject(new Error(`html-pdf-script-load-failed:${src}`));
            (doc.head || doc.documentElement).appendChild(script);
        });
    }

    public async ensureHtmlDocumentPdfExporter() {
        const win: any = this.htmlDocumentPdfFrameWindow();
        if (!win) throw new Error('html-pdf-frame-unavailable');
        const exporterVersion = '20260628-client-canvas-pdf-v9';
        if (typeof win.__REVIEWOPS_EXPORT_PDF__ === 'function' && win.__REVIEWOPS_EXPORT_PDF_VERSION__ === exporterVersion) return win;
        let doc: Document | null = null;
        try {
            doc = win.document;
        } catch (e) {
            doc = null;
        }
        if (!doc) throw new Error('html-pdf-document-unavailable');
        await this.loadHtmlPdfFrameScript(doc, `/assets/reviewops-html-client-pdf-exporter.js?v=${exporterVersion}`, 'data-reviewops-pdf-exporter-runtime');
        if (typeof win.__REVIEWOPS_EXPORT_PDF__ !== 'function') throw new Error('html-pdf-exporter-unavailable');
        return win;
    }

    public htmlDocumentPdfProgressText(state: any) {
        const phase = String(state && state.phase || '');
        const page = Number(state && state.page) || 0;
        const pageCount = Number(state && state.pageCount) || 0;
        const suffix = pageCount > 0 && page > 0 ? ` ${page}/${pageCount}` : '';
        if (phase === 'prepare-capture') return '캡처 준비 중';
        if (phase === 'render') return `페이지 준비${suffix}`;
        if (phase === 'capture') return `페이지 캡처${suffix}`;
        if (phase === 'captured') return `캡처 완료${suffix}`;
        if (phase === 'assemble') return 'PDF 조립 중';
        if (phase === 'done') return 'PDF 다운로드 중';
        return 'PDF 생성 중';
    }

    public downloadBlob(blob: Blob, fileName: string) {
        const objectUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = this.safeAttachmentName(fileName);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    }

    public async downloadHtmlDocumentPdf() {
        if (!this.canExportHtmlDocumentPdf()) return;

        this.htmlPdfExporting = true;
        this.setHtmlPdfExportProgress('PDF 생성 준비 중');
        this.setHtmlPdfExportLock(true);
        await this.renderView();
        try {
            const exporterWindow: any = await this.ensureHtmlDocumentPdfExporter();
            await exporterWindow.__REVIEWOPS_EXPORT_PDF__({
                filename: this.htmlDocumentPdfFileName(),
                progress: async (state: any) => {
                    this.setHtmlPdfExportProgress(this.htmlDocumentPdfProgressText(state));
                    await this.renderView();
                }
            });
        } catch (e) {
            await this.service.modal.error('PDF 다운로드에 실패했습니다. HTML 화면을 새로고침한 뒤 다시 시도해 주세요.');
        } finally {
            this.htmlPdfExporting = false;
            this.htmlPdfExportProgress = '';
            this.setHtmlPdfExportLock(false);
            await this.renderView();
        }
    }

    public previewLinkModeButtonClass(mode: string) {
        const base = 'h-8 w-11 shrink-0 text-[11px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ';
        if (this.normalizePreviewLinkMode(this.previewLinkMode) === mode) return base + 'bg-slate-900 text-white';
        return base + 'bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-900';
    }

    public previewLinkModeButtonTitle(mode: string) {
        return mode === 'dev' ? '개발 서버 URL로 전환' : 'QA 서버 URL로 전환';
    }

    public previewLinkTarget(mode: string) {
        const nextMode = this.normalizePreviewLinkMode(mode);
        const targetBase = this.projectPreviewServerUrl(nextMode);
        if (!targetBase) return '';
        const currentMode = this.normalizePreviewLinkMode(this.previewLinkMode);
        const currentBase = this.projectPreviewServerUrl(currentMode);
        const current = this.currentUrl || this.frameUrl || currentBase;
        try {
            const currentUrl = new URL(this.normalizeFrameUrl(current));
            const currentBaseUrl = new URL(this.normalizeFrameUrl(currentBase));
            const targetUrl = new URL(this.normalizeFrameUrl(targetBase));
            if (currentUrl.origin === currentBaseUrl.origin) {
                targetUrl.pathname = currentUrl.pathname;
                targetUrl.search = currentUrl.search;
                targetUrl.hash = currentUrl.hash;
                return targetUrl.toString();
            }
        } catch (e) { }
        return this.normalizeFrameUrl(targetBase);
    }

    public async switchPreviewLinkMode(mode: string) {
        if (!this.hasPreviewLinkToggle() || this.frameActionBusy) return;
        const nextMode = this.normalizePreviewLinkMode(mode);
        const target = this.previewLinkTarget(nextMode);
        if (!target) return;
        const shouldForceFrameLoad = this.normalizeFrameHistoryUrl(this.frameUrl) === target;
        this.previewLinkMode = nextMode;
        this.frameTitle = '';
        if (!this.beginFrameNavigation(target, 'new')) return;
        this.currentUrl = target;
        this.remoteAddress = target;
        await this.service.render();
        if (shouldForceFrameLoad) this.applyFrameUrlToIframe(target);
        this.finishPendingFrameNavigationLater(this.frameHistorySeq);
    }

    public syncCategoryOptions() {
        this.categoryOptions = this.usesDocumentCategoryOptions() ? this.documentCategoryOptions.slice() : this.webCategoryOptions.slice();
        const fallback = this.categoryOptions[0] || 'other';
        if (!this.categoryOptions.includes(this.reviewForm.category)) this.reviewForm.category = fallback;
        if (this.reviewFilters.category && !this.categoryOptions.includes(this.reviewFilters.category)) this.reviewFilters.category = '';
        if (this.reviewEditForm && this.reviewEditForm.category && !this.categoryOptions.includes(this.reviewEditForm.category)) {
            this.reviewEditForm.category = fallback;
        }
    }

    public documentVersions(project: any = this.project) {
        return project && Array.isArray(project.document_versions) ? project.document_versions : [];
    }

    public visibleDocumentVersions() {
        const total = this.documentVersionTotalPages();
        const page = Math.min(Math.max(Number(this.documentVersionPage) || 1, 1), total);
        const start = (page - 1) * this.documentVersionPageSize;
        return this.documentVersions().slice(start, start + this.documentVersionPageSize);
    }

    public documentVersionTotalPages() {
        const total = Math.ceil(this.documentVersions().length / this.documentVersionPageSize);
        return Math.max(total || 1, 1);
    }

    public documentVersionPageStart() {
        if (!this.documentVersions().length) return 0;
        return (this.documentVersionPage - 1) * this.documentVersionPageSize + 1;
    }

    public documentVersionPageEnd() {
        return Math.min(this.documentVersionPage * this.documentVersionPageSize, this.documentVersions().length);
    }

    public documentVersionPageNumbers() {
        const total = this.documentVersionTotalPages();
        const current = Math.min(Math.max(this.documentVersionPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async setDocumentVersionPage(page: number) {
        const total = this.documentVersionTotalPages();
        this.documentVersionPage = Math.min(Math.max(Number(page) || 1, 1), total);
        await this.service.render();
    }

    public ensureDocumentVersionPage() {
        const total = this.documentVersionTotalPages();
        this.documentVersionPage = Math.min(Math.max(Number(this.documentVersionPage) || 1, 1), total);
    }

    public latestDocumentVersion(project: any = this.project) {
        const versions = this.documentVersions(project);
        return versions.length ? versions[0] : null;
    }

    public currentDocumentVersion() {
        const versions = this.documentVersions();
        if (!versions.length) return null;
        if (this.selectedDocumentVersionId) {
            const selected = versions.find((item: any) => String(item.id) === String(this.selectedDocumentVersionId));
            if (selected) return selected;
        }
        return this.latestDocumentVersion();
    }

    public currentDocumentVersionFileLoaded() {
        const version = this.currentDocumentVersion();
        return !!(version && version.file_data_url);
    }

    public ensureDocumentVersionSelection(resetPage: boolean = false) {
        if (!this.isDocumentProject()) return;
        const versions = this.documentVersions();
        const selected = this.selectedDocumentVersionId
            ? versions.find((item: any) => String(item.id) === String(this.selectedDocumentVersionId))
            : null;
        if (!selected) {
            const latest = this.latestDocumentVersion();
            this.selectedDocumentVersionId = latest ? latest.id : '';
        }
        if (resetPage || !this.pdfPage) this.pdfPage = 1;
        this.ensureDocumentVersionPage();
        this.setPdfPage(this.pdfPage, false);
    }

    public documentPageCount() {
        if (this.pdfDocument && Number(this.pdfDocument.numPages)) return Number(this.pdfDocument.numPages);
        const version = this.currentDocumentVersion();
        return Number(version && version.page_count) || 0;
    }

    public selectedDocumentVersionLabel() {
        const version = this.currentDocumentVersion();
        if (!version) return '-';
        const size = version.file_size_label || this.networkSizeLabel(version.file_size);
        return `${this.documentVersionDisplayLabel(version)} · ${version.file_name || 'document.pdf'} · ${size}`;
    }

    public documentReviewCurrentUrl() {
        const projectName = this.project && this.project.name ? this.project.name : '문서';
        const version = this.currentDocumentVersion();
        const versionLabel = version ? this.documentVersionDisplayLabel(version) : '-';
        return `${projectName} / ${this.projectTypeLabel()} / ${versionLabel} / p.${Math.max(Number(this.pdfPage) || 1, 1)}`;
    }

    public pdfPreviewLoading() {
        return this.documentFileLoading || this.pdfJsLoading || this.pdfRendering;
    }

    public pdfLoadingMessage() {
        if (this.documentFileLoading) return 'PDF 문서를 불러오는 중입니다.';
        if (this.pdfJsLoading) return 'PDF 렌더러를 준비하는 중입니다.';
        if (this.pdfRendering) return `PDF ${Math.max(Number(this.pdfPage) || 1, 1)}페이지를 렌더링 중입니다.`;
        return 'PDF를 준비하는 중입니다.';
    }

    public pdfTransparentImageUrl() {
        return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    }

    public pdfDisplayImageUrl() {
        return this.pdfPageImageUrl || this.pdfTransparentImageUrl();
    }

    public pdfImageClass() {
        const base = 'mx-auto block shrink-0 rounded-sm bg-white shadow transition-opacity';
        return this.pdfPageImageUrl ? base : `${base} opacity-0`;
    }

    public pdfCanvasElement() {
        return this.pdfRenderedCanvas;
    }

    public pdfStageElement() {
        return document.getElementById('reviewops-pdf-stage') as HTMLElement;
    }

    public pdfViewerElement() {
        return document.getElementById('reviewops-pdf-viewer') as HTMLElement;
    }

    public pdfShellElement() {
        return document.getElementById('reviewops-pdf-shell') as HTMLElement;
    }

    public pdfShellClass() {
        const base = 'flex min-h-0 flex-1 flex-col bg-slate-100';
        if (this.pdfFullscreenActive()) return `${base} h-screen w-screen overflow-hidden`;
        return base;
    }

    public pdfViewerClass() {
        const base = 'min-h-0 flex-1 bg-slate-100 outline-none';
        if (this.pdfFullscreenActive()) return `${base} h-screen overflow-hidden p-0`;
        return `${base} overflow-auto p-2 lg:p-5`;
    }

    public pdfStageClass() {
        if (this.pdfFullscreenActive()) return 'relative flex h-full min-h-0 w-full items-center justify-center overflow-hidden';
        return 'relative mx-auto flex min-h-[360px] w-full items-start justify-start overflow-visible lg:min-h-[620px]';
    }

    public pdfFullscreenElement() {
        const doc: any = document;
        return doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement || null;
    }

    public pdfFullscreenSupported() {
        const shell: any = this.pdfShellElement() || document.documentElement;
        const doc: any = document;
        return !!(shell && (shell.requestFullscreen || shell.webkitRequestFullscreen || shell.mozRequestFullScreen || shell.msRequestFullscreen) && (doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen));
    }

    public pdfFullscreenActive() {
        const shell = this.pdfShellElement();
        return !!(shell && this.pdfFullscreenElement() === shell);
    }

    public pdfFullscreenButtonTitle() {
        return this.pdfFullscreenActive() ? 'PDF 전체화면 종료' : 'PDF 전체화면 보기';
    }

    public pdfFullscreenButtonLabel() {
        return this.pdfFullscreenActive() ? '전체화면 종료' : '전체화면';
    }

    public pdfFullscreenIconClass() {
        return this.pdfFullscreenActive() ? 'fa-solid fa-compress text-[12px]' : 'fa-solid fa-expand text-[12px]';
    }

    public pdfFullscreenButtonClass() {
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold disabled:opacity-40';
        if (this.pdfFullscreenActive()) return `${base} border-slate-900 bg-slate-900 text-white hover:bg-slate-800`;
        return `${base} border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public async togglePdfFullscreen() {
        if (!this.currentDocumentVersion() || !this.pdfFullscreenSupported()) return;
        try {
            if (this.pdfFullscreenActive()) await this.exitPdfFullscreen();
            else await this.enterPdfFullscreen();
        } catch (e) { }
        await this.syncPdfFullscreenState();
    }

    public async enterPdfFullscreen() {
        const shell: any = this.pdfShellElement();
        if (!shell) return;
        const request = shell.requestFullscreen || shell.webkitRequestFullscreen || shell.mozRequestFullScreen || shell.msRequestFullscreen;
        if (!request) return;
        await request.call(shell);
        this.focusPdfViewer();
    }

    public async exitPdfFullscreen() {
        const doc: any = document;
        const exit = doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen;
        if (!exit) return;
        await exit.call(doc);
    }

    public async syncPdfFullscreenState() {
        const active = this.pdfFullscreenActive();
        const changed = this.pdfFullscreen !== active;
        this.pdfFullscreen = active;
        if (this.isDocumentProject()) {
            this.queuePdfRender();
            if (active) window.setTimeout(() => this.focusPdfViewer(), 0);
        }
        if (changed) await this.renderView();
    }

    public focusPdfViewer() {
        const viewer = this.pdfViewerElement();
        if (!viewer) return;
        try {
            viewer.focus({ preventScroll: true } as any);
        } catch (e) {
            try {
                viewer.focus();
            } catch (_e) { }
        }
    }

    public htmlShellElement() {
        const root = this.componentRootElement();
        return root ? root.querySelector('#reviewops-html-shell') as HTMLElement : null;
    }

    public previewCanvasElement() {
        const root = this.componentRootElement();
        return root ? root.querySelector('.review-preview-canvas') as HTMLElement : null;
    }

    public normalizeWebViewerMode(value: any) {
        return String(value || '').trim().toLowerCase() === 'fullscreen' ? 'fullscreen' : 'browser';
    }

    public webViewerFullscreenActive() {
        return !!(this.isWebServiceProject() && this.webViewerMode === 'fullscreen');
    }

    public webViewerChromeVisible() {
        return !!(this.isWebServiceProject() && !this.webViewerFullscreenActive());
    }

    public webViewerFullscreenButtonTitle() {
        return this.webViewerFullscreenActive() ? '뷰어 전체화면 종료' : '뷰어 전체화면';
    }

    public webViewerFullscreenButtonLabel() {
        return this.webViewerFullscreenActive() ? '전체화면 종료' : '전체화면';
    }

    public webViewerFullscreenIconClass() {
        return this.webViewerFullscreenActive() ? 'fa-solid fa-compress text-[12px]' : 'fa-solid fa-expand text-[12px]';
    }

    public webViewerFullscreenButtonClass() {
        const base = 'inline-flex h-9 shrink-0 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (this.webViewerFullscreenActive()) return `${base} border-slate-900 bg-slate-900 text-white hover:bg-slate-800`;
        return `${base} border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    private webViewerBrowserStateSnapshot() {
        return {
            viewport: {
                width: Number(this.viewport && this.viewport.width) || 1440,
                height: Number(this.viewport && this.viewport.height) || 900
            },
            selectedPreset: this.selectedPreset || 'Custom',
            scale: this.clampHtmlScale(this.scale),
            scaleMode: this.scaleMode === 'fit' ? 'fit' : 'custom'
        };
    }

    private restoreWebViewerBrowserState() {
        const state = this.webViewerBrowserState;
        if (state && state.viewport) {
            this.viewport = {
                width: Number(state.viewport.width) || 1440,
                height: Number(state.viewport.height) || 900
            };
            this.selectedPreset = state.selectedPreset || this.viewportPresetName();
            this.scale = this.clampHtmlScale(state.scale);
            this.scaleMode = state.scaleMode === 'fit' ? 'fit' : 'custom';
        } else {
            this.viewport = {
                width: Number(this.project && this.project.default_viewport_width) || 1440,
                height: Number(this.project && this.project.default_viewport_height) || 900
            };
            this.selectedPreset = this.viewportPresetName();
            this.scale = 1;
            this.scaleMode = 'fit';
        }
        this.webViewerBrowserState = null;
    }

    public async toggleWebViewerFullscreen() {
        if (!this.isWebServiceProject()) return;
        if (this.webViewerFullscreenActive()) {
            this.webViewerMode = 'browser';
            this.clearWebViewerLayoutTimer();
            this.disconnectWebViewerResizeObserver();
            this.restoreWebViewerBrowserState();
            this.recordNavigation(this.currentUrl, 'viewer:browser');
        } else {
            this.webViewerBrowserState = this.webViewerBrowserStateSnapshot();
            this.webViewerMode = 'fullscreen';
            this.scale = 1;
            this.scaleMode = 'fit';
            this.previewLogPanelOpen = false;
            this.deactivateElementSelect(false);
            this.recordNavigation(this.currentUrl, 'viewer:fullscreen');
        }
        await this.service.render();
        if (this.webViewerFullscreenActive() || this.scaleMode === 'fit') this.scheduleFitScale();
        else this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
    }

    private clearWebViewerLayoutTimer() {
        if (!this.webViewerLayoutTimer) return;
        window.clearTimeout(this.webViewerLayoutTimer);
        this.webViewerLayoutTimer = null;
    }

    private disconnectWebViewerResizeObserver() {
        if (this.webViewerResizeObserver && this.webViewerResizeObserver.disconnect) {
            try {
                this.webViewerResizeObserver.disconnect();
            } catch (e) { }
        }
        this.webViewerResizeObserver = null;
        this.webViewerObservedElement = null;
    }

    private connectWebViewerResizeObserver(shell: HTMLElement) {
        const ResizeObserverClass = typeof window !== 'undefined' ? (window as any).ResizeObserver : null;
        if (!ResizeObserverClass || !shell) return;
        if (this.webViewerResizeObserver && this.webViewerObservedElement === shell) return;
        this.disconnectWebViewerResizeObserver();
        this.webViewerResizeObserver = new ResizeObserverClass(() => this.scheduleWebViewerLayout());
        this.webViewerObservedElement = shell;
        this.webViewerResizeObserver.observe(shell);
    }

    private applyWebViewerFullscreenLayout(shell: HTMLElement) {
        if (!this.webViewerFullscreenActive() || !shell) return false;
        const width = Math.floor(Number(shell.clientWidth) || 0);
        const height = Math.floor(Number(shell.clientHeight) || 0);
        if (width < 1 || height < 1) return false;
        const changed = width !== Number(this.viewport && this.viewport.width)
            || height !== Number(this.viewport && this.viewport.height)
            || this.scale !== 1;
        this.viewport = { width, height };
        this.scale = 1;
        this.scaleMode = 'fit';
        if (changed) {
            this.postSdkCommand('viewport', { width, height, scale: 1 }, false);
        }
        return changed;
    }

    private scheduleWebViewerLayout() {
        if (!this.webViewerFullscreenActive()) return;
        this.clearWebViewerLayoutTimer();
        this.webViewerLayoutTimer = window.setTimeout(async () => {
            this.webViewerLayoutTimer = null;
            if (!this.webViewerFullscreenActive() || this.destroyed) return;
            const shell = this.htmlShellElement();
            if (!shell) return;
            this.connectWebViewerResizeObserver(shell);
            if (this.applyWebViewerFullscreenLayout(shell)) await this.service.render();
        }, 0);
    }

    public htmlFullscreenElement() {
        const doc: any = document;
        return doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement || null;
    }

    public htmlNativeFullscreenSupported() {
        if (!this.isHtmlProject()) return false;
        const shell: any = this.htmlShellElement() || document.documentElement;
        const doc: any = document;
        return !!(shell && (shell.requestFullscreen || shell.webkitRequestFullscreen || shell.mozRequestFullScreen || shell.msRequestFullscreen) && (doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen));
    }

    public htmlFullscreenSupported() {
        return this.isHtmlProject();
    }

    public htmlNativeFullscreenActive() {
        if (!this.isHtmlProject()) return false;
        const shell = this.htmlShellElement();
        return !!(shell && this.htmlFullscreenElement() === shell);
    }

    public htmlFallbackFullscreenActive() {
        return !!(this.isHtmlProject() && this.htmlFullscreenFallback);
    }

    public htmlFullscreenActive() {
        if (!this.isHtmlProject()) return false;
        return this.htmlFallbackFullscreenActive() || this.htmlNativeFullscreenActive();
    }

    public htmlFullscreenButtonTitle() {
        return this.htmlFullscreenActive() ? 'HTML 전체화면 종료' : 'HTML 전체화면 보기';
    }

    public htmlFullscreenButtonLabel() {
        return this.htmlFullscreenActive() ? '전체화면 종료' : '전체화면';
    }

    public htmlFullscreenIconClass() {
        return this.htmlFullscreenActive() ? 'fa-solid fa-compress text-[12px]' : 'fa-solid fa-expand text-[12px]';
    }

    public htmlFullscreenButtonClass() {
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold disabled:opacity-40';
        if (this.htmlFullscreenActive()) return `${base} border-slate-900 bg-slate-900 text-white hover:bg-slate-800`;
        return `${base} border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public htmlFullscreenIconButtonClass() {
        const base = 'flex h-9 w-9 shrink-0 items-center justify-center rounded-md border text-slate-600 disabled:opacity-40';
        if (this.htmlFullscreenActive()) return `${base} border-slate-900 bg-slate-900 text-white hover:bg-slate-800`;
        return `${base} border-slate-300 bg-white hover:bg-slate-50`;
    }

    public async toggleHtmlFullscreen() {
        if (!this.htmlFullscreenSupported()) return;
        try {
            if (this.htmlFullscreenActive()) await this.exitHtmlFullscreen();
            else await this.enterHtmlFullscreen();
        } catch (e) { }
        await this.syncHtmlFullscreenState();
    }

    public async enterHtmlFullscreen() {
        const shell: any = this.htmlShellElement();
        if (!shell) return;
        const request = shell.requestFullscreen || shell.webkitRequestFullscreen || shell.mozRequestFullScreen || shell.msRequestFullscreen;
        this.scaleMode = 'fit';
        if (request && this.htmlNativeFullscreenSupported()) {
            try {
                await request.call(shell);
                this.htmlFullscreenFallback = false;
                this.setHtmlFullscreenLock(false);
                this.scheduleFitScale();
                return;
            } catch (e) { }
        }
        this.htmlFullscreenFallback = true;
        this.setHtmlFullscreenLock(true);
        this.scheduleFitScale();
    }

    public async exitHtmlFullscreen() {
        if (this.htmlFullscreenFallback) {
            this.htmlFullscreenFallback = false;
            this.setHtmlFullscreenLock(false);
            this.scheduleFitScale();
            return;
        }
        const doc: any = document;
        const exit = doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen;
        if (!exit) return;
        await exit.call(doc);
    }

    public async syncHtmlFullscreenState() {
        const active = this.htmlFullscreenActive();
        const changed = this.htmlFullscreen !== active;
        this.htmlFullscreen = active;
        if (!this.isHtmlProject()) this.htmlFullscreenFallback = false;
        this.setHtmlFullscreenLock(this.htmlFallbackFullscreenActive());
        if (this.isHtmlProject()) {
            if (active) this.scaleMode = 'fit';
            this.scheduleFitScale();
        }
        if (changed) await this.renderView();
    }

    private setHtmlFullscreenLock(locked: boolean) {
        const root = document.documentElement;
        const body = document.body;
        if (!root || !body) return;
        root.classList.toggle('reviewops-html-fullscreen-open', locked);
        body.classList.toggle('reviewops-html-fullscreen-open', locked);
    }

    public clampPdfScale(value: any) {
        const scale = Number(value);
        if (!Number.isFinite(scale)) return 1;
        return Math.min(Math.max(scale, this.pdfScaleMin), this.pdfScaleMax);
    }

    public pdfAvailableSizeForFit() {
        const stage = this.pdfStageElement();
        const viewer = this.pdfViewerElement();
        const fallbackWidth = Math.max(window.innerWidth - this.reviewPanelWidthPx() - 56, 360);
        const fallbackHeight = Math.max(window.innerHeight - 180, 420);
        const stageWidth = stage ? stage.clientWidth : 0;
        const viewerWidth = viewer ? viewer.clientWidth : 0;
        const stageHeight = stage ? stage.clientHeight : 0;
        const viewerHeight = viewer ? viewer.clientHeight : 0;
        return {
            width: Math.max(stageWidth || viewerWidth || fallbackWidth, 320),
            height: Math.max(stageHeight || viewerHeight || fallbackHeight, 320)
        };
    }

    public pdfFitScale(baseWidth: number, baseHeight: number = 0) {
        const width = Math.max(Number(baseWidth) || 1, 1);
        const height = Math.max(Number(baseHeight) || 0, 0);
        const available = this.pdfAvailableSizeForFit();
        if (this.pdfFullscreenActive() && height) {
            const widthScale = available.width / width;
            const heightScale = available.height / height;
            return Math.max(Math.min(widthScale, heightScale), this.pdfScaleMin);
        }
        return this.clampPdfScale(available.width / width);
    }

    public pdfRenderScale(baseWidth: number, baseHeight: number = 0) {
        if (this.pdfFullscreenActive()) return this.pdfFitScale(baseWidth, baseHeight);
        if (this.pdfScaleMode === 'fit') return this.pdfFitScale(baseWidth, baseHeight);
        this.pdfScale = this.clampPdfScale(this.pdfScale);
        return this.pdfScale;
    }

    public pdfScaleSelectValue() {
        if (this.pdfScaleMode === 'fit') return 'fit';
        return String(this.clampPdfScale(this.pdfScale));
    }

    public pdfScaleLabel() {
        if (this.pdfScaleMode === 'fit') return '맞춤';
        return `${Math.round(this.clampPdfScale(this.pdfScale) * 100)}%`;
    }

    public async selectPdfScale(value: any) {
        if (value === 'fit') {
            this.pdfScaleMode = 'fit';
        } else {
            this.pdfScaleMode = 'custom';
            this.pdfScale = this.clampPdfScale(value);
        }
        await this.renderView();
        this.queuePdfRender();
    }

    public currentPdfScaleForAdjustment() {
        const scale = this.pdfScaleMode === 'fit' ? this.pdfRenderedScale : this.pdfScale;
        return this.clampPdfScale(scale || 1);
    }

    public adjustPdfScale(direction: number) {
        const current = this.currentPdfScaleForAdjustment();
        const presets = this.pdfScaleOptions
            .map((option: any) => Number(option.value))
            .filter((value: number) => Number.isFinite(value))
            .sort((a: number, b: number) => a - b);
        const gap = 0.001;
        const next = direction < 0
            ? presets.slice().reverse().find((value: number) => value < current - gap)
            : presets.find((value: number) => value > current + gap);
        this.selectPdfScale(String(next || this.clampPdfScale(current + (direction < 0 ? -0.25 : 0.25))));
    }

    public canDecreasePdfScale() {
        return this.currentPdfScaleForAdjustment() > this.pdfScaleMin;
    }

    public canIncreasePdfScale() {
        return this.currentPdfScaleForAdjustment() < this.pdfScaleMax;
    }

    public decreasePdfScale() {
        this.adjustPdfScale(-1);
    }

    public increasePdfScale() {
        this.adjustPdfScale(1);
    }

    public pdfCanvasContext(canvas: HTMLCanvasElement) {
        try {
            const context = (canvas.getContext as any)('2d', {
                alpha: false,
                colorSpace: 'srgb'
            });
            if (context) return context as CanvasRenderingContext2D;
        } catch (e) { }
        try {
            const context = (canvas.getContext as any)('2d', { alpha: false });
            if (context) return context as CanvasRenderingContext2D;
        } catch (e) { }
        return canvas.getContext('2d') as CanvasRenderingContext2D;
    }

    public stylePdfCanvas(canvas: HTMLCanvasElement) {
        canvas.style.backgroundColor = '#ffffff';
        canvas.style.filter = 'none';
        canvas.style.mixBlendMode = 'normal';
        try {
            (canvas.style as any).colorScheme = 'only light';
            (canvas.style as any).forcedColorAdjust = 'none';
        } catch (e) { }
    }

    public resetPdfCanvasContext(context: CanvasRenderingContext2D) {
        try {
            context.setTransform(1, 0, 0, 1, 0, 0);
        } catch (e) { }
        context.globalAlpha = 1;
        context.globalCompositeOperation = 'source-over';
        context.imageSmoothingEnabled = true;
        try {
            (context as any).filter = 'none';
            (context as any).imageSmoothingQuality = 'high';
        } catch (e) { }
        try {
            context.shadowColor = 'rgba(0, 0, 0, 0)';
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        } catch (e) { }
    }

    public fillPdfCanvasWhite(context: CanvasRenderingContext2D, width: number, height: number) {
        this.resetPdfCanvasContext(context);
        context.clearRect(0, 0, width, height);
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height);
    }

    public clearPdfCanvas() {
        const canvas = this.pdfCanvasElement();
        if (canvas) {
            this.stylePdfCanvas(canvas);
            const context = this.pdfCanvasContext(canvas);
            if (context) this.fillPdfCanvasWhite(context, canvas.width, canvas.height);
            canvas.width = 0;
            canvas.height = 0;
            canvas.style.width = '';
            canvas.style.height = '';
        }
        this.pdfCanvasWidth = 0;
        this.pdfCanvasHeight = 0;
        this.pdfPageImageUrl = '';
        this.pdfRenderedCanvas = null;
        this.pdfLastRenderedKey = '';
    }

    public cancelPdfRenderTask() {
        if (!this.pdfRenderTask) return;
        try {
            if (typeof this.pdfRenderTask.cancel === 'function') this.pdfRenderTask.cancel();
        } catch (e) { }
        this.pdfRenderTask = null;
    }

    public disposePdfDocument() {
        this.cancelPdfRenderTask();
        try {
            if (this.pdfDocument && typeof this.pdfDocument.destroy === 'function') this.pdfDocument.destroy();
        } catch (e) { }
        this.pdfDocument = null;
        this.pdfDocumentVersionId = '';
        this.pdfLastRenderedKey = '';
    }

    public resetPdfRenderer(clearCanvas: boolean = true) {
        this.pdfRenderSeq += 1;
        this.pdfRenderError = '';
        this.pdfRendering = false;
        this.cancelPdfRenderTask();
        this.pdfLastRenderedKey = '';
        if (clearCanvas) this.clearPdfCanvas();
        this.disposePdfDocument();
    }

    public async ensurePdfJs(render: boolean = true) {
        if (this.pdfjsLib) return this.pdfjsLib;
        this.pdfJsLoading = true;
        this.pdfRenderError = '';
        if (render) await this.renderView();
        try {
            const importer: any = new Function('url', 'return import(url);');
            const pdfjsLib = await importer('/assets/pdfjs/pdf.mjs');
            pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdfjs/pdf.worker.mjs';
            this.pdfjsLib = pdfjsLib;
            return pdfjsLib;
        } catch (e) {
            this.pdfRenderError = 'PDF 렌더러를 불러오지 못했습니다.';
            return null;
        } finally {
            this.pdfJsLoading = false;
            if (render) await this.renderView();
        }
    }

    public pdfDocumentLoadOptions(bytes: Uint8Array) {
        // Keep PDF.js image decoding on the main 2D path, but provide the worker
        // resources required for ICC/CMYK color conversion.
        return {
            data: bytes.slice ? bytes.slice(0) : bytes,
            cMapUrl: '/assets/pdfjs/cmaps/',
            cMapPacked: true,
            standardFontDataUrl: '/assets/pdfjs/standard_fonts/',
            wasmUrl: '/assets/pdfjs/wasm/',
            iccUrl: '/assets/pdfjs/iccs/',
            useWorkerFetch: true,
            useWasm: true,
            enableHWA: false,
            isImageDecoderSupported: false,
            isOffscreenCanvasSupported: false,
            canvasMaxAreaInBytes: -1
        };
    }

    public async ensurePdfDocument(version: any, render: boolean = true) {
        const id = version && version.id ? String(version.id) : '';
        if (!id) return null;
        if (this.pdfDocument && this.pdfDocumentVersionId === id) return this.pdfDocument;

        this.disposePdfDocument();
        const dataUrl = version && version.file_data_url ? String(version.file_data_url) : '';
        if (!dataUrl) return null;

        const bytes = this.dataUrlToBytes(dataUrl);
        if (!bytes) {
            this.pdfRenderError = 'PDF 문서 데이터를 읽지 못했습니다.';
            return null;
        }

        const pdfjsLib = await this.ensurePdfJs(render);
        if (!pdfjsLib) return null;

        const loadingTask = pdfjsLib.getDocument(this.pdfDocumentLoadOptions(bytes));
        this.pdfDocument = await loadingTask.promise;
        this.pdfDocumentVersionId = id;
        this.syncDocumentPageCount(id, Number(this.pdfDocument.numPages) || 0);
        return this.pdfDocument;
    }

    public syncDocumentPageCount(versionId: string, pageCount: number) {
        const count = Number(pageCount) || 0;
        if (!versionId || !count) return;
        const versions = this.documentVersions();
        const local = versions.find((item: any) => String(item.id) === String(versionId));
        if (local) local.page_count = count;
        if (this.project && this.project.current_document_version && String(this.project.current_document_version.id) === String(versionId)) {
            this.project.current_document_version.page_count = count;
        }
    }

    public isPdfReviewVisible() {
        return !!(this.isDocumentProject() && !this.loading);
    }

    public nextPdfFrame() {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve(true)));
        });
    }

    public pdfViewerReady() {
        if (!this.isPdfReviewVisible()) return false;
        const viewer = this.pdfViewerElement();
        const stage = this.pdfStageElement();
        if (!viewer || !stage) return false;
        return Math.max(stage.clientWidth || 0, viewer.clientWidth || 0) > 0;
    }

    public async waitForPdfViewerReady(attempts: number = 8) {
        for (let i = 0; i < attempts; i++) {
            if (this.pdfViewerReady()) return true;
            await this.nextPdfFrame();
        }
        return this.pdfViewerReady();
    }

    public pdfLayoutKey() {
        const viewer = this.pdfViewerElement();
        const stage = this.pdfStageElement();
        return [
            viewer ? viewer.clientWidth : 0,
            viewer ? viewer.clientHeight : 0,
            stage ? stage.clientWidth : 0,
            this.reviewPanelWidthPx() || 0
        ].join(':');
    }

    public pdfRenderCacheKey(version: any) {
        const id = version && version.id ? String(version.id) : '';
        const page = Math.max(Number(this.pdfPage) || 1, 1);
        const scale = this.pdfScaleMode === 'fit' ? 'fit' : this.clampPdfScale(this.pdfScale).toFixed(3);
        const outputScale = Math.min(Math.max(window.devicePixelRatio || 1, 1), 2).toFixed(2);
        return [
            id,
            page,
            this.pdfScaleMode,
            scale,
            this.pdfLayoutKey(),
            this.pdfFullscreenActive() ? 'fullscreen' : 'inline',
            outputScale
        ].join('|');
    }

    public pdfRenderedCanvasMatches(renderKey: string) {
        if (!renderKey || this.pdfLastRenderedKey !== renderKey) return false;
        if (!this.pdfPageImageUrl) return false;
        if (!this.pdfCanvasWidth || !this.pdfCanvasHeight) return false;
        const canvas = this.pdfRenderedCanvas || this.pdfCanvasElement();
        if (!canvas) return true;
        if (!canvas.width || !canvas.height) return true;
        this.stylePdfCanvas(canvas);
        return true;
    }

    public pdfServerRenderParams() {
        const available = this.pdfAvailableSizeForFit();
        const fullscreen = this.pdfFullscreenActive();
        return {
            render_page: Math.max(Number(this.pdfPage) || 1, 1),
            render_scale_mode: this.pdfScaleMode === 'fit' ? 'fit' : 'custom',
            render_scale: this.clampPdfScale(this.pdfScale),
            render_fit_width: Math.max(Math.round(available.width || 0), 0),
            render_fit_height: fullscreen ? Math.max(Math.round(available.height || 0), 0) : 0,
            render_output_scale: Math.min(Math.max(window.devicePixelRatio || 1, 1), 2)
        };
    }

    public applyServerRenderedPdfVersion(version: any, renderKey: string) {
        if (!version) return;
        const versionId = version.id ? String(version.id) : '';
        const pageImageUrl = version.page_image_url ? String(version.page_image_url) : '';
        if (!versionId || !pageImageUrl) return;

        const versions = this.documentVersions();
        const index = versions.findIndex((item: any) => String(item.id) === versionId);
        if (index >= 0) {
            versions[index] = Object.assign({}, versions[index], {
                page_count: Number(version.page_count) || versions[index].page_count || 0,
                file_size_label: version.file_size_label || versions[index].file_size_label
            });
        }
        if (this.project && this.project.current_document_version && String(this.project.current_document_version.id) === versionId) {
            this.project.current_document_version = Object.assign({}, this.project.current_document_version, {
                page_count: Number(version.page_count) || this.project.current_document_version.page_count || 0,
                file_size_label: version.file_size_label || this.project.current_document_version.file_size_label
            });
        }

        this.pdfRenderedCanvas = null;
        this.pdfPage = Math.max(Number(version.page) || Number(this.pdfPage) || 1, 1);
        this.pdfPageImageUrl = pageImageUrl;
        this.pdfCanvasWidth = Math.max(Math.round(Number(version.page_width) || 0), 1);
        this.pdfCanvasHeight = Math.max(Math.round(Number(version.page_height) || 0), 1);
        this.pdfRenderedScale = this.clampPdfScale(Number(version.rendered_scale) || this.pdfRenderedScale || this.pdfScale || 1);
        this.pdfLastRenderedKey = renderKey;
        this.pdfRenderError = '';
        this.screenshotDataUrl = pageImageUrl;
        this.captureMethod = 'pdf-viewer';
        this.syncDocumentPageCount(versionId, Number(version.page_count) || 0);
        this.updateDocumentCurrentUrl();
    }

    public async renderCurrentPdfPageOnServer(version: any, renderKey: string, render: boolean = true) {
        const versionId = version && version.id ? String(version.id) : '';
        if (!versionId) return true;

        const seq = ++this.pdfRenderSeq;
        this.pdfRendering = true;
        this.pdfRenderError = '';
        this.cancelPdfRenderTask();
        this.pdfLastRenderedKey = '';
        if (render) await this.renderView();

        try {
            const { code, data } = await wiz.call('load_document_version', this.requestParams(Object.assign({
                id: this.projectId,
                version_id: versionId
            }, this.pdfServerRenderParams())));
            if (seq !== this.pdfRenderSeq) return true;
            if (code === 200 && data && data.version && data.version.page_image_url) {
                this.applyServerRenderedPdfVersion(data.version, renderKey);
                return true;
            } else {
                this.pdfRenderError = (data && data.message) || 'PDF 페이지를 렌더링하지 못했습니다.';
            }
        } catch (e) {
            if (seq === this.pdfRenderSeq) {
                this.pdfRenderError = 'PDF 페이지를 렌더링하지 못했습니다.';
            }
        } finally {
            if (seq === this.pdfRenderSeq) {
                this.pdfRendering = false;
                await this.renderView();
            }
        }
        return false;
    }

    public replacePdfDisplayCanvas(canvas: HTMLCanvasElement) {
        const parent = canvas && canvas.parentElement ? canvas.parentElement : null;
        if (!parent) return canvas;
        const next = canvas.cloneNode(false) as HTMLCanvasElement;
        next.width = 0;
        next.height = 0;
        next.style.width = '';
        next.style.height = '';
        this.stylePdfCanvas(next);
        parent.replaceChild(next, canvas);
        return next;
    }

    public disconnectPdfLayoutObserver() {
        if (this.pdfLayoutObserver) {
            try {
                this.pdfLayoutObserver.disconnect();
            } catch (e) { }
        }
        this.pdfLayoutObserver = null;
        this.pdfLayoutObservedElement = null;
        this.pdfLastLayoutKey = '';
    }

    public connectPdfLayoutObserver() {
        if (!this.isPdfReviewVisible()) {
            this.disconnectPdfLayoutObserver();
            return;
        }
        const viewer = this.pdfViewerElement();
        if (!viewer || !(window as any).ResizeObserver) return;
        if (this.pdfLayoutObservedElement === viewer && this.pdfLayoutObserver) return;
        this.disconnectPdfLayoutObserver();
        this.pdfLastLayoutKey = this.pdfLayoutKey();
        const ResizeObserverClass = (window as any).ResizeObserver;
        this.pdfLayoutObserver = new ResizeObserverClass(() => {
            if (!this.isPdfReviewVisible()) return;
            const nextKey = this.pdfLayoutKey();
            if (nextKey === this.pdfLastLayoutKey) return;
            this.pdfLastLayoutKey = nextKey;
            this.queuePdfRender(40);
        });
        this.pdfLayoutObserver.observe(viewer);
        this.pdfLayoutObservedElement = viewer;
    }

    public schedulePdfDomRetry(delay: number = 120) {
        if (!this.isPdfReviewVisible()) return;
        if (this.pdfDomRetryTimer) window.clearTimeout(this.pdfDomRetryTimer);
        this.pdfDomRetryTimer = window.setTimeout(() => {
            this.pdfDomRetryTimer = null;
            this.preparePdfViewer(false).catch(() => { });
        }, delay);
    }

    public async preparePdfViewer(loadFile: boolean = false) {
        if (!this.isDocumentProject()) return;
        if (!this.isPdfReviewVisible()) {
            this.disconnectPdfLayoutObserver();
            return;
        }

        if (this.pdfDomRetryTimer) {
            window.clearTimeout(this.pdfDomRetryTimer);
            this.pdfDomRetryTimer = null;
        }

        const version = this.currentDocumentVersion();
        if (!version) {
            this.resetPdfRenderer(true);
            await this.renderView();
            this.disconnectPdfLayoutObserver();
            return;
        }

        await this.renderView();
        if (!(await this.waitForPdfViewerReady())) {
            this.schedulePdfDomRetry();
            return;
        }

        this.connectPdfLayoutObserver();
        if (loadFile && version && !version.file_data_url) {
            await this.loadDocumentVersionFile(version.id, false, false);
        }
        await this.renderCurrentPdfPage(false);
    }

    public queuePdfRender(delay: number = 80) {
        if (!this.isDocumentProject()) return;
        if (this.pdfRenderTimer) window.clearTimeout(this.pdfRenderTimer);
        this.pdfRenderTimer = window.setTimeout(() => {
            this.pdfRenderTimer = null;
            this.preparePdfViewer(false).catch(() => { });
        }, delay);
    }

    public async renderCurrentPdfPage(render: boolean = true) {
        if (!this.isDocumentProject()) return;
        if (!this.isPdfReviewVisible()) return;
        const version = this.currentDocumentVersion();
        if (!version) {
            this.resetPdfRenderer(true);
            if (render) await this.renderView();
            return;
        }

        if (!(await this.waitForPdfViewerReady())) {
            this.schedulePdfDomRetry();
            return;
        }
        const cachedRenderKey = this.pdfRenderCacheKey(version);
        if (this.pdfRenderedCanvasMatches(cachedRenderKey)) {
            this.pdfRenderError = '';
            this.pdfRendering = false;
            return;
        }
        if (await this.renderCurrentPdfPageOnServer(version, cachedRenderKey, render)) return;

        let renderVersion = this.currentDocumentVersion() || version;
        if (renderVersion && renderVersion.id && !renderVersion.file_data_url) {
            const loaded = await this.loadDocumentVersionFile(renderVersion.id, false, false);
            renderVersion = this.currentDocumentVersion() || loaded || renderVersion;
        }
        if (!renderVersion || !renderVersion.file_data_url) {
            this.pdfRenderError = 'PDF 문서 데이터를 읽지 못했습니다.';
            this.clearPdfCanvas();
            if (render) await this.renderView();
            return;
        }

        const seq = ++this.pdfRenderSeq;
        this.pdfRendering = true;
        this.pdfRenderError = '';
        this.cancelPdfRenderTask();
        this.pdfLastRenderedKey = '';
        if (render) await this.renderView();

        try {
            const pdfDocument = await this.ensurePdfDocument(renderVersion, render);
            if (seq !== this.pdfRenderSeq || !pdfDocument) return;

            const pageCount = Number(pdfDocument.numPages) || 0;
            const nextPage = Math.min(Math.max(Number(this.pdfPage) || 1, 1), pageCount || 1);
            if (nextPage !== this.pdfPage) {
                this.pdfPage = nextPage;
                this.updateDocumentCurrentUrl();
            }

            const page = await pdfDocument.getPage(nextPage);
            if (seq !== this.pdfRenderSeq) return;

            const baseViewport = page.getViewport({ scale: 1 });
            const scale = this.pdfRenderScale(baseViewport.width, baseViewport.height);
            this.pdfRenderedScale = scale;
            const viewport = page.getViewport({ scale });
            const outputScale = Math.min(Math.max(window.devicePixelRatio || 1, 1), 2);
            const renderKey = this.pdfRenderCacheKey(renderVersion);
            if (this.pdfRenderedCanvasMatches(renderKey)) return;
            const renderCanvas = document.createElement('canvas');
            renderCanvas.width = Math.max(Math.round(viewport.width * outputScale), 1);
            renderCanvas.height = Math.max(Math.round(viewport.height * outputScale), 1);
            this.stylePdfCanvas(renderCanvas);
            const renderContext = this.pdfCanvasContext(renderCanvas);
            if (!renderContext) throw new Error('Canvas context is not available');
            this.fillPdfCanvasWhite(renderContext, renderCanvas.width, renderCanvas.height);

            const renderTask = page.render({
                canvas: renderCanvas,
                canvasContext: renderContext,
                viewport,
                transform: outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : undefined,
                background: '#ffffff'
            });
            this.pdfRenderTask = renderTask;
            await renderTask.promise;
            if (this.pdfRenderTask === renderTask) this.pdfRenderTask = null;
            if (seq !== this.pdfRenderSeq) return;

            renderCanvas.style.width = `${Math.round(viewport.width)}px`;
            renderCanvas.style.height = `${Math.round(viewport.height)}px`;
            const pageImageUrl = renderCanvas.toDataURL('image/png');
            if (seq !== this.pdfRenderSeq) return;
            this.pdfRenderedCanvas = renderCanvas;
            this.pdfPageImageUrl = pageImageUrl;
            this.pdfCanvasWidth = Math.round(viewport.width);
            this.pdfCanvasHeight = Math.round(viewport.height);
            this.pdfLastRenderedKey = renderKey;
            try {
                this.screenshotDataUrl = this.pdfSnapshotDataUrl(renderCanvas);
            } catch (e) { }
        } catch (e) {
            if (seq === this.pdfRenderSeq) {
                this.pdfRenderError = 'PDF 페이지를 렌더링하지 못했습니다.';
                this.clearPdfCanvas();
            }
        } finally {
            if (seq === this.pdfRenderSeq) {
                this.pdfRenderTask = null;
                this.pdfRendering = false;
                await this.renderView();
            }
        }
    }

    public pdfSnapshotDataUrl(canvas: HTMLCanvasElement) {
        const width = Math.max(Number(canvas.width) || 0, 1);
        const height = Math.max(Number(canvas.height) || 0, 1);
        const maxWidth = 1600;
        const scale = Math.min(maxWidth / width, 1);
        if (scale >= 1) return canvas.toDataURL('image/png');

        const snapshot = document.createElement('canvas');
        snapshot.width = Math.max(Math.round(width * scale), 1);
        snapshot.height = Math.max(Math.round(height * scale), 1);
        this.stylePdfCanvas(snapshot);
        const context = this.pdfCanvasContext(snapshot);
        if (!context) return canvas.toDataURL('image/png');
        this.fillPdfCanvasWhite(context, snapshot.width, snapshot.height);
        this.resetPdfCanvasContext(context);
        context.drawImage(canvas, 0, 0, snapshot.width, snapshot.height);
        return snapshot.toDataURL('image/png');
    }

    public async capturePdfPageSnapshot() {
        const version = this.currentDocumentVersion();
        if (!version) {
            return {
                screenshot_asset_id: 'pdf-viewer-unavailable',
                screenshot_data_url: '',
                capture_method: 'pdf-viewer'
            };
        }
        if (this.pdfRenderTimer) {
            window.clearTimeout(this.pdfRenderTimer);
            this.pdfRenderTimer = null;
        }

        await this.renderCurrentPdfPage(false);

        if (this.pdfPageImageUrl) {
            try {
                const dataUrl = String(this.pdfPageImageUrl);
                if (!(await this.isRenderableImageDataUrl(dataUrl))) throw new Error('pdf-snapshot-not-renderable');
                this.screenshotDataUrl = dataUrl;
                this.captureMethod = 'pdf-viewer';
                return {
                    screenshot_asset_id: 'pdf-viewer-page',
                    screenshot_data_url: dataUrl,
                    capture_method: 'pdf-viewer'
                };
            } catch (e) { }
        }

        const canvas = this.pdfCanvasElement();
        if (!canvas || !canvas.width || !canvas.height) {
            return {
                screenshot_asset_id: 'pdf-viewer-unavailable',
                screenshot_data_url: '',
                capture_method: 'pdf-viewer'
            };
        }

        try {
            const dataUrl = this.pdfSnapshotDataUrl(canvas);
            if (!(await this.isRenderableImageDataUrl(dataUrl))) throw new Error('pdf-snapshot-not-renderable');
            this.screenshotDataUrl = dataUrl;
            this.captureMethod = 'pdf-viewer';
            return {
                screenshot_asset_id: 'pdf-viewer-page',
                screenshot_data_url: dataUrl,
                capture_method: 'pdf-viewer'
            };
        } catch (e) {
            return {
                screenshot_asset_id: 'pdf-viewer-unavailable',
                screenshot_data_url: '',
                capture_method: 'pdf-viewer'
            };
        }
    }

    public async loadDocumentVersionFile(versionId: string = '', render: boolean = true, renderAfterLoad: boolean = true) {
        const id = versionId || (this.currentDocumentVersion() ? this.currentDocumentVersion().id : '');
        if (!id) return null;
        const local = this.documentVersions().find((item: any) => String(item.id) === String(id));
        if (local && local.file_data_url) {
            if (renderAfterLoad && String(id) === String(this.currentDocumentVersion() && this.currentDocumentVersion().id)) {
                await this.renderCurrentPdfPage(render);
            }
            return local;
        }

        this.documentFileLoading = true;
        this.pdfRenderError = '';
        if (render) await this.renderView();
        const { code, data } = await wiz.call('load_document_version', this.requestParams({
            id: this.projectId,
            version_id: id
        }));
        this.documentFileLoading = false;
        if (code === 200 && data.version) {
            const versions = this.documentVersions();
            const index = versions.findIndex((item: any) => String(item.id) === String(data.version.id));
            if (index >= 0) {
                versions[index] = Object.assign({}, versions[index], data.version);
            }
            if (this.project && this.project.current_document_version && String(this.project.current_document_version.id) === String(data.version.id)) {
                this.project.current_document_version = Object.assign({}, this.project.current_document_version, data.version);
            }
            if (renderAfterLoad && String(data.version.id) === String(this.currentDocumentVersion() && this.currentDocumentVersion().id)) {
                await this.renderCurrentPdfPage(render);
            } else if (render) {
                await this.renderView();
            }
            return data.version;
        }
        if (render) {
            await this.service.modal.error(data.message || 'PDF 문서를 불러오지 못했습니다.');
            await this.renderView();
        }
        return null;
    }

    public loadCurrentDocumentVersionFile(render: boolean = true) {
        return this.loadDocumentVersionFile('', render);
    }

    public async selectDocumentVersion(id: string) {
        this.selectedDocumentVersionId = id || '';
        this.pdfPage = 1;
        this.resetPdfRenderer(true);
        this.updateDocumentCurrentUrl();
        await this.renderView();
        await this.preparePdfViewer(true);
    }

    public async setPdfPage(value: any, render: boolean = true) {
        const max = this.documentPageCount();
        let page = Math.max(Number(value) || 1, 1);
        if (max) page = Math.min(page, max);
        this.pdfPage = page;
        this.updateDocumentCurrentUrl();
        if (render) {
            await this.renderView();
            this.queuePdfRender();
        }
    }

    public canPrevPdfPage() {
        return Math.max(Number(this.pdfPage) || 1, 1) > 1;
    }

    public canNextPdfPage() {
        const max = this.documentPageCount();
        if (!max) return false;
        return Math.max(Number(this.pdfPage) || 1, 1) < max;
    }

    public prevPdfPage() {
        if (!this.canPrevPdfPage()) return;
        this.setPdfPage(this.pdfPage - 1);
    }

    public nextPdfPage() {
        if (!this.canNextPdfPage()) return;
        this.setPdfPage(this.pdfPage + 1);
    }

    public isPdfKeyboardEditableTarget(target: any) {
        if (!target) return false;
        const tag = String(target.tagName || '').toLowerCase();
        if (['input', 'textarea', 'select', 'button'].includes(tag)) return true;
        if (target.isContentEditable) return true;
        return false;
    }

    public shouldHandlePdfKeyboardNavigation(event: KeyboardEvent) {
        if (!this.isDocumentProject() || !this.currentDocumentVersion()) return false;
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return false;
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return false;
        if (this.isPdfKeyboardEditableTarget(event.target)) return false;
        const shell = this.pdfShellElement();
        const target = event.target as HTMLElement;
        if (!this.pdfFullscreenActive() && shell && target && target !== document.body && !shell.contains(target)) return false;
        return event.key === 'ArrowLeft' ? this.canPrevPdfPage() : this.canNextPdfPage();
    }

    public handlePdfKeyboardNavigation(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.pdfFullscreenActive()) {
            event.preventDefault();
            event.stopPropagation();
            this.exitPdfFullscreen();
            return true;
        }
        if (!this.shouldHandlePdfKeyboardNavigation(event)) return false;
        event.preventDefault();
        event.stopPropagation();
        if (event.key === 'ArrowLeft') this.prevPdfPage();
        if (event.key === 'ArrowRight') this.nextPdfPage();
        return true;
    }

    public updateDocumentCurrentUrl() {
        if (!this.isDocumentProject()) return;
        this.currentUrl = this.documentReviewCurrentUrl();
        this.captureMethod = 'pdf-viewer';
    }

    public documentEvidenceVersion(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const id = evidence.document_version_id || '';
        if (id) {
            const local = this.documentVersions().find((item: any) => String(item.id) === String(id));
            if (local) return local;
        }
        return evidence.document_version || null;
    }

    public reviewIsDocument(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        return this.isDocumentProject() || !!evidence.document_version_id;
    }

    public documentEvidenceLabel(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const version = this.documentEvidenceVersion(review);
        const file = version && version.file_name ? version.file_name : 'PDF 문서';
        const label = this.documentVersionDisplayLabel(version);
        const page = Number(evidence.document_page) || 1;
        return `${file} · ${label} · p.${page}`;
    }

    public documentVersionUploadButtonClass() {
        const disabled = this.documentVersionBusy || !this.canEditSettings();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public documentVersionDownloadFileName(version: any) {
        const projectName = this.project && this.project.name ? this.project.name : 'document';
        const versionLabel = version && (version.version_label || version.created) ? version.version_label || version.created : 'latest';
        const fallback = `${projectName}-${versionLabel}.pdf`;
        const fileName = version && version.file_name ? version.file_name : fallback;
        const safeName = this.safeAttachmentName(fileName);
        return /\.[a-z0-9]{1,12}$/i.test(safeName) ? safeName : `${safeName}.pdf`;
    }

    public documentVersionDownloading(version: any) {
        return !!version && String(this.downloadingDocumentVersionId) === String(version.id);
    }

    public async downloadDocumentVersion(version: any = null) {
        const target = version || this.currentDocumentVersion();
        const id = target && target.id ? String(target.id) : '';
        if (!id || this.downloadingDocumentVersionId) return;

        this.downloadingDocumentVersionId = id;
        await this.renderView();
        try {
            const loaded = await this.loadDocumentVersionFile(id, false);
            const documentVersion = loaded || target;
            const dataUrl = documentVersion && documentVersion.file_data_url ? String(documentVersion.file_data_url) : '';
            if (!dataUrl) {
                await this.service.modal.error('다운로드할 PDF 파일을 불러오지 못했습니다.');
                return;
            }
            this.downloadDataUrl(dataUrl, this.documentVersionDownloadFileName(documentVersion), documentVersion.file_mime || 'application/pdf');
        } catch (e) {
            await this.service.modal.error('PDF 파일을 다운로드하지 못했습니다.');
        } finally {
            this.downloadingDocumentVersionId = '';
            await this.renderView();
        }
    }

    public downloadCurrentDocumentVersion() {
        return this.downloadDocumentVersion(this.currentDocumentVersion());
    }

    public downloadReviewDocument(review: any) {
        return this.downloadDocumentVersion(this.documentEvidenceVersion(review));
    }

    public async selectProjectDocumentVersionFile(event: any) {
        const files = this.uploadEventFiles(event);
        if (!this.canEditSettings() || !this.isDocumentProject() || this.documentVersionBusy) return;
        if (!files.length) return;

        if (files.length !== 1) {
            await this.service.modal.error('PDF 버전은 한 번에 하나만 업로드할 수 있습니다.');
            return;
        }

        const file = files[0];
        const validationMessage = this.uploadPolicyValidationMessage('project_document', [file]);
        if (validationMessage) {
            await this.service.modal.error(validationMessage);
            return;
        }

        this.documentVersionBusy = true;
        this.startUploadProgress('document-version', 'PDF 버전', [file], 'uploading');
        await this.renderView();
        try {
            const payload = {
                document: {
                    name: this.safeAttachmentName(file.name),
                    mime: file.type || 'application/octet-stream',
                    size: file.size
                }
            };
            const fd = new FormData();
            fd.append('data', JSON.stringify(payload));
            fd.append('file', file);
            await this.updateUploadProgress('document-version', {
                currentIndex: 1,
                currentFileName: file.name || 'document.pdf',
                currentTotal: file.size || 0
            }, true);
            const { code, data } = this.normalizeUploadResponse(await this.service.file.upload(this.documentVersionUploadUrl(), fd, async (percent: number, total: number, position: number) => {
                const loaded = Number(position || 0);
                const currentTotal = Number(total || file.size || 0);
                await this.updateUploadProgress('document-version', {
                    currentPercent: Number(percent || 0),
                    currentLoaded: loaded,
                    currentTotal,
                    processedBytes: loaded
                });
            }));
            if (code === 200) {
                await this.updateUploadProgress('document-version', {
                    completedFiles: 1,
                    currentPercent: 100,
                    currentLoaded: file.size || 0,
                    currentTotal: file.size || 0,
                    processedBytes: file.size || 0
                }, true);
                this.finishUploadProgress('document-version', true, '업로드가 완료되었습니다.');
                this.applyProject(data.project);
                const latest = this.latestDocumentVersion();
                this.selectedDocumentVersionId = latest ? latest.id : '';
                this.pdfPage = 1;
                this.documentVersionPage = 1;
                this.updateDocumentCurrentUrl();
                await this.loadCurrentDocumentVersionFile(false);
                await this.service.modal.success('새 문서 버전이 추가되었습니다.');
            } else {
                this.finishUploadProgress('document-version', false, data.message || '문서 버전을 추가하지 못했습니다.');
                await this.service.modal.error(data.message || '문서 버전을 추가하지 못했습니다.');
            }
        } catch (e) {
            this.finishUploadProgress('document-version', false, '파일을 업로드하지 못했습니다.');
            await this.service.modal.error('파일을 읽지 못했습니다.');
        }
        this.documentVersionBusy = false;
        await this.service.render();
    }

    public applyProject(project: any) {
        this.project = project;
        this.applyUploadSettings(project && project.upload_settings);
        this.updateDocumentTitle();
        if (this.tab === 'file' && !this.canUseProjectFiles()) {
            this.fileViewer = null;
            this.fileBrowser = { path: '', root_label: 'root', breadcrumbs: [{ label: 'root', path: '' }], items: [] };
            this.tab = this.canEditSettings() ? 'settings' : 'review';
            void this.syncTabUrl(true);
        }
        if (this.tab === 'macro' && !this.canUseProjectMacros()) {
            this.macros = [];
            this.macroEditorOpen = false;
            this.tab = this.canEditSettings() ? 'settings' : 'review';
            void this.syncTabUrl(true);
        }
        if (!this.canUseProjectTerminal() && (this.terminalStarting || this.terminalReady || this.terminal)) {
            this.stopProjectTerminal(false);
            this.disposeProjectTerminal();
        }
        if (this.tab === 'terminal' && !this.canUseProjectTerminal()) {
            this.tab = this.canEditSettings() ? 'settings' : 'review';
            void this.syncTabUrl(true);
        }
        this.projectForm = this.projectFormPayload(this.project);
        this.projectAdminForm = { user_id: '' };
        this.groupForm = this.groupFormPayload(this.project && this.project.group ? this.project.group : {});
        this.syncGroupMoveForm();
        this.syncCategoryOptions();
        this.ensureDocumentVersionSelection(false);
        this.ensureHtmlSnapshotSelection();
        this.ensureSettingsSubTab();
        if (!this.editingIntro) {
            this.introForm = {
                intro_html: this.project.intro_html || '',
                intro_attachments: this.cloneIntroAttachments(this.project.intro_attachments)
            };
        }
        if (this.selectedReview) {
            const selected = this.reviews.find((item) => item.id === this.selectedReview.id);
            if (selected) this.selectedReview = selected;
        }
    }

    public updateDocumentTitle() {
        const name = this.project && this.project.name ? String(this.project.name).trim() : '';
        document.title = name ? `[ReviewOps] ${name}` : 'SEASON::ReviewOps';
    }

    public projectIntroHtml() {
        return this.project && this.project.intro_html ? String(this.project.intro_html) : '';
    }

    public cloneIntroAttachments(value: any) {
        const items = Array.isArray(value) ? value : [];
        return items.map((item: any) => Object.assign({}, item));
    }

    public projectIntroAttachments() {
        return this.cloneIntroAttachments(this.project && this.project.intro_attachments);
    }

    public introAttachments() {
        if (!Array.isArray(this.introForm.intro_attachments)) this.introForm.intro_attachments = [];
        return this.introForm.intro_attachments;
    }

    public introEmpty() {
        return !this.projectIntroHtml().trim();
    }

    public introDocumentBaseHref() {
        try {
            const origin = window.location && window.location.origin ? window.location.origin : '';
            return origin ? `${origin}/` : '/';
        } catch (e) {
            return '/';
        }
    }

    public introDocumentStyles() {
        return `
html { background: #ffffff; color-scheme: light; }
*, *::before, *::after { box-sizing: border-box; }
body {
    margin: 0;
    padding: 28px;
    color: #0f172a;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-size: 14px;
    line-height: 1.65;
    overflow-wrap: anywhere;
}
.reviewops-intro-content { max-width: 100%; }
.reviewops-intro-content::after { clear: both; content: ""; display: block; }
h1, h2, h3, h4, h5, h6 { color: #0f172a; line-height: 1.25; margin: 1.2em 0 .55em; }
h1:first-child, h2:first-child, h3:first-child { margin-top: 0; }
p { margin: 0 0 .9em; }
a { color: #0369a1; text-decoration: underline; text-underline-offset: 2px; }
img { max-width: 100%; height: auto; }
figure { margin: 1em 0; }
figure.image { clear: both; display: table; margin: 1em auto; min-width: 50px; text-align: center; }
figure.image img { display: block; margin: 0 auto; max-width: 100%; }
figure.image figcaption { caption-side: bottom; color: #64748b; display: table-caption; font-size: 12px; outline-offset: -1px; padding: .6em; word-break: break-word; }
figure.image-style-align-left, .image-style-align-left { float: left; margin-right: 1.5em; }
figure.image-style-align-right, .image-style-align-right { float: right; margin-left: 1.5em; }
figure.image-style-align-center, .image-style-align-center { margin-left: auto; margin-right: auto; }
figure.image-style-side, .image-style-side { float: right; max-width: 50%; margin-left: 1.5em; }
figure.image_resized, .image_resized { display: block; max-width: 100%; }
figure.image_resized img, .image_resized img { width: 100%; }
figure.table { display: table; margin: 1em auto; max-width: 100%; }
figure.table table { width: 100%; }
table { border-collapse: collapse; border-spacing: 0; max-width: 100%; }
td, th { border: 1px solid #cbd5e1; min-width: 2em; padding: 8px 10px; vertical-align: top; }
th { background: #f8fafc; font-weight: 700; }
blockquote { border-left: 5px solid #cbd5e1; color: #475569; font-style: italic; margin: 1em 0; overflow: hidden; padding: .25em 0 .25em 1em; }
pre, code { background: #f1f5f9; border-radius: 6px; }
code { padding: .15em .35em; }
pre { overflow-x: auto; padding: 12px; white-space: pre-wrap; }
pre code { background: transparent; padding: 0; }
hr { border: 0; border-top: 1px solid #e2e8f0; margin: 1.5em 0; }
ul.todo-list { list-style: none; padding-left: 0; }
.todo-list li { margin: .35em 0; }
.todo-list__label { display: inline-flex; gap: .5em; align-items: flex-start; }
.todo-list__label input { margin-top: .35em; }
oembed[url] { display: block; overflow-wrap: anywhere; padding: 12px; border: 1px solid #cbd5e1; border-radius: 6px; background: #f8fafc; }
oembed[url]::before { color: #0369a1; content: attr(url); text-decoration: underline; text-underline-offset: 2px; }
.reviewops-empty { display: flex; min-height: 360px; align-items: center; justify-content: center; color: #64748b; font-size: 13px; }
@media (max-width: 720px) {
    body { padding: 18px; }
    figure.image-style-side, .image-style-side,
    figure.image-style-align-left, .image-style-align-left,
    figure.image-style-align-right, .image-style-align-right { float: none; max-width: 100%; margin-left: auto; margin-right: auto; }
}
`.trim();
    }

    public introDocumentHead() {
        return `<meta charset="utf-8">
<base href="${this.escapeHtml(this.introDocumentBaseHref())}" target="_blank">
<style data-reviewops-intro-rendering>
${this.introDocumentStyles()}
</style>`;
    }

    public introHasDocumentShell(html: any) {
        const value = String(html || "");
        return /<!doctype\s+html/i.test(value) || /<html[\s>]/i.test(value) || /<head[\s>]/i.test(value) || /<body[\s>]/i.test(value);
    }

    public injectIntroRenderingStyles(html: string) {
        const style = `<style data-reviewops-intro-rendering>
${this.introDocumentStyles()}
</style>`;
        if (/data-reviewops-intro-rendering/i.test(html)) return html;
        if (/<head(\s[^>]*)?>/i.test(html)) {
            return html.replace(/<head(\s[^>]*)?>/i, (match) => `${match}
${style}`);
        }
        if (/<html(\s[^>]*)?>/i.test(html)) {
            return html.replace(/<html(\s[^>]*)?>/i, (match) => `${match}
<head>
<meta charset="utf-8">
${style}
</head>`);
        }
        if (/<body(\s[^>]*)?>/i.test(html)) {
            return `<!doctype html>
<html lang="ko">
<head>
${this.introDocumentHead()}
</head>
${html}
</html>`;
        }
        return `<!doctype html>
<html lang="ko">
<head>
${this.introDocumentHead()}
</head>
<body><main class="reviewops-intro-content ck-content">${html}</main></body>
</html>`;
    }

    public introDocumentHtml() {
        const html = this.projectIntroHtml().trim()
            ? this.projectIntroHtml()
            : '<div class="reviewops-empty">등록된 소개 정보가 없습니다.</div>';
        if (this.introHasDocumentShell(html)) return this.injectIntroRenderingStyles(html);
        return `<!doctype html>
<html lang="ko">
<head>
${this.introDocumentHead()}
</head>
<body><main class="reviewops-intro-content ck-content">${html}</main></body>
</html>`;
    }

    public introFrameSrc() {
        const html = this.introDocumentHtml();
        if (this.introFrameUrl && this.introFrameHtml === html) return this.introFrameUrl;
        this.revokeIntroFrameUrl();
        this.introFrameHtml = html;
        try {
            this.introFrameUrl = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
        } catch (e) {
            this.introFrameUrl = '';
        }
        return this.introFrameUrl;
    }

    public revokeIntroFrameUrl() {
        if (this.introFrameUrl) {
            try {
                URL.revokeObjectURL(this.introFrameUrl);
            } catch (e) { }
        }
        this.introFrameUrl = '';
        this.introFrameHtml = '';
    }

    public resizeIntroFrame(event: any) {
        const iframe = event && event.target ? event.target : null;
        if (!iframe) return;
        const apply = () => {
            try {
                const doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
                if (!doc) return;
                const body = doc.body;
                const root = doc.documentElement;
                const height = Math.max(
                    320,
                    body ? body.scrollHeight : 0,
                    body ? body.offsetHeight : 0,
                    root ? root.scrollHeight : 0,
                    root ? root.offsetHeight : 0
                );
                iframe.style.height = `${height}px`;
            } catch (e) { }
        };
        apply();
        window.setTimeout(apply, 80);
        window.setTimeout(apply, 300);
    }

    public introHasHtmlCss(value: any) {
        const html = String(value || '');
        return /<!doctype\s+html/i.test(html)
            || /<\/?(html|head|body)\b/i.test(html)
            || /<(style|link)\b/i.test(html)
            || /\sstyle\s*=/i.test(html);
    }

    public introCurrentData() {
        if (this.introEditor && this.introEditor.getData) {
            return this.introEditor.getData();
        }
        return String(this.introForm.intro_html || '');
    }

    public async startIntroEdit() {
        if (!this.canEditIntro()) return;
        this.introForm = {
            intro_html: this.projectIntroHtml(),
            intro_attachments: this.projectIntroAttachments()
        };
        this.editingIntro = true;
        this.introEditorMode = this.introHasHtmlCss(this.introForm.intro_html) ? 'html' : 'visual';
        await this.service.render();
        if (this.introEditorMode === 'visual') await this.initIntroEditor();
    }

    public async cancelIntroEdit() {
        this.editingIntro = false;
        this.introForm = {
            intro_html: this.projectIntroHtml(),
            intro_attachments: this.projectIntroAttachments()
        };
        await this.destroyIntroEditor();
        await this.service.render();
    }

    public async parkIntroEditor() {
        if (this.introEditor && this.introEditor.getData) {
            this.introForm.intro_html = this.introEditor.getData();
        }
        await this.destroyIntroEditor();
    }

    public async destroyIntroEditor() {
        const editor = this.introEditor;
        this.introEditor = null;
        if (editor && editor.destroy) {
            try {
                await editor.destroy();
            } catch (e) { }
        }
    }

    public introModeButtonClass(mode: string) {
        const base = 'h-9 rounded-md px-3 text-[12px] font-semibold transition-colors ';
        if (this.introEditorMode === mode) return base + 'bg-slate-900 text-white';
        return base + 'text-slate-600 hover:bg-slate-100 hover:text-slate-950';
    }

    public introUploadButtonClass() {
        const base = 'inline-flex h-9 cursor-pointer items-center gap-2 rounded-md border px-3 text-[12px] font-semibold ';
        if (this.savingIntro || this.introFileBusy) return base + 'border-slate-200 bg-slate-100 text-slate-400';
        return base + 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50';
    }

    public async setIntroEditorMode(mode: string) {
        if (!this.editingIntro || this.introEditorMode === mode) return;
        if (this.introEditor && this.introEditor.getData) {
            this.introForm.intro_html = this.introEditor.getData();
        }
        if (mode === 'visual' && this.introHasHtmlCss(this.introForm.intro_html)) {
            await this.service.modal.error('HTML/CSS가 포함된 소개는 비주얼 모드에서 스타일이 제거될 수 있어 HTML 모드에서 편집해주세요.');
            return;
        }
        await this.destroyIntroEditor();
        this.introEditorMode = mode === 'html' ? 'html' : 'visual';
        await this.service.render();
        if (this.introEditorMode === 'visual') await this.initIntroEditor();
    }

    public loadCkeditor(): Promise<any> {
        const scope = window as any;
        if (scope.ClassicEditor) return Promise.resolve(scope.ClassicEditor);
        if (this.ckeditorLoader) return this.ckeditorLoader;

        this.ckeditorLoader = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-reviewops-ckeditor="1"]');
            const done = () => {
                if (scope.ClassicEditor) resolve(scope.ClassicEditor);
                else reject(new Error('ckeditor-load-failed'));
            };
            if (existing) {
                existing.addEventListener('load', done, { once: true });
                existing.addEventListener('error', reject, { once: true });
                return;
            }
            const script = document.createElement('script');
            script.src = '/assets/ckeditor/ckeditor.js';
            script.async = true;
            script.setAttribute('data-reviewops-ckeditor', '1');
            script.onload = done;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return this.ckeditorLoader;
    }

    public introEditorConfig() {
        return {
            language: 'ko',
            removePlugins: ['Markdown'],
            toolbar: {
                items: [
                    'heading', '|',
                    'fontColor', 'highlight', 'fontBackgroundColor',
                    'bold', 'italic', 'strikethrough', 'underline',
                    'bulletedList', 'numberedList', 'todoList', 'blockQuote',
                    '|', 'outdent', 'indent', '|',
                    'link', 'imageUpload', 'insertTable', 'mediaEmbed',
                    'undo', 'redo', 'code', 'codeBlock', 'horizontalLine', 'removeFormat'
                ],
                shouldNotGroupWhenFull: true
            },
            image: {
                toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side', 'linkImage']
            },
            table: {
                contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties']
            },
            link: {
                addTargetToExternalLinks: true
            },
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        attributes: true,
                        classes: true,
                        styles: true
                    }
                ]
            }
        };
    }

    public configureIntroUploadAdapter(editor: any) {
        try {
            const repository = editor.plugins.get('FileRepository');
            repository.createUploadAdapter = (loader: any) => this.createIntroUploadAdapter(loader);
        } catch (e) { }
    }

    public constrainIntroEditorSize(editor: any) {
        try {
            const editable = editor && editor.ui && editor.ui.view && editor.ui.view.editable
                ? editor.ui.view.editable.element
                : null;
            if (!editable) return;
            editable.style.minHeight = '0';
            editable.style.height = '100%';
            editable.style.maxHeight = 'none';
            editable.style.flex = '1 1 auto';
            editable.style.overflowY = 'auto';
        } catch (e) { }
    }

    public createIntroUploadAdapter(loader: any) {
        return {
            upload: () => loader.file.then(async (file: File) => {
                if (!file || !String(file.type || '').startsWith('image/')) {
                    return Promise.reject(new Error('image-only'));
                }
                if (file.size > this.introUploadLimits.fileBytes) {
                    return Promise.reject(new Error('file-too-large'));
                }
                const progressKey = 'intro-editor-image';
                this.startUploadProgress(progressKey, '본문 이미지', [file], 'reading');
                await this.service.render();
                try {
                    const dataUrl = await this.readFileAsDataUrl(file, async (loaded: number, total: number) => {
                        await this.updateUploadProgress(progressKey, {
                            currentIndex: 1,
                            currentFileName: file.name,
                            currentPercent: total > 0 ? Math.round(loaded / total * 100) : 0,
                            currentLoaded: loaded,
                            currentTotal: total,
                            processedBytes: loaded
                        });
                    });
                    this.finishUploadProgress(progressKey, true, '이미지가 추가되었습니다.');
                    await this.service.render();
                    return { default: dataUrl };
                } catch (e) {
                    this.finishUploadProgress(progressKey, false, '이미지를 추가하지 못했습니다.');
                    await this.service.render();
                    throw e;
                }
            }),
            abort: () => { }
        };
    }

    public async initIntroEditor() {
        if (!this.editingIntro || this.introEditorMode !== 'visual' || this.introEditor) return;
        const element = document.getElementById('project-intro-editor');
        if (!element) return;

        this.ckeditorLoading = true;
        await this.service.render();
        try {
            const ClassicEditor = await this.loadCkeditor();
            if (!this.editingIntro || this.introEditorMode !== 'visual') {
                this.ckeditorLoading = false;
                await this.service.render();
                return;
            }
            const editor = await ClassicEditor.create(element, this.introEditorConfig());
            this.configureIntroUploadAdapter(editor);
            this.constrainIntroEditorSize(editor);
            editor.setData(this.introForm.intro_html || '');
            this.introEditor = editor;
        } catch (e) {
            this.introEditorMode = 'html';
            await this.service.modal.error('에디터를 불러오지 못했습니다. HTML 편집으로 전환합니다.');
        }
        this.ckeditorLoading = false;
        await this.service.render();
    }

    public escapeHtml(value: any) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    public async insertIntroHtml(fragment: string) {
        if (this.introEditorMode === 'visual' && this.introEditor) {
            const editor = this.introEditor;
            const viewFragment = editor.data.processor.toView(fragment);
            const modelFragment = editor.data.toModel(viewFragment);
            editor.model.insertContent(modelFragment);
            this.introForm.intro_html = editor.getData();
        } else {
            this.introForm.intro_html = `${this.introForm.intro_html || ''}${fragment}`;
        }
        await this.service.render();
    }

    public introAttachmentTotalSize() {
        return this.introAttachments().reduce((sum: number, attachment: any) => {
            return sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
        }, 0);
    }

    public async fileToIntroAttachment(file: File, progress: any = null) {
        const dataUrl = await this.readFileAsDataUrl(file, progress);
        const mime = file.type || this.dataUrlMime(dataUrl) || 'application/octet-stream';
        return {
            name: this.safeAttachmentName(file.name),
            mime,
            size: file.size || this.dataUrlBytes(dataUrl),
            kind: 'file',
            data_url: dataUrl
        };
    }

    public async selectIntroFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (!this.editingIntro || this.savingIntro || this.introFileBusy) return;
        if (!files.length) return;

        const introMaxFiles = Number(this.introUploadLimits.files || 10);
        if (this.introAttachments().length + files.length > introMaxFiles) {
            await this.service.modal.error(`소개 첨부는 최대 ${introMaxFiles}개까지 가능합니다.`);
            return;
        }

        if (files.some((file) => String(file.type || '').startsWith('image/'))) {
            await this.service.modal.error('이미지는 에디터의 이미지 삽입 버튼으로 추가해주세요.');
            return;
        }

        const oversized = files.find((file) => file.size > this.introUploadLimits.fileBytes);
        if (oversized) {
            await this.service.modal.error(`파일당 최대 ${this.networkSizeLabel(this.introUploadLimits.fileBytes)}까지 업로드할 수 있습니다.`);
            return;
        }

        const selectedBytes = files.reduce((sum, file) => sum + file.size, 0);
        if (this.introUploadLimits.totalBytes && this.introAttachmentTotalSize() + selectedBytes > this.introUploadLimits.totalBytes) {
            await this.service.modal.error(`소개 첨부 총 용량은 최대 ${this.networkSizeLabel(this.introUploadLimits.totalBytes)}까지 가능합니다.`);
            return;
        }
        const validationMessage = this.uploadPolicyValidationMessage('intro_attachment', files, this.introAttachments(), this.introAttachmentTotalSize());
        if (validationMessage) {
            await this.service.modal.error(validationMessage);
            return;
        }

        this.introFileBusy = true;
        this.startUploadProgress('intro-attachments', '소개 첨부', files, 'reading');
        await this.service.render();
        try {
            const attachments = [];
            let processedBefore = 0;
            for (let index = 0; index < files.length; index++) {
                const file = files[index];
                await this.updateUploadProgress('intro-attachments', {
                    phase: 'reading',
                    currentIndex: index + 1,
                    currentFileName: file.name || 'file',
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
                attachments.push(await this.fileToIntroAttachment(file, async (loaded: number, total: number) => {
                    await this.updateUploadProgress('intro-attachments', {
                        currentPercent: total ? Math.round(loaded / total * 10000) / 100 : 0,
                        currentLoaded: loaded,
                        currentTotal: total || file.size || 0,
                        processedBytes: processedBefore + loaded
                    });
                }));
                processedBefore += Number(file.size || 0);
                await this.updateUploadProgress('intro-attachments', {
                    completedFiles: index + 1,
                    currentPercent: 100,
                    currentLoaded: file.size || 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
            this.introForm.intro_attachments = this.introAttachments().concat(attachments);
            this.finishUploadProgress('intro-attachments', true, '파일 준비가 완료되었습니다.');
        } catch (e) {
            this.finishUploadProgress('intro-attachments', false, '파일을 읽지 못했습니다.');
            await this.service.modal.error('파일을 읽지 못했습니다.');
        }
        this.introFileBusy = false;
        await this.service.render();
    }

    public removeIntroAttachment(index: number) {
        this.introForm.intro_attachments = this.introAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
        this.service.render();
    }

    public async saveProjectIntro() {
        if (!this.canEditIntro()) return;
        if (this.introEditor && this.introEditor.getData) {
            this.introForm.intro_html = this.introEditor.getData();
        }

        this.savingIntro = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_project_intro', this.requestParams({
            id: this.projectId,
            data: JSON.stringify({
                intro_html: this.introForm.intro_html || '',
                intro_attachments: this.introAttachments()
            })
        }));
        this.savingIntro = false;
        if (code === 200) {
            this.editingIntro = false;
            await this.destroyIntroEditor();
            this.applyProject(data.project);
            await this.service.modal.success('저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '소개 정보를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    private customViewportSessionProjectId() {
        return String(this.projectId || (this.project && this.project.id) || '').trim();
    }

    private customViewportSessionStorageKey() {
        const projectId = this.customViewportSessionProjectId();
        if (!projectId) return '';
        return this.customViewportSessionStoragePrefix + projectId;
    }

    private validCustomViewportSessionDimension(value: any, minimum: number, maximum: number) {
        const dimension = Number(value);
        return Number.isFinite(dimension)
            && Math.round(dimension) === dimension
            && dimension >= minimum
            && dimension <= maximum;
    }

    private clearCustomViewportSession() {
        const key = this.customViewportSessionStorageKey();
        if (!key) return;
        try {
            if (typeof window === 'undefined' || !window.sessionStorage) return;
            window.sessionStorage.removeItem(key);
        } catch (e) { }
    }

    private loadCustomViewportSession() {
        if (!this.isWebServiceProject()) {
            this.clearCustomViewportSession();
            return null;
        }
        const key = this.customViewportSessionStorageKey();
        const projectId = this.customViewportSessionProjectId();
        if (!key || !projectId) return null;

        try {
            if (typeof window === 'undefined' || !window.sessionStorage) return null;
            const raw = window.sessionStorage.getItem(key);
            if (!raw) return null;
            const data = JSON.parse(raw);
            const valid = data
                && Number(data.version) === this.customViewportSessionStorageVersion
                && String(data.project_id || '') === projectId
                && String(data.preset || '') === 'Custom'
                && this.validCustomViewportSessionDimension(data.width, this.viewportResizeMinWidth, this.viewportResizeMaxWidth)
                && this.validCustomViewportSessionDimension(data.height, this.viewportResizeMinHeight, this.viewportResizeMaxHeight);
            if (!valid) {
                window.sessionStorage.removeItem(key);
                return null;
            }
            return { width: Number(data.width), height: Number(data.height) };
        } catch (e) {
            this.clearCustomViewportSession();
            return null;
        }
    }

    private restoreCustomViewportSession() {
        const stored = this.loadCustomViewportSession();
        if (!stored) return false;
        this.viewport = { width: stored.width, height: stored.height };
        this.selectedPreset = 'Custom';
        return true;
    }

    private saveCustomViewportSession() {
        if (!this.isWebServiceProject() || this.selectedPreset !== 'Custom') return;
        const key = this.customViewportSessionStorageKey();
        const projectId = this.customViewportSessionProjectId();
        const width = Number(this.viewport && this.viewport.width);
        const height = Number(this.viewport && this.viewport.height);
        if (!key || !projectId) return;
        if (!this.validCustomViewportSessionDimension(width, this.viewportResizeMinWidth, this.viewportResizeMaxWidth)) return;
        if (!this.validCustomViewportSessionDimension(height, this.viewportResizeMinHeight, this.viewportResizeMaxHeight)) return;

        try {
            if (typeof window === 'undefined' || !window.sessionStorage) return;
            window.sessionStorage.setItem(key, JSON.stringify({
                version: this.customViewportSessionStorageVersion,
                project_id: projectId,
                preset: 'Custom',
                width,
                height
            }));
        } catch (e) { }
    }

    public viewportPresetName() {
        const width = Number(this.viewport && this.viewport.width) || 0;
        const height = Number(this.viewport && this.viewport.height) || 0;
        const preset = this.presets.find((item) => item.name !== 'Custom' && Number(item.width) === width && Number(item.height) === height);
        return preset ? preset.name : 'Custom';
    }

    public applyPreset(name: string) {
        if (this.webViewerFullscreenActive()) return;
        const preset = this.presets.find((item) => item.name === name);
        if (!preset) return;
        this.selectedPreset = preset.name;
        if (preset.name === 'Custom') {
            this.normalizeViewport();
            this.saveCustomViewportSession();
        } else {
            this.viewport = { width: preset.width, height: preset.height };
            this.clearCustomViewportSession();
        }
        this.scaleMode = 'fit';
        this.scheduleFitScale();
        this.recordNavigation(this.currentUrl, `viewport:${preset.name}`);
        if (!this.isHtmlProject()) this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        this.service.render();
    }

    public syncViewport() {
        if (this.webViewerFullscreenActive()) return;
        this.selectedPreset = 'Custom';
        this.viewport = {
            width: this.clampViewportResizeDimension(Number(this.viewport.width), this.viewportResizeMinWidth, this.viewportResizeMaxWidth),
            height: this.clampViewportResizeDimension(Number(this.viewport.height), this.viewportResizeMinHeight, this.viewportResizeMaxHeight)
        };
        this.saveCustomViewportSession();
        this.scaleMode = 'fit';
        this.scheduleFitScale();
        this.recordNavigation(this.currentUrl, 'viewport:custom');
        if (!this.isHtmlProject()) this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        this.service.render();
    }

    public htmlScaleSelectValue() {
        if (this.scaleMode === 'fit') return 'fit';
        return String(Math.round(this.scale * 100));
    }

    public htmlScaleOptionExists(value: any) {
        const key = String(value || '');
        return this.htmlScaleOptions.some((option) => String(option.value) === key);
    }

    public htmlScaleOptionLabel(option: any) {
        if (String(option && option.value || '') === 'fit') return `Fit · ${this.displayScaleLabel()}`;
        return option && option.label ? option.label : '';
    }

    public canDecreaseHtmlScale() {
        if (this.webViewerFullscreenActive()) return false;
        return this.scaleMode === 'fit' || this.scale > 0.1;
    }

    public canIncreaseHtmlScale() {
        if (this.webViewerFullscreenActive()) return false;
        return this.scaleMode === 'fit' || this.scale < 3;
    }

    public clampHtmlScale(value: any) {
        const scale = Number(value);
        if (!Number.isFinite(scale)) return 1;
        return Math.min(Math.max(scale, 0.1), 3);
    }

    public async selectHtmlScale(value: any) {
        if (!this.isWebProject() || this.webViewerFullscreenActive()) return;
        const next = String(value || 'fit');
        if (next === 'fit') {
            this.scaleMode = 'fit';
            this.scheduleFitScale();
        } else {
            this.scaleMode = 'custom';
            this.scale = this.clampHtmlScale((Number(next) || 100) / 100);
            if (!this.isHtmlProject()) this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        }
        await this.service.render();
    }

    public async adjustHtmlScale(deltaPercent: number) {
        if (!this.isWebProject() || this.webViewerFullscreenActive()) return;
        const base = this.clampHtmlScale(this.scale);
        this.scaleMode = 'custom';
        this.scale = this.clampHtmlScale(base + ((Number(deltaPercent) || 0) / 100));
        if (!this.isHtmlProject()) this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        await this.service.render();
    }

    public scheduleFitScale() {
        if (this.webViewerFullscreenActive()) {
            this.scheduleWebViewerLayout();
            return;
        }
        if (this.scaleMode !== 'fit') return;
        if (this.fitScaleTimer) window.clearTimeout(this.fitScaleTimer);
        this.fitScaleTimer = window.setTimeout(() => {
            this.fitScaleTimer = null;
            this.applyFitScale();
            this.service.render();
            if (!this.isHtmlProject()) this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        }, 0);
    }

    public applyFitScale() {
        if (this.webViewerFullscreenActive()) {
            const shell = this.htmlShellElement();
            if (shell) this.applyWebViewerFullscreenLayout(shell);
            return;
        }
        if (this.scaleMode !== 'fit') return;
        this.normalizeViewport();

        const canvas = this.previewCanvasElement();
        const canvasWidth = canvas ? canvas.clientWidth : window.innerWidth - 520;
        const canvasHeight = canvas ? canvas.clientHeight : window.innerHeight - 180;
        const fullscreen = this.isHtmlProject() && this.htmlFullscreenActive();
        const canvasPadding = fullscreen ? 0 : (this.isDesktopLayout() ? 48 : 16);
        const maxWidth = Math.max(canvasWidth - canvasPadding, 280);
        const maxHeight = Math.max(canvasHeight - canvasPadding - this.frameChromeHeight(), 280);
        const widthScale = maxWidth / this.viewport.width;
        const heightScale = maxHeight / this.viewport.height;
        const maxScale = fullscreen ? 3 : 1;
        this.scale = Math.max(Math.min(widthScale, heightScale, maxScale), 0.1);
    }

    public normalizeViewport() {
        this.viewport.width = Math.max(Number(this.viewport.width) || 1, 1);
        this.viewport.height = Math.max(Number(this.viewport.height) || 1, 1);
    }

    public frameTransform() {
        return `scale(${this.scale})`;
    }

    public htmlPreviewCanvasClass() {
        if (this.htmlFallbackFullscreenActive()) return 'review-preview-canvas reviewops-html-fallback-fullscreen fixed inset-0 z-[96] flex h-screen w-screen min-h-0 items-center justify-center overflow-hidden bg-black p-0';
        if (this.htmlFullscreenActive()) return 'review-preview-canvas relative flex h-screen w-screen min-h-0 flex-1 items-center justify-center overflow-hidden bg-black p-0';
        if (this.webViewerFullscreenActive()) return 'review-preview-canvas flex min-h-0 w-full flex-1 items-stretch justify-stretch overflow-hidden bg-white p-0';
        return 'review-preview-canvas min-h-0 flex-1 overflow-auto bg-slate-100 p-2 lg:p-6';
    }

    public frameOuterWrapperClass() {
        if (this.htmlFullscreenActive()) return 'shrink-0';
        if (this.webViewerFullscreenActive()) return 'h-full min-h-0 w-full';
        return 'mx-auto';
    }

    public frameViewportClass() {
        if (this.htmlFullscreenActive()) return 'relative overflow-hidden bg-white';
        if (this.webViewerFullscreenActive()) return 'relative h-full min-h-0 w-full overflow-hidden bg-white';
        return 'relative overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-slate-200';
    }

    public frameChromeHeight() {
        if (this.webViewerFullscreenActive()) return 0;
        if (this.htmlFullscreenActive()) return 0;
        if (this.isHtmlProject()) return 0;
        return 82;
    }

    public frameOuterWidth() {
        return Math.ceil(this.viewport.width * this.scale);
    }

    public frameContentHeight() {
        return Math.ceil(this.viewport.height * this.scale);
    }

    public frameOuterHeight() {
        return this.frameContentHeight() + this.frameChromeHeight();
    }

    public displayScaleLabel() {
        return `${Math.round(this.scale * 100)}%`;
    }

    public reviewScaleLabel(value: any) {
        const scale = Number(value);
        if (!Number.isFinite(scale)) return value || '-';
        return scale.toFixed(2);
    }

    private isViewportResizePointer(event: any) {
        if (!event || event.pointerId === undefined || this.viewportResizePointerId === null) return true;
        return event.pointerId === this.viewportResizePointerId;
    }

    private clampViewportResizeDimension(value: number, minimum: number, maximum: number) {
        return Math.min(Math.max(Math.round(Number(value) || minimum), minimum), maximum);
    }

    public viewportResizeCursor() {
        if (this.viewportResizeAxis === 'width') return 'ew-resize';
        if (this.viewportResizeAxis === 'height') return 'ns-resize';
        return 'nwse-resize';
    }

    public startViewportResize(event: any, axis: string) {
        if (!this.isWebServiceProject() || this.htmlFullscreenActive() || this.webViewerFullscreenActive()) return;
        if (!['width', 'height', 'both'].includes(axis)) return;
        if (this.resizingViewport && !this.isViewportResizePointer(event)) return;
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();

        this.normalizeViewport();
        if (this.fitScaleTimer) {
            window.clearTimeout(this.fitScaleTimer);
            this.fitScaleTimer = null;
        }

        this.resizingViewport = true;
        this.viewportResizeAxis = axis;
        this.viewportResizePointerId = event && event.pointerId !== undefined ? event.pointerId : null;
        this.viewportResizeCaptureElement = event && event.currentTarget ? event.currentTarget : null;
        this.viewportResizeStart = {
            clientX: Number(event && event.clientX) || 0,
            clientY: Number(event && event.clientY) || 0,
            width: Number(this.viewport.width) || 1,
            height: Number(this.viewport.height) || 1,
            scale: Math.max(this.clampHtmlScale(this.scale), 0.1)
        };

        if (this.viewportResizeCaptureElement && this.viewportResizeCaptureElement.setPointerCapture && this.viewportResizePointerId !== null) {
            try {
                this.viewportResizeCaptureElement.setPointerCapture(this.viewportResizePointerId);
            } catch (e) { }
        }
        this.service.render();
    }

    public resizeViewport(clientX: number, clientY: number) {
        const start = this.viewportResizeStart;
        if (!this.resizingViewport || !start) return;
        const scale = Math.max(Number(start.scale) || 1, 0.1);
        let width = Number(start.width) || 1;
        let height = Number(start.height) || 1;

        if (this.viewportResizeAxis === 'width' || this.viewportResizeAxis === 'both') {
            width = this.clampViewportResizeDimension(
                width + ((Number(clientX) - Number(start.clientX)) / scale),
                this.viewportResizeMinWidth,
                this.viewportResizeMaxWidth
            );
        }
        if (this.viewportResizeAxis === 'height' || this.viewportResizeAxis === 'both') {
            height = this.clampViewportResizeDimension(
                height + ((Number(clientY) - Number(start.clientY)) / scale),
                this.viewportResizeMinHeight,
                this.viewportResizeMaxHeight
            );
        }
        if (width === Number(this.viewport.width) && height === Number(this.viewport.height)) return;

        this.viewport = { width, height };
        this.selectedPreset = 'Custom';
        this.service.render();
    }

    public onViewportResizeLayerPointerMove(event: PointerEvent) {
        if (!this.resizingViewport || !this.isViewportResizePointer(event)) return;
        if (event && event.stopPropagation) event.stopPropagation();
        if (event.pointerType === 'mouse' && event.buttons === 0) {
            this.finishViewportResize(event);
            return;
        }
        if (event && event.preventDefault) event.preventDefault();
        this.resizeViewport(event.clientX, event.clientY);
    }

    public finishViewportResize(event?: any) {
        if (!this.resizingViewport) return;
        if (event && !this.isViewportResizePointer(event)) return;
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();

        const start = this.viewportResizeStart;
        const changed = !!start && (
            Number(start.width) !== Number(this.viewport.width)
            || Number(start.height) !== Number(this.viewport.height)
        );
        if (this.viewportResizeCaptureElement && this.viewportResizeCaptureElement.releasePointerCapture && this.viewportResizePointerId !== null) {
            try {
                this.viewportResizeCaptureElement.releasePointerCapture(this.viewportResizePointerId);
            } catch (e) { }
        }

        this.viewportResizeCaptureElement = null;
        this.viewportResizePointerId = null;
        this.viewportResizeStart = null;
        this.viewportResizeAxis = '';
        this.resizingViewport = false;

        if (this.selectedPreset === 'Custom') this.saveCustomViewportSession();
        if (this.destroyed) return;
        if (changed) {
            this.recordNavigation(this.currentUrl, 'viewport:drag');
        }
        if (this.scaleMode === 'fit') {
            this.scheduleFitScale();
        } else if (changed && !this.isHtmlProject()) {
            this.postSdkCommand('viewport', { width: this.viewport.width, height: this.viewport.height, scale: this.scale }, false);
        }
        this.service.render();
    }

    private isReviewPanelResizePointer(event: any) {
        if (!event || event.pointerId === undefined || this.reviewPanelResizePointerId === null) return true;
        return event.pointerId === this.reviewPanelResizePointerId;
    }

    private reviewPanelResizeContainerBounds() {
        const rect = this.reviewPanelResizeContainerRect;
        if (rect && Number.isFinite(rect.left) && Number.isFinite(rect.right) && Number.isFinite(rect.width)) {
            return rect;
        }
        return { left: 0, right: window.innerWidth, width: window.innerWidth };
    }

    private captureReviewPanelResizeContainer(event: any) {
        const target = event && event.currentTarget ? event.currentTarget : null;
        const container = target && target.parentElement ? target.parentElement : null;
        if (container && container.getBoundingClientRect) {
            this.reviewPanelResizeContainerRect = container.getBoundingClientRect();
            return;
        }
        this.reviewPanelResizeContainerRect = null;
    }

    private reviewPanelDockSide() {
        return this.isDashboardTab() ? 'left' : 'right';
    }

    public startReviewPanelResize(event: any) {
        if (!this.isDesktopLayout()) return;
        if (this.resizingReviewPanel && event && event.pointerId === undefined && this.reviewPanelResizePointerId !== null) return;
        event.preventDefault();
        event.stopPropagation();
        this.resizingReviewPanel = true;
        this.reviewPanelResizePointerId = event && event.pointerId !== undefined ? event.pointerId : null;
        this.reviewPanelResizeCaptureElement = event && event.currentTarget ? event.currentTarget : null;
        this.captureReviewPanelResizeContainer(event);
        if (this.reviewPanelResizeCaptureElement && this.reviewPanelResizeCaptureElement.setPointerCapture && this.reviewPanelResizePointerId !== null) {
            try {
                this.reviewPanelResizeCaptureElement.setPointerCapture(this.reviewPanelResizePointerId);
            } catch (e) { }
        }
        const point = event.touches && event.touches.length ? event.touches[0] : event;
        this.resizeReviewPanel(point.clientX);
        this.service.render();
    }

    public onReviewPanelResizeLayerPointerMove(event: PointerEvent) {
        if (event && event.stopPropagation) event.stopPropagation();
        this.onDocumentPointerMove(event);
    }

    public finishReviewPanelResize(event?: any) {
        if (!this.resizingReviewPanel) return;
        if (event && !this.isReviewPanelResizePointer(event)) return;
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        if (this.reviewPanelResizeCaptureElement && this.reviewPanelResizeCaptureElement.releasePointerCapture && this.reviewPanelResizePointerId !== null) {
            try {
                this.reviewPanelResizeCaptureElement.releasePointerCapture(this.reviewPanelResizePointerId);
            } catch (e) { }
        }
        this.reviewPanelResizeCaptureElement = null;
        this.reviewPanelResizePointerId = null;
        this.reviewPanelResizeContainerRect = null;
        this.resizingReviewPanel = false;
        if (!this.destroyed) this.service.render();
    }

    public resizeReviewPanel(clientX: number) {
        const bounds = this.reviewPanelResizeContainerBounds();
        const containerWidth = Math.max(Number(bounds.width) || window.innerWidth, this.reviewPanelMinWidth);
        const maxByContainer = Math.max(this.reviewPanelMinWidth, containerWidth - 360);
        const maxWidth = Math.min(this.reviewPanelMaxWidth, maxByContainer);
        const rawWidth = this.reviewPanelDockSide() === 'left'
            ? clientX - Number(bounds.left || 0)
            : Number(bounds.right || window.innerWidth) - clientX;
        const nextWidth = Math.max(this.reviewPanelMinWidth, Math.min(maxWidth, rawWidth));
        this.reviewPanelWidth = nextWidth;
        this.scheduleFitScale();
        if (this.isDocumentProject()) this.queuePdfRender();
        this.service.render();
    }

    public isDesktopLayout() {
        return window.innerWidth >= 1024;
    }

    public reviewPanelWidthPx() {
        if (!this.isDesktopLayout()) return null;
        return this.reviewPanelWidth;
    }

    public reviewOpsReloadUrl(url: string) {
        const target = String(url || '').trim();
        if (!target) return '';
        const token = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        try {
            const parsed = new URL(target, window.location.origin);
            parsed.searchParams.set('__reviewops_reload', token);
            return parsed.toString();
        } catch (e) {
            const hashIndex = target.indexOf('#');
            const base = hashIndex >= 0 ? target.slice(0, hashIndex) : target;
            const hash = hashIndex >= 0 ? target.slice(hashIndex) : '';
            const separator = base.indexOf('?') >= 0 ? '&' : '?';
            return `${base}${separator}__reviewops_reload=${encodeURIComponent(token)}${hash}`;
        }
    }

    public reloadIframeWindow(iframe: HTMLIFrameElement | null) {
        try {
            const win: any = iframe && iframe.contentWindow;
            if (!win || !win.location || typeof win.location.reload !== 'function') return false;
            win.location.reload();
            return true;
        } catch (e) {
            return false;
        }
    }

    public reloadHtmlProjectFrame() {
        const outerFrame = this.reviewFrame();
        const outerDoc = this.htmlFrameDocument();
        const nestedFrame = this.htmlDocumentNestedFrameElement(outerDoc);
        if (nestedFrame && this.reloadIframeWindow(nestedFrame)) return true;

        const target = this.projectPreviewServerUrl('qa') || this.frameUrl || this.currentUrl || (outerFrame ? outerFrame.src : '');
        const reloadUrl = this.reviewOpsReloadUrl(target);
        if (!outerFrame || !reloadUrl) return false;
        try {
            outerFrame.src = reloadUrl;
            return true;
        } catch (e) {
            return false;
        }
    }

    public async reloadFrame() {
        const htmlProject = this.isHtmlProject();
        if (htmlProject) {
            this.htmlDocumentRestorePageAfterLoad = this.htmlDocumentPage();
        }
        this.frameActionBusy = true;
        this.clearFrameScreenshotCache('capture-pending');
        await this.service.render();
        const sent = htmlProject ? this.reloadHtmlProjectFrame() : this.postSdkCommand('reload', {}, false);
        if (htmlProject) {
            if (!sent) {
                const iframe = this.reviewFrame();
                const reloadUrl = this.reviewOpsReloadUrl(this.frameUrl || this.currentUrl || (iframe ? iframe.src : ''));
                if (iframe && reloadUrl) iframe.src = reloadUrl;
            }
            this.updateHtmlDocumentState({
                page: Math.max(Number(this.htmlDocumentState && this.htmlDocumentState.page) || 1, 1),
                page_count: Math.max(this.htmlDocumentPageCount(), 1),
                strategy: 'loading',
                standard: false
            });
        } else if (!sent) {
            const iframe = this.reviewFrame();
            if (iframe && !this.reloadIframeWindow(iframe)) iframe.src = iframe.src || this.frameUrl;
        }
        this.collectFingerprintLog('iframe-reload');
        window.setTimeout(async () => {
            this.frameActionBusy = false;
            await this.service.render();
        }, 250);
    }

    public async navigateFrameAddress() {
        const url = this.normalizeFrameUrl(this.remoteAddress || '');
        if (!url) return;
        if (!this.beginFrameNavigation(url, 'new')) return;
        await this.service.render();
        this.finishPendingFrameNavigationLater();
    }

    public async frameBack() {
        await this.navigateFrameHistory('back');
    }

    public async frameForward() {
        await this.navigateFrameHistory('forward');
    }

    public componentRootElement() {
        return this.elementRef && this.elementRef.nativeElement
            ? this.elementRef.nativeElement as HTMLElement
            : null;
    }

    public reviewFrame() {
        const root = this.componentRootElement();
        return root ? root.querySelector('.review-preview-frame') as HTMLIFrameElement : null;
    }

    public previewLogPanelTitle() {
        return this.previewLogPanelOpen ? '로그 창 닫기' : '로그 창 열기';
    }

    public previewLogButtonClass() {
        const base = 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md border text-[12px] disabled:opacity-40';
        if (this.previewLogPanelOpen) return `${base} border-slate-900 bg-slate-900 text-white hover:bg-slate-800`;
        if (this.previewLogCount('all') > 0) return `${base} border-slate-300 bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-950`;
        return `${base} border-slate-300 bg-white text-slate-400 hover:bg-slate-50 hover:text-slate-700`;
    }

    public async togglePreviewLogPanel() {
        this.previewLogPanelOpen = !this.previewLogPanelOpen;
        await this.service.render();
    }

    public async selectPreviewLogTab(tab: string) {
        this.previewLogTab = tab || 'all';
        await this.service.render();
    }

    public previewLogTabClass(tab: string) {
        const base = 'flex h-7 shrink-0 items-center rounded px-2 text-[11px] font-semibold';
        if (this.previewLogTab === tab) return `${base} bg-slate-100 text-slate-950`;
        return `${base} text-slate-300 hover:bg-slate-800 hover:text-white`;
    }

    public logTimeValue(entry: any) {
        const value = Date.parse(entry && entry.at ? entry.at : '');
        return Number.isFinite(value) ? value : 0;
    }

    public sortedPreviewLogEntries(entries: any[]) {
        return (entries || []).slice().sort((a, b) => this.logTimeValue(b) - this.logTimeValue(a));
    }

    public previewLogKindEntries(kind: string) {
        if (kind === 'navigation') {
            return this.combinedNavigationLog().map((item) => Object.assign({ _kind: 'navigation' }, item));
        }
        if (kind === 'input') {
            return this.inputLog.map((item) => Object.assign({ _kind: 'input' }, item));
        }
        if (kind === 'network') {
            return this.uniqueNetworkEntries(this.combinedNetworkLog()).map((item) => Object.assign({ _kind: 'network' }, item));
        }
        if (kind === 'console') {
            return this.combinedConsoleLog().map((item) => Object.assign({ _kind: 'console' }, item));
        }
        if (kind === 'fingerprint') {
            return this.fingerprintLog.map((item) => {
                const copy = Object.assign({ _kind: 'fingerprint' }, item);
                delete copy._key;
                return copy;
            });
        }
        return [];
    }

    public previewLogEntries(kind: string = '') {
        const tab = kind || this.previewLogTab || 'all';
        if (tab !== 'all') return this.sortedPreviewLogEntries(this.previewLogKindEntries(tab));
        const entries = [
            ...this.previewLogKindEntries('navigation'),
            ...this.previewLogKindEntries('input'),
            ...this.previewLogKindEntries('network'),
            ...this.previewLogKindEntries('console'),
            ...this.previewLogKindEntries('fingerprint')
        ];
        return this.sortedPreviewLogEntries(entries).slice(0, 300);
    }

    public previewLogCount(kind: string) {
        return this.previewLogEntries(kind || 'all').length;
    }

    public async clearPreviewLog(kind: string = 'all') {
        const tab = kind || this.previewLogTab || 'all';
        if (tab === 'all' || tab === 'navigation') {
            this.navigationLog = [];
            this.remoteNavigationLog = [];
        }
        if (tab === 'all' || tab === 'input') {
            this.inputLog = [];
        }
        if (tab === 'all' || tab === 'network') {
            this.networkLog = [];
            this.remoteNetworkLog = [];
        }
        if (tab === 'all' || tab === 'console') {
            this.consoleLog = [];
            this.remoteConsoleLog = [];
        }
        if (tab === 'all' || tab === 'fingerprint') {
            this.fingerprintLog = [];
        }
        await this.service.render();
    }

    public previewLogKindLabel(kind: string) {
        const labels: any = {
            navigation: 'NAV',
            input: 'INPUT',
            network: 'NET',
            console: 'CONSOLE',
            fingerprint: 'ENV'
        };
        return labels[kind] || 'LOG';
    }

    public previewLogTabLabel(tab: string) {
        const found = this.previewLogTabs.find((item) => item.key === tab);
        return found ? found.label : '전체';
    }

    public previewLogEntryClass(item: any) {
        const base = 'border-b border-slate-800 px-3 py-2 last:border-b-0';
        const kind = item && item._kind;
        const level = String(item && (item.level || item.type) || '').toLowerCase();
        const status = Number(item && item.status) || 0;
        if (kind === 'console' && (level === 'error' || level === 'assert' || level === 'unhandledrejection')) return `${base} bg-rose-950/30`;
        if (kind === 'console' && (level === 'warn' || level === 'warning')) return `${base} bg-amber-950/20`;
        if (kind === 'network' && ((item && item.error) || status >= 400)) return `${base} bg-rose-950/30`;
        return base;
    }

    public previewLogEntryBadgeClass(item: any) {
        const base = 'mt-0.5 shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold';
        const kind = item && item._kind;
        if (kind === 'navigation') return `${base} bg-sky-500/20 text-sky-200`;
        if (kind === 'input') return `${base} bg-violet-500/20 text-violet-200`;
        if (kind === 'network') return `${base} bg-emerald-500/20 text-emerald-200`;
        if (kind === 'console') {
            const level = String(item && (item.level || item.type) || '').toLowerCase();
            if (level === 'error' || level === 'assert' || level === 'unhandledrejection') return `${base} bg-rose-500/25 text-rose-100`;
            if (level === 'warn' || level === 'warning') return `${base} bg-amber-500/25 text-amber-100`;
            return `${base} bg-slate-700 text-slate-100`;
        }
        if (kind === 'fingerprint') return `${base} bg-cyan-500/20 text-cyan-100`;
        return `${base} bg-slate-700 text-slate-100`;
    }

    public previewLogEntryTitle(item: any) {
        const kind = item && item._kind;
        if (kind === 'navigation') return item.url || '-';
        if (kind === 'input') return item.field || 'unknown';
        if (kind === 'network') return `${item.method || 'GET'} ${item.status || ''} ${item.url || ''}`.trim();
        if (kind === 'console') return item.text || item.stack || '-';
        if (kind === 'fingerprint') return this.fingerprintSummary(item) || item.type || '-';
        return '-';
    }

    public previewLogEntryMeta(item: any) {
        const kind = item && item._kind;
        const time = this.kstDateTime(item && item.at);
        if (kind === 'navigation') return `${item.source || '-'} · ${time}`;
        if (kind === 'input') return `masked · 길이 ${item.value_length || 0} · ${item.input_type || '-'} · ${item.source || '-'} · ${time}`;
        if (kind === 'network') {
            return `${item.event || '-'} · ${item.resource_type || item.source || '-'} · ${this.networkDurationLabel(item)} · ${this.networkSizeLabel(item.transfer_size || item.encoded_body_size)} · ${time}`;
        }
        if (kind === 'console') return `${item.level || item.type || 'log'} · ${item.source || '-'} · ${item.url || '-'} · ${item.line || 0}:${item.column || 0} · ${time}`;
        if (kind === 'fingerprint') return `${item.type || '-'} · ${item.source || '-'} · ${item.target_origin || item.platform || '-'} · ${time}`;
        return time;
    }

    public previewLogEntryBody(item: any) {
        const kind = item && item._kind;
        if (kind === 'network') {
            const parts = [];
            if (item.error) parts.push(`error: ${item.error}`);
            if (item.status_text) parts.push(`status: ${item.status_text}`);
            if (item.frame_url) parts.push(`frame: ${item.frame_url}`);
            return parts.join('\n');
        }
        if (kind === 'console') return item.stack || '';
        if (kind === 'fingerprint') {
            const parts = [];
            if (item.reason) parts.push(`reason: ${item.reason}`);
            if (item.target_url) parts.push(`target: ${item.target_url}`);
            if (item.viewport) parts.push(`viewport: ${this.compactJson(item.viewport)}`);
            if (item.storage) parts.push(`storage: ${this.compactJson(item.storage)}`);
            if (item.screen) parts.push(`screen: ${this.compactJson(item.screen)}`);
            return parts.join('\n');
        }
        return '';
    }

    public elementSelectButtonTitle() {
        if (this.elementSelectActive) return '요소 지정 취소';
        if (this.selectedElementInfo) return '요소 지정 해제';
        return '요소 지정';
    }

    public elementSelectButtonClass() {
        const base = 'flex h-8 w-8 shrink-0 items-center justify-center rounded-md border text-[12px] disabled:opacity-40';
        if (this.elementSelectActive) return `${base} border-red-600 bg-red-600 text-white hover:bg-red-700`;
        if (this.selectedElementInfo) return `${base} border-red-300 bg-red-50 text-red-700 hover:bg-red-100`;
        return `${base} border-slate-300 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public async toggleElementSelect() {
        if (this.elementSelectActive || this.selectedElementInfo) this.deactivateElementSelect(true);
        else this.activateElementSelect();
        await this.service.render();
    }

    public activateElementSelect() {
        this.clearElementSelection(false);
        this.elementSelectActive = true;
        this.elementSelectStatus = '';
        const sent = this.postSdkCommand('element-select', { enabled: true }, false);
        if (!sent && !this.installSameOriginElementSelector()) {
            this.elementSelectStatus = 'cross-origin-sdk-required';
            this.probeSdk(false);
        }
    }

    public deactivateElementSelect(render: boolean = true) {
        this.elementSelectActive = false;
        this.elementSelectStatus = '';
        this.selectedElementInfo = null;
        this.postSdkCommand('element-select', { enabled: false }, false);
        this.uninstallSameOriginElementSelector(false);
        if (render) this.service.render();
    }

    public clearElementSelection(render: boolean = true) {
        this.selectedElementInfo = null;
        this.elementSelectStatus = '';
        this.postSdkCommand('element-select', { enabled: false }, false);
        this.uninstallSameOriginElementSelector(false);
        if (render) this.service.render();
    }

    public installSameOriginElementSelector() {
        const iframe = this.reviewFrame();
        try {
            const doc = iframe && iframe.contentDocument;
            const win: any = iframe && iframe.contentWindow;
            if (!doc || !win || !doc.body) return false;
            this.uninstallSameOriginElementSelector(false);

            const overlay = doc.createElement('div');
            overlay.setAttribute('data-reviewops-element-overlay', '1');
            overlay.style.cssText = [
                'position:fixed',
                'left:0',
                'top:0',
                'width:0',
                'height:0',
                'z-index:2147483647',
                'pointer-events:none',
                'box-sizing:border-box',
                'border:3px solid #dc2626',
                'background:rgba(220,38,38,0.16)',
                'box-shadow:0 0 0 99999px rgba(127,29,29,0.10),0 0 0 1px rgba(255,255,255,0.9) inset',
                'display:none'
            ].join(';');
            doc.body.appendChild(overlay);
            this.sameOriginElementOverlay = overlay;

            let selected: any = null;
            const describe = (target: any) => {
                const rect = target.getBoundingClientRect();
                const selector = this.elementSelector(target);
                return {
                    tag: String(target.tagName || '').toLowerCase(),
                    id: target.id || '',
                    class_name: target.className && typeof target.className === 'string' ? target.className : '',
                    text: String(target.innerText || target.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
                    selector,
                    rect: {
                        x: Math.round(rect.left),
                        y: Math.round(rect.top),
                        width: Math.round(rect.width),
                        height: Math.round(rect.height)
                    },
                    url: win.location && win.location.href ? win.location.href : this.currentUrl || this.frameUrl,
                    source: 'same-origin-element-select',
                    at: new Date().toISOString()
                };
            };
            const draw = (target: any) => {
                if (!target || target === overlay) return;
                const rect = target.getBoundingClientRect();
                overlay.style.display = 'block';
                overlay.style.left = `${rect.left}px`;
                overlay.style.top = `${rect.top}px`;
                overlay.style.width = `${rect.width}px`;
                overlay.style.height = `${rect.height}px`;
            };
            const move = (event: any) => draw(event.target);
            const click = (event: any) => {
                event.preventDefault();
                event.stopPropagation();
                selected = event.target;
                draw(selected);
                this.selectedElementInfo = describe(selected);
                this.elementSelectStatus = this.selectedElementInfo.selector || this.selectedElementInfo.tag;
                this.elementSelectActive = false;
                this.uninstallSameOriginElementSelector(true);
                this.service.render();
            };
            const redraw = () => {
                if (selected) draw(selected);
            };

            doc.addEventListener('mousemove', move, true);
            doc.addEventListener('click', click, true);
            win.addEventListener('scroll', redraw, true);
            win.addEventListener('resize', redraw, true);
            this.sameOriginElementSelectCleanup = (keepOverlay: boolean = false) => {
                doc.removeEventListener('mousemove', move, true);
                doc.removeEventListener('click', click, true);
                if (!keepOverlay) {
                    win.removeEventListener('scroll', redraw, true);
                    win.removeEventListener('resize', redraw, true);
                }
            };
            return true;
        } catch (e) {
            return false;
        }
    }

    public uninstallSameOriginElementSelector(keepOverlay: boolean = false) {
        if (this.sameOriginElementSelectCleanup) {
            try {
                this.sameOriginElementSelectCleanup(keepOverlay);
            } catch (e) { }
        }
        if (!keepOverlay) {
            this.sameOriginElementSelectCleanup = null;
            this.removeSameOriginElementOverlay();
        }
    }

    public removeSameOriginElementOverlay() {
        const overlay = this.sameOriginElementOverlay;
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        this.sameOriginElementOverlay = null;
    }

    public elementSelector(element: any) {
        if (!element || !element.tagName) return '';
        if (element.id) return `#${String(element.id).replace(/[^a-zA-Z0-9_-]/g, '\\$&')}`;
        const parts: string[] = [];
        let current = element;
        while (current && current.nodeType === 1 && parts.length < 5) {
            let part = String(current.tagName || '').toLowerCase();
            const className = typeof current.className === 'string' ? current.className.trim() : '';
            if (className) {
                const firstClass = className.split(/\s+/).filter(Boolean)[0];
                if (firstClass) part += `.${firstClass.replace(/[^a-zA-Z0-9_-]/g, '\\$&')}`;
            }
            const parent = current.parentElement;
            if (parent) {
                const siblings = Array.prototype.filter.call(parent.children || [], (item: any) => item.tagName === current.tagName);
                if (siblings.length > 1) part += `:nth-of-type(${siblings.indexOf(current) + 1})`;
            }
            parts.unshift(part);
            current = parent;
        }
        return parts.join(' > ');
    }

    public normalizeFrameUrl(url: string) {
        let value = String(url || '').trim();
        if (!value) return '';
        if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) value = `https://${value}`;
        return value;
    }

    public resetSdkStatus() {
        this.sdkInstalled = false;
        this.sdkStatus = 'checking';
        this.sdkVersion = '';
        this.sdkOrigin = '';
        this.sdkLastMessageAt = '';
        this.htmlDocumentStandardReady = false;
        this.htmlDocumentStandardMessage = '';
        if (this.sdkProbeTimer) {
            window.clearTimeout(this.sdkProbeTimer);
            this.sdkProbeTimer = null;
        }
    }

    public clearFrameScreenshotCache(captureMethod: string = 'capture-pending') {
        this.screenshotDataUrl = '';
        this.screenshotFallbackDataUrl = '';
        this.screenshotReceivedAt = 0;
        this.screenshotErrorAt = 0;
        this.screenshotInlinedResources = 0;
        this.screenshotSkippedResources = 0;
        this.captureMethod = captureMethod;
    }

    public sdkTargetOrigin() {
        try {
            const url = new URL(this.frameUrl || this.currentUrl || '');
            return url.origin;
        } catch (e) {
            return '*';
        }
    }

    public async probeSdk(manual: boolean = false) {
        if (!this.project) return;
        if (this.workspaceDetached && !manual) return;
        if (manual && this.sdkManualChecking) return;
        if (manual) {
            this.sdkManualChecking = true;
            this.sdkManualProbeCompleted = false;
            this.sdkProbeCheckedAt = '';
            this.sdkProbeResultMessage = '';
            this.sdkProbeResultDetail = '';
            await this.service.render();
        }
        this.resetSdkStatus();
        const sent = this.postSdkCommand('probe', {
            project_id: this.projectId,
            viewport: this.viewport,
            current_url: this.currentUrl || this.frameUrl
        }, true);
        if (!sent) {
            this.noteSdkMissing('probe-not-sent');
            this.finishManualSdkProbe(false, 'iframe에 메시지를 보낼 수 없습니다. 대상 페이지가 아직 로드되지 않았거나 iframe 접근이 차단되었을 수 있습니다.');
            await this.service.render();
            return;
        }
        this.sdkProbeTimer = window.setTimeout(async () => {
            if (this.sdkStatus === 'checking') {
                this.noteSdkMissing('probe-timeout');
                this.finishManualSdkProbe(false, '정해진 시간 안에 SDK 응답을 받지 못했습니다. 설치 스크립트와 parentOrigin 설정을 확인해주세요.');
                await this.service.render();
            }
        }, manual ? 1500 : 1000);
    }

    public markSdkInstalled(data: any, origin: string = '') {
        this.sdkInstalled = true;
        this.sdkStatus = 'connected';
        this.sdkVersion = data.version || data.sdk_version || this.sdkVersion || '';
        this.sdkOrigin = origin || this.sdkOrigin || '';
        this.sdkLastMessageAt = new Date().toISOString();
        if (this.sdkProbeTimer) {
            window.clearTimeout(this.sdkProbeTimer);
            this.sdkProbeTimer = null;
        }
        if (data.url && data.event !== 'navigation') this.commitFrameHistoryNavigation(data.url, 'sdk-ready');
        if (this.elementSelectActive) this.postSdkCommand('element-select', { enabled: true }, false);
        this.recordFingerprint({
            type: 'reviewops-sdk',
            source: data.event || 'sdk-ready',
            summary: `SDK ${this.sdkVersion || 'connected'} / ${origin || 'unknown-origin'}`,
            target_url: data.url || this.currentUrl || this.frameUrl,
            target_origin: origin || '',
            readable: true
        });
        this.finishManualSdkProbe(true, 'SDK가 현재 iframe에서 정상 응답했습니다.');
    }

    public noteSdkMissing(source: string) {
        if (this.sdkInstalled) return;
        this.sdkStatus = 'missing';
        this.recordFingerprint({
            type: 'reviewops-sdk',
            source,
            summary: 'SDK missing',
            target_url: this.currentUrl || this.frameUrl,
            target_origin: this.sdkTargetOrigin(),
            readable: false,
            reason: 'sdk-not-installed'
        });
    }

    public finishManualSdkProbe(success: boolean, detail: string = '') {
        if (!this.sdkManualChecking) return;
        this.sdkManualChecking = false;
        this.sdkManualProbeCompleted = true;
        this.sdkProbeCheckedAt = new Date().toISOString();
        this.sdkProbeResultMessage = success ? 'SDK 연결 확인 완료' : 'SDK 연결을 확인하지 못했습니다.';
        this.sdkProbeResultDetail = detail;
    }

    public postSdkCommand(command: string, payload: any = {}, allowProbeWhenUnknown: boolean = false) {
        const iframe = this.reviewFrame();
        const win: any = iframe && iframe.contentWindow;
        if (!win) return false;
        if (!allowProbeWhenUnknown && !this.sdkInstalled) return false;
        try {
            const targetOrigin = '*';
            win.postMessage({
                type: command === 'probe' ? 'reviewops-sdk-probe' : 'reviewops-command',
                command,
                project_id: this.projectId,
                payload: Object.assign({
                    current_url: this.currentUrl || this.frameUrl,
                    viewport_width: this.viewport.width,
                    viewport_height: this.viewport.height,
                    scale: this.scale
                }, payload || {})
            }, targetOrigin);
            return true;
        } catch (e) {
            return false;
        }
    }

    public async startRemoteSession(showError: boolean = true) {
        if (!this.project || this.remoteLoading) return;
        this.remoteLoading = true;
        this.remoteError = '';
        this.scheduleRemoteRender();

        let { code, data } = await this.remoteSocketRequest('join_remote', {}, true);
        if (code === 0) {
            const fallback = await this.remoteRestCommand('remote_start', {});
            code = fallback.code;
            data = fallback.data;
        }

        this.remoteLoading = false;
        if (code === 200) {
            this.applyRemoteSession(data.session);
            this.scheduleRemoteSnapshotRefresh(650);
        } else {
            this.remoteReady = false;
            this.remoteError = data.message || '원격 브라우저 세션을 시작하지 못했습니다.';
            if (showError) await this.service.modal.error(this.remoteError);
        }
        this.scheduleRemoteRender();
    }

    public remoteSessionPayload(payload: any = {}) {
        this.normalizeViewport();
        const currentUrl = this.currentUrl || this.remoteAddress || this.projectPreviewServerUrl(this.previewLinkMode) || '';
        return Object.assign({
            project_id: this.projectId,
            admin: this.adminMode ? '1' : '',
            width: this.viewport.width,
            height: this.viewport.height,
            url: currentUrl,
            current_url: currentUrl
        }, payload || {});
    }

    public remoteSocketNamespace() {
        const projectName = typeof wiz.project === 'function' ? wiz.project() : 'main';
        return `/wiz/app/${projectName}/page.projects.item`;
    }

    public async connectRemoteSocket() {
        if (this.remoteSocket && this.remoteSocket.connected) return true;
        if (this.remoteSocketConnecting) {
            for (let i = 0; i < 15; i++) {
                await this.service.sleep(120);
                if (this.remoteSocket && this.remoteSocket.connected) return true;
                if (!this.remoteSocketConnecting) break;
            }
            return !!(this.remoteSocket && this.remoteSocket.connected);
        }

        this.remoteSocketConnecting = true;
        if (!this.remoteSocket) {
            this.remoteSocket = io.connect(this.remoteSocketNamespace(), {
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionAttempts: 5,
                reconnectionDelay: 500
            });
            this.remoteSocket.on('connect', () => {
                this.remoteSocketConnected = true;
                this.remoteSocketConnecting = false;
                if (this.remoteReady && this.projectId && this.tab === 'review') {
                    this.remoteSocketRequest('join_remote', {}, false);
                }
                this.scheduleRemoteRender();
            });
            this.remoteSocket.on('disconnect', () => {
                this.remoteSocketConnected = false;
                this.scheduleRemoteRender();
            });
            this.remoteSocket.on('remote_session', (data: any) => {
                this.completeRemoteRequest(data, 200);
                this.applyRemoteSession(data.session);
                this.scheduleRemoteRender();
            });
            this.remoteSocket.on('remote_error', (data: any) => {
                this.completeRemoteRequest(data, 400);
                this.remoteReady = false;
                this.remoteError = data.message || '원격 브라우저 명령을 처리하지 못했습니다.';
                this.scheduleRemoteRender();
            });
            this.remoteSocket.on('terminal_ready', (data: any) => {
                this.handleTerminalReady(data);
            });
            this.remoteSocket.on('terminal_data', (data: any) => {
                this.handleTerminalData(data);
            });
            this.remoteSocket.on('terminal_error', (data: any) => {
                this.handleTerminalError(data);
            });
            this.remoteSocket.on('terminal_closed', (data: any) => {
                this.handleTerminalClosed(data);
            });
        }

        return await new Promise<boolean>((resolve) => {
            if (this.remoteSocket.connected) {
                this.remoteSocketConnected = true;
                this.remoteSocketConnecting = false;
                resolve(true);
                return;
            }
            const timer = window.setTimeout(() => {
                this.remoteSocketConnecting = false;
                resolve(false);
            }, 1800);
            this.remoteSocket.once('connect', () => {
                window.clearTimeout(timer);
                this.remoteSocketConnected = true;
                this.remoteSocketConnecting = false;
                resolve(true);
            });
            this.remoteSocket.once('connect_error', () => {
                window.clearTimeout(timer);
                this.remoteSocketConnecting = false;
                resolve(false);
            });
        });
    }

    public disconnectRemoteSocket() {
        if (!this.remoteSocket) return;
        try {
            this.remoteSocket.emit('leave_remote', this.remoteSocketEnvelope({}));
            this.remoteSocket.emit('leave_terminal', this.terminalSocketEnvelope({}));
            this.remoteSocket.disconnect();
        } catch (e) { }
        this.remoteSocket = null;
        this.remoteSocketConnected = false;
        this.remoteRequests = {};
    }

    public remoteSocketEnvelope(payload: any, requestId: string = '') {
        return {
            request_id: requestId,
            project_id: this.projectId,
            admin: this.adminMode ? '1' : '',
            payload: this.remoteSessionPayload(payload)
        };
    }

    public async remoteSocketRequest(event: string, payload: any = {}, waitResponse: boolean = true, command: string = '') {
        const connected = await this.connectRemoteSocket();
        if (!connected || !this.remoteSocket) {
            return { code: 0, data: { message: '원격 브라우저 소켓에 연결하지 못했습니다.' } };
        }

        const requestId = `${Date.now()}-${++this.remoteRequestSeq}`;
        const envelope: any = this.remoteSocketEnvelope(payload, requestId);
        if (command) envelope.command = command;

        if (!waitResponse) {
            this.remoteSocket.emit(event, envelope);
            return { code: 202, data: {} };
        }

        return await new Promise<any>((resolve) => {
            const timeout = window.setTimeout(() => {
                delete this.remoteRequests[requestId];
                resolve({ code: 0, data: { message: '원격 브라우저 응답 시간이 초과되었습니다.' } });
            }, 30000);
            this.remoteRequests[requestId] = { resolve, timeout };
            this.remoteSocket.emit(event, envelope);
        });
    }

    public completeRemoteRequest(data: any, code: number) {
        const requestId = data && data.request_id ? data.request_id : '';
        if (!requestId || !this.remoteRequests[requestId]) return;
        const pending = this.remoteRequests[requestId];
        window.clearTimeout(pending.timeout);
        delete this.remoteRequests[requestId];
        pending.resolve({ code, data });
    }

    public scheduleRemoteRender() {
        if (this.remoteRenderTimer) return;
        this.remoteRenderTimer = requestAnimationFrame(async () => {
            this.remoteRenderTimer = null;
            await this.service.render();
            this.updateRemoteFrameDom();
        });
    }

    public async stopRemoteSession(render: boolean = true) {
        if (!this.projectId) return;
        if (this.remotePollTimer) {
            window.clearInterval(this.remotePollTimer);
            this.remotePollTimer = null;
        }
        try {
            if (this.remoteSocket && this.remoteSocket.connected) {
                await this.remoteSocketRequest('remote_stop', {}, true);
            } else {
                await this.remoteRestCommand('remote_stop', {});
            }
        } catch (e) { }
        this.remoteReady = false;
        if (render) await this.service.render();
    }

    public startRemotePoll() {
        if (this.remotePollTimer) window.clearInterval(this.remotePollTimer);
        this.remotePollTimer = null;
        this.connectRemoteSocket();
    }

    public async syncRemoteSnapshot(render: boolean = true, preferPatch: boolean = false, forceFull: boolean = false) {
        if (this.workspaceDetached || this.destroyed) return;
        const payload: any = {};
        if (preferPatch) payload.prefer_patch = true;
        if (forceFull) payload.force_full = true;
        if (!forceFull && this.remoteSnapshotId) payload.since_snapshot_id = this.remoteSnapshotId;

        let { code, data } = await this.remoteSocketRequest('remote_snapshot', payload, true);
        if (code === 0) {
            const fallback = await this.remoteRestCommand('remote_snapshot', payload);
            code = fallback.code;
            data = fallback.data;
        }
        if (code === 200) {
            this.applyRemoteSession(data.session);
        } else {
            this.remoteError = data.message || '원격 브라우저 상태를 불러오지 못했습니다.';
            this.remoteReady = false;
            if (this.isRemoteSessionMissing(data)) await this.startRemoteSession(false);
        }
        if (render) this.scheduleRemoteRender();
    }

    public scheduleRemoteSnapshotRefresh(delay: number = 120, forceFull: boolean = false) {
        if (this.remoteSnapshotRefreshTimer) window.clearTimeout(this.remoteSnapshotRefreshTimer);
        if (this.workspaceDetached || this.destroyed) {
            this.remoteSnapshotRefreshTimer = null;
            return;
        }
        this.remoteSnapshotRefreshTimer = window.setTimeout(async () => {
            this.remoteSnapshotRefreshTimer = null;
            if (this.workspaceDetached || this.destroyed) return;
            await this.syncRemoteSnapshot(true, !forceFull, forceFull);
        }, delay);
    }

    public async remoteCommand(command: string, payload: any = {}, waitResponse: boolean = true, showBusy: boolean = true) {
        if (!this.remoteReady && command !== 'remote_start') {
            await this.startRemoteSession(false);
        }

        if (waitResponse && showBusy) {
            this.remoteActionBusy = true;
            this.scheduleRemoteRender();
        }

        let { code, data } = await this.remoteSocketRequest('remote_command', payload, waitResponse, command);
        if (code === 0) {
            const fallback = await this.remoteRestCommand(command, payload);
            code = fallback.code;
            data = fallback.data;
        }
        if (!waitResponse) {
            if (code === 200 && data && data.session) this.applyRemoteSession(data.session);
            return;
        }

        this.remoteActionBusy = false;
        if (code === 200) {
            this.applyRemoteSession(data.session);
            if (['remote_start', 'remote_navigate', 'remote_reload', 'remote_back', 'remote_forward', 'remote_resize'].includes(command)) {
                this.scheduleRemoteSnapshotRefresh(650);
            }
        } else {
            this.remoteReady = false;
            this.remoteError = data.message || '원격 브라우저 명령을 처리하지 못했습니다.';
            await this.service.modal.error(this.remoteError);
        }
        this.scheduleRemoteRender();
    }

    public async remoteRestCommand(command: string, payload: any = {}) {
        const query: any = this.requestParams({ id: this.projectId, data: JSON.stringify(this.remoteSessionPayload(payload)) });
        let { code, data } = await wiz.call(command, query);
        if (code !== 200 && this.isRemoteSessionMissing(data)) {
            await this.startRemoteSession(false);
            query.data = JSON.stringify(this.remoteSessionPayload(payload));
            const retry = await wiz.call(command, query);
            code = retry.code;
            data = retry.data;
        }
        return { code, data };
    }

    public applyRemoteSession(session: any) {
        if (!session) return;
        if (session.project_id && String(session.project_id) !== String(this.projectId)) return;
        this.remoteReady = !!session.ready;
        this.remoteError = session.last_error || '';
        if (session.snapshot_id) this.remoteSnapshotId = session.snapshot_id;
        if (session.screenshot_data_url) {
            if (session.visual_blank && session.snapshot_pending) {
                this.remoteScreenshotDataUrl = this.remoteScreenshotDataUrl || '';
            } else {
                this.remoteFrameDrawSeq++;
                this.remoteScreenshotDataUrl = session.screenshot_data_url;
                this.setRemoteFrameDataUrl(session.screenshot_data_url);
            }
        } else if (session.screenshot_patch && this.remoteScreenshotDataUrl) {
            this.composeRemoteFramePatch(session.screenshot_patch);
        } else if (session.screenshot_patch && !this.remoteScreenshotDataUrl) {
            this.scheduleRemoteSnapshotRefresh(0, true);
        } else if (this.remoteDisplayDataUrl) {
            this.updateRemoteFrameDom();
        }
        if (session.snapshot_pending) {
            const nextDelay = Math.max(Number(session.next_snapshot_delay_ms) || 180, 120);
            this.scheduleRemoteSnapshotRefresh(nextDelay, !this.remoteScreenshotDataUrl);
        }
        this.remoteNavigationLog = (session.navigation_log || []).slice(-this.logBufferLimits.navigation);
        this.remoteNetworkLog = (session.network_log || []).slice(-this.logBufferLimits.network);
        this.remoteConsoleLog = session.console_log || [];
        this.captureMethod = session.capture_method || 'remote-cdp-screencast';
        if (session.current_url) {
            this.currentUrl = session.current_url;
            this.remoteAddress = session.current_url;
            this.recordNavigation(session.current_url, 'remote-session');
        }
    }

    public setRemoteFrameDataUrl(dataUrl: string, render: boolean = true) {
        this.remoteDisplayDataUrl = dataUrl || '';
        this.updateRemoteFrameDom();
        if (render) this.scheduleRemoteRender();
    }

    public updateRemoteFrameDom(dataUrl?: string) {
        if (typeof document === 'undefined') return;
        const displayDataUrl = typeof dataUrl === 'string' ? dataUrl : this.remoteDisplayDataUrl;
        const frame = document.getElementById('remote-browser-frame') as HTMLImageElement;
        if (frame) {
            if (displayDataUrl) {
                if ((frame.getAttribute('src') || '') !== displayDataUrl) frame.setAttribute('src', displayDataUrl);
                frame.style.opacity = '1';
                frame.style.visibility = 'visible';
                frame.style.pointerEvents = 'auto';
            } else {
                frame.removeAttribute('src');
                frame.style.opacity = '0';
                frame.style.visibility = 'hidden';
                frame.style.pointerEvents = 'none';
            }
            frame.style.width = `${this.frameOuterWidth()}px`;
            frame.style.height = `${this.frameContentHeight()}px`;
        }

        const placeholder = document.getElementById('remote-browser-placeholder') as HTMLElement;
        if (placeholder) {
            placeholder.style.display = displayDataUrl ? 'none' : 'flex';
        }
    }

    public onRemoteImageLoad() {
        if (!this.remoteDisplayDataUrl) return;
        this.remoteError = '';
        this.updateRemoteFrameDom();
    }

    public onRemoteImageError() {
        if (!this.remoteDisplayDataUrl) return;
        this.remoteError = '원격 브라우저 이미지를 표시하지 못해 다시 불러오는 중입니다.';
        this.remoteScreenshotDataUrl = '';
        this.setRemoteFrameDataUrl('');
        this.scheduleRemoteSnapshotRefresh(250, true);
    }

    public isRemoteSessionMissing(data: any) {
        const message = data && data.message ? String(data.message) : '';
        return message.includes('원격 브라우저 세션');
    }

    public async navigateRemoteAddress() {
        const url = (this.remoteAddress || '').trim();
        if (!url) return;
        await this.remoteCommand('remote_navigate', { url });
    }

    public async remoteBack() {
        await this.remoteCommand('remote_back');
    }

    public async remoteForward() {
        await this.remoteCommand('remote_forward');
    }

    public async resizeRemoteSession() {
        if (!this.remoteReady) return;
        await this.remoteCommand('remote_resize', {
            width: this.viewport.width,
            height: this.viewport.height
        });
    }

    public focusRemoteSurface(event: any) {
        const target = event && event.currentTarget ? event.currentTarget as HTMLElement : document.querySelector('.remote-browser-surface') as HTMLElement;
        const surface = target && target.classList && target.classList.contains('remote-browser-surface')
            ? target
            : target && target.closest ? target.closest('.remote-browser-surface') as HTMLElement : null;
        if (surface && surface.focus) {
            try {
                surface.focus({ preventScroll: true });
            } catch (e) {
                surface.focus();
            }
            this.remoteSurfaceFocused = true;
        }
    }

    public blurRemoteSurface() {
        this.remoteSurfaceFocused = false;
    }

    public clampRemotePoint(value: number, max: number) {
        return Math.max(0, Math.min(Math.round(value), Math.max(max - 1, 0)));
    }

    public remoteMouseButton(event: MouseEvent) {
        return event.button === 2 ? 'right' : event.button === 1 ? 'middle' : 'left';
    }

    public remoteMousePayload(event: MouseEvent, action: string) {
        const surface = this.remoteSurfaceElement(event);
        const rect = surface ? surface.getBoundingClientRect() : null;
        const width = rect ? Math.max(rect.width, 1) : Math.max(this.frameOuterWidth(), 1);
        const height = rect ? Math.max(rect.height, 1) : Math.max(this.frameContentHeight(), 1);
        const left = rect ? rect.left : 0;
        const top = rect ? rect.top : 0;
        const x = this.clampRemotePoint((event.clientX - left) / width * this.viewport.width, this.viewport.width);
        const y = this.clampRemotePoint((event.clientY - top) / height * this.viewport.height, this.viewport.height);
        return {
            action,
            x,
            y,
            button: this.remoteMouseButton(event),
            buttons: event.buttons || 0
        };
    }

    public remoteSurfaceElement(event?: any) {
        const currentTarget = event && event.currentTarget ? event.currentTarget as any : null;
        if (currentTarget && currentTarget.classList && currentTarget.classList.contains('remote-browser-surface')) {
            return currentTarget as HTMLElement;
        }

        const target = event && event.target ? event.target as any : null;
        if (target && target.classList && target.classList.contains('remote-browser-surface')) {
            return target as HTMLElement;
        }
        if (target && target.closest) {
            const surface = target.closest('.remote-browser-surface') as HTMLElement;
            if (surface) return surface;
        }
        return document.querySelector('.remote-browser-surface') as HTMLElement;
    }

    public swallowRemoteBrowserEvent(event: any) {
        if (!event) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    public async onRemoteMouseDown(event: MouseEvent) {
        if (!this.remoteReady || !this.remoteDisplayDataUrl) return;
        this.swallowRemoteBrowserEvent(event);
        this.flushRemoteTextInput();
        this.flushRemoteWheel();
        this.focusRemoteSurface(event);
        this.remoteMouseButtonDown = true;
        if (event.button === 2) this.remoteLastRightMouseAt = Date.now();
        this.remoteCommand('remote_mouse', this.remoteMousePayload(event, 'down'), false, false);
    }

    public async onRemoteMouseUp(event: MouseEvent) {
        if (!this.remoteReady || !this.remoteDisplayDataUrl) return;
        this.swallowRemoteBrowserEvent(event);
        this.focusRemoteSurface(event);
        if (event.button === 2) this.remoteLastRightMouseAt = Date.now();
        this.remoteMouseButtonDown = false;
        this.remoteCommand('remote_mouse', this.remoteMousePayload(event, 'up'), false, false);
    }

    public async onRemoteMouseMove(event: MouseEvent) {
        if (!this.remoteReady || !this.remoteDisplayDataUrl) return;
        if (!this.remoteSurfaceFocused && !this.remoteMouseButtonDown && !(event.buttons || 0)) return;
        this.swallowRemoteBrowserEvent(event);
        this.remoteMouseMovePayload = this.remoteMousePayload(event, 'move');
        if (this.remoteMouseMoveTimer) return;
        this.remoteMouseMoveTimer = window.setTimeout(() => {
            this.remoteMouseMoveTimer = null;
            const payload = this.remoteMouseMovePayload;
            this.remoteMouseMovePayload = null;
            if (payload) this.remoteCommand('remote_mouse', payload, false, false);
        }, 35);
    }

    public async onRemoteMouseLeave(event: MouseEvent) {
        if (!this.remoteReady || !this.remoteDisplayDataUrl || !this.remoteMouseButtonDown) return;
        this.swallowRemoteBrowserEvent(event);
        this.remoteMouseMovePayload = this.remoteMousePayload(event, 'move');
    }

    public async onRemoteContextMenu(event: MouseEvent) {
        this.swallowRemoteBrowserEvent(event);
        if (!this.remoteReady || !this.remoteDisplayDataUrl) return;
        this.focusRemoteSurface(event);
        const hasRecentRightEvent = Date.now() - this.remoteLastRightMouseAt < 350;
        if (this.remoteMouseButtonDown) {
            this.remoteMouseButtonDown = false;
            this.remoteCommand('remote_mouse', this.remoteMousePayload(event, 'up'), false, false);
            return;
        }
        if (!hasRecentRightEvent) {
            this.remoteLastRightMouseAt = Date.now();
            this.remoteCommand('remote_click', this.remoteMousePayload(event, 'click'), false, false);
        }
    }

    public async onRemoteWheel(event: WheelEvent) {
        if (!this.remoteReady) return;
        event.preventDefault();
        this.remoteWheelBuffer.delta_x += event.deltaX;
        this.remoteWheelBuffer.delta_y += event.deltaY;
        if (this.remoteWheelFlushTimer) return;
        this.remoteWheelFlushTimer = window.setTimeout(() => this.flushRemoteWheel(), 60);
    }

    public async onRemotePaste(event: ClipboardEvent) {
        const text = event.clipboardData ? event.clipboardData.getData('text') : '';
        if (!text) return;
        event.preventDefault();
        this.remoteTextBuffer += text;
        this.recordRemoteInput(text.length);
        this.flushRemoteTextInput();
    }

    public async onRemoteKey(event: KeyboardEvent) {
        if (!this.remoteReady) return;
        const payload = this.remoteKeyPayload(event);
        if (!payload) {
            this.swallowRemoteBrowserEvent(event);
            return;
        }
        this.swallowRemoteBrowserEvent(event);
        if (payload.text) {
            this.remoteTextBuffer += payload.text;
            if (this.remoteTextFlushTimer) window.clearTimeout(this.remoteTextFlushTimer);
            this.remoteTextFlushTimer = window.setTimeout(() => this.flushRemoteTextInput(), 45);
            this.recordRemoteInput(payload.text.length);
            return;
        }
        this.flushRemoteTextInput();
        this.remoteCommand('remote_key', payload, false, false);
    }

    public shouldCaptureRemoteKeyboard(event: KeyboardEvent) {
        if (!event || event.defaultPrevented) return false;
        if (this.tab !== 'review' || !this.remoteReady || !this.remoteDisplayDataUrl || !this.remoteSurfaceFocused) return false;

        const target = event.target as HTMLElement;
        if (target && target.closest && target.closest('.remote-browser-surface')) return true;
        if (this.isEditableTarget(target)) return false;
        return true;
    }

    public isEditableTarget(target: any) {
        if (!target || !target.tagName) return false;
        const tagName = String(target.tagName).toLowerCase();
        if (['input', 'textarea', 'select', 'button'].includes(tagName)) return true;
        return !!(target.isContentEditable || (target.closest && target.closest('[contenteditable="true"], [contenteditable=""]')));
    }

    public flushRemoteTextInput() {
        if (this.remoteTextFlushTimer) {
            window.clearTimeout(this.remoteTextFlushTimer);
            this.remoteTextFlushTimer = null;
        }
        const text = this.remoteTextBuffer;
        this.remoteTextBuffer = '';
        if (!text) return;
        this.remoteCommand('remote_key', { text }, false, false);
    }

    public recordRemoteInput(length: number) {
        this.recordInput({
            field: 'remote-browser',
            value_length: length,
            masked: true,
            at: new Date().toISOString(),
            source: 'remote-playwright'
        });
    }

    public async composeRemoteFramePatch(patch: any) {
        if (!patch || !patch.data_url) return;
        const baseDataUrl = this.remoteDisplayDataUrl || this.remoteScreenshotDataUrl;
        if (!baseDataUrl) {
            this.scheduleRemoteSnapshotRefresh(0, true);
            return;
        }

        const drawSeq = ++this.remoteFrameDrawSeq;
        try {
            const base = await this.loadRemoteImage(baseDataUrl);
            const patchImage = await this.loadRemoteImage(patch.data_url);
            if (drawSeq !== this.remoteFrameDrawSeq) return;

            const canvas = document.createElement('canvas');
            canvas.width = Math.max(Number(this.viewport.width) || base.width || 1, 1);
            canvas.height = Math.max(Number(this.viewport.height) || base.height || 1, 1);
            const context = canvas.getContext('2d');
            if (!context) return;

            context.drawImage(base, 0, 0, canvas.width, canvas.height);
            context.drawImage(
                patchImage,
                Number(patch.x) || 0,
                Number(patch.y) || 0,
                Number(patch.width) || patchImage.width,
                Number(patch.height) || patchImage.height
            );
            const dataUrl = canvas.toDataURL('image/jpeg', 0.72);
            this.remoteScreenshotDataUrl = dataUrl;
            this.setRemoteFrameDataUrl(dataUrl);
        } catch (e) {
            this.scheduleRemoteSnapshotRefresh(0, true);
        }
    }

    public loadRemoteImage(dataUrl: string) {
        return new Promise<HTMLImageElement>((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error('remote-image-load-failed'));
            image.src = dataUrl;
        });
    }

    public flushRemoteWheel() {
        if (this.remoteWheelFlushTimer) {
            window.clearTimeout(this.remoteWheelFlushTimer);
            this.remoteWheelFlushTimer = null;
        }
        const deltaX = this.remoteWheelBuffer.delta_x;
        const deltaY = this.remoteWheelBuffer.delta_y;
        this.remoteWheelBuffer = { delta_x: 0, delta_y: 0 };
        if (!deltaX && !deltaY) return;
        this.remoteCommand('remote_wheel', {
            delta_x: deltaX,
            delta_y: deltaY
        }, false, false);
    }

    public remoteKeyPayload(event: KeyboardEvent) {
        if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            return { text: event.key };
        }
        const direct: any = {
            Enter: 'Enter',
            Backspace: 'Backspace',
            Tab: 'Tab',
            Escape: 'Escape',
            Delete: 'Delete',
            Home: 'Home',
            End: 'End',
            PageUp: 'PageUp',
            PageDown: 'PageDown',
            ArrowLeft: 'ArrowLeft',
            ArrowRight: 'ArrowRight',
            ArrowUp: 'ArrowUp',
            ArrowDown: 'ArrowDown',
            ' ': 'Space',
            Insert: 'Insert',
            F1: 'F1',
            F2: 'F2',
            F3: 'F3',
            F4: 'F4',
            F5: 'F5',
            F6: 'F6',
            F7: 'F7',
            F8: 'F8',
            F9: 'F9',
            F10: 'F10',
            F11: 'F11',
            F12: 'F12'
        };
        if (event.ctrlKey && event.key.length === 1) return { key: `Control+${event.key.toUpperCase()}` };
        if (event.metaKey && event.key.length === 1) return { key: `Meta+${event.key.toUpperCase()}` };
        if (event.altKey && event.key.length === 1) return { key: `Alt+${event.key.toUpperCase()}` };
        if (event.shiftKey && direct[event.key]) return { key: `Shift+${direct[event.key]}` };
        if (direct[event.key]) return { key: direct[event.key] };
        return null;
    }

    public onFrameLoad() {
        const frameLoadSeq = ++this.htmlDocumentLoadSeq;
        this.captureMethod = 'browser-capture-required';
        this.uninstallSameOriginElementSelector();
        if (this.isHtmlProject() && this.ensureHtmlProjectFrameUrl('iframe-load-url-guard')) {
            this.service.render();
            return;
        }
        if (!this.isHtmlProject()) {
            if (!this.syncCurrentUrlFromFrame('iframe-load', true)) {
                this.commitFrameHistoryNavigation(this.pendingFrameFallbackUrl(), 'iframe-load');
            }
            this.collectSameOriginFrameInfo();
            this.collectFingerprintLog('iframe-load');
            this.startFrameUrlWatcher();
            this.probeSdk(false);
        } else {
            this.commitFrameHistoryNavigation(this.pendingFrameFallbackUrl(), 'iframe-load');
            this.startFrameUrlWatcher();
        }
        if (this.isHtmlProject()) {
            const previousState = this.htmlDocumentState || {};
            const manualPageCount = this.configuredHtmlDocumentPageCount();
            const htmlPageCount = Math.max(manualPageCount, Number(previousState.page_count) || 1, 1);
            const previousPage = Math.min(Math.max(Number(previousState.page) || 1, 1), htmlPageCount);
            const restorePage = Math.min(Math.max(Number(this.htmlDocumentRestorePageAfterLoad) || 0, 0), htmlPageCount);
            this.htmlDocumentRestorePageAfterLoad = 0;
            this.htmlDocumentState = Object.assign({}, previousState, {
                page: previousPage,
                page_count: htmlPageCount,
                manual_page_count: manualPageCount,
                strategy: 'loading'
            });
            window.setTimeout(() => {
                if (frameLoadSeq !== this.htmlDocumentLoadSeq || !this.isHtmlProject()) return;
                const readable = this.requestHtmlDocumentState(false);
                if (restorePage > 0 && readable) this.goToHtmlDocumentPage(restorePage, 'html-document-reload-restore');
                else this.service.render();
            }, restorePage > 0 ? 220 : 160);
        }
        if (this.elementSelectActive) window.setTimeout(() => this.activateElementSelect(), 0);
        this.service.render();
    }

    public collectSameOriginFrameInfo() {
        if (this.isHtmlProject()) return;
        this.syncCurrentUrlFromFrame('same-origin', true);
    }

    public syncCurrentUrlFromFrame(source: string, recordAccess: boolean = false) {
        if (this.isHtmlProject()) return false;
        const iframe = this.reviewFrame();
        try {
            const win: any = iframe && iframe.contentWindow;
            if (!win) return false;
            const frameLocation = win.location && win.location.href;
            const url = frameLocation;
            if (url) {
                const changed = this.commitFrameHistoryNavigation(url, source);
                const titleChanged = this.setFrameTitle(win.document && win.document.title ? win.document.title : '', source);
                if (recordAccess) this.recordFingerprint(this.frameFingerprint('same-origin-frame', true));
                return changed || titleChanged;
            }
            return false;
        } catch (e) {
            if (recordAccess) {
                this.captureMethod = 'capture-unavailable-cross-origin';
                this.recordFingerprint(this.frameFingerprint('cross-origin-frame', false, 'cross-origin-or-blocked'));
            }
            return false;
        }
    }

    public startFrameUrlWatcher() {
        if (this.frameUrlWatchTimer) window.clearInterval(this.frameUrlWatchTimer);
        this.frameUrlWatchTimer = window.setInterval(() => {
            if (this.frameActionBusy) return;
            const changed = this.isHtmlProject()
                ? this.syncHtmlDocumentFrameState('html-iframe-watch')
                : this.syncCurrentUrlFromFrame('same-origin-watch', false);
            if (changed) this.service.render();
        }, this.isHtmlProject() ? 300 : 500);
    }

    public setCurrentUrl(url: string, source: string, record: boolean = true) {
        const normalized = String(url || '').trim();
        if (!normalized) return false;
        const changed = this.currentUrl !== normalized;
        this.currentUrl = normalized;
        this.remoteAddress = normalized;
        if (record) this.recordNavigation(normalized, source);
        return changed;
    }

    public resetFrameHistory(url: string) {
        const normalized = this.normalizeFrameHistoryUrl(url);
        this.frameHistoryEntries = normalized ? [normalized] : [];
        this.frameHistoryIndex = this.frameHistoryEntries.length - 1;
        this.frameHistoryPending = null;
        this.frameHistorySeq++;
    }

    public normalizeFrameHistoryUrl(url: any) {
        return String(url || '').trim();
    }

    public canFrameGoBack() {
        return this.frameHistoryIndex > 0;
    }

    public canFrameGoForward() {
        return this.frameHistoryIndex >= 0 && this.frameHistoryIndex < this.frameHistoryEntries.length - 1;
    }

    public currentFrameHistoryUrl() {
        if (this.frameHistoryIndex < 0) return '';
        return this.frameHistoryEntries[this.frameHistoryIndex] || '';
    }

    public isFrameHistoryReplaceSource(source: string) {
        const value = String(source || '').toLowerCase();
        return value.indexOf('replacestate') >= 0 || value.indexOf('replace-state') >= 0;
    }

    public trimFrameHistoryEntries() {
        if (this.frameHistoryEntries.length <= this.frameHistoryLimit) return;
        const drop = this.frameHistoryEntries.length - this.frameHistoryLimit;
        this.frameHistoryEntries = this.frameHistoryEntries.slice(drop);
        this.frameHistoryIndex = Math.max(this.frameHistoryIndex - drop, 0);
    }

    public replaceFrameHistoryCurrent(url: string) {
        const normalized = this.normalizeFrameHistoryUrl(url);
        if (!normalized) return;
        if (this.frameHistoryIndex < 0) {
            this.frameHistoryEntries = [normalized];
            this.frameHistoryIndex = 0;
            return;
        }
        this.frameHistoryEntries[this.frameHistoryIndex] = normalized;
    }

    public pushFrameHistoryEntry(url: string) {
        const normalized = this.normalizeFrameHistoryUrl(url);
        if (!normalized) return;
        if (this.currentFrameHistoryUrl() === normalized) return;
        const nextEntries = this.frameHistoryIndex >= 0
            ? this.frameHistoryEntries.slice(0, this.frameHistoryIndex + 1)
            : [];
        nextEntries.push(normalized);
        this.frameHistoryEntries = nextEntries;
        this.frameHistoryIndex = this.frameHistoryEntries.length - 1;
        this.trimFrameHistoryEntries();
    }

    public commitFrameHistoryTraversal(url: string) {
        const normalized = this.normalizeFrameHistoryUrl(url);
        if (!normalized || !this.frameHistoryPending) return false;
        const targetIndex = Number(this.frameHistoryPending.targetIndex);
        if (!Number.isFinite(targetIndex) || targetIndex < 0 || targetIndex >= this.frameHistoryEntries.length) return false;
        this.frameHistoryEntries[targetIndex] = normalized;
        this.frameHistoryIndex = targetIndex;
        this.frameHistoryPending = null;
        return true;
    }

    public commitFrameHistoryNavigation(url: string, source: string = '') {
        const normalized = this.normalizeFrameHistoryUrl(url);
        if (!normalized) return false;
        const changed = this.currentUrl !== normalized;

        if (this.frameHistoryPending && this.frameHistoryPending.type === 'traverse') {
            this.commitFrameHistoryTraversal(normalized);
        } else if (this.frameHistoryPending && this.frameHistoryPending.type === 'new') {
            this.frameHistoryPending = null;
            if (this.isFrameHistoryReplaceSource(source)) this.replaceFrameHistoryCurrent(normalized);
            else this.pushFrameHistoryEntry(normalized);
        } else if (!this.frameHistoryEntries.length) {
            this.resetFrameHistory(normalized);
        } else if (this.currentFrameHistoryUrl() !== normalized) {
            const previousIndex = this.frameHistoryIndex - 1;
            const nextIndex = this.frameHistoryIndex + 1;
            if (previousIndex >= 0 && this.frameHistoryEntries[previousIndex] === normalized) {
                this.frameHistoryIndex = previousIndex;
            } else if (nextIndex < this.frameHistoryEntries.length && this.frameHistoryEntries[nextIndex] === normalized) {
                this.frameHistoryIndex = nextIndex;
            } else if (this.isFrameHistoryReplaceSource(source)) {
                this.replaceFrameHistoryCurrent(normalized);
            } else {
                this.pushFrameHistoryEntry(normalized);
            }
        }

        this.setCurrentUrl(normalized, source, true);
        this.frameActionBusy = false;
        return changed;
    }

    public beginFrameNavigation(url: string, type: string = 'new', targetIndex: number = -1) {
        const normalized = this.normalizeFrameHistoryUrl(url);
        if (!normalized) return false;
        this.frameHistorySeq++;
        this.frameHistoryPending = { type, targetUrl: normalized, targetIndex, seq: this.frameHistorySeq };
        this.frameActionBusy = true;
        this.frameUrl = normalized;
        this.remoteAddress = normalized;
        this.resetSdkStatus();
        this.clearFrameScreenshotCache('capture-pending');
        return true;
    }

    public pendingFrameFallbackUrl() {
        return this.normalizeFrameHistoryUrl(
            this.frameHistoryPending && this.frameHistoryPending.targetUrl
                ? this.frameHistoryPending.targetUrl
                : (this.frameUrl || this.currentUrl)
        );
    }

    public async navigateFrameHistory(direction: string) {
        if (this.frameActionBusy) return;
        const isBack = direction === 'back';
        const targetIndex = this.frameHistoryIndex + (isBack ? -1 : 1);
        if (targetIndex < 0 || targetIndex >= this.frameHistoryEntries.length) return;
        const target = this.frameHistoryEntries[targetIndex];
        const shouldForceFrameLoad = this.normalizeFrameHistoryUrl(this.frameUrl) === target;
        if (!this.beginFrameNavigation(target, 'traverse', targetIndex)) return;
        await this.service.render();
        if (shouldForceFrameLoad) this.applyFrameUrlToIframe(target);
        this.finishPendingFrameNavigationLater(this.frameHistorySeq);
    }

    public finishPendingFrameNavigationLater(seq: number = this.frameHistorySeq, delay: number = 1400) {
        window.setTimeout(async () => {
            if (seq !== this.frameHistorySeq) return;
            if (this.frameHistoryPending) {
                this.commitFrameHistoryNavigation(this.pendingFrameFallbackUrl(), this.frameHistoryPending.type === 'traverse' ? 'iframe-history-fallback' : 'iframe-load-fallback');
            } else {
                this.frameActionBusy = false;
            }
            await this.service.render();
        }, delay);
    }

    public applyFrameUrlToIframe(url: string) {
        const target = this.normalizeFrameHistoryUrl(url);
        const iframe = this.reviewFrame();
        if (!target || !iframe) return;
        try {
            iframe.src = target;
        } catch (e) { }
    }

    public setFrameTitle(title: any, source: string = '') {
        const normalized = String(title || '').trim();
        const changed = this.frameTitle !== normalized;
        this.frameTitle = normalized;
        return changed;
    }

    public displayFrameTitle() {
        return this.frameTitle || (this.project && this.project.name) || '-';
    }

    public displayFrameUrl() {
        return this.currentUrl || this.frameUrl || this.projectPreviewServerUrl(this.previewLinkMode) || '';
    }

    public recordNavigation(url: string, source: string) {
        if (!url) return;
        const last = this.navigationLog[this.navigationLog.length - 1];
        if (last && last.url === url && last.source === source) return;
        this.navigationLog.push({ url, source, at: new Date().toISOString() });
        if (this.navigationLog.length > this.logBufferLimits.navigation) {
            this.navigationLog = this.navigationLog.slice(this.navigationLog.length - this.logBufferLimits.navigation);
        }
    }

    public recordInput(entry: any) {
        if (!entry) return;
        this.inputLog.push({
            field: String(entry.field || 'unknown').slice(0, 180),
            value_length: Number(entry.value_length) || 0,
            masked: true,
            input_type: String(entry.input_type || '').slice(0, 60),
            at: entry.at || new Date().toISOString(),
            source: String(entry.source || 'postMessage').slice(0, 80)
        });
        if (this.inputLog.length > this.logBufferLimits.input) {
            this.inputLog = this.inputLog.slice(this.inputLog.length - this.logBufferLimits.input);
        }
    }

    public recordNetwork(entry: any) {
        if (!entry || !entry.url) return;
        const item: any = {
            event: String(entry.event || 'network').slice(0, 80),
            source: String(entry.source || 'sdk').slice(0, 80),
            method: String(entry.method || 'GET').slice(0, 20),
            url: String(entry.url || '').slice(0, 1500),
            status: Number(entry.status) || 0,
            status_text: String(entry.status_text || '').slice(0, 160),
            error: String(entry.error || '').slice(0, 300),
            resource_type: String(entry.resource_type || '').slice(0, 80),
            frame_url: String(entry.frame_url || this.currentUrl || this.frameUrl || '').slice(0, 1500),
            duration_ms: Number(entry.duration_ms) || 0,
            transfer_size: Number(entry.transfer_size) || 0,
            encoded_body_size: Number(entry.encoded_body_size) || 0,
            decoded_body_size: Number(entry.decoded_body_size) || 0,
            from_cache: !!entry.from_cache,
            at: entry.at || new Date().toISOString()
        };
        const exists = this.networkLog.slice(-40).some((log) => {
            return log.event === item.event
                && log.method === item.method
                && log.url === item.url
                && log.status === item.status
                && log.at === item.at;
        });
        if (exists) return;
        this.networkLog.push(item);
        if (this.networkLog.length > this.logBufferLimits.network) {
            this.networkLog = this.networkLog.slice(this.networkLog.length - this.logBufferLimits.network);
        }
    }

    public recordConsole(entry: any) {
        if (!entry) return;
        const level = String(entry.level || entry.type || 'log').toLowerCase().slice(0, 40);
        const item: any = {
            level: level || 'log',
            type: String(entry.type || level || 'log').slice(0, 60),
            text: String(entry.text || '').slice(0, 1800),
            source: String(entry.source || 'sdk-console').slice(0, 120),
            url: String(entry.url || this.currentUrl || this.frameUrl || '').slice(0, 1500),
            line: Number(entry.line) || 0,
            column: Number(entry.column) || 0,
            stack: String(entry.stack || '').slice(0, 2000),
            at: entry.at || new Date().toISOString()
        };
        if (!item.text && !item.stack) return;
        const key = [item.level, item.type, item.text, item.url, item.line, item.column, item.at].join('|');
        const exists = this.consoleLog.slice(-30).some((log) => {
            return [log.level, log.type, log.text, log.url, log.line, log.column, log.at].join('|') === key;
        });
        if (exists) return;
        this.consoleLog.push(item);
        if (this.consoleLog.length > this.logBufferLimits.console) {
            this.consoleLog = this.consoleLog.slice(this.consoleLog.length - this.logBufferLimits.console);
        }
    }

    public combinedNavigationLog() {
        const entries = [...this.navigationLog, ...this.remoteNavigationLog];
        return entries.slice(-this.logBufferLimits.navigation);
    }

    public combinedNetworkLog() {
        const entries = [...this.networkLog, ...this.remoteNetworkLog];
        return entries.slice(-this.logBufferLimits.network);
    }

    public combinedConsoleLog() {
        const entries = [...this.consoleLog, ...this.remoteConsoleLog];
        return entries.slice(-this.logBufferLimits.console);
    }

    public recentLogEntries(entries: any[], limit: number) {
        const list = Array.isArray(entries) ? entries : [];
        const size = Math.max(Number(limit) || 0, 0);
        if (!size) return [];
        return list.slice(-size);
    }

    public networkEntryKey(entry: any) {
        return [
            entry && entry.event || '',
            entry && entry.method || '',
            entry && entry.url || '',
            entry && entry.status || '',
            entry && entry.at || ''
        ].join('|');
    }

    public uniqueNetworkEntries(entries: any[]) {
        const seen: any = {};
        const result: any[] = [];
        for (const entry of entries || []) {
            const key = this.networkEntryKey(entry);
            if (seen[key]) continue;
            seen[key] = true;
            result.push(entry);
        }
        return result;
    }

    public isImportantNetworkEntry(entry: any) {
        const event = String(entry && entry.event || '').toLowerCase();
        const source = String(entry && entry.source || '').toLowerCase();
        const type = String(entry && entry.resource_type || '').toLowerCase();
        const method = String(entry && entry.method || 'GET').toUpperCase();
        const status = Number(entry && entry.status) || 0;
        if (entry && entry.error) return true;
        if (status >= 400) return true;
        if (method !== 'GET') return true;
        if (event.indexOf('fetch') >= 0 || event.indexOf('xhr') >= 0) return true;
        if (source.indexOf('fetch') >= 0 || source.indexOf('xhr') >= 0) return true;
        if (type === 'fetch' || type === 'xmlhttprequest' || type === 'document') return true;
        return false;
    }

    public evidenceNavigationLog() {
        return this.recentLogEntries(this.combinedNavigationLog(), this.evidenceLimits.navigation);
    }

    public evidenceInputLog() {
        return this.recentLogEntries(this.inputLog, this.evidenceLimits.input);
    }

    public evidenceNetworkLog() {
        const pool = this.uniqueNetworkEntries(this.combinedNetworkLog()).slice(-this.logBufferLimits.network);
        const important = pool.filter((entry) => this.isImportantNetworkEntry(entry)).slice(-this.evidenceLimits.networkImportant);
        const selected: any = {};
        for (const entry of important) selected[this.networkEntryKey(entry)] = true;
        const remainingLimit = Math.max(this.evidenceLimits.network - important.length, 0);
        const remaining = remainingLimit
            ? pool.filter((entry) => !selected[this.networkEntryKey(entry)]).slice(-remainingLimit)
            : [];
        for (const entry of remaining) selected[this.networkEntryKey(entry)] = true;
        return pool.filter((entry) => selected[this.networkEntryKey(entry)]).slice(-this.evidenceLimits.network);
    }

    public evidenceConsoleLog() {
        return this.recentLogEntries(this.combinedConsoleLog(), this.evidenceLimits.console);
    }

    public evidenceFingerprintLog() {
        return this.recentLogEntries(this.fingerprintLog, this.evidenceLimits.fingerprint).map((item) => {
            const copy = Object.assign({}, item);
            delete copy._key;
            return copy;
        });
    }

    public evidencePreviewCount(kind: string) {
        if (kind === 'navigation') return this.evidenceNavigationLog().length;
        if (kind === 'input') return this.evidenceInputLog().length;
        if (kind === 'network') return this.evidenceNetworkLog().length;
        if (kind === 'console') return this.evidenceConsoleLog().length;
        if (kind === 'fingerprint') return this.evidenceFingerprintLog().length;
        return 0;
    }

    public collectFingerprintLog(source: string) {
        this.recordFingerprint(this.browserFingerprint(source));
        this.recordFingerprint(this.frameFingerprint(source, false, 'not-read-yet'));
    }

    public recordFingerprint(entry: any) {
        if (!entry) return;
        const item = Object.assign({ at: new Date().toISOString() }, entry);
        const key = [
            item.type || '',
            item.source || '',
            item.target_url || '',
            item.readable === true ? 'readable' : item.reason || '',
            item.fingerprint_hash || ''
        ].join('|');
        const exists = this.fingerprintLog.some((log) => log._key === key);
        if (!exists) this.fingerprintLog.push(Object.assign({ _key: key }, item));
        if (this.fingerprintLog.length > this.logBufferLimits.fingerprint) {
            this.fingerprintLog = this.fingerprintLog.slice(this.fingerprintLog.length - this.logBufferLimits.fingerprint);
        }
    }

    public browserFingerprint(source: string) {
        const nav: any = navigator;
        const screenInfo = {
            width: window.screen ? window.screen.width : 0,
            height: window.screen ? window.screen.height : 0,
            availWidth: window.screen ? window.screen.availWidth : 0,
            availHeight: window.screen ? window.screen.availHeight : 0,
            colorDepth: window.screen ? window.screen.colorDepth : 0,
            pixelDepth: window.screen ? window.screen.pixelDepth : 0,
            devicePixelRatio: window.devicePixelRatio || 1
        };
        const viewportInfo = {
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            outerWidth: window.outerWidth,
            outerHeight: window.outerHeight,
            documentHidden: document.hidden,
            visibilityState: document.visibilityState
        };
        const parentPage = {
            url: window.location.href,
            origin: window.location.origin,
            pathname: window.location.pathname,
            referrer: document.referrer || '',
            title: document.title || '',
            historyLength: window.history ? window.history.length : 0
        };
        const connection: any = nav.connection || nav.mozConnection || nav.webkitConnection || {};
        const storage = {
            localStorage: this.storageAvailable('localStorage'),
            sessionStorage: this.storageAvailable('sessionStorage'),
            indexedDB: typeof indexedDB !== 'undefined',
            cookieEnabled: !!nav.cookieEnabled
        };
        const webgl = this.webglFingerprint();
        const seed = JSON.stringify({
            userAgent: nav.userAgent || '',
            platform: nav.platform || '',
            language: nav.language || '',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
            screen: screenInfo,
            webgl
        });
        return {
            type: 'browser-fingerprint',
            source,
            summary: `${nav.platform || 'unknown'} / ${nav.language || 'unknown'} / ${screenInfo.width}x${screenInfo.height}`,
            fingerprint_hash: this.simpleHash(seed),
            user_agent: nav.userAgent || '',
            platform: nav.platform || '',
            vendor: nav.vendor || '',
            languages: (nav.languages || [nav.language || '']).join(','),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
            timezone_offset: String(new Date().getTimezoneOffset()),
            screen: screenInfo,
            viewport: viewportInfo,
            parent_page: parentPage,
            connection: {
                online: nav.onLine,
                effectiveType: connection.effectiveType || '',
                downlink: connection.downlink || 0,
                rtt: connection.rtt || 0,
                saveData: !!connection.saveData
            },
            storage,
            webgl,
            security: {
                isSecureContext: window.isSecureContext,
                crossOriginIsolated: (window as any).crossOriginIsolated === true,
                cookiesEnabled: !!nav.cookieEnabled
            }
        };
    }

    public frameFingerprint(source: string, readable: boolean, reason: string = '') {
        const iframe = this.reviewFrame();
        const target = this.currentUrl || (this.project && this.project.link_url) || '';
        let parsed: any = {};
        try {
            parsed = new URL(target);
        } catch (e) { }
        const rect = iframe ? iframe.getBoundingClientRect() : null;
        return {
            type: 'iframe-fingerprint',
            source,
            summary: `${readable ? 'readable' : 'restricted'} / ${parsed.origin || target}`,
            target_url: target,
            target_origin: parsed.origin || '',
            target_protocol: parsed.protocol || '',
            target_host: parsed.host || '',
            readable,
            reason,
            iframe: {
                src: iframe ? iframe.src || '' : '',
                sandbox: iframe ? iframe.getAttribute('sandbox') || '' : '',
                referrerPolicy: iframe ? iframe.referrerPolicy || '' : '',
                loading: iframe ? iframe.loading || '' : '',
                width: iframe ? iframe.width || this.viewport.width : this.viewport.width,
                height: iframe ? iframe.height || this.viewport.height : this.viewport.height,
                displayedWidth: rect ? Math.round(rect.width) : 0,
                displayedHeight: rect ? Math.round(rect.height) : 0
            },
            review_viewport: {
                width: this.viewport.width,
                height: this.viewport.height,
                scale: this.scale,
                scaleMode: this.scaleMode
            }
        };
    }

    public webglFingerprint() {
        try {
            const canvas = document.createElement('canvas');
            const gl: any = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
            if (!gl) return { supported: false };
            const debug = gl.getExtension('WEBGL_debug_renderer_info');
            return {
                supported: true,
                vendor: debug ? gl.getParameter(debug.UNMASKED_VENDOR_WEBGL) : gl.getParameter(gl.VENDOR),
                renderer: debug ? gl.getParameter(debug.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER),
                version: gl.getParameter(gl.VERSION),
                shadingLanguageVersion: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
                extensionCount: (gl.getSupportedExtensions() || []).length
            };
        } catch (e) {
            return { supported: false };
        }
    }

    public storageAvailable(type: string) {
        try {
            const storage = (window as any)[type];
            const key = '__reviewops_probe__';
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        } catch (e) {
            return false;
        }
    }

    public simpleHash(value: string) {
        let hash = 0;
        for (let i = 0; i < value.length; i++) {
            hash = ((hash << 5) - hash) + value.charCodeAt(i);
            hash |= 0;
        }
        return Math.abs(hash).toString(16);
    }

    public fingerprintSummary(item: any) {
        if (!item) return '';
        return item.summary || item.target_origin || item.fingerprint_hash || item.reason || item.type || '';
    }

    public isRenderableImageDataUrl(dataUrl: string) {
        const value = String(dataUrl || '');
        if (!/^data:image\//i.test(value)) return Promise.resolve(false);
        return new Promise<boolean>((resolve) => {
            const image = new Image();
            let settled = false;
            const finish = (ok: boolean) => {
                if (settled) return;
                settled = true;
                window.clearTimeout(timer);
                resolve(ok);
            };
            const timer = window.setTimeout(() => finish(false), 1600);
            image.onload = () => finish(Boolean(image.naturalWidth || image.width) && Boolean(image.naturalHeight || image.height));
            image.onerror = () => finish(false);
            image.src = value;
        });
    }

    public async firstRenderableImageDataUrl(candidates: string[]) {
        for (const candidate of candidates) {
            if (await this.isRenderableImageDataUrl(candidate)) return candidate;
        }
        return '';
    }

    public canvasLooksVisuallyBlank(canvas: HTMLCanvasElement) {
        if (!canvas || !canvas.width || !canvas.height) return true;
        try {
            const sample = document.createElement('canvas');
            sample.width = 64;
            sample.height = 64;
            const context = sample.getContext('2d');
            if (!context) return false;
            context.drawImage(canvas, 0, 0, sample.width, sample.height);
            const pixels = context.getImageData(0, 0, sample.width, sample.height).data;
            const total = sample.width * sample.height;
            let visible = 0;
            let nonWhite = 0;
            let varied = 0;
            let minR = 255;
            let minG = 255;
            let minB = 255;
            let maxR = 0;
            let maxG = 0;
            let maxB = 0;
            let baseR = -1;
            let baseG = -1;
            let baseB = -1;
            for (let index = 0; index < pixels.length; index += 4) {
                const alpha = pixels[index + 3];
                if (alpha <= 8) continue;
                const red = pixels[index];
                const green = pixels[index + 1];
                const blue = pixels[index + 2];
                visible++;
                if (baseR < 0) {
                    baseR = red;
                    baseG = green;
                    baseB = blue;
                }
                minR = Math.min(minR, red);
                minG = Math.min(minG, green);
                minB = Math.min(minB, blue);
                maxR = Math.max(maxR, red);
                maxG = Math.max(maxG, green);
                maxB = Math.max(maxB, blue);
                if (red < 245 || green < 245 || blue < 245) nonWhite++;
                if (Math.abs(red - baseR) + Math.abs(green - baseG) + Math.abs(blue - baseB) > 36) varied++;
            }
            if (!visible || visible / total < 0.05) return true;
            const nonWhiteRatio = nonWhite / visible;
            const variedRatio = varied / visible;
            const colorRange = (maxR - minR) + (maxG - minG) + (maxB - minB);
            return nonWhiteRatio < 0.006 && variedRatio < 0.006 && colorRange < 42;
        } catch (e) {
            return false;
        }
    }

    public imageDataUrlLooksVisuallyBlank(dataUrl: string) {
        const value = String(dataUrl || '');
        if (!/^data:image\//i.test(value)) return Promise.resolve(true);
        return new Promise<boolean>((resolve) => {
            const image = new Image();
            let settled = false;
            const finish = (ok: boolean) => {
                if (settled) return;
                settled = true;
                window.clearTimeout(timer);
                resolve(ok);
            };
            const timer = window.setTimeout(() => finish(false), 1800);
            image.onload = () => {
                window.clearTimeout(timer);
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.max(image.naturalWidth || image.width || 1, 1);
                    canvas.height = Math.max(image.naturalHeight || image.height || 1, 1);
                    const context = canvas.getContext('2d');
                    if (!context) {
                        finish(false);
                        return;
                    }
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    finish(this.canvasLooksVisuallyBlank(canvas));
                } catch (e) {
                    finish(false);
                }
            };
            image.onerror = () => finish(true);
            image.src = value;
        });
    }

    public async isMeaningfulScreenshotDataUrl(dataUrl: string) {
        if (!(await this.isRenderableImageDataUrl(dataUrl))) return false;
        return !(await this.imageDataUrlLooksVisuallyBlank(dataUrl));
    }

    public async firstMeaningfulImageDataUrl(candidates: string[]) {
        for (const candidate of candidates) {
            if (await this.isMeaningfulScreenshotDataUrl(candidate)) return candidate;
        }
        return '';
    }

    public utf8ToBase64(value: string) {
        return window.btoa(encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (_match, hex) => {
            return String.fromCharCode(parseInt(hex, 16));
        }));
    }

    public blobToDataUrl(blob: Blob) {
        return new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => resolve('');
            reader.readAsDataURL(blob);
        });
    }

    public async fetchSnapshotResourceDataUrl(url: string, cache: any = null) {
        const target = String(url || '').trim();
        if (!target || /^data:/i.test(target)) return target;
        let absolute = target;
        try {
            absolute = new URL(target, window.location.href).href;
        } catch (e) { }
        if (cache && Object.prototype.hasOwnProperty.call(cache, absolute)) return cache[absolute];
        let dataUrl = '';
        try {
            const requestUrl = new URL(absolute, window.location.href);
            const sameOrigin = requestUrl.origin === window.location.origin;
            const response = await fetch(absolute, { credentials: sameOrigin ? 'include' : 'omit', mode: 'cors' });
            if (response.ok) dataUrl = await this.blobToDataUrl(await response.blob());
        } catch (e) {
            dataUrl = '';
        }
        if (cache) cache[absolute] = dataUrl;
        return dataUrl;
    }

    public async inlineCssImports(css: string, baseUrl: string, cache: any = null, depth: number = 0) {
        let value = String(css || '');
        if (depth >= 3 || value.indexOf('@import') < 0) return value;
        const pattern = /@import\s+(?:url\(\s*)?['"]?([^'")\s;]+)['"]?\s*\)?[^;]*;/ig;
        const replacements: any = {};
        let match: RegExpExecArray | null = null;
        while ((match = pattern.exec(value)) !== null) {
            const raw = String(match[1] || '').trim();
            if (!raw || replacements[raw] !== undefined) continue;
            try {
                const absolute = new URL(raw, baseUrl).href;
                const response = await fetch(absolute, { credentials: 'omit', mode: 'cors' });
                if (!response.ok) throw new Error('css-import-fetch-failed');
                replacements[raw] = await this.inlineCssResourceUrls(await response.text(), absolute, cache, depth + 1);
            } catch (e) {
                replacements[raw] = '';
            }
        }
        value = value.replace(pattern, (full, raw) => {
            const replacement = replacements[String(raw || '').trim()];
            return replacement ? replacement : '';
        });
        return value;
    }

    public async inlineCssResourceUrls(css: string, baseUrl: string, cache: any = null, depth: number = 0) {
        const value = String(css || '');
        const withImports = await this.inlineCssImports(value, baseUrl, cache, depth);
        const pattern = /url\(\s*(['"]?)(?!data:|blob:|#)([^'")]+)\1\s*\)/ig;
        const replacements: any = {};
        let match: RegExpExecArray | null = null;
        while ((match = pattern.exec(withImports)) !== null) {
            const raw = String(match[2] || '').trim();
            if (!raw || replacements[raw] !== undefined) continue;
            try {
                const absolute = new URL(raw, baseUrl).href;
                replacements[raw] = await this.fetchSnapshotResourceDataUrl(absolute, cache);
            } catch (e) {
                replacements[raw] = '';
            }
        }
        return withImports.replace(pattern, (full, quote, raw) => {
            const dataUrl = replacements[String(raw || '').trim()];
            if (!dataUrl) return full;
            const q = quote || '';
            return `url(${q}${dataUrl}${q})`;
        });
    }

    public async inlineDomSnapshotStyleAttributes(doc: Document, clone: HTMLElement, cache: any = null) {
        const baseUrl = doc.location && doc.location.href ? doc.location.href : this.currentUrl || window.location.href;
        const nodes = [clone].concat(Array.from(clone.querySelectorAll('[style]')) as HTMLElement[]);
        for (let index = 0; index < nodes.length; index++) {
            const node = nodes[index] as HTMLElement;
            const style = node && node.getAttribute ? String(node.getAttribute('style') || '') : '';
            if (!style || style.indexOf('url(') < 0) continue;
            node.setAttribute('style', await this.inlineCssResourceUrls(style, baseUrl, cache));
        }
    }

    public async inlineDomSnapshotResources(doc: Document, clone: HTMLElement, cache: any = null) {
        let inlined = 0;
        let skipped = 0;
        const baseUrl = doc.location && doc.location.href ? doc.location.href : this.currentUrl || window.location.href;
        const resourceCache = cache || {};

        const originalImages = Array.from(doc.querySelectorAll('img')) as HTMLImageElement[];
        const cloneImages = Array.from(clone.querySelectorAll('img')) as HTMLImageElement[];
        for (let index = 0; index < originalImages.length; index++) {
            const source = originalImages[index];
            const target = cloneImages[index];
            if (!source || !target || !source.src) continue;
            const dataUrl = await this.fetchSnapshotResourceDataUrl(source.src, resourceCache);
            if (dataUrl) {
                target.setAttribute('src', dataUrl);
                target.removeAttribute('srcset');
                inlined++;
            } else {
                skipped++;
            }
        }

        const cloneSources = Array.from(clone.querySelectorAll('source')) as HTMLElement[];
        cloneSources.forEach((source) => source.removeAttribute('srcset'));

        const originalLinks = Array.from(doc.querySelectorAll('link[rel~="stylesheet"]')) as HTMLLinkElement[];
        const cloneLinks = Array.from(clone.querySelectorAll('link[rel~="stylesheet"]')) as HTMLLinkElement[];
        for (let index = 0; index < originalLinks.length; index++) {
            const source = originalLinks[index];
            const target = cloneLinks[index];
            if (!source || !target || !source.href) continue;
            try {
                const response = await fetch(source.href, { credentials: 'same-origin', mode: 'cors' });
                if (!response.ok) throw new Error('stylesheet-fetch-failed');
                const css = await this.inlineCssResourceUrls(await response.text(), source.href, resourceCache);
                const style = clone.ownerDocument.createElement('style');
                style.textContent = css;
                target.parentNode && target.parentNode.replaceChild(style, target);
                inlined++;
            } catch (e) {
                skipped++;
                target.parentNode && target.parentNode.removeChild(target);
            }
        }

        const originalStyles = Array.from(doc.querySelectorAll('style')) as HTMLStyleElement[];
        const cloneStyles = Array.from(clone.querySelectorAll('style')) as HTMLStyleElement[];
        for (let index = 0; index < originalStyles.length; index++) {
            const source = originalStyles[index];
            const target = cloneStyles[index];
            if (!source || !target || !source.textContent) continue;
            target.textContent = await this.inlineCssResourceUrls(source.textContent, baseUrl, resourceCache);
        }

        await this.inlineDomSnapshotStyleAttributes(doc, clone, resourceCache);

        this.screenshotInlinedResources = inlined;
        this.screenshotSkippedResources = skipped;
    }

    public copyDomSnapshotFormState(sourceRoot: Element, cloneRoot: Element) {
        const sourceFields = Array.from(sourceRoot.querySelectorAll('input, textarea, select')) as any[];
        const cloneFields = Array.from(cloneRoot.querySelectorAll('input, textarea, select')) as any[];
        for (let index = 0; index < sourceFields.length; index++) {
            const source = sourceFields[index];
            const clone = cloneFields[index];
            if (!source || !clone) continue;
            const tag = String(source.tagName || '').toLowerCase();
            const type = String(source.getAttribute('type') || '').toLowerCase();
            if (tag === 'textarea') {
                clone.textContent = source.value || '';
                continue;
            }
            if (tag === 'select') {
                const sourceOptions = Array.from(source.querySelectorAll('option')) as any[];
                const cloneOptions = Array.from(clone.querySelectorAll('option')) as any[];
                for (let optionIndex = 0; optionIndex < sourceOptions.length; optionIndex++) {
                    if (!cloneOptions[optionIndex]) continue;
                    if (sourceOptions[optionIndex].selected) cloneOptions[optionIndex].setAttribute('selected', 'selected');
                    else cloneOptions[optionIndex].removeAttribute('selected');
                }
                continue;
            }
            if (type === 'checkbox' || type === 'radio') {
                if (source.checked) clone.setAttribute('checked', 'checked');
                else clone.removeAttribute('checked');
            }
            if (typeof source.value === 'string') clone.setAttribute('value', source.value);
        }
    }

    public inlineDomSnapshotComputedStyles(doc: Document, sourceRoot: Element, cloneRoot: Element) {
        const win: any = doc.defaultView || window;
        if (!win || !win.getComputedStyle) return;
        const sourceNodes = [sourceRoot].concat(Array.from(sourceRoot.querySelectorAll('*')));
        const cloneNodes = [cloneRoot].concat(Array.from(cloneRoot.querySelectorAll('*')));
        for (let index = 0; index < sourceNodes.length; index++) {
            const source = sourceNodes[index] as Element;
            const clone = cloneNodes[index] as any;
            if (!source || !clone || !clone.style || !clone.style.setProperty) continue;
            try {
                const computed = win.getComputedStyle(source);
                for (let styleIndex = 0; styleIndex < computed.length; styleIndex++) {
                    const name = computed[styleIndex];
                    const value = computed.getPropertyValue(name);
                    if (!name || !value) continue;
                    clone.style.setProperty(name, value, computed.getPropertyPriority(name));
                }
                this.freezeDomSnapshotElementMotion(clone);
            } catch (e) { }
        }
    }

    public freezeDomSnapshotElementMotion(element: any) {
        if (!element || !element.style || !element.style.setProperty) return;
        element.style.setProperty('animation', 'none', 'important');
        element.style.setProperty('-webkit-animation', 'none', 'important');
        element.style.setProperty('transition', 'none', 'important');
        element.style.setProperty('-webkit-transition', 'none', 'important');
        element.style.setProperty('scroll-behavior', 'auto', 'important');
        element.style.setProperty('caret-color', 'transparent', 'important');
    }

    public addDomSnapshotMotionFreezeStyle(clone: HTMLElement) {
        try {
            const style = clone.ownerDocument.createElement('style');
            style.setAttribute('data-reviewops-snapshot-freeze', '1');
            style.textContent = '*,*::before,*::after{animation:none!important;-webkit-animation:none!important;transition:none!important;-webkit-transition:none!important;scroll-behavior:auto!important;caret-color:transparent!important;}';
            const head = clone.querySelector('head');
            if (head) head.insertBefore(style, head.firstChild);
            else clone.insertBefore(style, clone.firstChild);
        } catch (e) { }
    }

    public hasDomSnapshotScrollableOverflow(source: any, scrollLeft: number, scrollTop: number) {
        const overflowX = Number(source.scrollWidth || 0) > Number(source.clientWidth || 0) + 1;
        const overflowY = Number(source.scrollHeight || 0) > Number(source.clientHeight || 0) + 1;
        return !!((scrollLeft && overflowX) || (scrollTop && overflowY));
    }

    public applyDomSnapshotScrollOffset(clone: HTMLElement, scrollLeft: number, scrollTop: number) {
        if (!clone || !clone.style) return;
        clone.style.setProperty('overflow', 'hidden', 'important');
        clone.style.setProperty('scroll-behavior', 'auto', 'important');
        const children = Array.from(clone.children || []) as HTMLElement[];
        for (const child of children) {
            if (!child || !child.style) continue;
            const existing = child.style.getPropertyValue('transform');
            let next = `translate(${-scrollLeft}px, ${-scrollTop}px)`;
            if (existing && existing !== 'none') next += ` ${existing}`;
            child.style.setProperty('transform', next, 'important');
            child.style.setProperty('transform-origin', 'top left', 'important');
        }
    }

    public applyDomSnapshotScrollPositions(doc: Document, sourceRoot: Element, cloneRoot: Element, rootScrollX: number = 0, rootScrollY: number = 0) {
        const sourceNodes = [sourceRoot].concat(Array.from(sourceRoot.querySelectorAll('*')));
        const cloneNodes = [cloneRoot].concat(Array.from(cloneRoot.querySelectorAll('*')));
        const body = doc.body;
        for (let index = 0; index < sourceNodes.length; index++) {
            const source: any = sourceNodes[index];
            const clone = cloneNodes[index] as HTMLElement;
            if (!source || !clone || source === sourceRoot) continue;
            const scrollLeft = Math.round(Number(source.scrollLeft || 0));
            const scrollTop = Math.round(Number(source.scrollTop || 0));
            if (!scrollLeft && !scrollTop) continue;
            if (body && source === body && Math.abs(scrollLeft - rootScrollX) < 1 && Math.abs(scrollTop - rootScrollY) < 1) continue;
            if (!this.hasDomSnapshotScrollableOverflow(source, scrollLeft, scrollTop)) continue;
            this.applyDomSnapshotScrollOffset(clone, scrollLeft, scrollTop);
        }
    }

    public firstNonZeroSnapshotScrollValue(values: any[]) {
        let fallback = 0;
        for (const item of values || []) {
            const value = Number(item || 0);
            if (!Number.isFinite(value)) continue;
            if (!fallback) fallback = value;
            if (Math.abs(value) > 0.5) return value;
        }
        return fallback || 0;
    }

    public domSnapshotRootScrollOffset(doc: Document) {
        const win: any = doc.defaultView || window;
        const root: any = doc.documentElement || {};
        const body: any = doc.body || {};
        const scrolling: any = doc.scrollingElement || root;
        return {
            x: this.firstNonZeroSnapshotScrollValue([
                win && win.scrollX,
                win && win.pageXOffset,
                scrolling.scrollLeft,
                root.scrollLeft,
                body.scrollLeft
            ]),
            y: this.firstNonZeroSnapshotScrollValue([
                win && win.scrollY,
                win && win.pageYOffset,
                scrolling.scrollTop,
                root.scrollTop,
                body.scrollTop
            ])
        };
    }

    public async domSnapshotDataUrl(doc: Document, width: number, height: number, outputScale: number = 1) {
        // Keep SVG viewport units at the iframe size; PDF high-res scaling happens in the canvas step.
        void outputScale;
        const logicalWidth = Math.max(Math.round(Number(width) || 1), 1);
        const logicalHeight = Math.max(Math.round(Number(height) || 1), 1);
        const sourceRoot = doc.documentElement as HTMLElement;
        const clone = sourceRoot.cloneNode(true) as HTMLElement;
        const rootScroll = this.domSnapshotRootScrollOffset(doc);
        const scrollX = rootScroll.x;
        const scrollY = rootScroll.y;
        const resourceCache: any = {};
        await this.waitForHtmlDocumentAssets(doc, 3000);
        this.copyDomSnapshotFormState(sourceRoot, clone);
        this.inlineDomSnapshotComputedStyles(doc, sourceRoot, clone);
        this.applyDomSnapshotScrollPositions(doc, sourceRoot, clone, scrollX, scrollY);
        clone.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
        const unsafeNodes = clone.querySelectorAll('script, noscript, link[rel="preload"], link[rel="modulepreload"]');
        unsafeNodes.forEach((node) => node.parentNode && node.parentNode.removeChild(node));
        await this.inlineDomSnapshotResources(doc, clone, resourceCache);
        this.addDomSnapshotMotionFreezeStyle(clone);
        const snapshotWidth = Math.max(Number(sourceRoot.scrollWidth) || logicalWidth, logicalWidth);
        const snapshotHeight = Math.max(Number(sourceRoot.scrollHeight) || logicalHeight, logicalHeight);
        clone.style.width = `${snapshotWidth}px`;
        clone.style.minWidth = `${logicalWidth}px`;
        clone.style.minHeight = `${snapshotHeight}px`;
        clone.style.margin = '0';
        clone.style.transform = `translate(${-scrollX}px, ${-scrollY}px)`;
        clone.style.transformOrigin = 'top left';
        const html = new XMLSerializer().serializeToString(clone);
        const svg = [
            `<svg xmlns="http://www.w3.org/2000/svg" width="${logicalWidth}" height="${logicalHeight}" viewBox="0 0 ${logicalWidth} ${logicalHeight}">`,
            `<foreignObject x="0" y="0" width="${logicalWidth}" height="${logicalHeight}">`,
            html,
            '</foreignObject>',
            '</svg>'
        ].join('');
        return `data:image/svg+xml;base64,${this.utf8ToBase64(svg)}`;
    }

    public renderSnapshotDataUrlToPng(dataUrl: string, width: number, height: number) {
        return new Promise<string>((resolve) => {
            if (!dataUrl) {
                resolve('');
                return;
            }
            const image = new Image();
            const timer = window.setTimeout(() => resolve(''), 1800);
            image.onload = () => {
                window.clearTimeout(timer);
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.max(Math.round(Number(width) || image.naturalWidth || image.width || 1), 1);
                    canvas.height = Math.max(Math.round(Number(height) || image.naturalHeight || image.height || 1), 1);
                    const context = canvas.getContext('2d');
                    if (!context) {
                        resolve('');
                        return;
                    }
                    context.fillStyle = '#ffffff';
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    resolve(canvas.toDataURL('image/png'));
                } catch (e) {
                    resolve('');
                }
            };
            image.onerror = () => {
                window.clearTimeout(timer);
                resolve('');
            };
            image.src = dataUrl;
        });
    }

    public domSnapshotComplexity(doc: Document, width: number, height: number) {
        const root: any = doc && doc.documentElement ? doc.documentElement : {};
        const logicalWidth = Math.max(Math.round(Number(width) || 1), 1);
        const logicalHeight = Math.max(Math.round(Number(height) || 1), 1);
        const scrollWidth = Math.max(Number(root.scrollWidth) || logicalWidth, logicalWidth);
        const scrollHeight = Math.max(Number(root.scrollHeight) || logicalHeight, logicalHeight);
        const viewportArea = Math.max(logicalWidth * logicalHeight, 1);
        const scrollAreaRatio = (scrollWidth * scrollHeight) / viewportArea;
        let nodeCount = 0;
        try {
            nodeCount = root && root.getElementsByTagName ? root.getElementsByTagName('*').length + 1 : 0;
        } catch (e) {
            nodeCount = 0;
        }
        return { nodeCount, scrollWidth, scrollHeight, scrollAreaRatio };
    }

    public domSnapshotBypassReason(doc: Document, width: number, height: number) {
        const complexity = this.domSnapshotComplexity(doc, width, height);
        const logicalHeight = Math.max(Math.round(Number(height) || 1), 1);
        if (complexity.nodeCount > 6000) return 'dom-snapshot-too-many-nodes';
        if (complexity.scrollAreaRatio > 8) return 'dom-snapshot-scroll-area-too-large';
        if (complexity.scrollHeight > logicalHeight * 12) return 'dom-snapshot-scroll-height-too-large';
        return '';
    }

    public async requestSdkScreenshot() {
        if (!this.sdkInstalled) return null;
        const before = this.screenshotDataUrl;
        const beforeFallback = this.screenshotFallbackDataUrl;
        const beforeReceivedAt = this.screenshotReceivedAt;
        const beforeErrorAt = this.screenshotErrorAt;
        const sent = this.postSdkCommand('screenshot', {}, false);
        if (!sent) return null;
        for (let i = 0; i < 20; i++) {
            await this.service.sleep(150);
            if (this.screenshotErrorAt !== beforeErrorAt) return null;
            if (this.screenshotReceivedAt !== beforeReceivedAt) {
                const dataUrl = await this.firstMeaningfulImageDataUrl([
                    this.screenshotDataUrl,
                    this.screenshotFallbackDataUrl
                ]);
                if (!dataUrl) {
                    this.screenshotDataUrl = before;
                    this.screenshotFallbackDataUrl = beforeFallback;
                    this.captureMethod = 'reviewops-sdk-screenshot-unavailable';
                    return null;
                }
                this.screenshotDataUrl = dataUrl;
                return {
                    screenshot_asset_id: this.captureMethod || 'reviewops-sdk-screenshot',
                    screenshot_data_url: dataUrl,
                    capture_method: this.captureMethod || 'reviewops-sdk-screenshot'
                };
            }
        }
        return null;
    }

    public async prepareHtmlFrameForCapture() {
        if (!this.isHtmlProject()) return;
        this.syncHtmlDocumentFrameState('html-capture-sync');
        await this.service.sleep(80);
        this.syncHtmlDocumentFrameState('html-capture-sync-final');
    }

    public async captureFrameSnapshot(captureMode: any = 'browser-partial') {
        const mode = this.normalizeScreenshotCaptureMode(captureMode);
        if (mode === 'browser-partial') {
            await this.prepareHtmlFrameForCapture();
            return await this.captureBrowserDisplay();
        }

        const sdkCapture = this.isHtmlProject() ? null : await this.requestSdkScreenshot();
        if (sdkCapture) return sdkCapture;

        if (!this.isHtmlProject() && this.screenshotDataUrl) {
            const dataUrl = await this.firstMeaningfulImageDataUrl([
                this.screenshotDataUrl,
                this.screenshotFallbackDataUrl
            ]);
            if (!dataUrl) {
                this.screenshotDataUrl = '';
                this.screenshotFallbackDataUrl = '';
                this.captureMethod = 'reviewops-sdk-screenshot-unavailable';
            } else {
                this.screenshotDataUrl = dataUrl;
                return {
                    screenshot_asset_id: this.captureMethod || 'postmessage-screenshot',
                    screenshot_data_url: dataUrl,
                    capture_method: this.captureMethod || 'postmessage-screenshot'
                };
            }
        }

        await this.prepareHtmlFrameForCapture();
        const iframe = this.reviewFrame();
        try {
            const doc = iframe && iframe.contentDocument;
            const win: any = iframe && iframe.contentWindow;
            if (!doc || !doc.documentElement || !win) throw new Error('frame-not-readable');
            const url = win.location && win.location.href;
            if (url) this.currentUrl = url;
            const bypassReason = this.domSnapshotBypassReason(doc, this.viewport.width, this.viewport.height);
            if (bypassReason) throw new Error(bypassReason);
            const snapshotDataUrl = await this.domSnapshotDataUrl(doc, this.viewport.width, this.viewport.height);
            const snapshotTooLarge = this.dataUrlBytes(snapshotDataUrl) > this.domSnapshotInlineMaxBytes;
            const pngDataUrl = await this.renderSnapshotDataUrlToPng(snapshotDataUrl, this.viewport.width, this.viewport.height);
            const fallbackCandidates = pngDataUrl ? [pngDataUrl] : (snapshotTooLarge ? [] : [snapshotDataUrl]);
            const dataUrl = await this.firstMeaningfulImageDataUrl(fallbackCandidates);
            if (!dataUrl && snapshotTooLarge) throw new Error('dom-snapshot-too-large');
            if (!(await this.isMeaningfulScreenshotDataUrl(dataUrl))) throw new Error('dom-snapshot-not-renderable');
            this.screenshotDataUrl = dataUrl;
            this.captureMethod = 'same-origin-dom-snapshot';
            return {
                screenshot_asset_id: 'same-origin-dom-snapshot',
                screenshot_data_url: dataUrl,
                capture_method: 'same-origin-dom-snapshot'
            };
        } catch (e) {
            return await this.captureBrowserDisplay();
        }
    }

    public async captureBrowserDisplay() {
        const nav: any = navigator;
        if (!nav.mediaDevices || !nav.mediaDevices.getDisplayMedia) {
            this.captureMethod = 'browser-capture-unavailable';
            return {
                screenshot_asset_id: 'browser-capture-unavailable',
                screenshot_data_url: '',
                capture_method: 'browser-capture-unavailable'
            };
        }

        let stream: any = null;
        try {
            stream = await this.requestDisplayCaptureStream(nav);
            const elementCropped = await this.cropDisplayStreamToPreview(stream);

            const video = document.createElement('video');
            video.muted = true;
            video.srcObject = stream;
            await new Promise((resolve) => {
                video.onloadedmetadata = async () => {
                    try {
                        await video.play();
                    } catch (e) { }
                    resolve(true);
                };
                setTimeout(() => resolve(true), 1500);
            });
            await this.waitForDisplayVideoFrame(video);

            let dataUrl = await this.captureDisplayFrameDataUrl(video, elementCropped);
            let captureMethod = elementCropped ? 'browser-display-capture-element' : 'browser-display-capture-crop';
            if (!dataUrl && elementCropped && await this.resetDisplayStreamCrop(stream)) {
                await this.waitForDisplayVideoFrame(video);
                dataUrl = await this.captureDisplayFrameDataUrl(video, false);
                captureMethod = 'browser-display-capture-crop';
            }
            if (!dataUrl) throw new Error('browser-capture-blank');
            this.screenshotDataUrl = dataUrl;
            this.captureMethod = captureMethod;
            this.stopCaptureStream(stream);
            return {
                screenshot_asset_id: captureMethod,
                screenshot_data_url: dataUrl,
                capture_method: captureMethod
            };
        } catch (e) {
            this.stopCaptureStream(stream);
            const reason = e && e.message === 'browser-capture-blank' ? 'browser-capture-blank' : 'browser-capture-denied';
            this.captureMethod = reason;
            return {
                screenshot_asset_id: reason,
                screenshot_data_url: '',
                capture_method: reason
            };
        }
    }

    public async waitForDisplayVideoFrame(video: HTMLVideoElement, timeoutMs: number = 2400) {
        const started = Date.now();
        while (Date.now() - started < timeoutMs) {
            if ((video.videoWidth || 0) > 0 && (video.videoHeight || 0) > 0 && video.readyState >= 2) {
                await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
                return true;
            }
            await this.service.sleep(80);
        }
        return (video.videoWidth || 0) > 0 && (video.videoHeight || 0) > 0;
    }

    public displayCaptureFrameCanvas(video: HTMLVideoElement, elementCropped: boolean) {
        const crop = elementCropped ? {
            x: 0,
            y: 0,
            width: Math.max(video.videoWidth || window.innerWidth, 1),
            height: Math.max(video.videoHeight || window.innerHeight, 1)
        } : this.captureCropRect(video);
        const canvas = document.createElement('canvas');
        canvas.width = crop.width;
        canvas.height = crop.height;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('canvas-context-unavailable');
        context.drawImage(video, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        return canvas;
    }

    public async captureDisplayFrameDataUrl(video: HTMLVideoElement, elementCropped: boolean, timeoutMs: number = 2200) {
        const started = Date.now();
        while (Date.now() - started < timeoutMs) {
            const canvas = this.displayCaptureFrameCanvas(video, elementCropped);
            if (!this.canvasLooksVisuallyBlank(canvas)) return canvas.toDataURL('image/png');
            await this.service.sleep(140);
        }
        return '';
    }

    public async resetDisplayStreamCrop(stream: any) {
        try {
            const tracks = stream && stream.getVideoTracks ? stream.getVideoTracks() : [];
            const track = tracks && tracks.length ? tracks[0] : null;
            if (!track || !track.cropTo) return false;
            await track.cropTo(null);
            return true;
        } catch (e) {
            return false;
        }
    }

    public async requestDisplayCaptureStream(nav: any) {
        const preferredOptions: any = {
            video: {
                displaySurface: 'browser',
                cursor: 'never'
            },
            audio: false,
            preferCurrentTab: true,
            selfBrowserSurface: 'include',
            surfaceSwitching: 'exclude',
            monitorTypeSurfaces: 'exclude'
        };
        try {
            return await nav.mediaDevices.getDisplayMedia(preferredOptions);
        } catch (e) {
            return await nav.mediaDevices.getDisplayMedia({
                video: {
                    displaySurface: 'browser'
                },
                audio: false
            });
        }
    }

    public async cropDisplayStreamToPreview(stream: any) {
        try {
            const cropTarget = (window as any).CropTarget;
            const iframe = this.reviewFrame();
            const tracks = stream && stream.getVideoTracks ? stream.getVideoTracks() : [];
            const track = tracks && tracks.length ? tracks[0] : null;
            if (!cropTarget || !cropTarget.fromElement || !iframe || !track || !track.cropTo) return false;

            const target = await cropTarget.fromElement(iframe);
            await track.cropTo(target);
            return true;
        } catch (e) {
            return false;
        }
    }

    public captureCropRect(video: HTMLVideoElement) {
        const videoWidth = Math.max(video.videoWidth || window.innerWidth, 1);
        const videoHeight = Math.max(video.videoHeight || window.innerHeight, 1);
        const iframe = this.reviewFrame();
        if (!iframe) {
            return { x: 0, y: 0, width: videoWidth, height: videoHeight };
        }

        const rect = iframe.getBoundingClientRect();
        const left = Math.max(rect.left, 0);
        const top = Math.max(rect.top, 0);
        const right = Math.min(rect.right, window.innerWidth);
        const bottom = Math.min(rect.bottom, window.innerHeight);
        const visibleWidth = Math.max(right - left, 1);
        const visibleHeight = Math.max(bottom - top, 1);

        const scaleX = videoWidth / Math.max(window.innerWidth, 1);
        const scaleY = videoHeight / Math.max(window.innerHeight, 1);
        const x = Math.min(Math.max(Math.floor(left * scaleX), 0), Math.max(videoWidth - 1, 0));
        const y = Math.min(Math.max(Math.floor(top * scaleY), 0), Math.max(videoHeight - 1, 0));
        const width = Math.max(Math.min(Math.ceil(visibleWidth * scaleX), videoWidth - x), 1);
        const height = Math.max(Math.min(Math.ceil(visibleHeight * scaleY), videoHeight - y), 1);

        if (width < 2 || height < 2) {
            return { x: 0, y: 0, width: videoWidth, height: videoHeight };
        }
        return { x, y, width, height };
    }

    public stopCaptureStream(stream: any) {
        try {
            if (!stream) return;
            for (const track of stream.getTracks()) {
                track.stop();
            }
        } catch (e) { }
    }

    public reviewCreateLogCapture(evidence: any) {
        const source = evidence && typeof evidence === 'object' ? evidence : {};
        const capturedAt = new Date().toISOString();
        const entries = (field: string) => Array.isArray(source[field])
            ? source[field].map((entry: any) => entry && typeof entry === 'object' ? Object.assign({}, entry) : entry)
            : [];
        return {
            label: '리뷰 등록 로그',
            source: 'review-create-log-capture',
            created: capturedAt,
            captured_at: capturedAt,
            document_version_id: source.document_version_id || '',
            document_page: Number(source.document_page) || 0,
            navigation_log: entries('navigation_log'),
            input_log: entries('input_log'),
            network_log: entries('network_log'),
            console_log: entries('console_log'),
            fingerprint_log: entries('fingerprint_log')
        };
    }

    public async buildEvidence() {
        if (this.isDocumentProject()) {
            const version = this.currentDocumentVersion();
            this.updateDocumentCurrentUrl();
            const capture = this.reviewFormIncludesScreenshot()
                ? await this.capturePdfPageSnapshot()
                : this.emptyReviewScreenshotCapture();
            return {
                document_version_id: version && version.id ? version.id : '',
                document_page: Math.max(Number(this.pdfPage) || 1, 1),
                navigation_log: [],
                input_log: [],
                network_log: [],
                console_log: [],
                fingerprint_log: [],
                screenshot_asset_id: capture.screenshot_asset_id,
                screenshot_data_url: capture.screenshot_data_url,
                capture_method: capture.capture_method
            };
        }
        this.collectSameOriginFrameInfo();
        this.collectFingerprintLog('review-submit');
        if (this.sdkInstalled && !this.isHtmlProject()) {
            this.postSdkCommand('fingerprint', {}, false);
            this.postSdkCommand('network-log', {}, false);
            this.postSdkCommand('console-log', {}, false);
            await this.service.sleep(180);
        }
        const capture = this.reviewFormIncludesScreenshot()
            ? await this.captureFrameSnapshot(this.reviewForm.capture_mode)
            : this.emptyReviewScreenshotCapture();
        const evidence: any = {
            document_version_id: '',
            document_page: 0,
            navigation_log: this.evidenceNavigationLog(),
            input_log: this.evidenceInputLog(),
            network_log: this.evidenceNetworkLog(),
            console_log: this.evidenceConsoleLog(),
            fingerprint_log: this.evidenceFingerprintLog(),
            screenshot_asset_id: capture.screenshot_asset_id,
            screenshot_data_url: capture.screenshot_data_url,
            capture_method: capture.capture_method
        };
        evidence.log_captures = [this.reviewCreateLogCapture(evidence)];
        return evidence;
    }

    public captureReviewModalScreenshot = async (_review: any = null, captureMode: any = 'browser-partial') => {
        if (this.isDocumentProject()) {
            return await this.capturePdfPageSnapshot();
        }
        this.collectSameOriginFrameInfo();
        this.collectFingerprintLog('review-modal-capture');
        if (this.sdkInstalled && !this.isHtmlProject()) {
            this.postSdkCommand('fingerprint', {}, false);
            this.postSdkCommand('network-log', {}, false);
            this.postSdkCommand('console-log', {}, false);
            await this.service.sleep(180);
        }
        return await this.captureFrameSnapshot(captureMode);
    };

    public captureReviewModalLogs = async (_review: any = null) => {
        if (this.isDocumentProject()) {
            return {
                document_version_id: this.currentDocumentVersion() && this.currentDocumentVersion().id ? this.currentDocumentVersion().id : '',
                document_page: Math.max(Number(this.pdfPage) || 1, 1),
                navigation_log: [],
                input_log: [],
                network_log: [],
                console_log: [],
                fingerprint_log: [],
                source: 'review-modal-log-capture',
                captured_at: new Date().toISOString()
            };
        }
        this.collectSameOriginFrameInfo();
        this.collectFingerprintLog('review-modal-log-capture');
        if (this.sdkInstalled && !this.isHtmlProject()) {
            this.postSdkCommand('fingerprint', {}, false);
            this.postSdkCommand('network-log', {}, false);
            this.postSdkCommand('console-log', {}, false);
            await this.service.sleep(180);
        }
        return {
            document_version_id: '',
            document_page: 0,
            navigation_log: this.evidenceNavigationLog(),
            input_log: this.evidenceInputLog(),
            network_log: this.evidenceNetworkLog(),
            console_log: this.evidenceConsoleLog(),
            fingerprint_log: this.evidenceFingerprintLog(),
            source: 'review-modal-log-capture',
            captured_at: new Date().toISOString()
        };
    };

    public label(group: string, key: string) {
        const dictionary = this.dictionaries[this.language] || this.dictionaries.ko;
        return (dictionary[group] && dictionary[group][key]) || key;
    }

    public statusLabel(status: string) {
        return this.label('status', status);
    }

    public statusDescription(status: string) {
        return this.label('statusDescription', status);
    }

    public priorityLabel(priority: string) {
        return this.label('priority', priority);
    }

    public categoryLabel(category: string) {
        return this.label('category', category);
    }

    public captureLabel(method: string) {
        return this.label('capture', method || 'not_available');
    }

    public statusBadgeClass(status: string) {
        const base = 'shrink-0 rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (status === 'resolved') return base + 'bg-emerald-50 text-emerald-700';
        if (status === 'closed') return base + 'bg-slate-100 text-slate-700';
        if (status === 'in_review') return base + 'bg-indigo-50 text-indigo-700';
        if (status === 'in_progress') return base + 'bg-amber-50 text-amber-700';
        if (status === 'recheck') return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-rose-50 text-rose-700';
    }

    public codexJobRowStatus(review: any) {
        const status = review && review.codex_job_status;
        return ['running', 'queued'].includes(status) ? status : '';
    }

    public reviewTableRowClass(review: any) {
        const base = 'cursor-pointer border-b border-slate-100 transition-colors ';
        const status = this.codexJobRowStatus(review);
        if (status === 'running') return base + 'bg-emerald-50 hover:bg-emerald-100';
        if (status === 'queued') return base + 'bg-slate-100 hover:bg-slate-200';
        return base + 'hover:bg-slate-50';
    }

    public reviewMobileCardClass(review: any) {
        const base = 'reviewops-mobile-safe-card w-full rounded-md border p-3 text-left shadow-sm transition-colors ';
        const status = this.codexJobRowStatus(review);
        if (status === 'running') return base + 'border-emerald-100 bg-emerald-50 hover:bg-emerald-100';
        if (status === 'queued') return base + 'border-slate-300 bg-slate-100 hover:bg-slate-200';
        return base + 'border-slate-200 bg-white hover:bg-slate-50';
    }

    public codexWorkCountValue(value: any) {
        const count = Number(value || 0);
        if (isNaN(count) || count < 0) return 0;
        return Math.floor(count);
    }

    public codexWorkCount(review: any) {
        return this.codexWorkCountValue(review && review.codex_work_count);
    }

    public codexWorkCountLabel(review: any) {
        return `${this.codexWorkCount(review)}회`;
    }

    public codexWorkCountTitle(review: any) {
        return `에이전트 작업 ${this.codexWorkCount(review)}회`;
    }

    public codexWorkCountBadgeClass(review: any) {
        const base = 'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ';
        if (this.codexWorkCount(review) > 0) return base + 'bg-sky-50 text-sky-700 ring-1 ring-sky-100';
        return base + 'bg-slate-100 text-slate-500 ring-1 ring-slate-200';
    }

    public evidenceEntries(review: any, key: string) {
        const evidence = review && review.evidence ? review.evidence : {};
        return evidence[key] || [];
    }

    public evidenceCount(review: any, key: string) {
        return this.evidenceEntries(review, key).length;
    }

    public latestEvidenceEntry(review: any, key: string) {
        const entries = this.evidenceEntries(review, key);
        return entries.length ? entries[entries.length - 1] : null;
    }

    public lastAccessUrl(review: any) {
        const lastNavigation = this.latestEvidenceEntry(review, 'navigation_log');
        return (lastNavigation && lastNavigation.url) || (review && review.current_url) || '';
    }

    public latestFingerprint(review: any, type: string = '') {
        const entries = this.evidenceEntries(review, 'fingerprint_log');
        for (let i = entries.length - 1; i >= 0; i--) {
            if (!type || entries[i].type === type) return entries[i];
        }
        return null;
    }

    public debugInfoCards(review: any) {
        const sdk = this.latestFingerprint(review, 'reviewops-sdk');
        const browser = this.latestFingerprint(review, 'browser-fingerprint');
        const frame = this.latestFingerprint(review, 'iframe-fingerprint');
        const evidence = review && review.evidence ? review.evidence : {};
        if (this.reviewIsDocument(review)) {
            const version = this.documentEvidenceVersion(review);
            return [
                {
                    title: '문서',
                    rows: [
                        ['프로젝트 종류', this.projectTypeLabel()],
                        ['버전', this.documentVersionDisplayLabel(version)],
                        ['파일', version && version.file_name],
                        ['크기', version && (version.file_size_label || this.networkSizeLabel(version.file_size))],
                        ['페이지', evidence.document_page ? `p.${evidence.document_page}` : 'p.1'],
                        ['캡처', this.captureLabel(evidence.capture_method || 'pdf-viewer')]
                    ]
                }
            ];
        }
        return [
            {
                title: '리뷰',
                rows: [
                    ['요청 링크', review && review.current_url],
                    ['마지막 접속 링크', this.lastAccessUrl(review)],
                    ['화면', review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : ''],
                    ['캡처', this.captureLabel(evidence.capture_method || 'not_available')],
                    ['스크린샷', evidence.screenshot_data_url ? '첨부됨' : '없음']
                ]
            },
            {
                title: 'SDK',
                rows: [
                    ['상태', sdk ? '수집됨' : '없음'],
                    ['버전', sdk && sdk.sdk ? sdk.sdk.version : ''],
                    ['Origin', sdk && sdk.target_origin],
                    ['문서', sdk && sdk.document ? this.compactJson(sdk.document) : ''],
                    ['보안', sdk && sdk.security ? this.compactJson(sdk.security) : '']
                ]
            },
            {
                title: '브라우저',
                rows: [
                    ['플랫폼', browser && browser.platform],
                    ['언어', browser && browser.languages],
                    ['타임존', browser && browser.timezone],
                    ['Viewport', browser && browser.viewport ? this.compactJson(browser.viewport) : ''],
                    ['Storage', browser && browser.storage ? this.compactJson(browser.storage) : '']
                ]
            },
            {
                title: 'iframe',
                rows: [
                    ['읽기 가능', frame ? (frame.readable ? '가능' : '제한') : ''],
                    ['제한 사유', frame && frame.reason],
                    ['Target', frame && (frame.target_url || frame.target_origin)],
                    ['Frame', frame && frame.iframe ? this.compactJson(frame.iframe) : ''],
                    ['Review viewport', frame && frame.review_viewport ? this.compactJson(frame.review_viewport) : '']
                ]
            }
        ];
    }

    public filteredInfoRows(rows: any[]) {
        return (rows || []).filter((row) => row && row[1] !== undefined && row[1] !== null && String(row[1]).trim() !== '');
    }

    public async openReviewDetail(review: any) {
        const hadReviewListSync = !!this.reviewListSyncTimer;
        this.clearReviewListSyncTimer();
        this.clearReviewListAutoRefreshTimer();
        if (hadReviewListSync) this.reviewListSyncPaused = true;
        this.selectedReview = review;
        this.reviewDetailLoading = false;
        this.reviewModalTab = 'info';
        this.reviewLogTab = 'navigation';
        this.editingReview = false;
        this.reviewEditForm = this.reviewEditPayload(review);
        this.cancelActivityEdit();
        this.syncCategoryOptions();
        this.activityForm = this.blankActivityForm(review);
        await this.service.render();
    }

    public async openRouteReviewDetail() {
        const reviewId = this.routeReviewId();
        if (!reviewId || this.autoOpenedReviewId === reviewId) return;
        this.autoOpenedReviewId = reviewId;
        if (this.tab !== 'review') this.tab = 'review';
        const review = this.reviews.find((item) => item && item.id === reviewId) || { id: reviewId };
        await this.openReviewDetail(review);
    }

    public async closeReviewDetail() {
        this.selectedReview = null;
        this.reviewDetailLoading = false;
        this.editingReview = false;
        this.cancelActivityEdit();
        this.closeScreenshotPreview();
        const resumeReviewListSync = this.reviewListSyncPaused;
        this.reviewListSyncPaused = false;
        await this.service.render();
        if (resumeReviewListSync) this.scheduleReviewListSync(0);
        else this.syncCodexReviewStatusSocket(true);
        this.syncReviewListAutoRefresh();
    }

    public isReviewDetailOpen() {
        return !!(this.selectedReview && this.selectedReview.id);
    }

    public reviewEditPayload(review: any) {
        return {
            title: review ? review.title : '',
            body: review ? review.body : '',
            priority: review ? review.priority : 'normal',
            category: review ? review.category : 'ux'
        };
    }

    public activityStatusOptions(review: any = this.selectedReview) {
        const allowed = review && Array.isArray(review.allowed_statuses) ? review.allowed_statuses : [];
        return this.statusOptions.filter((status) => allowed.includes(status));
    }

    public defaultActivityStatus(review: any = this.selectedReview) {
        const options = this.activityStatusOptions(review);
        return options.length ? options[0] : '';
    }

    public blankActivityForm(review: any = null) {
        return {
            message: '',
            status: this.defaultActivityStatus(review),
            attachments: []
        };
    }

    public activityEditPayload(item: any) {
        const attachments = item && Array.isArray(item.attachments)
            ? JSON.parse(JSON.stringify(item.attachments))
            : [];
        return {
            message: item ? item.message : '',
            attachments
        };
    }

    public startActivityEdit(item: any) {
        if (!item || !item.can_edit) return;
        this.activityEditId = item.id || '';
        this.activityEditForm = this.activityEditPayload(item);
    }

    public cancelActivityEdit() {
        this.activityEditId = '';
        this.activityEditForm = { message: '', attachments: [] };
        this.savingActivityEdit = false;
        this.activityEditAttachmentBusy = false;
    }

    public isEditingActivity(item: any) {
        return !!(item && item.id && this.activityEditId === item.id);
    }

    public async setReviewModalTab(tab: string) {
        this.reviewModalTab = tab || 'info';
        if (this.reviewModalTab === 'history') {
            await this.service.render();
            this.scrollActivityHistoryToBottom();
        }
    }

    public scrollActivityHistoryToBottom() {
        window.setTimeout(() => {
            const el = document.getElementById('reviewops-activity-history-scroll');
            if (!el) return;
            el.scrollTop = el.scrollHeight;
        }, 80);
    }

    public workspaceTabClass(tab: string) {
        if (this.reviewModalTab === tab) return 'border-slate-900 text-slate-950';
        return 'border-transparent text-slate-500 hover:text-slate-800';
    }

    public logTabClass(tab: string) {
        if (this.reviewLogTab === tab) return 'bg-slate-900 text-white';
        return 'bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900';
    }

    public consoleLevelBadgeClass(level: string) {
        const base = 'shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold ';
        const value = String(level || '').toLowerCase();
        if (value === 'error' || value === 'assert' || value === 'unhandledrejection') return base + 'bg-rose-50 text-rose-700';
        if (value === 'warn' || value === 'warning') return base + 'bg-amber-50 text-amber-700';
        if (value === 'info') return base + 'bg-sky-50 text-sky-700';
        if (value === 'debug') return base + 'bg-slate-100 text-slate-500';
        return base + 'bg-slate-100 text-slate-700';
    }

    public compactJson(value: any) {
        try {
            return JSON.stringify(value || {});
        } catch (e) {
            return '';
        }
    }

    public networkDurationLabel(item: any) {
        const value = Number(item && item.duration_ms) || 0;
        return value ? `${Math.round(value)}ms` : '-';
    }

    public networkSizeLabel(value: any) {
        const bytes = Number(value) || 0;
        if (!bytes) return '-';
        if (bytes > 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)}MB`;
        if (bytes > 1024) return `${Math.round(bytes / 1024)}KB`;
        return `${bytes}B`;
    }

    public applyUploadSettings(settings: any) {
        if (!settings || typeof settings !== 'object') return;
        this.uploadSettings = settings;
        this.documentUploadAccept = this.uploadPolicyAccept('project_document', this.documentUploadAccept);
        this.reviewAttachmentAccept = this.uploadPolicyAccept('review_attachment', this.reviewAttachmentAccept);
        this.activityAttachmentAccept = this.uploadPolicyAccept('activity_attachment', this.activityAttachmentAccept);
        this.htmlReferenceUploadAccept = this.uploadPolicyAccept('html_reference_file', this.htmlReferenceUploadAccept);
        this.htmlResourceUploadAccept = this.uploadPolicyAccept('html_resource_file', this.htmlResourceUploadAccept);
        this.projectFileUploadAccept = this.uploadPolicyAccept(this.isHtmlProject() ? 'html_project_file' : 'project_file', '');
        this.introUploadAccept = this.uploadPolicyAccept('intro_attachment', this.introUploadAccept);
        this.reviewAttachmentLimits = {
            files: this.uploadPolicyMaxFiles('review_attachment', this.reviewAttachmentLimits.files),
            fileBytes: this.uploadPolicyFileBytes('review_attachment', this.reviewAttachmentLimits.fileBytes),
            totalBytes: this.uploadPolicyTotalBytes('review_attachment', this.reviewAttachmentLimits.totalBytes)
        };
        this.activityAttachmentLimits = {
            files: this.uploadPolicyMaxFiles('activity_attachment', this.activityAttachmentLimits.files),
            fileBytes: this.uploadPolicyFileBytes('activity_attachment', this.activityAttachmentLimits.fileBytes),
            totalBytes: this.uploadPolicyTotalBytes('activity_attachment', this.activityAttachmentLimits.totalBytes)
        };
        this.htmlDocumentUploadLimits = {
            fileBytes: Math.max(
                this.uploadPolicyFileBytes('html_reference_file', this.htmlDocumentUploadLimits.fileBytes),
                this.uploadPolicyFileBytes('html_resource_file', this.htmlDocumentUploadLimits.fileBytes)
            )
        };
        this.introUploadLimits = {
            files: this.uploadPolicyMaxFiles('intro_attachment', this.introUploadLimits.files || 10),
            fileBytes: this.uploadPolicyFileBytes('intro_attachment', this.introUploadLimits.fileBytes),
            totalBytes: this.uploadPolicyTotalBytes('intro_attachment', this.introUploadLimits.totalBytes)
        };
    }

    public uploadPolicy(key: string) {
        const policies = this.uploadSettings && this.uploadSettings.policies ? this.uploadSettings.policies : {};
        return policies && policies[key] ? policies[key] : {};
    }

    public uploadPolicyAccept(key: string, fallback: string = '') {
        const policy = this.uploadPolicy(key);
        if (policy.allow_all_formats) return '';
        if (Array.isArray(policy.allowed_mimes) && policy.allowed_mimes.indexOf('*/*') >= 0) return '';
        return String(policy.accept || fallback || '');
    }

    public uploadPolicyFileBytes(key: string, fallback: number) {
        const value = Number(this.uploadPolicy(key).max_file_bytes);
        return value > 0 ? value : fallback;
    }

    public uploadPolicyTotalBytes(key: string, fallback: number) {
        const policy = this.uploadPolicy(key);
        if (policy && policy.max_total_bytes !== undefined) return Number(policy.max_total_bytes) || 0;
        return fallback;
    }

    public uploadPolicyMaxFiles(key: string, fallback: number) {
        const value = Number(this.uploadPolicy(key).max_files);
        return value > 0 ? value : fallback;
    }

    public fileExtension(name: any) {
        const match = String(name || '').toLowerCase().match(/\.[a-z0-9_-]+$/);
        return match ? match[0] : '';
    }

    public uploadPolicyAllowsFile(key: string, file: File) {
        const policy = this.uploadPolicy(key);
        if (!policy || policy.allow_all_formats) return true;
        const extensions = Array.isArray(policy.allowed_extensions) ? policy.allowed_extensions : [];
        const mimes = Array.isArray(policy.allowed_mimes) ? policy.allowed_mimes : [];
        if (!extensions.length && !mimes.length) return true;
        if (mimes.indexOf('*/*') >= 0) return true;
        const ext = this.fileExtension(file && file.name);
        const mime = String(file && file.type ? file.type : '').toLowerCase();
        if (ext && extensions.indexOf(ext) >= 0) return true;
        if (mime) {
            for (const allowed of mimes) {
                const value = String(allowed || '').toLowerCase();
                if (value === mime) return true;
                if (value.endsWith('/*') && mime.startsWith(value.slice(0, -1))) return true;
            }
        }
        return false;
    }

    public uploadPolicyValidationMessage(key: string, files: File[], current: any[] = [], totalBytes: number = 0) {
        const policy = this.uploadPolicy(key);
        if (!policy || !files || !files.length) return '';
        const label = String(policy.label || '파일');
        const maxFiles = Number(policy.max_files || 0);
        if (maxFiles && (current || []).length + files.length > maxFiles) return `${label}은(는) 최대 ${maxFiles}개까지 업로드할 수 있습니다.`;
        const maxFileBytes = Number(policy.max_file_bytes || 0);
        const oversized = maxFileBytes ? files.find((file) => (file.size || 0) > maxFileBytes) : null;
        if (oversized) return `${label}은(는) 파일당 최대 ${this.networkSizeLabel(maxFileBytes)}까지 업로드할 수 있습니다.`;
        const maxTotalBytes = Number(policy.max_total_bytes || 0);
        const selectedSize = files.reduce((sum, file) => sum + (file.size || 0), 0);
        if (maxTotalBytes && Number(totalBytes || 0) + selectedSize > maxTotalBytes) return `${label} 총 용량은 최대 ${this.networkSizeLabel(maxTotalBytes)}까지 업로드할 수 있습니다.`;
        if (files.some((file) => !this.uploadPolicyAllowsFile(key, file))) return `${label}에서 허용되지 않는 파일 형식입니다.`;
        return '';
    }

    public dataUrlBytes(dataUrl: string) {
        const value = String(dataUrl || '');
        const base64 = value.split(',')[1] || '';
        return Math.max(Math.floor(base64.length * 0.75), 0);
    }

    public dataUrlMime(dataUrl: string) {
        const match = String(dataUrl || '').match(/^data:([^;,]+)/);
        return match ? match[1] : '';
    }

    public dataUrlSizeLabel(dataUrl: string) {
        return this.networkSizeLabel(this.dataUrlBytes(dataUrl));
    }

    public activityAttachments() {
        if (!this.activityForm.attachments) this.activityForm.attachments = [];
        return this.activityForm.attachments;
    }

    public activityAttachmentTotalSize() {
        return this.activityAttachments().reduce((sum: number, attachment: any) => {
            return sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
        }, 0);
    }

    public activityEditAttachments() {
        if (!this.activityEditForm.attachments) this.activityEditForm.attachments = [];
        return this.activityEditForm.attachments;
    }

    public activityEditAttachmentTotalSize() {
        return this.activityEditAttachments().reduce((sum: number, attachment: any) => {
            return sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
        }, 0);
    }

    public attachmentSizeLabel(attachment: any) {
        const size = Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url);
        return this.networkSizeLabel(size);
    }

    public canAddActivityAttachments() {
        return this.activityAttachments().length < this.activityAttachmentLimits.files;
    }

    public canAddActivityEditAttachments() {
        return this.activityEditAttachments().length < this.activityAttachmentLimits.files;
    }

    public activityUploadButtonClass() {
        const disabled = this.sendingActivity || this.activityAttachmentBusy || !this.canAddActivityAttachments();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public activityEditUploadButtonClass() {
        const disabled = this.savingActivityEdit || this.activityEditAttachmentBusy || !this.canAddActivityEditAttachments();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public reviewFormAttachments() {
        if (!this.reviewForm.attachments) this.reviewForm.attachments = [];
        return this.reviewForm.attachments;
    }

    public selectedReviewAttachments() {
        if (!this.selectedReview) return [];
        if (!this.selectedReview.attachments) this.selectedReview.attachments = [];
        return this.selectedReview.attachments;
    }

    public reviewAttachmentTotalSize(attachments: any[] = []) {
        return (attachments || []).reduce((sum: number, attachment: any) => {
            return sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
        }, 0);
    }

    public reviewFormAttachmentTotalSize() {
        return this.reviewAttachmentTotalSize(this.reviewFormAttachments());
    }

    public selectedReviewAttachmentTotalSize() {
        return this.reviewAttachmentTotalSize(this.selectedReviewAttachments());
    }

    public canAddReviewFormAttachments() {
        return this.reviewFormAttachments().length < this.reviewAttachmentLimits.files;
    }

    public canAddSelectedReviewAttachments() {
        return this.selectedReviewAttachments().length < this.reviewAttachmentLimits.files;
    }

    public reviewFormUploadButtonClass() {
        const disabled = this.savingReview || this.reviewAttachmentBusy || !this.canAddReviewFormAttachments();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public selectedReviewUploadButtonClass() {
        const disabled = this.selectedReviewAttachmentBusy || !this.selectedReview || !this.selectedReview.can_edit || !this.canAddSelectedReviewAttachments();
        const base = 'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-[12px] font-semibold';
        if (disabled) return `${base} cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400`;
        return `${base} cursor-pointer border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;
    }

    public reviewAttachmentValidationMessage(files: File[], current: any[] = []) {
        if ((current || []).length + files.length > this.reviewAttachmentLimits.files) {
            return `리뷰 첨부는 최대 ${this.reviewAttachmentLimits.files}개까지 가능합니다.`;
        }
        const oversized = files.find((file) => file.size > this.reviewAttachmentLimits.fileBytes);
        if (oversized) {
            return `파일당 최대 ${this.networkSizeLabel(this.reviewAttachmentLimits.fileBytes)}까지 첨부할 수 있습니다.`;
        }
        const selectedSize = files.reduce((sum, file) => sum + file.size, 0);
        if (this.reviewAttachmentLimits.totalBytes && this.reviewAttachmentTotalSize(current) + selectedSize > this.reviewAttachmentLimits.totalBytes) {
            return `리뷰 첨부 총 용량은 최대 ${this.networkSizeLabel(this.reviewAttachmentLimits.totalBytes)}까지 가능합니다.`;
        }
        const validationMessage = this.uploadPolicyValidationMessage('review_attachment', files, current, this.reviewAttachmentTotalSize(current));
        if (validationMessage) return validationMessage;
        return '';
    }

    public reviewUploadChunkBytes() {
        return 512 * 1024;
    }

    public reviewUploadSessionId() {
        const random = this.service && typeof this.service.random === 'function'
            ? this.service.random(16)
            : Math.random().toString(36).slice(2, 18);
        return `${Date.now().toString(36)}${random}`;
    }

    public async uploadReviewFileInChunks(url: string, file: Blob, fileName: string, mime: string, progress: any = null) {
        const size = Number(file && file.size || 0);
        const chunkSize = this.reviewUploadChunkBytes();
        const totalChunks = Math.max(1, Math.ceil(size / chunkSize));
        const uploadId = this.reviewUploadSessionId();
        let lastData: any = null;

        for (let index = 0; index < totalChunks; index++) {
            const start = index * chunkSize;
            const end = Math.min(start + chunkSize, size);
            const chunk = file.slice(start, end, mime || (file as any).type || 'application/octet-stream');
            const chunkBytes = Math.max(end - start, 0);
            const fd = new FormData();
            if (totalChunks > 1) {
                fd.append('upload_id', uploadId);
                fd.append('chunk_index', String(index));
                fd.append('chunk_total', String(totalChunks));
                fd.append('file_name', this.safeAttachmentName(fileName));
                fd.append('file_mime', mime || (file as any).type || 'application/octet-stream');
                fd.append('file_size', String(size));
            }
            fd.append('file', chunk, this.safeAttachmentName(fileName));
            const response = await this.service.file.upload(url, fd, async (percent: number, total: number, position: number) => {
                if (!progress) return;
                const chunkLoaded = Math.min(chunkBytes, Number(position || 0));
                const loaded = Math.min(size, start + chunkLoaded);
                const uploadPercent = size > 0 ? Math.round((loaded / size) * 10000) / 100 : Number(percent || 0);
                await progress(uploadPercent, size, loaded);
            });
            const { code, data } = this.normalizeUploadResponse(response);
            if (code !== 200) {
                throw new Error(data && data.message ? data.message : 'review-upload-failed');
            }
            lastData = data || {};
            if (totalChunks > 1 && lastData.pending && index < totalChunks - 1) {
                continue;
            }
            if (progress) {
                const loaded = Math.min(size, end);
                const uploadPercent = size > 0 ? Math.round((loaded / size) * 10000) / 100 : 100;
                await progress(uploadPercent, size, loaded);
            }
        }
        return lastData || {};
    }

    public async fileToReviewAttachment(file: File, progress: any = null) {
        const data = await this.uploadReviewFileInChunks(
            this.reviewAttachmentUploadUrl(),
            file,
            file.name || 'attachment',
            file.type || 'application/octet-stream',
            progress
        );
        if (!data || !data.attachment) {
            throw new Error(data && data.message ? data.message : 'review-attachment-upload-failed');
        }
        const attachment = data.attachment || {};
        const mime = attachment.mime || file.type || 'application/octet-stream';
        const previewDataUrl = this.canInlineAttachmentPreview(file, mime) ? await this.readFileAsDataUrl(file) : '';
        return Object.assign({}, attachment, {
            name: this.safeAttachmentName(file.name),
            mime,
            size: Number(attachment.size) || file.size || 0,
            kind: this.isPreviewImageMime(mime) ? 'image' : 'file',
            preview_data_url: previewDataUrl
        });
    }

    public async reviewFilesToAttachments(files: File[], progressKey: string = '') {
        const attachments = [];
        let processedBefore = 0;
        if (progressKey) {
            this.startUploadProgress(progressKey, '리뷰 첨부', files, 'uploading');
        }
        for (let index = 0; index < files.length; index++) {
            const file = files[index];
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    phase: 'uploading',
                    currentIndex: index + 1,
                    currentFileName: file.name || 'file',
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
            attachments.push(await this.fileToReviewAttachment(file, async (percent: number, total: number, position: number) => {
                if (!progressKey) return;
                const loaded = Number(position || 0);
                const currentTotal = Number(total || file.size || 0);
                await this.updateUploadProgress(progressKey, {
                    currentPercent: Number(percent || 0),
                    currentLoaded: loaded,
                    currentTotal,
                    processedBytes: processedBefore + loaded
                });
            }));
            processedBefore += Number(file.size || 0);
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    completedFiles: index + 1,
                    currentPercent: 100,
                    currentLoaded: file.size || 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
        }
        if (progressKey) this.finishUploadProgress(progressKey, true, '파일 업로드가 완료되었습니다.');
        return attachments;
    }

    public async selectReviewFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (this.savingReview || this.reviewAttachmentBusy || !this.canAddReviewFormAttachments()) return;
        if (!files.length) return;

        const message = this.reviewAttachmentValidationMessage(files, this.reviewFormAttachments());
        if (message) {
            await this.service.modal.error(message);
            return;
        }

        this.reviewAttachmentBusy = true;
        await this.service.render();
        try {
            const attachments = await this.reviewFilesToAttachments(files, 'review-form-attachments');
            this.reviewForm.attachments = this.reviewFormAttachments().concat(attachments);
        } catch (e) {
            this.finishUploadProgress('review-form-attachments', false, '첨부 파일을 업로드하지 못했습니다.');
            await this.service.modal.error('첨부 파일을 업로드하지 못했습니다.');
        }
        this.reviewAttachmentBusy = false;
        await this.service.render();
    }

    public async removeReviewFormAttachment(index: number) {
        this.reviewForm.attachments = this.reviewFormAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
        await this.service.render();
    }

    public async selectSelectedReviewFiles(event: any) {
        if (!this.selectedReview || !this.selectedReview.can_edit || this.selectedReviewAttachmentBusy) return;
        const files = this.uploadEventFiles(event);
        if (!files.length) return;

        const message = this.reviewAttachmentValidationMessage(files, this.selectedReviewAttachments());
        if (message) {
            await this.service.modal.error(message);
            return;
        }

        this.selectedReviewAttachmentBusy = true;
        await this.service.render();
        try {
            const attachments = await this.reviewFilesToAttachments(files, 'selected-review-attachments');
            await this.updateUploadProgress('selected-review-attachments', {
                status: 'running',
                phase: 'saving',
                message: '첨부 정보를 저장하는 중입니다.'
            }, true);
            await this.saveSelectedReviewAttachments(this.selectedReviewAttachments().concat(attachments), false);
        } catch (e) {
            this.finishUploadProgress('selected-review-attachments', false, '첨부 파일을 저장하지 못했습니다.');
            await this.service.modal.error('첨부 파일을 업로드하지 못했습니다.');
            this.selectedReviewAttachmentBusy = false;
        }
        await this.service.render();
    }

    public async removeSelectedReviewAttachment(index: number) {
        if (!this.selectedReview || !this.selectedReview.can_edit || this.selectedReviewAttachmentBusy) return;
        const next = this.selectedReviewAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
        await this.saveSelectedReviewAttachments(next);
    }

    public async saveSelectedReviewAttachments(attachments: any[], manageBusy: boolean = true) {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        if (manageBusy) {
            this.selectedReviewAttachmentBusy = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call('update_review', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify({ attachments: this.reviewAttachmentsForSubmit(attachments) })
        }));
        this.selectedReviewAttachmentBusy = false;
        const hasUploadProgress = this.uploadProgressVisible('selected-review-attachments');
        if (code === 200) {
            await this.syncReview(data.review);
            if (hasUploadProgress) this.finishUploadProgress('selected-review-attachments', true, '첨부 파일이 저장되었습니다.');
        } else {
            if (hasUploadProgress) this.finishUploadProgress('selected-review-attachments', false, data.message || '첨부 파일을 저장하지 못했습니다.');
            await this.service.modal.error(data.message || '첨부 파일을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public isImageAttachment(attachment: any) {
        const mime = String(attachment && attachment.mime ? attachment.mime : '').toLowerCase();
        const dataUrl = this.attachmentPreviewUrl(attachment);
        return this.isPreviewImageMime(mime) && /^data:image\/(png|jpeg|jpg|gif|webp);base64,/i.test(dataUrl);
    }

    public isPreviewImageMime(mime: any) {
        const value = String(mime || '').toLowerCase();
        const imageMimes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
        return imageMimes.indexOf(value) >= 0;
    }

    public canInlineAttachmentPreview(file: File, mime: any) {
        return !!(file && file.size <= this.reviewAttachmentPreviewMaxBytes && this.isPreviewImageMime(mime));
    }

    public isDataUrl(value: any) {
        return /^data:[^,]*;base64,/i.test(String(value || ''));
    }

    public attachmentPreviewUrl(attachment: any) {
        if (!attachment) return '';
        if (this.isDataUrl(attachment.preview_data_url)) return String(attachment.preview_data_url || '');
        if (this.isDataUrl(attachment.data_url)) return String(attachment.data_url || '');
        return '';
    }

    public reviewAttachmentForSubmit(attachment: any) {
        const storagePath = String(
            (attachment && attachment.storage_path)
            || (attachment && !this.isDataUrl(attachment.data_url) ? attachment.data_url : '')
            || (attachment && attachment.path)
            || ''
        );
        const dataUrl = storagePath || (attachment && this.isDataUrl(attachment.data_url) ? String(attachment.data_url || '') : '');
        return {
            name: this.safeAttachmentName(attachment && attachment.name),
            mime: String(attachment && attachment.mime ? attachment.mime : 'application/octet-stream'),
            size: Number(attachment && attachment.size) || this.dataUrlBytes(dataUrl),
            kind: String(attachment && attachment.kind ? attachment.kind : (this.isPreviewImageMime(attachment && attachment.mime) ? 'image' : 'file')),
            data_url: dataUrl,
            storage_path: storagePath
        };
    }

    public reviewAttachmentsForSubmit(attachments: any[] = []) {
        return (attachments || []).map((attachment: any) => this.reviewAttachmentForSubmit(attachment)).filter((attachment: any) => !!attachment.data_url);
    }

    public safeAttachmentName(name: any) {
        const value = String(name || 'attachment')
            .replace(/[\\/]/g, '-')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 160);
        return value || 'attachment';
    }

    public documentVersionUploadUrl() {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId }) as any).toString();
        return `/wiz/api/page.projects.item/add_document_version_upload${query ? `?${query}` : ''}`;
    }

    public reviewAttachmentUploadUrl() {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId }) as any).toString();
        return `/wiz/api/page.projects.item/upload_review_attachment${query ? `?${query}` : ''}`;
    }

    public reviewScreenshotUploadUrl() {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId }) as any).toString();
        return `/wiz/api/page.projects.item/upload_review_screenshot${query ? `?${query}` : ''}`;
    }

    public dataUrlToBlob(dataUrl: string) {
        const value = String(dataUrl || '');
        if (!this.isDataUrl(value)) return null;
        const comma = value.indexOf(',');
        if (comma < 0) return null;
        const mime = this.dataUrlMime(value) || 'application/octet-stream';
        const binary = window.atob(value.slice(comma + 1));
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index++) {
            bytes[index] = binary.charCodeAt(index);
        }
        return new Blob([bytes], { type: mime });
    }

    public screenshotFileExtension(mime: string) {
        const value = String(mime || '').toLowerCase();
        if (value === 'image/svg+xml') return 'svg';
        if (value === 'image/jpeg') return 'jpg';
        if (value === 'image/webp') return 'webp';
        return 'png';
    }

    public async uploadReviewScreenshotDataUrl(dataUrl: string) {
        if (!this.isDataUrl(dataUrl)) return { screenshot_data_url: dataUrl };
        const blob = this.dataUrlToBlob(dataUrl);
        if (!blob) throw new Error('review-screenshot-blob-failed');
        const mime = this.dataUrlMime(dataUrl) || blob.type || 'image/png';
        const data = await this.uploadReviewFileInChunks(
            this.reviewScreenshotUploadUrl(),
            blob,
            `review-screenshot.${this.screenshotFileExtension(mime)}`,
            mime
        );
        if (!data || !data.screenshot) {
            throw new Error(data && data.message ? data.message : 'review-screenshot-upload-failed');
        }
        return data.screenshot;
    }

    public async prepareEvidenceForSubmit(evidence: any) {
        const payload = Object.assign({}, evidence || {});
        if (this.isDataUrl(payload.screenshot_data_url)) {
            const screenshot = await this.uploadReviewScreenshotDataUrl(payload.screenshot_data_url);
            payload.screenshot_data_url = screenshot.screenshot_data_url || '';
            payload.screenshot_asset_id = payload.screenshot_asset_id || screenshot.screenshot_asset_id || 'stored-review-screenshot';
        }
        return payload;
    }

    public normalizeUploadResponse(response: any) {
        if (response && typeof response.code === 'number') return response;
        if (response && typeof response.responseJSON === 'object') return response.responseJSON;
        if (response && typeof response.responseText === 'string') {
            try {
                return JSON.parse(response.responseText);
            } catch (e) { }
        }
        if (typeof response === 'string') {
            try {
                return JSON.parse(response);
            } catch (e) { }
        }
        const status = response && typeof response.status === 'number' ? response.status : 500;
        return { code: status, data: { message: status === 413 ? '업로드 용량이 너무 큽니다.' : '파일을 업로드하지 못했습니다.' } };
    }

    public readFileAsDataUrl(file: File, progress: any = null): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('file-read-failed'));
            reader.onprogress = async (event: any) => {
                if (progress && event && event.lengthComputable) {
                    await progress(Number(event.loaded || 0), Number(event.total || file.size || 0));
                }
            };
            reader.readAsDataURL(file);
        });
    }

    public async fileToActivityAttachment(file: File, progress: any = null) {
        const dataUrl = await this.readFileAsDataUrl(file, progress);
        const mime = file.type || this.dataUrlMime(dataUrl) || 'application/octet-stream';
        return {
            name: this.safeAttachmentName(file.name),
            mime,
            size: file.size || this.dataUrlBytes(dataUrl),
            kind: this.isImageAttachment({ mime, data_url: dataUrl }) ? 'image' : 'file',
            data_url: dataUrl
        };
    }

    public activityAttachmentValidationMessage(files: File[], current: any[] = []) {
        if ((current || []).length + files.length > this.activityAttachmentLimits.files) {
            return `첨부는 최대 ${this.activityAttachmentLimits.files}개까지 가능합니다.`;
        }
        const oversized = files.find((file) => file.size > this.activityAttachmentLimits.fileBytes);
        if (oversized) {
            return `파일당 최대 ${this.networkSizeLabel(this.activityAttachmentLimits.fileBytes)}까지 첨부할 수 있습니다.`;
        }
        const selectedSize = files.reduce((sum, file) => sum + file.size, 0);
        const currentSize = (current || []).reduce((sum: number, attachment: any) => {
            return sum + (Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url));
        }, 0);
        if (this.activityAttachmentLimits.totalBytes && currentSize + selectedSize > this.activityAttachmentLimits.totalBytes) {
            return `첨부 총 용량은 최대 ${this.networkSizeLabel(this.activityAttachmentLimits.totalBytes)}까지 가능합니다.`;
        }
        const validationMessage = this.uploadPolicyValidationMessage('activity_attachment', files, current, currentSize);
        if (validationMessage) return validationMessage;
        return '';
    }

    public async filesToActivityAttachments(files: File[], progressKey: string = '') {
        const attachments = [];
        let processedBefore = 0;
        if (progressKey) {
            this.startUploadProgress(progressKey, '작업이력 첨부', files, 'reading');
        }
        for (let index = 0; index < files.length; index++) {
            const file = files[index];
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    phase: 'reading',
                    currentIndex: index + 1,
                    currentFileName: file.name || 'file',
                    currentPercent: 0,
                    currentLoaded: 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
            attachments.push(await this.fileToActivityAttachment(file, async (loaded: number, total: number) => {
                if (!progressKey) return;
                await this.updateUploadProgress(progressKey, {
                    currentPercent: total ? Math.round(loaded / total * 10000) / 100 : 0,
                    currentLoaded: loaded,
                    currentTotal: total || file.size || 0,
                    processedBytes: processedBefore + loaded
                });
            }));
            processedBefore += Number(file.size || 0);
            if (progressKey) {
                await this.updateUploadProgress(progressKey, {
                    completedFiles: index + 1,
                    currentPercent: 100,
                    currentLoaded: file.size || 0,
                    currentTotal: file.size || 0,
                    processedBytes: processedBefore
                }, true);
            }
        }
        if (progressKey) this.finishUploadProgress(progressKey, true, '파일 준비가 완료되었습니다.');
        return attachments;
    }

    public async selectActivityFiles(event: any) {
        const files = this.uploadEventFiles(event);
        if (!files.length) return;

        const message = this.activityAttachmentValidationMessage(files, this.activityAttachments());
        if (message) {
            await this.service.modal.error(message);
            return;
        }

        this.activityAttachmentBusy = true;
        await this.service.render();
        try {
            const attachments = await this.filesToActivityAttachments(files, 'activity-attachments');
            this.activityForm.attachments = this.activityAttachments().concat(attachments);
        } catch (e) {
            this.finishUploadProgress('activity-attachments', false, '첨부 파일을 읽지 못했습니다.');
            await this.service.modal.error('첨부 파일을 읽지 못했습니다.');
        }
        this.activityAttachmentBusy = false;
        await this.service.render();
    }

    public removeActivityAttachment(index: number) {
        this.activityForm.attachments = this.activityAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
    }

    public async selectActivityEditFiles(event: any) {
        if (this.savingActivityEdit || this.activityEditAttachmentBusy) return;
        const files = this.uploadEventFiles(event);
        if (!files.length) return;

        const message = this.activityAttachmentValidationMessage(files, this.activityEditAttachments());
        if (message) {
            await this.service.modal.error(message);
            return;
        }

        this.activityEditAttachmentBusy = true;
        await this.service.render();
        try {
            const attachments = await this.filesToActivityAttachments(files, 'activity-edit-attachments');
            this.activityEditForm.attachments = this.activityEditAttachments().concat(attachments);
        } catch (e) {
            this.finishUploadProgress('activity-edit-attachments', false, '첨부 파일을 읽지 못했습니다.');
            await this.service.modal.error('첨부 파일을 읽지 못했습니다.');
        }
        this.activityEditAttachmentBusy = false;
        await this.service.render();
    }

    public removeActivityEditAttachment(index: number) {
        this.activityEditForm.attachments = this.activityEditAttachments().filter((_: any, itemIndex: number) => itemIndex !== index);
    }

    public downloadAttachment(attachment: any) {
        if (!attachment || !attachment.data_url) return;
        this.downloadDataUrl(attachment.data_url, this.safeAttachmentName(attachment.name), attachment.mime || 'application/octet-stream');
    }

    public downloadDataUrl(dataUrl: string, fileName: string, fallbackMime: string = 'application/octet-stream') {
        const value = String(dataUrl || '');
        if (!value) return;
        const anchor = document.createElement('a');
        const bytes = this.dataUrlToBytes(value);
        let objectUrl = '';
        if (bytes) {
            const mime = this.dataUrlMime(value) || fallbackMime;
            objectUrl = window.URL.createObjectURL(new Blob([bytes], { type: mime }));
            anchor.href = objectUrl;
        } else {
            anchor.href = value;
        }
        anchor.download = this.safeAttachmentName(fileName);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        if (objectUrl) window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
    }

    public dataUrlExtension(dataUrl: string) {
        const mime = this.dataUrlMime(dataUrl);
        if (mime === 'image/jpeg') return 'jpg';
        if (mime === 'image/svg+xml') return 'svg';
        if (mime === 'image/webp') return 'webp';
        return 'png';
    }

    public screenshotFileName(review: any) {
        const id = review && review.id ? String(review.id) : 'review';
        const dataUrl = this.screenshotPreviewUrl || (review && review.evidence ? review.evidence.screenshot_data_url : '');
        return `reviewops-${id}-screenshot.${this.dataUrlExtension(dataUrl)}`;
    }

    public openScreenshotPreview(review: any) {
        const dataUrl = review && review.evidence ? review.evidence.screenshot_data_url : '';
        if (!dataUrl) return;
        this.screenshotPreviewUrl = dataUrl;
        this.screenshotPreviewTitle = review && review.title ? review.title : '스크린샷';
    }

    public closeScreenshotPreview() {
        this.screenshotPreviewUrl = '';
        this.screenshotPreviewTitle = '';
    }

    public downloadScreenshot(review: any = this.selectedReview) {
        const dataUrl = this.screenshotPreviewUrl || (review && review.evidence ? review.evidence.screenshot_data_url : '');
        if (!dataUrl) return;
        const anchor = document.createElement('a');
        anchor.href = dataUrl;
        anchor.download = this.screenshotFileName(review);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }

    public downloadReviewScreenshot(review: any = this.selectedReview) {
        const dataUrl = review && review.evidence ? review.evidence.screenshot_data_url : '';
        if (!dataUrl) return;
        const anchor = document.createElement('a');
        anchor.href = dataUrl;
        anchor.download = this.screenshotFileName(review);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }

    public markdownText(value: any) {
        if (value === undefined || value === null || value === '') return '-';
        if (typeof value === 'object') return JSON.stringify(value, null, 2);
        return String(value);
    }

    public markdownHtml(value: any) {
        const text = value === undefined || value === null || value === '' ? '-' : String(value);
        if (this.markdownHtmlCache[text]) return this.markdownHtmlCache[text];
        let html = '';
        try {
            html = this.markdownConverter.makeHtml(text);
        } catch (e) {
            html = `<p>${this.escapeHtml(text)}</p>`;
        }
        this.markdownHtmlCache[text] = html;
        this.markdownHtmlCacheKeys.push(text);
        if (this.markdownHtmlCacheKeys.length > 80) {
            const oldest = this.markdownHtmlCacheKeys.shift();
            if (oldest) delete this.markdownHtmlCache[oldest];
        }
        return html;
    }

    public escapeHtml(value: any) {
        return String(value === undefined || value === null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/\r?\n/g, '<br>');
    }

    public markdownJson(value: any) {
        try {
            return JSON.stringify(value || [], null, 2);
        } catch (e) {
            return '[]';
        }
    }

    public agentInstructionLogSpecs() {
        return [
            { key: 'navigation_log', label: 'navigation' },
            { key: 'input_log', label: 'input' },
            { key: 'network_log', label: 'network' },
            { key: 'console_log', label: 'console' },
            { key: 'fingerprint_log', label: 'fingerprint' }
        ];
    }

    public csvCellText(value: any): string {
        if (value === undefined || value === null) return '';
        if (Array.isArray(value)) return value.map((item) => this.csvCellText(item)).filter((item) => item !== '').join('; ');
        if (typeof value === 'object') {
            return Object.keys(value)
                .filter((key) => typeof value[key] !== 'function' && key !== '_key')
                .map((key) => `${key}=${this.csvCellText(value[key])}`)
                .filter((item) => item !== '')
                .join('; ');
        }
        return String(value).replace(/\r?\n/g, ' ').trim();
    }

    public csvEscape(value: any) {
        const text = this.csvCellText(value);
        if (/[",\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
        return text;
    }

    public agentInstructionLogRows(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const rows: any[] = [];
        this.agentInstructionLogSpecs().forEach((spec) => {
            const entries = Array.isArray(evidence[spec.key]) ? evidence[spec.key] : [];
            entries.forEach((entry: any, index: number) => {
                const row: any = { log_type: spec.label, index: index + 1 };
                if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
                    Object.keys(entry).forEach((key) => {
                        if (key !== '_key' && typeof entry[key] !== 'function') row[key] = entry[key];
                    });
                } else {
                    row.message = entry;
                }
                rows.push(row);
            });
        });
        return rows;
    }

    public buildAgentInstructionLogsCsv(review: any) {
        const rows = this.agentInstructionLogRows(review);
        const headers = ['log_type', 'index'];
        rows.forEach((row) => {
            Object.keys(row).forEach((key) => {
                if (headers.indexOf(key) < 0) headers.push(key);
            });
        });
        if (!rows.length) return headers.join(',');
        return [headers.join(',')].concat(rows.map((row) => headers.map((header) => this.csvEscape(row[header])).join(','))).join('\n');
    }

    public buildAgentInstructionCopyMarkdown(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const documentVersion = this.documentEvidenceVersion(review);
        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        return [
            '# 에이전트 작업 지시서',
            '',
            '## 요청사항',
            '',
            `- ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel())}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 첨부 파일: ${reviewAttachments.length}개`,
            '',
            this.markdownText(review && review.body),
            '',
            '## 로그',
            '',
            '```csv',
            this.buildAgentInstructionLogsCsv(review),
            '```',
            ''
        ].join('\n');
    }

    public async copyTextToClipboard(text: string) {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('clipboard copy failed');
    }

    public async copyAgentInstructionMarkdown(review: any) {
        if (!review) return;
        try {
            await this.copyTextToClipboard(this.buildAgentInstructionCopyMarkdown(review));
            await this.service.modal.success('MD가 복사되었습니다.');
        } catch (e) {
            await this.service.modal.error('MD 복사에 실패했습니다.');
        }
    }

    public agentInstructionArchiveFileName(review: any) {
        const id = review && review.id ? String(review.id) : 'review';
        const title = String(review && review.title ? review.title : 'agent-work-order')
            .replace(/[^a-zA-Z0-9가-힣._-]+/g, '-')
            .replace(/-+/g, '-')
            .slice(0, 48)
            .replace(/^-|-$/g, '');
        return `reviewops-${id}-${title || 'agent-work-order'}.zip`;
    }

    public buildReviewRequestMarkdown(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const screenshotDataUrl = evidence.screenshot_data_url || '';
        const documentVersion = this.documentEvidenceVersion(review);
        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        return [
            '# 리뷰 요청사항',
            '',
            '이 파일은 리뷰어가 남긴 원 요청을 사람이 읽기 쉽게 분리한 문서입니다. 전체 작업 순서와 파일 위치는 ZIP 루트의 `README.md`를 먼저 확인하세요.',
            '',
            '## 리뷰 정보',
            '',
            `- ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 작성자: ${this.markdownText(review && review.author ? review.author.name : '')}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel())}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 파일: ${this.reviewIsDocument(review) ? this.markdownText(documentVersion && documentVersion.file_name) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 화면: ${review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : '-'}`,
            `- 캡처 방식: ${this.markdownText(this.captureLabel(evidence.capture_method || 'not_available'))}`,
            `- 스크린샷 첨부: ${evidence.screenshot_data_url ? 'yes' : 'no'}`,
            `- 리뷰 첨부 파일: ${reviewAttachments.length}개`,
            `- 콘솔 로그: ${(evidence.console_log || []).length}건`,
            `- 스크린샷 MIME: ${this.markdownText(this.dataUrlMime(screenshotDataUrl))}`,
            `- 스크린샷 크기: ${this.markdownText(this.dataUrlSizeLabel(screenshotDataUrl))}`,
            '',
            '## 리뷰어 요청 내용',
            '',
            this.markdownText(review && review.body),
            '',
            '## 첨부 파일',
            '',
            reviewAttachments.length ? reviewAttachments.map((attachment: any, index: number) => {
                return `- ${index + 1}. ${this.markdownText(attachment && attachment.name)} (${this.markdownText(attachment && attachment.mime)}, ${this.attachmentSizeLabel(attachment)})`;
            }).join('\n') : '-',
            ''
        ].join('\n');
    }

    public archiveJson(value: any) {
        try {
            return JSON.stringify(value || {}, null, 2);
        } catch (e) {
            return '{}';
        }
    }

    public utf8Bytes(value: any) {
        return new TextEncoder().encode(String(value === undefined || value === null ? '' : value));
    }

    public dataUrlToBytes(dataUrl: string) {
        const value = String(dataUrl || '');
        const match = value.match(/^data:([^;,]*)(;base64)?,(.*)$/i);
        if (!match) return null;
        try {
            const payload = match[3] || '';
            if (match[2]) {
                const binary = atob(payload.replace(/\s/g, ''));
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                return bytes;
            }
            return this.utf8Bytes(decodeURIComponent(payload));
        } catch (e) {
            return null;
        }
    }

    public zipFileExtensionForMime(mime: string, fallback: string = 'bin') {
        const value = String(mime || '').toLowerCase();
        const map: any = {
            'image/png': 'png',
            'image/jpeg': 'jpg',
            'image/gif': 'gif',
            'image/webp': 'webp',
            'image/svg+xml': 'svg',
            'application/pdf': 'pdf',
            'text/plain': 'txt',
            'text/markdown': 'md',
            'text/csv': 'csv',
            'application/json': 'json',
            'application/zip': 'zip',
            'application/msword': 'doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
            'application/vnd.ms-excel': 'xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
            'application/vnd.ms-powerpoint': 'ppt',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
        };
        return map[value] || fallback;
    }

    public safeArchivePathPart(value: any, fallback: string = 'file') {
        const text = String(value || fallback)
            .replace(/[\\/:*?"<>|#%{}^~[\]`]+/g, '-')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 120);
        return text || fallback;
    }

    public archiveAttachmentName(attachment: any, index: number) {
        const base = this.safeAttachmentName(attachment && attachment.name ? attachment.name : `attachment-${index + 1}`);
        if (/\.[a-z0-9]{1,8}$/i.test(base)) return this.safeArchivePathPart(base, `attachment-${index + 1}`);
        const ext = this.zipFileExtensionForMime(attachment && attachment.mime, 'bin');
        return `${this.safeArchivePathPart(base, `attachment-${index + 1}`)}.${ext}`;
    }

    public uniqueArchivePath(path: string, used: any) {
        const normalized = String(path || 'file').replace(/^\/+/, '');
        if (!used[normalized]) {
            used[normalized] = true;
            return normalized;
        }
        const slash = normalized.lastIndexOf('/');
        const dir = slash >= 0 ? normalized.slice(0, slash + 1) : '';
        const name = slash >= 0 ? normalized.slice(slash + 1) : normalized;
        const dot = name.lastIndexOf('.');
        const stem = dot > 0 ? name.slice(0, dot) : name;
        const ext = dot > 0 ? name.slice(dot) : '';
        let seq = 2;
        while (used[`${dir}${stem}-${seq}${ext}`]) seq++;
        const next = `${dir}${stem}-${seq}${ext}`;
        used[next] = true;
        return next;
    }

    public sanitizedActivitiesForArchive(review: any, attachmentPaths: any) {
        const activities = review && review.activities ? review.activities : [];
        return activities.map((activity: any, activityIndex: number) => {
            const key = String(activity && (activity.id || activity.created || activityIndex));
            const paths = attachmentPaths[key] || [];
            return {
                index: activityIndex + 1,
                id: activity && activity.id,
                author: activity && activity.author,
                created: activity && activity.created,
                status: activity && activity.status,
                status_label: activity && activity.status ? this.statusLabel(activity.status) : '',
                message: activity && activity.message,
                attachments: (activity && activity.attachments ? activity.attachments : []).map((attachment: any, index: number) => ({
                    name: attachment && attachment.name,
                    mime: attachment && attachment.mime,
                    size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
                    archive_path: paths[index] || ''
                }))
            };
        });
    }

    public buildActivityMarkdown(activity: any, index: number, attachmentPaths: string[]) {
        const attachments = activity && activity.attachments ? activity.attachments : [];
        return [
            `# 작업이력 ${index + 1}`,
            '',
            `- 작성자: ${this.markdownText(activity && activity.author ? activity.author.name : '')}`,
            `- 작성일: ${this.markdownText(this.kstDateTime(activity && activity.created))}`,
            `- 상태: ${activity && activity.status ? this.statusLabel(activity.status) : '-'}`,
            '',
            '## 내용',
            '',
            this.markdownText(activity && activity.message),
            '',
            '## 첨부 파일',
            '',
            attachments.length ? attachments.map((attachment: any, attachmentIndex: number) => {
                const path = attachmentPaths[attachmentIndex] || '';
                return `- ${this.markdownText(attachment && attachment.name)} (${this.markdownText(attachment && attachment.mime)}, ${this.attachmentSizeLabel(attachment)})${path ? `: ${path}` : ''}`;
            }).join('\n') : '-',
            ''
        ].join('\n');
    }

    public buildArchiveReadme(review: any, entries: any[]) {
        const evidence = review && review.evidence ? review.evidence : {};
        const documentVersion = this.documentEvidenceVersion(review);
        const tree = entries.map((entry: any) => `- \`${entry.path}\`${entry.description ? `: ${entry.description}` : ''}`).join('\n');
        return [
            '# README - 에이전트 작업 지시서',
            '',
            '에이전트는 이 파일을 가장 먼저 읽고 작업을 시작하세요. 이 ZIP은 ReviewOps 리뷰 분석을 위해 표준화된 파일 구조로 만든 작업 지시서입니다.',
            '',
            '## 요청사항',
            '',
            '아래 리뷰 요청, 스크린샷, 수집 로그, 작업이력과 첨부 파일을 기준으로 문제를 파악하고 재현 경로, 원인 후보, 수정 방향을 제안하거나 필요한 코드를 수정하세요.',
            '',
            `- 리뷰 ID: ${this.markdownText(review && review.id)}`,
            `- 제목: ${this.markdownText(review && review.title)}`,
            `- 상태: ${this.markdownText(review && this.statusLabel(review.status))}`,
            `- 우선순위: ${this.markdownText(review && this.priorityLabel(review.priority))}`,
            `- 분류: ${this.markdownText(review && this.categoryLabel(review.category))}`,
            `- 프로젝트 종류: ${this.markdownText(this.projectTypeLabel())}`,
            `- 문서 버전: ${this.reviewIsDocument(review) ? this.markdownText(this.documentVersionDisplayLabel(documentVersion)) : '-'}`,
            `- 문서 페이지: ${this.reviewIsDocument(review) ? `p.${Number(evidence.document_page) || 1}` : '-'}`,
            `- 요청 링크: ${this.markdownText(review && review.current_url)}`,
            `- 마지막 접속 링크: ${this.markdownText(this.lastAccessUrl(review))}`,
            `- 화면: ${review ? `${review.viewport_width}x${review.viewport_height} / ${this.reviewScaleLabel(review.scale)}` : '-'}`,
            `- 캡처 방식: ${this.markdownText(this.captureLabel(evidence.capture_method || 'not_available'))}`,
            '',
            '## 먼저 볼 파일',
            '',
            '1. `review/request.md`: 리뷰어가 남긴 요청 내용과 기본 메타데이터',
            '2. `assets/screenshots/`: 실제 화면 캡처 파일',
            '3. `assets/review-attachments/`: 리뷰 등록 시 첨부한 파일',
            '4. `activities/`: 작업이력과 작업이력별 첨부 파일 위치',
            '5. `evidence/`: 네비게이션, 입력, 네트워크, 콘솔, 브라우저/SDK 환경 로그',
            '6. `assets/documents/`: 문서형 프로젝트의 리뷰 대상 PDF 파일',
            '',
            '## 파일 트리',
            '',
            tree || '- 파일 없음',
            '',
            '## 분석 메모',
            '',
            '- 입력 로그는 민감정보 원문 대신 마스킹된 요약/메타데이터만 포함합니다.',
            '- 리뷰 첨부 파일은 `assets/review-attachments/` 하위에 파일 단위로 분리되어 있습니다.',
            '- 작업이력 첨부 파일은 `assets/activity-attachments/` 하위에 파일 단위로 분리되어 있습니다.',
            '- `metadata/file-manifest.json`에는 각 파일의 설명과 크기가 들어 있습니다.',
            ''
        ].join('\n');
    }

    public buildAgentInstructionArchiveEntries(review: any) {
        const evidence = review && review.evidence ? review.evidence : {};
        const used: any = {};
        const entries: any[] = [];
        const reviewAttachmentPaths: string[] = [];
        const attachmentPaths: any = {};

        const addEntry = (path: string, bytes: Uint8Array, description: string) => {
            const uniquePath = this.uniqueArchivePath(path, used);
            entries.push({ path: uniquePath, bytes, description, size: bytes.length });
            return uniquePath;
        };
        const addText = (path: string, content: string, description: string) => addEntry(path, this.utf8Bytes(content), description);
        const addJson = (path: string, value: any, description: string) => addText(path, this.archiveJson(value), description);
        const addDataUrl = (path: string, dataUrl: string, description: string) => {
            const bytes = this.dataUrlToBytes(dataUrl);
            if (!bytes) return '';
            return addEntry(path, bytes, description);
        };

        const documentVersion = this.documentEvidenceVersion(review);
        const documentDataUrl = documentVersion && documentVersion.file_data_url ? documentVersion.file_data_url : '';
        const documentPath = documentDataUrl
            ? addDataUrl(
                `assets/documents/${this.safeArchivePathPart(documentVersion.file_name || 'review-document.pdf', 'review-document.pdf')}`,
                documentDataUrl,
                '리뷰 대상 PDF 문서 버전'
            )
            : '';
        const screenshotDataUrl = evidence.screenshot_data_url || '';
        const screenshotPath = screenshotDataUrl
            ? addDataUrl(
                `assets/screenshots/review-screenshot.${this.dataUrlExtension(screenshotDataUrl)}`,
                screenshotDataUrl,
                '리뷰 화면 스크린샷'
            )
            : '';

        const reviewAttachments = review && Array.isArray(review.attachments) ? review.attachments : [];
        for (let attachmentIndex = 0; attachmentIndex < reviewAttachments.length; attachmentIndex++) {
            const attachment = reviewAttachments[attachmentIndex];
            const path = addDataUrl(
                `assets/review-attachments/${String(attachmentIndex + 1).padStart(2, '0')}-${this.archiveAttachmentName(attachment, attachmentIndex)}`,
                attachment && attachment.data_url,
                '리뷰 첨부 파일'
            );
            reviewAttachmentPaths.push(path);
        }

        const activities = review && review.activities ? review.activities : [];
        for (let activityIndex = 0; activityIndex < activities.length; activityIndex++) {
            const activity = activities[activityIndex];
            const key = String(activity && (activity.id || activity.created || activityIndex));
            attachmentPaths[key] = [];
            const attachments = activity && activity.attachments ? activity.attachments : [];
            for (let attachmentIndex = 0; attachmentIndex < attachments.length; attachmentIndex++) {
                const attachment = attachments[attachmentIndex];
                const path = addDataUrl(
                    `assets/activity-attachments/activity-${String(activityIndex + 1).padStart(3, '0')}/${String(attachmentIndex + 1).padStart(2, '0')}-${this.archiveAttachmentName(attachment, attachmentIndex)}`,
                    attachment && attachment.data_url,
                    `작업이력 ${activityIndex + 1} 첨부 파일`
                );
                attachmentPaths[key].push(path);
            }
        }

        addText('review/request.md', this.buildReviewRequestMarkdown(review), '리뷰어 요청사항과 리뷰 기본 정보');
        addJson('review/review.json', {
            id: review && review.id,
            title: review && review.title,
            body: review && review.body,
            status: review && review.status,
            status_label: review && review.status ? this.statusLabel(review.status) : '',
            priority: review && review.priority,
            priority_label: review && review.priority ? this.priorityLabel(review.priority) : '',
            category: review && review.category,
            category_label: review && review.category ? this.categoryLabel(review.category) : '',
            author: review && review.author,
            current_url: review && review.current_url,
            last_access_url: this.lastAccessUrl(review),
            viewport_width: review && review.viewport_width,
            viewport_height: review && review.viewport_height,
            scale: review && review.scale,
            project_type: this.projectType(),
            project_type_label: this.projectTypeLabel(),
            document_version_id: evidence.document_version_id || '',
            document_page: evidence.document_page || 0,
            document_version: documentVersion ? {
                id: documentVersion.id,
                version_label: documentVersion.version_label,
                file_name: documentVersion.file_name,
                file_mime: documentVersion.file_mime,
                file_size: documentVersion.file_size,
                file_size_label: documentVersion.file_size_label,
                created: documentVersion.created
            } : null,
            document_path: documentPath,
            screenshot_path: screenshotPath,
            attachments: reviewAttachments.map((attachment: any, index: number) => ({
                name: attachment && attachment.name,
                mime: attachment && attachment.mime,
                size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
                archive_path: reviewAttachmentPaths[index] || ''
            }))
        }, '리뷰 기본 메타데이터 JSON');
        addJson('review/attachments.json', reviewAttachments.map((attachment: any, index: number) => ({
            name: attachment && attachment.name,
            mime: attachment && attachment.mime,
            size: Number(attachment && attachment.size) || this.dataUrlBytes(attachment && attachment.data_url),
            archive_path: reviewAttachmentPaths[index] || ''
        })), '리뷰 첨부 파일 목록 JSON');
        addJson('evidence/navigation-log.json', evidence.navigation_log || [], 'iframe/SDK 네비게이션 로그');
        addJson('evidence/input-log.json', evidence.input_log || [], '마스킹된 입력 이벤트 로그');
        addJson('evidence/network-log.json', evidence.network_log || [], '네트워크 요청/응답 로그');
        addJson('evidence/console-log.json', evidence.console_log || [], 'SDK/원격 브라우저 콘솔 로그');
        addJson('evidence/fingerprint-log.json', evidence.fingerprint_log || [], '브라우저, iframe, SDK 환경 로그');
        addJson('evidence/debug-summary.json', {
            capture_method: evidence.capture_method || 'not_available',
            capture_label: this.captureLabel(evidence.capture_method || 'not_available'),
            screenshot_path: screenshotPath,
            screenshot_mime: this.dataUrlMime(screenshotDataUrl),
            screenshot_size: this.dataUrlBytes(screenshotDataUrl),
            document_path: documentPath,
            document_page: evidence.document_page || 0,
            console_count: (evidence.console_log || []).length,
            sdk: this.latestFingerprint(review, 'reviewops-sdk') || {},
            browser: this.latestFingerprint(review, 'browser-fingerprint') || {},
            iframe: this.latestFingerprint(review, 'iframe-fingerprint') || {}
        }, '디버깅 요약 JSON');

        const sanitizedActivities = this.sanitizedActivitiesForArchive(review, attachmentPaths);
        addJson('activities/activity-log.json', sanitizedActivities, '작업이력 전체 JSON');
        for (let activityIndex = 0; activityIndex < activities.length; activityIndex++) {
            const activity = activities[activityIndex];
            const key = String(activity && (activity.id || activity.created || activityIndex));
            addText(
                `activities/activity-${String(activityIndex + 1).padStart(3, '0')}.md`,
                this.buildActivityMarkdown(activity, activityIndex, attachmentPaths[key] || []),
                `작업이력 ${activityIndex + 1} 요약`
            );
        }

        const manifestEntry = {
            path: 'metadata/file-manifest.json',
            bytes: this.utf8Bytes(this.archiveJson(entries.map((entry) => ({
                path: entry.path,
                description: entry.description,
                size: entry.size
            })))),
            description: 'ZIP 파일 목록과 설명',
            size: 0
        };
        manifestEntry.size = manifestEntry.bytes.length;
        manifestEntry.path = this.uniqueArchivePath(manifestEntry.path, used);
        entries.push(manifestEntry);

        const readme = this.buildArchiveReadme(review, entries);
        return [{ path: 'README.md', bytes: this.utf8Bytes(readme), description: '에이전트가 가장 먼저 읽어야 할 작업 지시서', size: this.utf8Bytes(readme).length }].concat(entries);
    }

    public zipCrcTable() {
        const cached = (this as any)._zipCrcTable;
        if (cached) return cached;
        const table: number[] = [];
        for (let n = 0; n < 256; n++) {
            let c = n;
            for (let k = 0; k < 8; k++) {
                c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
            }
            table[n] = c >>> 0;
        }
        (this as any)._zipCrcTable = table;
        return table;
    }

    public crc32(bytes: Uint8Array) {
        const table = this.zipCrcTable();
        let crc = 0xffffffff;
        for (let i = 0; i < bytes.length; i++) {
            crc = table[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
        }
        return (crc ^ 0xffffffff) >>> 0;
    }

    public zipDosTime(date: Date) {
        return (date.getHours() << 11) | (date.getMinutes() << 5) | Math.floor(date.getSeconds() / 2);
    }

    public zipDosDate(date: Date) {
        return ((date.getFullYear() - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate();
    }

    public concatBytes(chunks: Uint8Array[]) {
        const total = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
        const out = new Uint8Array(total);
        let offset = 0;
        for (const chunk of chunks) {
            out.set(chunk, offset);
            offset += chunk.length;
        }
        return out;
    }

    public createZipBlob(entries: any[]) {
        const now = new Date();
        const dosTime = this.zipDosTime(now);
        const dosDate = this.zipDosDate(now);
        const locals: Uint8Array[] = [];
        const centrals: Uint8Array[] = [];
        let offset = 0;

        for (const entry of entries) {
            const nameBytes = this.utf8Bytes(entry.path);
            const bytes = entry.bytes || new Uint8Array();
            const crc = this.crc32(bytes);

            const local = new Uint8Array(30 + nameBytes.length);
            const localView = new DataView(local.buffer);
            localView.setUint32(0, 0x04034b50, true);
            localView.setUint16(4, 20, true);
            localView.setUint16(6, 0x0800, true);
            localView.setUint16(8, 0, true);
            localView.setUint16(10, dosTime, true);
            localView.setUint16(12, dosDate, true);
            localView.setUint32(14, crc, true);
            localView.setUint32(18, bytes.length, true);
            localView.setUint32(22, bytes.length, true);
            localView.setUint16(26, nameBytes.length, true);
            localView.setUint16(28, 0, true);
            local.set(nameBytes, 30);
            locals.push(local, bytes);

            const central = new Uint8Array(46 + nameBytes.length);
            const centralView = new DataView(central.buffer);
            centralView.setUint32(0, 0x02014b50, true);
            centralView.setUint16(4, 20, true);
            centralView.setUint16(6, 20, true);
            centralView.setUint16(8, 0x0800, true);
            centralView.setUint16(10, 0, true);
            centralView.setUint16(12, dosTime, true);
            centralView.setUint16(14, dosDate, true);
            centralView.setUint32(16, crc, true);
            centralView.setUint32(20, bytes.length, true);
            centralView.setUint32(24, bytes.length, true);
            centralView.setUint16(28, nameBytes.length, true);
            centralView.setUint16(30, 0, true);
            centralView.setUint16(32, 0, true);
            centralView.setUint16(34, 0, true);
            centralView.setUint16(36, 0, true);
            centralView.setUint32(38, 0, true);
            centralView.setUint32(42, offset, true);
            central.set(nameBytes, 46);
            centrals.push(central);
            offset += local.length + bytes.length;
        }

        const centralOffset = offset;
        const centralBytes = this.concatBytes(centrals);
        const end = new Uint8Array(22);
        const endView = new DataView(end.buffer);
        endView.setUint32(0, 0x06054b50, true);
        endView.setUint16(4, 0, true);
        endView.setUint16(6, 0, true);
        endView.setUint16(8, entries.length, true);
        endView.setUint16(10, entries.length, true);
        endView.setUint32(12, centralBytes.length, true);
        endView.setUint32(16, centralOffset, true);
        endView.setUint16(20, 0, true);

        return new Blob([this.concatBytes(locals.concat([centralBytes, end]))], { type: 'application/zip' });
    }

    public async downloadAgentQuery(review: any) {
        if (!review) return;
        const documentVersion = this.documentEvidenceVersion(review);
        if (documentVersion && documentVersion.id && !documentVersion.file_data_url) {
            await this.loadDocumentVersionFile(documentVersion.id);
        }
        const blob = this.createZipBlob(this.buildAgentInstructionArchiveEntries(review));
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.agentInstructionArchiveFileName(review);
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    public startReviewEdit() {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
        this.editingReview = true;
    }

    public cancelReviewEdit() {
        this.editingReview = false;
        this.reviewEditForm = this.reviewEditPayload(this.selectedReview);
    }

    public projectSettingsSavePayload(consumeLabelInput: boolean = true) {
        if (consumeLabelInput) this.addProjectFormLabel();
        const payload = Object.assign({}, this.projectForm, { labels: this.normalizeLabels(this.projectForm.labels) });
        payload.default_viewer_mode = this.normalizeWebViewerMode(payload.default_viewer_mode);
        if (this.isHtmlProject()) {
            payload.html_document_settings = this.normalizeHtmlDocumentSettings(
                this.projectForm.html_document_settings,
                this.projectForm.default_viewport_width,
                this.projectForm.default_viewport_height
            );
        }
        payload.codex_model_settings = this.normalizeCodexModelSettings(payload.codex_model_settings);
        delete payload.labelInput;
        delete payload.codex_status;
        delete payload.ssh_password_configured;
        if (!payload.ssh_password_changed) delete payload.ssh_password;
        delete payload.ssh_password_changed;
        delete payload.ssh_private_key;
        delete payload.ssh_private_key_configured;
        delete payload.ssh_private_key_name;
        delete payload.ssh_private_key_passphrase;
        delete payload.ssh_private_key_passphrase_configured;
        delete payload.ssh_public_key;
        delete payload.ssh_public_key_configured;
        delete payload.ssh_public_key_name;
        delete payload.ssh_key_algorithm;
        delete payload.ssh_key_fingerprint;
        delete payload.ssh_proxy_password_configured;
        if (!payload.ssh_proxy_password_changed) delete payload.ssh_proxy_password;
        delete payload.ssh_proxy_password_changed;
        delete payload.ssh_proxy2_password_configured;
        if (!payload.ssh_proxy2_password_changed) delete payload.ssh_proxy2_password;
        delete payload.ssh_proxy2_password_changed;
        return payload;
    }

    public async saveProject() {
        if (!this.canEditSettings() || this.sshKeyUploading || this.sshKeyDeleting) return;
        this.saving = true;
        await this.service.render();

        const payload = this.projectSettingsSavePayload(true);
        const { code, data } = await wiz.call('save_project', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload)
        }));
        this.saving = false;
        if (code === 200) {
            this.applyProject(data.project);
            this.clearCustomViewportSession();
            this.setupViewport();
            await this.service.modal.success('저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public reviewInfoExportFileName() {
        const projectName = this.project && this.project.name ? this.project.name : 'review-info';
        const suffix = this.kstDateTime(new Date().toISOString()).replace(/[^\d]+/g, '-');
        return this.safeAttachmentName(`${projectName}-review-info-${suffix}.zip`);
    }

    public reviewInfoExportUrl() {
        const query = new URLSearchParams(this.requestParams({ id: this.projectId }) as any).toString();
        return `/wiz/api/page.projects.item/export_review_info${query ? `?${query}` : ''}`;
    }

    public responseDownloadFileName(response: any, fallback: string) {
        const header = String(response && response.headers ? response.headers.get('content-disposition') || '' : '');
        const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
        if (encoded && encoded[1]) {
            try {
                return this.safeAttachmentName(decodeURIComponent(encoded[1].replace(/"/g, '')));
            } catch (e) { }
        }
        const quoted = /filename="?([^";]+)"?/i.exec(header);
        if (quoted && quoted[1]) return this.safeAttachmentName(quoted[1]);
        return this.safeAttachmentName(fallback);
    }

    public async downloadReviewInfoExport() {
        if (!this.canExportReviewInfo() || this.reviewInfoExporting) return;
        this.reviewInfoExporting = true;
        await this.service.render();
        try {
            const response = await fetch(this.reviewInfoExportUrl(), { credentials: 'same-origin' });
            const contentType = String(response.headers.get('content-type') || '').toLowerCase();
            if (!response.ok || contentType.indexOf('application/json') >= 0) {
                let message = '리뷰 정보 내보내기에 실패했습니다.';
                try {
                    const payload = await response.json();
                    message = (payload && payload.data && payload.data.message) || payload.message || message;
                } catch (e) { }
                await this.service.modal.error(message);
                return;
            }
            const blob = await response.blob();
            if (!blob || blob.size <= 0) {
                await this.service.modal.error('다운로드할 내보내기 파일을 생성하지 못했습니다.');
                return;
            }
            const objectUrl = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = this.responseDownloadFileName(response, this.reviewInfoExportFileName());
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
        } catch (e) {
            await this.service.modal.error('리뷰 정보 내보내기에 실패했습니다.');
        } finally {
            this.reviewInfoExporting = false;
            await this.service.render();
        }
    }

    public async testSshConnection() {
        if (!this.canEditSettings() || this.testingSshConnection) return;
        const form = this.projectForm || {};
        const payload: any = {
            ssh_host: form.ssh_host || '',
            ssh_port: this.cleanSshPortValue(form.ssh_port, 22),
            ssh_user: form.ssh_user || '',
            ssh_auth_mode: this.normalizeSshAuthMode(form.ssh_auth_mode),
            ssh_proxy_enabled: !!form.ssh_proxy_enabled,
            ssh_proxy_host: form.ssh_proxy_host || '',
            ssh_proxy_user: form.ssh_proxy_user || '',
            ssh_proxy2_enabled: !!form.ssh_proxy2_enabled,
            ssh_proxy2_host: form.ssh_proxy2_host || '',
            ssh_proxy2_user: form.ssh_proxy2_user || ''
        };
        if (form.ssh_password_changed) payload.ssh_password = form.ssh_password || '';
        if (form.ssh_proxy_password_changed) payload.ssh_proxy_password = form.ssh_proxy_password || '';
        if (form.ssh_proxy2_password_changed) payload.ssh_proxy2_password = form.ssh_proxy2_password || '';
        this.testingSshConnection = true;
        await this.service.render();
        const { code, data } = await wiz.call('test_ssh_connection', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload)
        }));
        this.testingSshConnection = false;
        if (code === 200 && data && data.result && data.result.ok) {
            await this.service.modal.success(data.result.message || 'SSH 접속에 성공했습니다.');
        } else {
            await this.service.modal.error((data && data.message) || 'SSH 접속에 실패했습니다.');
        }
        await this.service.render();
    }

    public async testCodexSettings() {
        if (!this.canTestCodexSettings()) return;
        const payload = this.codexSettingsPayload();
        this.testingCodexSettings = true;
        await this.service.render();
        const { code, data } = await wiz.call('test_codex_settings', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload)
        }));
        this.testingCodexSettings = false;
        if (data && data.result && data.result.status) {
            if (this.project) this.project.codex_status = data.result.status;
            if (this.projectForm) this.projectForm.codex_status = data.result.status;
        }
        if (data && data.result) {
            this.codexFooterError = data.result.ok ? '' : (data.result.message || this.codexStatusProblemText(data.result.status));
        }
        if (code === 200 && data.result && data.result.ok) {
            if (this.codexDeviceAuth && this.codexAccountLoggedIn()) {
                this.codexDeviceAuth = null;
                this.copiedCodexDeviceCode = '';
                this.codexLoginPanelOpen = false;
            }
            await this.service.modal.success(data.result.message || '에이전트 설정 확인에 성공했습니다.');
        } else {
            await this.service.modal.error((data && data.result && data.result.message) || (data && data.message) || '에이전트 설정 확인에 실패했습니다.');
        }
        await this.service.render();
    }

    public async upgradeCodexCli() {
        if (!this.canRunCodexToolAction()) return;
        const confirmed = await this.service.modal.show({
            title: '에이전트 업그레이드',
            message: 'SSH 서버에서 codex-cli를 최신 버전으로 설치 또는 업그레이드합니다. 계속할까요?',
            action: '업그레이드',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'primary'
        });
        if (!confirmed) return;
        this.codexUpgradeBusy = true;
        await this.service.render();
        const { code, data } = await wiz.call('upgrade_codex_cli', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(this.codexSettingsPayload())
        }));
        this.codexUpgradeBusy = false;
        const result = data && data.result ? data.result : null;
        if (result && result.status) {
            if (this.project) this.project.codex_status = result.status;
            if (this.projectForm) this.projectForm.codex_status = result.status;
        }
        if (code === 200 && result && result.ok) {
            await this.service.modal.success(result.message || 'codex-cli를 업그레이드했습니다.');
        } else {
            await this.service.modal.error((result && result.message) || (data && data.message) || 'codex-cli 업그레이드에 실패했습니다.');
        }
        await this.service.render();
    }

    public async checkWizCodexSettings() {
        if (!this.canRunCodexToolAction()) return;
        this.wizSetupChecking = true;
        await this.service.render();
        const { code, data } = await wiz.call('check_wiz_codex_settings', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(this.codexSettingsPayload())
        }));
        this.wizSetupChecking = false;
        if (code === 200 && data && data.result) {
            this.wizSetupStatus = data.result;
            this.wizSetupStatusPanelOpen = false;
        } else {
            this.wizSetupStatus = { ok: false, configured: false, message: (data && data.message) || 'WIZ 설정을 확인하지 못했습니다.' };
            this.wizSetupStatusPanelOpen = false;
            await this.service.modal.error(this.wizSetupStatus.message);
        }
        await this.service.render();
    }

    public async confirmAndRunWizCodexSettings() {
        if (!this.canRunCodexToolAction()) return;
        const rootPath = String((this.projectForm && this.projectForm.codex_root_path) || '/opt/app').trim() || '/opt/app';
        const confirmed = await this.service.modal.show({
            title: 'WIZ 설정 확인',
            message: `현재 SSH 서버의 에이전트 루트 경로가 WIZ 프로젝트인지 확인해주세요.\n\n대상 경로: ${rootPath}\n\n확인 후 WIZ MCP와 에이전트 AGENTS 설정을 적용합니다.`,
            action: 'WIZ 설정 적용',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'primary'
        });
        if (!confirmed) return;
        await this.runWizCodexSettings();
    }

    public async runWizCodexSettings() {
        if (!this.canRunCodexToolAction()) return;
        this.wizSetupRunning = true;
        await this.service.render();
        const { code, data } = await wiz.call('run_wiz_codex_settings', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(this.codexSettingsPayload())
        }));
        this.wizSetupRunning = false;
        const result = data && data.result ? data.result : null;
        if (result && result.status) {
            this.wizSetupStatus = result.status;
            this.wizSetupStatusPanelOpen = false;
        }
        if (code === 200 && result && result.ok) {
            await this.service.modal.success(result.message || 'WIZ 설정을 적용했습니다.');
        } else {
            await this.service.modal.error((result && result.message) || (data && data.message) || 'WIZ 설정 적용에 실패했습니다.');
        }
        await this.service.render();
    }

    public async loginCodexSettings() {
        if (!this.canLoginCodexSettings()) return;
        const payload = this.codexSettingsPayload();
        this.loggingInCodex = true;
        this.copiedCodexDeviceCode = '';
        await this.service.render();
        const { code, data } = await wiz.call('login_codex_settings', this.requestParams({
            id: this.projectId,
            data: JSON.stringify(payload)
        }));
        this.loggingInCodex = false;
        if (code === 200 && data.result && data.result.ok) {
            this.codexDeviceAuth = data.result;
            this.codexLoginPanelOpen = true;
        } else {
            await this.service.modal.error((data && data.message) || 'OpenAI 디바이스 인증 시작에 실패했습니다.');
        }
        await this.service.render();
    }

    public async requestCodexLogin(reasonInput: string = '') {
        if (!this.canRequestCodexLogin()) return;
        const reason = String(reasonInput || '').trim();
        if (!reason) {
            await this.service.modal.error('에이전트 인증 요청 사유를 입력해주세요.');
            return;
        }
        const payload: any = {
            request_type: this.codexLoginRequestType(),
            reason
        };
        this.requestingCodexLogin = true;
        await this.service.render();
        let code = 0;
        let data: any = {};
        try {
            const response = await wiz.call('request_codex_login', this.requestParams({
                id: this.projectId,
                data: JSON.stringify(payload)
            }));
            code = response.code;
            data = response.data;
        } catch (e) {
            data = { message: '에이전트 인증 요청에 실패했습니다.' };
        }
        this.requestingCodexLogin = false;
        if (code === 200 && data && data.request) {
            if (this.project) this.project.codex_login_request = data.request;
            if (this.projectForm) this.projectForm.codex_login_request = data.request;
            this.codexLoginRequestFormOpen = false;
            this.codexLoginRequestReason = '';
            await this.service.modal.success('관리자에게 에이전트 인증을 요청했습니다.');
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 인증 요청에 실패했습니다.');
        }
        await this.service.render();
    }

    public async saveProjectAdminIds(adminUserIds: string[]) {
        if (!this.canManageProjectAdmins() || this.savingProjectAdmins) return;
        this.savingProjectAdmins = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_project_admins', this.requestParams({
            id: this.projectId,
            data: JSON.stringify({ admin_ids: adminUserIds })
        }));
        this.savingProjectAdmins = false;
        if (code === 200) {
            this.applyProject(data.project);
        } else {
            await this.service.modal.error(data.message || '프로젝트 관리자를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async addProjectAdmin() {
        const userId = this.projectAdminForm.user_id || '';
        if (!userId) {
            await this.service.modal.error('추가할 프로젝트 관리자를 선택해주세요.');
            return;
        }
        const ids = this.projectAdmins().map((user: any) => user.id).filter((value: string) => !!value);
        if (!ids.includes(userId)) ids.push(userId);
        await this.saveProjectAdminIds(ids);
    }

    public async removeProjectAdmin(user: any) {
        if (!user || !user.id) return;
        if (!this.canRemoveProjectAdmin(user)) return;
        const ids = this.projectAdmins()
            .map((item: any) => item.id)
            .filter((value: string) => !!value && value !== user.id);
        await this.saveProjectAdminIds(ids);
    }

    public movableGroupOptions() {
        const current = this.project && this.project.group_id ? this.project.group_id : '';
        return (this.groupOptions || []).filter((group: any) => group && group.id && group.id !== current);
    }

    public syncGroupMoveForm() {
        this.groupMoveForm = { group_id: '', query: '', open: false };
        if (this.projectForm && this.project) this.projectForm.group_id = this.project.group_id || '';
    }

    public filteredGroupMoveOptions() {
        const query = String(this.groupMoveForm.query || '').trim().toLowerCase();
        return this.movableGroupOptions().filter((group: any) => {
            const text = [
                group.name,
                group.description,
                group.owner && group.owner.name,
                group.owner && group.owner.email
            ].join(' ').toLowerCase();
            return !query || text.includes(query);
        }).slice(0, 5);
    }

    public openGroupMovePicker() {
        this.groupMoveForm.open = true;
        this.service.render();
    }

    public groupMovePickerInput() {
        this.groupMoveForm.open = true;
        this.groupMoveForm.group_id = '';
        if (this.projectForm && this.project) this.projectForm.group_id = this.project.group_id || '';
        this.service.render();
    }

    public blurGroupMovePicker() {
        window.setTimeout(() => {
            this.groupMoveForm.open = false;
            this.service.render();
        }, 120);
    }

    public selectGroupMoveOption(group: any) {
        if (!group || !group.id) return;
        this.groupMoveForm.group_id = group.id;
        this.groupMoveForm.query = group.name || '';
        this.groupMoveForm.open = false;
        this.projectForm.group_id = group.id;
        this.service.render();
    }

    public clearGroupMovePicker() {
        this.groupMoveForm.group_id = '';
        this.groupMoveForm.query = '';
        this.groupMoveForm.open = false;
        if (this.projectForm && this.project) this.projectForm.group_id = this.project.group_id || '';
        this.service.render();
    }

    public async moveProjectGroup() {
        const targetGroupId = this.groupMoveForm.group_id || '';
        if (!this.canMoveProject() || !targetGroupId || targetGroupId === this.project.group_id) return;
        this.projectForm.group_id = targetGroupId;
        const target = (this.groupOptions || []).find((group: any) => group.id === targetGroupId);
        const ok = await this.service.modal.show({
            title: '프로젝트 이동',
            message: `${this.project.name} 프로젝트를 ${target ? target.name : '선택한 그룹'} 그룹으로 이동할까요?`,
            action: '이동',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.movingGroup = true;
        await this.service.render();
        const { code, data } = await wiz.call('move_project_group', this.requestParams({
            id: this.projectId,
            data: JSON.stringify({ group_id: targetGroupId })
        }));
        this.movingGroup = false;
        if (code === 200) {
            this.groupOptions = data.group_options || this.groupOptions;
            this.applyProject(data.project);
            await this.service.modal.success('프로젝트가 이동되었습니다.');
        } else {
            this.projectForm.group_id = this.project.group_id;
            this.groupMoveForm.group_id = '';
            await this.service.modal.error(data.message || '프로젝트를 이동하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteProject() {
        if (!this.canSubmitProjectDelete()) {
            await this.service.modal.error('삭제할 프로젝트명을 정확히 입력해주세요.');
            return;
        }
        const ok = await this.service.modal.show({
            title: '프로젝트 삭제',
            message: `${this.project.name} 프로젝트를 삭제 상태로 전환합니다. 일반 사용자 화면에서는 이 프로젝트가 보이지 않습니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.deletingProject = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_project', this.requestParams({
            id: this.projectId
        }));
        this.deletingProject = false;
        if (code === 200) {
            if (this.adminMode && data.project) {
                this.applyProject(data.project);
                this.projectDeleteConfirmName = '';
                await this.service.modal.success('프로젝트를 삭제 상태로 전환했습니다.');
            } else {
                const nextPath = this.projectGroupPath();
                await this.service.modal.success('프로젝트를 삭제 상태로 전환했습니다.');
                location.href = nextPath;
                return;
            }
        } else {
            await this.service.modal.error(data.message || '프로젝트를 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public async restoreProject() {
        if (!this.canRestoreProject()) return;
        const ok = await this.service.modal.show({
            title: '프로젝트 복원',
            message: `${this.project.name} 프로젝트를 활성 상태로 복원할까요?`,
            action: '복원',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.restoringProject = true;
        await this.service.render();
        const { code, data } = await wiz.call('restore_project', this.requestParams({
            id: this.projectId
        }));
        this.restoringProject = false;
        if (code === 200) {
            this.applyProject(data.project);
            this.projectDeleteConfirmName = '';
            await this.service.modal.success('프로젝트를 복원했습니다.');
        } else {
            await this.service.modal.error(data.message || '프로젝트를 복원하지 못했습니다.');
        }
        await this.service.render();
    }

    public async createReview() {
        if (this.reviewAttachmentBusy) {
            await this.service.modal.error('첨부 파일을 업로드하는 중입니다.');
            return;
        }
        if (!String(this.reviewForm.title || '').trim()) {
            await this.service.modal.error('리뷰 제목을 입력해주세요.');
            return;
        }
        if (this.reviewBodyLength(this.reviewForm) > this.reviewBodyMaxLength) {
            await this.service.modal.error(`리뷰 내용은 공백 포함 ${this.reviewBodyMaxLength}자까지 입력할 수 있습니다.`);
            return;
        }
        this.savingReview = true;
        await this.service.render();

        try {
            const evidence = await this.prepareEvidenceForSubmit(await this.buildEvidence());
            const payload = Object.assign({}, this.reviewForm, {
                attachments: this.reviewAttachmentsForSubmit(this.reviewFormAttachments()),
                viewport_width: this.isDocumentProject() ? 0 : this.viewport.width,
                viewport_height: this.isDocumentProject() ? 0 : this.viewport.height,
                scale: this.isDocumentProject() ? 1 : this.scale,
                current_url: this.isDocumentProject() ? this.documentReviewCurrentUrl() : this.currentUrl,
                evidence
            });

            const { code, data } = await wiz.call('create_review', this.requestParams({
                id: this.projectId,
                title: this.reviewFilters.title,
                statuses: this.reviewStatusFilterParam(),
                category: this.reviewFilters.category,
                priority: this.reviewFilters.priority,
                author_user_id: this.reviewFilters.author_user_id,
                sort: this.reviewSortField,
                sort_order: this.reviewSortOrder,
                page: 1,
                page_size: this.reviewPageSize,
                response_mode: 'created',
                data: JSON.stringify(payload)
            }));
            this.savingReview = false;
            if (code === 200) {
                this.invalidateProjectDashboardStats();
                this.reviewForm = this.blankReviewForm();
                this.syncCategoryOptions();
                this.showReviewForm = false;
                this.clearReviewCreateFocusMode();
                if (data.review) {
                    if (this.reviewPage === 1) {
                        await this.syncReview(data.review);
                        this.reviews = this.reviews.slice(0, this.reviewPageSize);
                    } else {
                        if (this.reviewMatchesCurrentFilters(data.review)) {
                            this.reviewTotalCount = this.reviewTotalItems() + 1;
                        }
                        this.scheduleReviewListSync(0);
                    }
                } else {
                    this.applyReviewPageData(data);
                }
                await this.service.render();
                return;
            }

            await this.service.modal.error(data.message || '리뷰를 등록하지 못했습니다.');
        } catch (e) {
            this.savingReview = false;
            await this.service.modal.error(e && e.message ? e.message : '리뷰를 등록하지 못했습니다.');
        }
        await this.service.render();
    }

    public async syncReview(review: any) {
        if (!review) return;
        this.invalidateProjectDashboardStats();
        const index = this.reviews.findIndex((item) => item.id === review.id);
        const previous = index >= 0 ? Object.assign({}, this.reviews[index]) : null;
        const matches = this.reviewMatchesCurrentFilters(review);
        let shouldReloadPage = false;
        let listChanged = !previous;
        if (index >= 0) {
            listChanged = this.reviewListFieldsChanged(previous, review);
            if (matches) {
                this.reviews[index] = review;
            } else {
                this.reviews.splice(index, 1);
                this.reviewTotalCount = Math.max(this.reviewTotalItems() - 1, 0);
                shouldReloadPage = true;
            }
        } else if (matches) {
            this.reviews.unshift(review);
            this.reviewTotalCount = Math.max(this.reviewTotalItems() + 1, this.reviews.length);
        }
        this.reviews = this.sortReviewRows(this.reviews);
        this.ensureReviewPage();
        if (this.selectedReview && this.selectedReview.id === review.id) {
            this.selectedReview = review;
            this.activityForm.status = this.defaultActivityStatus(review);
        }
        const activeCodex = ['queued', 'running'].includes(review.codex_job_status);
        this.syncCodexReviewStatusSocket(activeCodex && listChanged);
        if (shouldReloadPage) await this.loadReviews();
        else {
            if (listChanged && !activeCodex) this.scheduleReviewListSync(0);
            await this.service.render();
        }
    }

    public reviewListFieldsChanged(previous: any, next: any) {
        if (!previous || !next) return true;
        const fields = [
            'title',
            'status',
            'priority',
            'category',
            'current_url',
            'updated',
            'codex_job_status',
            'codex_job_id',
            'codex_job_message',
            'codex_job_started',
            'codex_work_count'
        ];
        return fields.some((field) => String(previous[field] === undefined ? '' : previous[field]) !== String(next[field] === undefined ? '' : next[field]));
    }

    public async removeReviewFromList(review: any) {
        const reviewId = review && review.id ? review.id : '';
        if (!reviewId) return;
        this.invalidateProjectDashboardStats();
        this.reviews = this.reviews.filter((item) => item && item.id !== reviewId);
        this.reviewTotalCount = Math.max(this.reviewTotalItems() - 1, 0);
        this.ensureReviewPage();
        if (this.selectedReview && this.selectedReview.id === reviewId) this.selectedReview = null;
        await this.loadReviews();
    }

    public async saveReviewEdit() {
        if (!this.selectedReview || !this.selectedReview.can_edit) return;
        if (this.reviewBodyLength(this.reviewEditForm) > this.reviewBodyMaxLength) {
            await this.service.modal.error(`리뷰 내용은 공백 포함 ${this.reviewBodyMaxLength}자까지 입력할 수 있습니다.`);
            return;
        }
        this.savingReviewEdit = true;
        await this.service.render();

        const { code, data } = await wiz.call('update_review', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify(this.reviewEditForm)
        }));
        this.savingReviewEdit = false;
        if (code === 200) {
            await this.syncReview(data.review);
            this.editingReview = false;
        } else {
            await this.service.modal.error(data.message || '리뷰 정보를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async sendReviewActivity() {
        if (!this.selectedReview) return;
        if (this.activityAttachmentBusy) {
            await this.service.modal.error('첨부 파일을 읽는 중입니다.');
            return;
        }
        const message = (this.activityForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('작업이력 메시지를 입력해주세요.');
            return;
        }
        const payload: any = { message, attachments: this.activityAttachments() };
        if (this.selectedReview.can_change_status && this.activityForm.status) {
            payload.status = this.activityForm.status;
        }

        this.sendingActivity = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_review_activity', this.requestParams({
            review_id: this.selectedReview.id,
            data: JSON.stringify(payload)
        }));
        this.sendingActivity = false;
        if (code === 200) {
            await this.syncReview(data.review);
            this.activityForm = this.blankActivityForm(data.review);
            await this.service.render();
            this.scrollActivityHistoryToBottom();
            return;
        } else {
            await this.service.modal.error(data.message || '작업이력을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async saveActivityEdit() {
        if (!this.selectedReview || !this.activityEditId) return;
        if (this.activityEditAttachmentBusy) {
            await this.service.modal.error('첨부 파일을 읽는 중입니다.');
            return;
        }
        const message = (this.activityEditForm.message || '').trim();
        if (!message) {
            await this.service.modal.error('작업이력 메시지를 입력해주세요.');
            return;
        }
        const payload: any = {
            message,
            attachments: this.activityEditAttachments()
        };

        this.savingActivityEdit = true;
        await this.service.render();
        const { code, data } = await wiz.call('update_review_activity', this.requestParams({
            review_id: this.selectedReview.id,
            activity_id: this.activityEditId,
            data: JSON.stringify(payload)
        }));
        this.savingActivityEdit = false;
        if (code === 200) {
            await this.syncReview(data.review);
            this.cancelActivityEdit();
        } else {
            await this.service.modal.error(data.message || '작업이력을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async updateReviewStatus(review: any, status: string) {
        const { code, data } = await wiz.call('update_review', this.requestParams({
            review_id: review.id,
            data: JSON.stringify({ status })
        }));
        if (code === 200) {
            await this.syncReview(data.review);
        } else {
            await this.service.modal.error(data.message || '리뷰 상태를 변경하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteReview(review: any) {
        if (!review || !review.can_delete) return;
        const ok = await this.service.modal.show({
            title: '리뷰 삭제',
            message: '이 리뷰를 삭제할까요? 삭제한 리뷰와 증거 정보는 목록에서 제거됩니다.',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!ok) return;

        const { code, data } = await wiz.call('delete_review', this.requestParams({
            id: this.projectId,
            review_id: review.id,
            title: this.reviewFilters.title,
            statuses: this.reviewStatusFilterParam(),
            category: this.reviewFilters.category,
            priority: this.reviewFilters.priority,
            author_user_id: this.reviewFilters.author_user_id,
            sort: this.reviewSortField,
            sort_order: this.reviewSortOrder,
            page: this.reviewPage,
            page_size: this.reviewPageSize
        }));
        if (code === 200) {
            this.applyReviewPageData(data);
            this.selectedReview = null;
        } else {
            await this.service.modal.error(data.message || '리뷰를 삭제하지 못했습니다.');
        }
        await this.service.render();
    }
}

export default PageProjectsItemComponent;